const enUS = {
    "page": {
        "SYS001": {},
        "omsMain": {
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "当前打印服务已是最新版本！": "The current print service is the latest version!",
            "问题处理": "Problem handling",
            "状态": "Status",
            "密码修改成功": "Password reset complete",
            "正在创建": "Creating",
            "密码长度不能少于12位": "Password length cannot be less than 12 digits",
            "转单回车查询详情": "Transfer Entering Query details",
            "您因长时间未进行操作导致页面过期": "You caussed the page expiration due to long-term operation",
            "首次登陆修改密码": "First login to change your password",
            "保存": "keep",
            "我": "I",
            "失败原因": "Failure reason",
            "请输入回复内容!": "Please enter the reply content!",
            "用户名": "username",
            "修改密码": "change Password",
            "密码不得少于": "Password is not less",
            " 条未读消息": " 条未读消息",
            "欢迎您": "Welcome",
            "原密码": "Old password",
            "获取文件路径异常": "Get file path exception",
            "导出列表": "Export Task List",
            "密码不能是完全相同的字符": "The password cannot be identical character",
            "调用表信息": "Calling table information",
            "你有 ": "你有",
            "新密码": "New Password",
            "控件": "Control",
            "操作": "Operation",
            "密码修改失败,密码有误！": "Password modification failed, password is incorrect!",
            "该问题件没有图片！": "There is no picture for this problem!",
            "确认密码": "Confirm Password",
            "为确保用户安全": "To ensure user security",
            "在此回复处理问题件": "Reply here to deal with the problem",
            "注意": "Notice",
            "选项表明细查询失败": "Options indicate that the fine query failed",
            "新密码和确认密码必须相同": "The new password and confirmation password must be the same",
            "任务名称": "Task Name",
            "输入运单": "Enter the waybill",
            "添加附件": "Add attachments",
            "是否确定退出控制中心": "Whether to determine the exit control center",
            "登录": "Log in",
            "登录窗口": "Login window",
            "序号": "No.",
            "登录验证成功": "Login verification success",
            "请做好密码修改": "Please do your password modification",
            "退出控制中心": "Exit control center",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "位": "Place",
            "创建成功": "Created successfully",
            "沟通记录": "Communication record",
            "关闭": "Close",
            "选项表明细查询成功": "Option indicates that the fine query is successful",
            "创建失败": "Creation failed",
            "导出任务列表": "Export Task List",
            "首次登陆后": "First login",
            "下载": "Download",
            "发送": "Send",
            "不允许出现连续数字或完全相同的字符": "Continuous numbers or identical characters are not allowed",
            "初始化密码容易被他人破解": "Initialization password is easy to be cracked by others",
            "密码不能是连续数字": "Password cannot be a continuous number",
            "确定": "OK",
            "提示": "Hint",
            "新消息": "News",
            "最新回复时间": "Latest reply time",
            "可添加附件": "Can add attachments",
            "密码": "Password",
            "回复失败，请重新回复!": "Reply failed, please reply again!",
            "清除": "Clear",
            "取消": "Cancel",
            "请输入密码": "Please enter the password",
            "创建时间": "Create time",
            "确认": "Confirm",
            "新密码不能与原密码相同": "The new password cannot be the same as the original password",
            "pos打印数据": "POS print data",
            "发送至邮箱": "Send to email",
            "导出报表已自动发送到当前账号绑定的邮箱": "The exported report has been automatically sent to the email address bound to the current account"
        },
        "tmsMain": {
            "快递到哪儿了":"Where's the package",
            "消息":"Message",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "当前打印服务已是最新版本！": "The current print service is the latest version!",
            "问题处理": "Problem handling",
            "状态": "Status",
            "密码修改成功": "Password reset complete",
            "正在创建": "Creating",
            "密码长度不能少于12位": "Password length cannot be less than 12 digits",
            "转单回车查询详情": "Transfer Entering Query details",
            "您因长时间未进行操作导致页面过期": "You caussed the page expiration due to long-term operation",
            "首次登陆修改密码": "First login to change your password",
            "保存": "keep",
            "我": "I",
            "失败原因": "Failure reason",
            "请输入回复内容!": "Please enter the reply content!",
            "用户名": "username",
            "修改密码": "change Password",
            "密码不得少于": "Password is not less",
            " 条未读消息": " 条未读消息",
            "欢迎您": "Welcome",
            "原密码": "Old password",
            "获取文件路径异常": "Get file path exception",
            "导出列表": "Export Task List",
            "密码不能是完全相同的字符": "The password cannot be identical character",
            "调用表信息": "Calling table information",
            "你有 ": "你有",
            "新密码": "New Password",
            "控件": "Control",
            "操作": "Operation",
            "密码修改失败,密码有误！": "Password modification failed, password is incorrect!",
            "该问题件没有图片！": "There is no picture for this problem!",
            "确认密码": "Confirm Password",
            "为确保用户安全": "To ensure user security",
            "在此回复处理问题件": "Reply here to deal with the problem",
            "注意": "Notice",
            "选项表明细查询失败": "Options indicate that the fine query failed",
            "新密码和确认密码必须相同": "The new password and confirmation password must be the same",
            "任务名称": "Task Name",
            "输入运单": "Enter the waybill",
            "添加附件": "Add attachments",
            "是否确定退出控制中心": "Whether to determine the exit control center",
            "登录": "Log in",
            "登录窗口": "Login window",
            "序号": "No.",
            "登录验证成功": "Login verification success",
            "请做好密码修改": "Please do your password modification",
            "退出控制中心": "Exit control center",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "位": "Place",
            "创建成功": "Created successfully",
            "沟通记录": "Communication record",
            "关闭": "Close",
            "选项表明细查询成功": "Option indicates that the fine query is successful",
            "创建失败": "Creation failed",
            "导出任务列表": "Export Task List",
            "首次登陆后": "First login",
            "下载": "Download",
            "发送": "Send",
            "不允许出现连续数字或完全相同的字符": "Continuous numbers or identical characters are not allowed",
            "初始化密码容易被他人破解": "Initialization password is easy to be cracked by others",
            "密码不能是连续数字": "Password cannot be a continuous number",
            "确定": "OK",
            "提示": "Hint",
            "新消息": "News",
            "最新回复时间": "Latest reply time",
            "可添加附件": "Can add attachments",
            "密码": "Password",
            "回复失败，请重新回复!": "Reply failed, please reply again!",
            "清除": "Clear",
            "取消": "Cancel",
            "请输入密码": "Please enter the password",
            "创建时间": "Create time",
            "确认": "Confirm",
            "新密码不能与原密码相同": "The new password cannot be the same as the original password",
            "pos打印数据": "POS print data"
        },
        "OMSHOME": {
            "草稿订单": "Draft",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "报价查询": "Quotation Inquiry",
            "问题处理": "Problem Handling",
            "问题状态": "Problem Status",
            "公告消息": "Announcement",
            "问题件": "Abnormal package",
            "正在研发中，敬请期待！": "In R & D, please look forward!",
            "运单号码": "Order No.",
            "姓名": "Name",
            "我": "I",
            "请输入回复内容!": "Please enter the reply content!",
            "收件邮编": "Consignee Postcode",
            "请选择目的地": "Please select a destination",
            "算": "Calculate",
            "待处理问题件": "Problematic Shipments",
            "问题描述": "Description",
            "包装类型": "Packing type",
            "业务看板": "Dashboard",
            "获取文件路径异常": "Get file path exception",
            "订单导入": "Order import",
            "发货记录如何使用": "How to use",
            "导航": "navigation",
            "待审核订单": "To be reviewed",
            "该问题件没有图片！": "There is no picture for this problem!",
            "在此回复处理问题件": "Reply here to deal with the problem",
            "您的专属服务信息": "Your Exclusive Service Information",
            "货物重量": "Weight",
            "请选择启运地": "Please select the Later Wall",
            "添加附件": "Add attachments",
            "业务类型": "Business type",
            "起运地": "Departure",
            "轨迹查询": "Tracking",
            "请输入货物重量": "Please enter the weight of the goods",
            "帮助中心": "Help Center",
            "账单管理": "Bill management",
            "电话": "Telephone",
            "运单查询": "Order Check",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "沟通记录": "Communication record",
            "已出货订单": "Warehouse Outbound",
            "关闭": "Closure",
            "您当前没有操作权限！": "You currently don't have action permissions!",
            "待出货订单": "Pending to ship",
            "试": "",
            "目的地": "Destination",
            "已收货订单": "Receivable order",
            "订单列表": "Order List",
            "待收货订单": "Uploaded orders",
            "平台操作说明书": "Platform operating instructions",
            "职务": "Duties",
            "发送": "Send",
            "登记日期": "Registration Date",
            "询": "Search",
            "查": "",
            "恒巽": "Constant",
            "订单导入操作指引": "Order import operation guidelines",
            "最新回复时间": "Latest reply time",
            "可添加附件": "Can add attachments",
            "暂无公告消息": "No announcement",
            "打单": "Order",
            "回复失败，请重新回复!": "Reply failed, please reply again!"
        },
        "OMS002": {
            "电池类型/型号":"Battery type/model",
            "选填，200字符以内": "Optional, within 300 characters",
            "必填，300字符以内": "Required, within 300 characters",
            "IOSS签发国":"IOSS Country",
            "收件门牌号":"House number ",
            "税号类型":"Tax number type ",
            "证件类型":"Type of certificate ",
            "证件号码":"ID number ",
            "寄件门牌号":"House number ",
            "转寄原单号":"Original number",
            "单位": 'Unit',
            "请输入收件城市": "Please enter the Consignee city",
            "请完善收件人信息": "Please complete the Consignee information",
            "省": "Province",
            "请选择税金支付": "Please select Payment Terms",
            "订单保存并预报成功，订单号码： <": "Order saves and forecasts success, Ref Number: <",
            "寄件邮箱": "Shipper Email",
            "税金支付不能为空": "Payment Terms cannot be empty",
            "添加": "Add to",
            "原产地": "Origin",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "收件州/省":"Province",
            "寄件州/省":"Province",
            "收件税号": "Receiving tax number",
            "Location Code": "Location Code",
            "选择": " Select Address",
            "保存": "Keep",
            "最多": "Max. ",
            "总价": "Total Price",
            "列": "List",
            "清空": "Clear",
            "包装类型": "Packing type",
            "请输入寄件城市": "Please enter the Consigner city",
            "获取文件路径异常": "Get file path exception",
            "单价不能为空": "Unique unit price cannot be empty",
            "操作": "Operation",
            "货物重量不能为空": "The weight of the cargo cannot be empty",
            "请输入收件地址": "Please enter the Consignee address",
            "请输入内容": "Search...",
            "否": "No",
            "行邮税号": "Postal Tax Number",
            "付款方式": "Payment",
            "寄件人": "Shipper",
            "其他": "Other",
            "基本信息": "Basic info",
            "是": "Yes",
            "件数": "Pieces",
            "查看订单": "Check order",
            "平台类型": "Platform",
            "不能上传jsp,bat,sh,js,exe文件": "Can't upload JSP, BAT, SH, JS, EXE file",
            "寄件税号": "Shipping tax number",
            "选择常用收件人": "Select Consignee",
            "请输入寄件地址": "Please enter the Shipper address",
            "请输入货物重量": "Please enter the weight of the goods",
            "收件人信息": "Consignee Info",
            "继续编辑": "Continue Editing",
            "收件城市": "City",
            "序号": "No.",
            "指定路线不能为空": "The channel code cannot be empty",
            "单价": "Unit Price",
            "自定义信息": "Additional Information on Label",
            "行": "Row",
            "必填": "Required",
            "注意以下几点要求": "Pay attention to the followings",
            "删除": "Delete",
            "数量": "Qty",
            "目的地": "Destination",
            "请完善寄件人信息": "Please complete the Shipping information",
            "请输入寄件邮编": "Please enter the Shipping postcode",
            "保存成功": "Successfully saved",
            "列与列直接用": "Separate Columns by ",
            "数量不能为空": "Quantity can't be empty",
            "寄件国家": "Country",
            "英文品名不能为空": "English description cannot be empty",
            "请输入0-9999之间的重量": "Please enter a weight between 0-9999",
            "信息复制到剪贴板即可": " Information to the clipboard before import",
            "请输入寄件国家": "Please enter the Shipping Country",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "文件大小不能大于10MB": "File size cannot be greater than 10MB",
            "商品图片地址": "Product Picture URL",
            "请选择目的地！": "Please select a destination!",
            "字符": " Characters",
            "订单保存到草稿成功，订单号码： <": "Order saves to the draft success, Ref Number: <",
            "请选择报关方式": "Please select the declaration method",
            "请输入寄件电话": "Please enter the Shipper phone",
            "收件人电话不能为空": "Consignee phone cannot be empty",
            "运费": "Shipping Cost",
            "取消": "Cancel",
            "位小数": "DP",
            "保存到草稿": "Save to draft",
            "收件邮箱": "Email",
            "配货信息": "Distribution Information",
            "海关编码": "HS Code",
            "商品链接地址": "Item Product URL",
            "快速录入": "Quick Entry",
            "用于额外打印在标签上": " for additional information show on the label",
            "请输入寄件人": "Please enter the Shipper",
            "删除成功!": "Successfully deleted!",
            "货物类型不能为空": "The cargo type cannot be empty",
            "选填": "Optional",
            "收件邮编": "Consignee postcode",
            "寄件电话": "Shipper phone",
            "请选择目的地": "Please select a destination",
            "请选择币别": "Please select currency",
            "包装类型不能为空": "Packaging type cannot be empty",
            "订单号码": "Ref No.",
            "品牌": "Brand",
            "请选择包装类型": "Please select the Packing type",
            "信息": "Details",
            "收件地址": "Consignee Address",
            "下一订单": "Next order",
            "寄件地址": "Shipper Address",
            "寄件邮编": "Postcode",
            "请输入收件人！": "Please enter the consignee!",
            "货物重量": "Weight",
            "英文品名": "Description EN",
            "寄件人不能为空": "Consigner name cannot be empty",
            "收件公司": "Consignee company",
            "请输入件数": "Please enter the number of pieces",
            "上传附件": "Upload Attachment",
            "请输入需要导入的信息!": "Please enter the information you want to import!",
            "收件人": "Consignee",
            "保存为常用收件人": "Save Address",
            "收件人不能为空": "The Consignee name cannot be empty",
            "备注": "Remark",
            "寄件城市": "City",
            "寄件人信息": "Shipper Info",
            "单个重量": "Piece Weight",
            "请输入收件电话！": "Please enter the receiving phone number!",
            "区县": "District",
            "关闭": "Closure",
            "请输入收件电话": "Please enter the Consignee phone",
            "格式为": "Format",
            "目的地不能为空": "Destination can't be empty",
            "材质": "Material",
            "收件人地址不能为空": "The Consignee address cannot be empty",
            "寄件公司": "Shipper company",
            "第三方税金账号": "Third-party tax account",
            "收件州": "Consignee Province",
            "请输入至少一行invoice信息！": "Please enter at least one line of INVOICE information!",
            "请选择指定路线": "Please select Channel Code",
            "请选择付款方式": "Please select a payment method",
            "代收款": "Agency fund",
            "导入": "Import",
            "用途": "Usage",
            "确定": "OK",
            "请输入订单号码": "Please enter the ref number",
            "点击保存按钮后添加信息": "Click OK button to add information",
            "税金支付": "Payment Terms",
            "请输入收件人": "Please enter the Consignee",
            "规格": "Specification",
            "件数不能为空": "The number of pieces cannot be empty",
            "订单号码为空，系统自动分配订单号码，是否继续？": "The order number is empty, the system automatically assigns the order number, is there?",
            "请输入收件地址！": "Please enter the receipt address!",
            "收件电话": "Consignee phone",
            "更多信息": "More",
            "导入格式": " Import Format",
            "保存为草稿": "Save as Draft",
            "保留上一笔": "Keep the previous",
            "导入前请将": "Please copy ",
            "货物类型": "Cargo type",
            "请输入收件邮编": "Please enter the Consignee postcode",
            "中文品名": "Description CN",
            "请选择货物类型": "Please select the Cargo type",
            "请输入中文品名": "Please enter Chinese description",
            "保存并预报": "Save&continue",
            "确定删除此行吗？": "Are you sure to delete this line?",
            "选取": "Select",
            "第三方付税金账号": "Third-party Payment Terms account",
            "隔开": "separation",
            "申报金额":"DeclarationAmount",
            "服务类型":"Service type",
            "平台运费":"Platform freight",
            "自定义面单URL":"Customize label URL",
            "税金付款":"Tax payment",
            "保险金额":"Insurance",
            "保险类别":"Insurance type",
            "包裹长":"Package length",
            "包裹宽":"Package width",
            "包裹高":"Package height",
            "目的国语言品名":"Target language name",
            "类别":"Category",
            "电池":"Battery type",
            "型号":"model",
            "电池数量":"Number of batteries",
            "销售平台商品编码":"Sales-platform product code",
            "长":"Length ",
            "宽":"Width ",
            "高":"Height "
        },
        "OMS003": {
            "导入处理类型":"Import processing type",
            "订单导入模板有更新, 请下载最新模板":"Order import template is updated, please download the latest template",
			"提示":"Hint",
			"确定":"OK",
            "指定路线":"Channel Code",
            "历史日志": "View Log",
            "订单导入成功": "Order imported successfully",
            "数据有": "Data",
            "成功": "Success",
            "状态": "Status",
            "自动获取运单号码": "Automatically get the waybill number",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import files cannot exceed 10MB",
            "文件大小不超过": "File size does not exceed",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "导入时": "Introduction",
            "批次号": "Batch No.",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select the import template!",
            "组对应表头": "Group correspondence",
            "需有": "Demand",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "条": "Strip",
            "导入": "Import",
            "请确认导入模板中表头的完整性": "Please confirm the integrity of the header in the import template",
            "导入历史日志": "Import Log",
            "总行数": "Total",
            "请选择模版！": "Please select a template!",
            "如单个运单最多的": "Such as a single wayblower",
            "导入时间": "Import Time",
            "模版下载": "Template download",
            "导入文件格式支持": "Import file format support",
            "错误说明": "Error Description",
            "导入文件": "Imported Files",
            "请输入": "please input",
            "文件下载": "file download",
            "上传中": "Uploading",
            "行号": "Line No.",
            "错误行数": "Error Rows",
            "导入模版": "Import template",
            "新增模板": "New template",
            "订单号码":"Ref No.",
            "序号":"Serial number",
            "模板管理":"Template List",
            "编码":"Channel Code",
            "名称":"Channel Name",
            "备注":"Remarks",
            "标准模板":"Standard Template",
            "仅校验":"Check only",
            "标准":"Standard",

        },
        "OMS008": {
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "点击上传附件": "Click to Upload Attachment",
            "全部问题件": "All Problem Pieces",
            "问题处理": "Problem Handling",
            "问题状态": "Status",
            "登记人": "Register Person",
            "登记成功！": "Registration is successful!",
            "运单号码": "Order No.",
            "指定路线": "Channel Code",
            "查询": "Search",
            "我": "I",
            "可上传一个后缀名为": "Upload a suffix name",
            "保存": "Keep",
            "请输入回复内容!": "Please enter the reply content!",
            "收件邮编": "Consignee Postcode",
            "笔": "Total",
            "请选择问题评价": "Please select question evaluation",
            "登记": "Register",
            "问题描述": "Description",
            "登记日期不能为空": "Registration date can't be empty",
            "问题个数": "# of Issues",
            "已处理": "Processed",
            "文件未上传完，禁止保存！": "The file has not been uploaded, it is forbidden to save!",
            "最新轨迹": "Status",
            "附件": "Attachments",
            "获取文件路径异常": "Get file path exception",
            "评价": "Evaluation",
            "请选择待评价的问题": "Please select the problem to be evaluated",
            "该问题件没有图片！": "There is no picture for this problem!",
            "大小不能超过": "Size can't exceed",
            "问题类型": "Question type",
            "问题件信息": "Problem information",
            "添加附件": "Add attachments",
            "件数": "Pieces",
            "问题件查询": "Questions inquiries",
            "处理描述": "Description",
            "处理状态": "Processing status",
            "待处理": "Pending",
            "登记异常": "Abnormal registration",
            "问题件登记": "Registration",
            "在此回复处理问题件；可添加附件": "Reply here to deal with the problem; attachments can be added",
            "评价成功": "Successful evaluation",
            "序号": "No.",
            "未评价": "Not evaluated",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "沟通记录": "Communication record",
            "回复中": "Replying",
            "关闭": "Closure",
            "处理完毕问题件": "Problem solved",
            "重置": "Reset",
            "评分": "Score",
            "已评价": "Evaluated",
            "请选择一行数据": "Please select a row of data",
            "发送": "Send",
            "登记日期": "Date",
            "评价 ": "评价",
            "未找到问题，请重新查询": "No problem found, please check again",
            "寄件日期": "Inbound Date",
            "请选择评分": "Please select a rating",
            "参考编号": "Ref number",
            "确定": "OK",
            "回复": "Reply",
            "转单号码": "Tracking number",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "提示": "Hint",
            "收费重": "Charge weight",
            "目的地信息": "Destination",
            "最新回复时间": "Latest reply time",
            "回复失败，请重新回复!": "Reply failed, please reply again!",
            "导出": "Export",
            "请输入": "please input",
            "取消": "Cancel",
            "的附件": "Attachment",
            "通过处理状态可快速筛选问题件": "Problem pieces can be quickly screened by processing status",
            "评价内容": "comment content"
        },
        "OMS018": {
            "特殊报表导出":"Special report export",
            "IOSS Number":"IOSS No.",
            "省": "Province",
            "彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！": 'The order is completely deleted. If the deletion fails, please check the specific error message in "Abnormal Forecast"！',
            "该订单无Invoice，无法下载": "This order is not invoice, you can't download",
            "日志信息": "Log Info",
            "寄件邮箱": "Shipper Email",
            "状态": "Status",
            "草稿": "Draft",
            "已收货情况下申请拦截": "Apply for the delivery situation",
            "成功转草稿": "Successful draft",
            "原产地": "country of origin",
            "清空指定路线": "New Channel Code To Copy",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "我是标题": "I am title",
            "当前数据无修改，请先修改数据！": "Current data has no modification, please modify the data first!",
            "收件税号": "Receiving tax number",
            "按百分比修改单价": "Modify unit price by percentage",
            "保存": "Keep",
            "是否确定标记为已打印？": "Is it sure that the tag is printed?",
            "请选择要拦截的数据": "Please select the data you want to temporarily",
            "请选择要彻底删除的数据": "Please select the data you want to completely delete",
            "真的要将选择的<": "Really want to choose <",
            "拦截原因": "Subsidy",
            "请选择订单状态是\"草稿\"的数据": "Please select the data whose order status is \"Draft\"",
            "总价": "Total price",
            "请选择要取消拦截的数据": "Please select the data you want to cancel",
            "文件名": "File name",
            "创建人": "Creator",
            "寄件时间": "Inbound At",
            "包装类型": "Packing type",
            "寄件区县": "Sending district",
            "类别": "Category",
            "获取文件路径异常": "Get file path exception",
            "请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据": "Please select the data whose order status is \"predicted\", \"shipped\",\"received\"",
            "发票下载": "Invoice Download",
            "单价百分比和单价只能二选一！": "Unplug the unit price and single price can only be one!",
            "操作": "Operation",
            "操作时间": "Operating At",
            "微软雅黑 Regular": "Microsoft Yaishi Regular",
            "申请拦截": "Block Order",
            "付款方式": "Payment method",
            "注意": "Notice",
            "基本信息": "Basic info",
            "请选择订单状态是\"草稿\",\"已收货\", \"已出货\",\"已预报\"的数据": "Please select the data whose order status is \"draft\", \"received\", \"shipped\",\"predicted\"",
            "拦截": "Block",
            "将不允许收货": "Received will not be allowed",
            "标签打印": "Print Label",
            "件数": "Pieces",
            "笔，有0未提交成功": "Pen, there is 0 uncommitted success",
            "平台类型": "Platform",
            "寄件税号": "Shipping tax number",
            "删除订单比较危险，您真的要删除吗？": "Deleting orders is more dangerous, do you really want to delete?",
            "成功修改指定路线": "Successfully Update Channel Code",
            "显示条件": "Show Filters",
            "收件人信息": "Consignee Info",
            "是否偏远": "Remote?",
            "修改指定路线": "Update Channel Code",
            "异常信息": "Exception Information",
            "隐藏条件": "Hide Filters",
            "请选择要复制订单的数据": "Please select the data you want to copy the order",
            "收件城市": "Consignee City",
            "COD币别": "COD Currency",
            "序号": "No.",
            "只有在已预报": "Only in prediction",
            "转寄原单号": "Original number",
            "单价": "Unit price",
            "单号": "Number",
            "自定义信息": "Remarks",
            "请选择订单状态是\"预报\"的数据": "Please select the data whose order status is \"Forecast\"",
            "已收货": "Warehouse Inbound",
            "删除": "Delete",
            "成功修改申报": "Success to modify the declaration",
            "买家": "Buyer",
            "请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据": "Please select the data whose order status is \"received\", \"shipped\", \"predicted\"",
            "复制订单会产生一个新的订单（建议只有在拆单时才使用），您真的要复制吗？": "Copy orders will produce a new order (suggestions only if you use it when you disassemble), do you really want to copy?",
            "彻底删除订单将不能恢复，您真的要彻底删除吗？": "Thoroughly delete orders will not be recovered, do you really want to completely delete it?",
            "重置": "Reset",
            "数量": "Qty",
            "请选择订单状态是\"草稿\",\"已预报\"的数据": "Please select the data whose order status is \"Draft\",\"Forecasted\" ",
            "已预报的订单在收货时": "The predicted order is receiving",
            "收件州省": "Consignee province",
            "目的地": "Destination",
            "相关文件": "Related documents",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it later in the export list!",
            "成功删除订单": "Successfully deleted orders",
            "您真的要将选择的数据提交预报？": "Do you really want to submit the selected data?",
            "请选择要提交预报的数据": "Please select the data you want to submit the forecast",
            "格式": "Format",
            "寄件国家": "Consigner Country",
            "请选择订单状态是\"已删除\",\"已预报\"的数据": "Please select the data whose order status is \"deleted\",\"predicted\" ",
            "转单号码": "Tracking number",
            "提示": "Hint",
            ">笔取消失败！": "> Pen cancels fail!",
            "寄件日期不能为空": "Inbound time cannot be empty",
            "打印": "Print",
            "收件区县": "Consignee District",
            "笔数据，其中<": "Pen, where <",
            ">笔订单取消拦截吗？": "> Does the pen order cancel?",
            "操作用户": "Operation By",
            "导出": "Export",
            "你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)": "Do you really want to get the selected data? (Note: This feature is suitable for express orders)",
            "成功提交": "Successfully submitted",
            "保留指定路线": "Keep Channel Code To Copy",
            "将不允许出货": "Shipment will not be allowed",
            "取消": "Cancel",
            "订单管理": "Order List",
            "请选择要修改指定路线的数据": "Please select the data you want to modify the Channel Code",
            "预报异常": "Exception pre-alert",
            "请选择订单状态是\"已预报\"的数据": "Please select the data whose order status is \"predicted\" ",
            "基础信息": "Basic Info",
            "收件邮箱": "Consignee Email",
            "配货信息": "Distribution information",
            "税金付款": "Tax payment",
            "海关编码": "HS code",
            "商品链接地址": "Item Product URL",
            "标记": "Tag",
            "表格双击后查看订单详情": "Double Click for Details",
            "全部": "All",
            "查询": "Search",
            "您真的要将选择的数据修改指定路线吗？": "Do you really want to modify the selected data?",
            "收件邮编": "Consignee Postcode",
            "未填写栏位不做修改": "Not filling in the field does not make changes",
            "成功提交预报": "Successfully submit forecast",
            "订单号码": "Ref No.",
            "品牌": "Brand",
            "COD金额": "COD Amount",
            "收件地址": "Consignee Address",
            "转草稿": "To Draft",
            "寄件地址": "Shipper address",
            "已收货的订单": "Reserved order",
            "寄件邮编": "Postcode",
            "货物重量": "Package Weight",
            "英文品名": "Description EN",
            "重量": "Weight",
            "打印状态": "Print Status",
            "货物信息": "Package Info",
            "订单日期": "Order Create Time",
            "已出货": "Warehouse Outbound",
            "申报价值": "Declared Value",
            "请选择要修改申报的数据": "Please select the data you want to modify",
            "复制订单": "Copy Orders",
            "真的要将选择的订单申请拦截吗？": "Do you really want to apply the selected order?",
            "成功取消订单": "Successfully cancel the order",
            "收件人": "Consignee",
            "导入修改": "Import modify",
            "请输入拦截原因!": "Please enter a billing!",
            "请选择要转草稿的数据": "Please select the data you want to draft",
            "成功复制订单": "Successfully replicated orders",
            "备注": "Remark",
            "寄件城市": "City",
            "寄件人信息": "Shipper",
            "订单日期不能为空": "Order create time cannot be empty",
            "关闭": "Closure",
            "申请拦截后": "After Block Order",
            "取消拦截": "Unblock Order",
            "请输入拦截原因": "Please enter a billing reason",
            "下载": "Download",
            "没有获取到下载地址！": "Did not get the download address!",
            "收件州": "Consignee Province",
            "选择的订单拦截成功！": "The selected order is temporarily buckle!",
            "已删除": "Deleted",
            "内容": "Content",
            "请选择指定路线": "Please select Channel Code",
            "请选择要打印订单的数据": "Please select the data to print orders",
            "确定": "OK",
            "创建导出任务失败:": "Create an export task failed:",
            "请选择订单状态是\"已删除\"的数据": "Please select the data whose order status is \"deleted\"",
            "收货标签": "Receipt label",
            "请选择小于50笔数据下载": "Please select less than 50 data downloads",
            "彻底删除": "Confirm Delete",
            "提交预报": "Submit To Create Order",
            "代表": "Represent",
            "收件电话": "Consignee phone",
            "单价百分比": "Unit price percentage",
            "货物类型": "Cargo type",
            "笔，有0笔未提交成功": "Pen, there are 0 uncommitted successfully",
            "中文品名": "Description CN",
            "创建时间": "Create time",
            "请选择要删除的数据": "Please select the data you want to delete",
            "请选择订单状态是\"草稿\", \"已预报\"的数据": "Please select the data whose order status is \"draft\", \"predicted\"",
            "彻底删除成功": "Remove successfully",
            "修改申报": "Modify Seclared Value",
            "请选择要获取转单号码的订单数据": "Please select order data to get the transfer number number",
            "客户":'Customer ',
            "客户(可多选)":"Customer (Multiple Selection) ",
            "揽收取件码":"Collection code",
            "单票浏览":"Single order browsing",
            "已预报":"Pre-alert",
            "运单号码":"Order Number",
        },
        "BMS122": {
            "应收客户增值费明细": "",
            "新增": "",
            "修改": "",
            "复制": "",
            "删除": "",
            "展开明细": "",
            "收起明细": "",
            "应收客户增值费": "",
            "导出": "",
            "导出明细": "",
            "显示待生效报价": "",
            "显示使用中报价": "",
            "显示历史报价": "",
            "应收其他科目": "",
            "特殊客户": "",
            "指定路线": "",
            "启用状态": "",
            "重置": "",
            "查询": "",
            "序号": "",
            "增加": "",
            "指定路线分类": "",
            "目的地": "",
            "起始重量": "",
            "终止重量": "",
            "最低价格": "",
            "最高价格": "",
            "公式": "",
            "创建时间": "",
            "创建人": "",
            "修改时间": "",
            "修改人": "",
            "基础信息": "",
            "启用": "",
            "客户分组": "",
            "已选客户分组列表": "",
            "请输入关键字": "",
            "保存": "",
            "修改应收报价明细": "",
            "客户编码": "",
            "客户名称": "",
            "所属网点": "",
            "销售员": "",
            "请输入起始重量": "",
            "请输入终止重量": "",
            "请输入公式": "",
            "请选择科目": "",
            "请选择币别": "",
            "请选择生效日期": "",
            "请输入停用日期": "",
            "请输入": "",
            "科目编码": "",
            "科目名称": "",
            "生效日期": "",
            "停用日期": "",
            "币别": "",
            "转本币结算": "",
            "适用所有客户": "",
            "生效对象数": "",
            "科目": "",
            "共": "",
            "条": "",
            "关闭": "",
            "报价因素": "",
            "指定线路分类": "",
            "最低价": "",
            "最高价": "",
            "公式说明": "",
            "符号：+：加、 -：减、 *：乘、 /：除、()：括号": "",
            "变量：收费重(@w)，实重(@a)，材重(@v)，申报价值(@s)，仓租天数(@d)，cod货款金额(@c)": "",
            "应收运费(@y),应收偏远费(@r)": "",
            "其他：明细中设置币别后，账单明细按设置币别生成":"",
            "函数：round()，按指定的小数位数，四舍五入；ceiling()，进位取整；floor()，退位取整": "",
            "case when then else end，判断语句": "",
            "范围：起始重量 <  收费重 <= 终止重量": "",
            "首重/续重设置方法：首重价 + ceiling ((@w-首重)/续重)*续重价": "",
            "保存并继续": "",
            "新增应收报价明细": "",
            "新增成功": "",
            "修改成功": "",
            "请选择数据": "",
            "是否确认删除明细？": "",
            "提示": "",
            "确定": "",
            "取消": "",
            "删除明细成功": "",
            "应收客户其他明细": "",
            "新增应收客户增值费": "",
            "修改成功！": "！",
            "内容有修改,是否确认关闭？": "",
            "将会同步删除明细数据，确定要删除吗？": "",
            "删除成功！": "",
            "请先选择数据！": "",
            "内容有修改,是否确认关闭？'": "",

        },
       
        "BMSAddedFee": {
            "指定路线": "Channel code",
            "请输入": "Please enter",
            "导入模版": "Import template",
            "导入": "Import",
            "模版下载": "Template download",
            "导入文件格式支持":"Supported file formats for import include",
            "文件大小不超过10M": "with a maximum file size of 10MB.",
            "批次号": "Batch number",
            "导入文件": "Import file",
            "导入时间": "Import time",
            "状态": "Status",
            "总行数": "Total number of rows",
            "错误行数": "Error number of rows",
            "文件下载": "Download file",
            "历史日志": "History logs",
            "错误说明下载": "Download error description",
            "导入历史日志": "Import historical logs",
            "行号": "Line number",
            "运单号": "Tracking number",
            "错误信息": "Error information",
            "请选择模版！": "Please select template",
            "请选择导入模版！": "Please select import template",
            "导入文件不能超过10MB": "The imported file must not exceed 10MB.",
            "上传中": "Uploading",
            "上传失败": "Upload failed",
            "解析中": "Parsing",
            "解析失败": "Parsing failed",
            "验证中": "Verifying",
            "验证失败": "Verification failed",
            "导入中": "Importing",
            "成功": "Success",
            "失败": "Fail",
        },
        "QuotehuImport":{
            "创建时间":"Create time",
            "查询":"Search",
            "删除":"Delete",
            "上传":"Upload",
            "通知客户":"Notify the customer",
            "失败再次推送":"Retry pushing failed items",
            "报价":"Quotation",
            "是否通知客户":"Should notify the customer?",
            "创建人":"Creator",
            "推送状态":"Push status",
            "失败原因":"Failure reason",
            "请求成功":"Request successful",
            "请选择推送状态为失败的数据":"Please select the data with push status as failed.",
            "推送成功":"Push successful",
            "请选择一行数据":"Please select one row of data.",
            "已通知客户":"Customer has been notified",
            "删除成功":"Delete successful",
        },

        "OMS005": {
            "自动翻译寄件公司": "Automatic translation Shipper company",
            "省": "Province",
            "终止邮编": "Termination",
            "公司": "Company",
            "净重": "Net weight",
            "添加": "Add to",
            "寄件信息": "Shipping information",
            "手动打印": "Manual print",
            "原产地": "country of origin",
            "没有得到走货路线": "Did not get the Delivery route",
            "付款账号": "Payment account",
            "指定路线": "Channel Code",
            "收件税号": "Receiving tax number",
            "保存": "Keep",
            "printScene:INVOICE打印机": "Printscene: Invoice Printer",
            "收件人账号": "Recipient account",
            "寄件机场代码": "Send airport code",
            "单价币别": "Single price currency",
            "收件信息": "Receiving information",
            "地址": "Address",
            "包装类型": "Packing type",
            "包装方式": "Packing",
            "收件电话可能包含电话区号,是否继续": "The recipient may contain a phone area code, do you continue?",
            "机场代码查询": "Airport code query",
            "操作": "Operation",
            "保险": "Insurance",
            "打印机": "Printer",
            "否": "No",
            "is_plt 配置为固定值了貌似修改了也无效": "IS_PLT is configured to have fixed values, which seems to be modified.",
            "打单前请设置好备份联打印机": "Please set the backup joint printer before gum.",
            "上下偏差": "Upper and down deviation",
            "邮编类型": "Zip code type",
            "付款方式": "Payment method",
            "其他": "Other",
            "注意": "Notice",
            "基本信息": "Basic info",
            "是": "Yes",
            "混打模式": "Hybrid mode",
            "寄件账号": "Mail account",
            "件数": "Pieces",
            "邮编": "Post code",
            "转单后打印": "Print after turning",
            "打单前请设置好LABEL打印机": "Please set a good label printer before gum.",
            "修改指定路线": "Modify Channel Code",
            "联络人": "Contact person",
            "出货重": "Shipping weight",
            "指定路线不能为空": "The channel code cannot be empty",
            "目的机场代码": "Destination airport code",
            "查询条件": "Query conditions",
            "单价": "Unit price",
            "国家编号": "National number",
            "删除": "Delete",
            "EDI_LABEL打印机": "EDI_LABEL printer",
            "黑名单确认": "Blacklist confirmation",
            "打印设置": "Printer settings",
            "税金第三方国家": "Tax third party country",
            "保存时获取转单": "Get the transfer when saving",
            "重置": "Reset",
            "国家": "Nation",
            "数量": "Quantity",
            "件数必填并且大于0": "Parts must be filled and greater than 0",
            "目的地": "Destination ",
            "有电池信息时": "Battery information",
            "毛重": "Gross weight",
            "设置": "Set up",
            "备份联": "Backup joint",
            "保存时不获取转单": "Do not get the transfer when saving",
            "提示": "Hint",
            "寄件操作中心": "Sending Operation Center",
            "国家简码": "National state",
            "INVOICE打印机": "Invoice printer",
            "税金第三方邮编": "Tax third party zip code",
            "打单前请设置好INVOICE打印机": "Please set a good Invoice printer before gum.",
            "确": "Indeed",
            "设置信息": "Setting information",
            "税金三方信息": "Tripartite information",
            "报关方式": "Declaration method",
            "备份联打印机": "Backup joint printer",
            "不支持的跳转方式": "Not supported way of jump",
            "运费": "Freight",
            "小计": "Subtotal",
            "加载失败：": "Failed to load:",
            "转单后打印备份联": "Print the backup after transfer",
            "机场代码": "Airport code",
            "海关编码": "HS code",
            "保存时打印": "Print when saving",
            "税金第三方公司": "Tax third party company",
            ">不一致": "> Inconsistent",
            "原始大小": "Original size",
            "运单号码": "Order Number",
            "暂不支持电池信打印": "Battery letter printing is not supported",
            "查询": "Search",
            "打单返回": "Order return",
            "回车后": "Enter",
            "货物类型不能为空": "The cargo type cannot be empty",
            "联系电话": "Contact number",
            "包装类型不能为空": "Packaging type cannot be empty",
            "需强制录入发票信息": "Need to enhance invoice information",
            "定": "Certainly",
            "安全的从有效字段缓存中取值": "Safe from the valid field cache",
            "郊区": "Suburbs",
            "开始邮编": "Start a postal code",
            "操作中心": "Operating center",
            "旋转角度": "Rotation angle",
            "打印份数": "Number of prints",
            "自动保存收件信息": "Automatically save the recipient information",
            "请选择代理EDI": "Please select the agent EDI",
            "密度": "Density",
            "打单设置": "Order setting",
            "英文品名": "Description EN",
            "无纸化": "Paperless",
            "货物信息": "Package Info",
            "服务方式": "Service method",
            "当前走货路线未配置EDI": "Current goods route does not configure EDI",
            "EDI 配置或API配置不能为空": "EDI configuration or API configuration cannot be empty",
            "电子邮件": "E-mail",
            "申报价值": "Declared value",
            "州省编号": "State number",
            "代理打单": "Agent list",
            "计量单位": "Unit of measurement",
            "公司名称": "Company Name",
            "API没有配置接口名称": "API does not have the interface name",
            "折扣": "Discount",
            "转单后打印电池信": "Print battery letter after turning",
            "包装类型和配置包装类型<": "Packaging type and configuration packaging type <",
            "备注": "Remark",
            "强制录入发票": "Forced entry invoice",
            "重量单位": "Weight unit",
            "关闭": "Closure",
            "寄件信息自动保留": "Send message automatically retain",
            "目的地不能为空": "Destination can't be empty",
            "已停用": "Terminated",
            "printScene:EDI_LABEL打印机": "PRINTSCENE: EDI_Label Printer",
            "当前参考编号已存在，如果继续将会导致数据重复，是否继续": "The current reference number already exists, if the continued data is repeated, do you continue?",
            "参考编号不能为空": "Reference number cannot be empty",
            "州": "State",
            "出货重必填并且大于0": "Shipment, heavy filling and greater than 0",
            "printScene:备份联打印机": "PRINTSCENE: Backup joint printer",
            "代收款": "Agency fund",
            "参考编号": "Ref number",
            "开始打单": "Start to play",
            "目的操作中心": "Destination Operation Center",
            "收件电话校验": "Recipient phone check",
            "危险品": "Dangerous goods",
            "税金账号": "Tax account",
            "税金支付": "Tax payment",
            "州省": "Province / State",
            "双击表格后选取表格当前行": "Select the table when you double-click the form.",
            "确认信息": "Confirmation",
            "货物类型": "Cargo type",
            "中文品名": "Description CN",
            "进口商": "Importer",
            "左右偏差": "Left and right deviation",
            "预约编号": "Appointment number",
            "选取": "Choose",
            "城市": "City"
        },
        "OMS006": {
            "修改": "Modify",
            "选中行还未生成运单数据，无法跳转至运单详情！": "The line of the bank has not generated the waybill data, and it is not possible to jump to the waybill details!",
            "打印时间": "printing time",
            "寄件邮箱": "Shipper Email",
            "取消审核成功！": "Cancel the review success!",
            "打单状态不为已审核，无法进行取消审核！": "The bill status is not reviewed and cannot be canceled!",
            ">笔，成功<": "> Pen, success",
            "指定路线": "Channel Code",
            "此操作将进行撤销账单, 是否继续?": "This will be revoked bills, is there any?",
            "确定要取消审核吗？": "Do you want to cancel the review?",
            "撤销审核成功！": "Revocation is successful!",
            "请勾选一行数据": "Please check a line of data",
            "没有配置LABEL自定义模板": "No configuration label custom template",
            "此操作将进行撤销审核, 是否继续?": "This will be revoked the audit, is it going?",
            "审核成功！": "Review success!",
            "寄件人": "Shipper",
            "付款方式": "Payment method",
            "没有获取到备用联label地址": "Did not get a backup Label address",
            "未审核数据，无法撤销审核！": "Undudited data, unable to revoke the audit!",
            "件数": "Pieces",
            "您真的要对选择的<": "You really want to choose <",
            "审核总数<": "Total audit <",
            "收件城市": "Consignee city",
            "没有配置LABEL 输出方式": "Did not configure label output",
            "批量预览": "Batch preview",
            "请选择数据进行修改": "Please select data to modify",
            "的数据": "The data",
            "转单状态": "Transfolio",
            "已审核数据，无法再次审核！": "The data has been reviewed and cannot be reviewed again!",
            "没有配置INVOICE自定义模板": "No invoice custom template",
            "重置": "Reset",
            "浏览": "Browse",
            "打单时间": "Order time",
            "审核异常": "Review abnormal",
            "收件国家简码": "Recipient country",
            "申报币别": "Declared currency",
            ">笔做批量审核吗？": "> Does the pen do batch audits?",
            "批量审核": "Bulk review",
            "含发票": "Invoice",
            "备份联": "Backup joint",
            "转单号码": "Tracking Number",
            "提示": "Hint",
            "取消打单数据成功！": "Cancel the order data is successful!",
            "已确认或部分确认数据，无法撤销账单！": "Confirmed or part of confirmation data, unable to undo bill!",
            "INVOICE打印机": "Invoice printer",
            "已审核数据，无法撤销账单！": "The data is reviewed and the bill cannot be revoked!",
            "请勾选至少一行\"待审核\"数据": "Please check at least one row of \"pending review\" data",
            "寄件地址3": "Shipper address 3",
            "取消审核": "Cancel the review",
            "寄件地址2": "Shipper address 2",
            "没有找到打印配置": "Did not find a print configuration",
            "英文品名1": "English name 1",
            "打印": "Print",
            "英文品名2": "English name 2",
            "英文品名3": "English name 3",
            "寄件地址1": "Shipper address 1",
            "导出": "Export",
            "打单子单信息": "Skill single information",
            "备份联打印机": "Backup joint printer",
            "取消": "Cancel",
            "请先配置INVOICE输出方式": "Please configure the Invoice output method",
            "收件邮箱": "Consignee Email",
            "取消打单数据异常": "Cancel the order data exception",
            "请勾选至少一行非\"待转单\"数据": "Please check at least one line of data other than \"to be transferred\"",
            "打单状态不为“待审核”，不允许取消重打": "The bill status is not ”to be reviewed”, and it is not allowed to be canceled.",
            "取消重打异常！": "Cancel the heavy exception!",
            "打单查询": "Order inquiry",
            "运单号码": "Order Number",
            "查询": "Search",
            "税金方式": "Tax method",
            "收件邮编": "Consignee Postcode",
            "单件补打": "Single piece",
            "取消打单": "Cancel the order",
            "获取子单信息失败！": "Get sub-information failed!",
            "打单状态不为待转单或待审核，无法进行取消！": "The order status is not to be turned or canceled!",
            "请选择需要": "Please select",
            "重量": "Weight",
            "打印状态": "Print Status",
            "申报价值": "Declared value",
            "子单信息": "Subform information",
            "收件公司": "Consignee company",
            "单票": "Single ticket",
            "撤销账单成功！": "Removing the bills!",
            "转重打": "Turnover",
            "收件人": "Consignee",
            "寄件城市": "City",
            "确定要取消该打单数据吗？": "Be sure to cancel the order data?",
            "关闭": "Closure",
            "此操作将进行数据审核, 是否继续?": "This will perform a data review, is there any?",
            "收件地址1": "Receive address 1",
            "没有获取到子单数据": "No sub-data",
            "_LABEL打印机": "_Label printer",
            "收件地址3": "Receive address 3",
            "寄件公司": "Shipper company",
            "收件地址2": "Receive address 2",
            "请选择一行数据": "Please select a row of data",
            "打单状态为待转单才可": "The order status is to be turned to",
            "没有获取到label 地址": "Did not get the Label address",
            "参考编号": "Ref number",
            "确定": "OK",
            "收件电话": "Consignee phone",
            "货物类型": "Cargo type",
            "中文品名": "Description CN",
            "取消重打成功！": "Cancel the success!",
            "取消审核异常": "Canceled audits"
        },
        "OMS007": {
            "路由变更":"Route variation",
            "重复扫描":"Duplicate scan",
            "出口清关开始":"Export customs clearance start",
            "出口清关扣查":"Export customs clearance on hold",
            "出口清关扣件不放行":"Export customs clearance not release",
            "末端退货移交给海外仓":"Lastmile Return Handover WH",
            "出口后退返客户":"Return To Shipper After Export",
            "已二次转寄":"Return warehouse outbound",
            "定为违禁品":"Prohibited",
            "IOSS Number": "IOSS No.",
            "末端退货移交海外仓":"Lastmile return handovered to warehouse",
            "状态": "Status",
            "原产地": "country of origin",
            "我是标题": "I am the title",
            "printScene:INVOICE打印机": "Printscene: Invoice Printer",
            "总价": "Total price",
            "材积除以数": "Volume divided by number",
            "文件名": "File name",
            "费用合计": "Total fee",
            "寄件区县": "Sending district",
            "最新轨迹": "Latest status",
            "获取文件路径异常": "Get file path exception",
            "没有文件可以下载": "No file to download",
            "操作": "Operation",
            "处理人": "Handler",
            "包装项目": "Packaging items",
            "已入库": "Warehouse Scan In",
            "汇率": "Exchange rate",
            "已退返": "Returned",
            "寄件税号": "Shipping tax number",
            "邮编": "Postcode",
            "打单前请设置好LABEL打印机": "Please set a good label printer before gum.",
            "币别": "Currency",
            "交货到末公里": "Handover to Lastmile",
            "转寄原单号": "Original number",
            "订单已支付":"Shipping Fee Paid",
            "货物状态": "Cargo Status",
            "单价": "Unit price",
            "数量": "Quantity",
            "收件州省": "Consignee province",
            "相关文件": "Related documents",
            "本币": "Currency",
            "发送": "Send",
            "格式": "Format",
            "未选则数据，请重新选择": "Unparalleled data, please re-select",
            "转单号码": "Tracking number",
            "出货": "Handover to Linehaul",
            "交货给干线代理":"Linehaul pickup",
            "打单前请设置好INVOICE打印机": "Please set a good Invoice printer before gum.",
            "可添加附件": "Can add attachments",
            "寄件日期不能为空": "Inbound time cannot be empty",
            "材重": "Volume weight",
            "报关方式": "Declaration method",
            "下载转单文件": "Download transfer order file",
            "请输入": "please input",
            "请至少选择一行数据！": "Please choose at least one line of data!",
            "航班起飞": "Freight ATD",
            "收件邮箱": "Consignee Email",
            "海关编码": "HS code",
            "新建问题": "New question",
            "运单轨迹显示": "Shipment order track display",
            "全部": "All",
            "参考": "Refer to",
            "查询": "Search",
            "只支持PDF下载": "Only support PDF download",
            "货物状态时间": "Cargo Status",
            "收费材重": "Charge volume weight",
            "该问题件没有图片！": "There is no picture for this problem!",
            "到付款": "COD amount",
            "轨迹信息": "Trajectory information",
            "个问题件": "Problem",
            "包裹损坏": "Damage",
            "添加附件": "Add attachments",
            "除以数": "Divide by number",
            "时间": "Time",
            "已出货": "Warehouse Outbound",
            "最新轨迹位置": "Latest status location",
            "一次导出单号数量不能超过3000": "The number of export numbers cannot exceed 3000",
            "运费合计": "Total freight",
            "模糊": "Blurry",
            "末端转运中": "Lastmile in transit",
            "其它": "Other",
            "退件号码": "Iroll number",
            "备注": "Remark",
            "退回海外仓": "Lastmile Return",
            "printScene:EDI_LABEL打印机": "PRINTSCENE: EDI_Label Printer",
            "待转单": "Pending transfer",
            "包裹到达自提点": "The parcel in pickup point already",
            "下载": "Download",
            "高": "Height",
            "没有获取到下载地址！": "Did not get the download address!",
            "预报重量": "Pre-alert weight",
            "双击行查看详情": "Double Click for Details",
            "printScene:备份联打印机": "PRINTSCENE: Backup joint printer",
            "目的地编码": "Country Code",
            "欠费锁机": "Arrears lock machine",
            "最新状态": "Latest status",
            "收费重": "Charge weight",
            "派送异常": "Exception",
            "当前转单Lable格式为EPL2，限制预览": "The current transfolio Lable format is EPL2, restriction preview",
            "收件电话": "Consignee phone",
            "材重合计": "Total material weight",
            "问题信息": "Problem information",
            "运单状态": "Status",
            "中文品名": "Description CN",
            "未找到发货记录，请重新查询": "The shipment order was not found, please check again",
            "金额": "Amount",
            "省": "Province",
            "寄件邮箱": "Shipper Email",
            "航班抵达": "Freight ATA",
            "入口清关站已通知提货":"Cargo ready at terminal",
            "中程起運":"Middlemile Uplift",
            "中程转运中":"Middlemile InTransit",
            "中程抵达":"Middlemile Arrived",
            "尾程退貨-轉運中":"Lastmile Return In Transit",
            "登记成功！": "Registration is successful!",
            "收件人拒收": "Rejected",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "收件税号": "Receiving tax number",
            "可多选": "Multiple choice",
            "实重合计": "Total actual weight",
            "创建人": "Creator",
            "寄件时间": "Inbound At",
            "收费重合计": "Total charge",
            "包装费合计": "Total Packaging fee",
            "包装类型": "Packing type",
            "类别": "Goods",
            "附件": "Attachments",
            "请选择数据": "Please select data",
            "微软雅黑 Regular": "Microsoft Yaishi Regular",
            "打单前请设置好备份联打印机": "Please set the backup joint printer before gum.",
            "在此回复处理问题件": "Reply here to deal with the problem",
            "公式": "formula",
            "付款方式": "Payment method",
            "退返客户": "Return the customer",
            "包裹丢失": "Lost",
            "基本信息": "Basic info",
            "第": "NS",
            "指定路线分类": "Route",
            "件数": "Pieces",
            "包装说明": "Package instruction",
            "登记异常": "Abnormal registration",
            "收件人信息": "Consignee Info",
            "收件城市": "Consignee City",
            "问题单号": "Question single number",
            "出口清关成功": "Export Custom Cleared",
            "序号": "No.",
            "该运单无单件信息，无法下载": "The waybill is not single piece, can't download",
            "二次转寄上架": "Return Warehouse Putaway",
            "海外仓移出":"Moved Out Return-Warehouse",
            "退回海外仓中": "Lastmile returning to warehouse",
            "返回末端退货仓库":"LastmileReturnDatetime",
            "单号": "Number",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "重置": "Reset",
            "目的地": "Destination",
            "请选择货物状态": "Please select the package status",
            "下载单件信息": "Download single piece information",
            "寄件国家": "Consigner Country",
            "偏远": "Remote",
            "收件区县": "Consignee District",
            "发生时间": "Time of occurrence",
            "导出": "Export",
            "最新轨迹状态": "Latest track status",
            "费用科目": "Expense Account",
            "转单": "Turnover",
            "入口清关成功": "Successful import clearance",
            "首次派送": "First Delivery Attempt",
            "首次派送失败":"FirstDeliveryFailedDatetime",
            "二次派送":"LastmileSecondDeliveryDatetime",
            "二次派送失败":"LM Second Delivery Attempt Failed",
            "再次派送":"OutDeliveryDatetime",
            "再次派送失败":"OutDeliveryFailedDatetime",
            "基础信息": "Basic Info",
            "长": "Length",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "税金付款": "Tax payment",
            "包裹销毁": "Scrapped",
            "网点": "Warehouse",
            "问题状态": "Problem status",
            "问题件": "Abnormal package",
            "费用结算": "Fee settlement",
            "运单号码": "Order No.",
            "包装费": "Packaging fee",
            "运单": "Waybill",
            "收件邮编": "Consignee Postcode",
            "已签收": "Delivered",
            "问题描述": "Problem Description",
            "该运单无Invoice，无法下载": "This will not be downloaded without INVOICE.",
            "品牌": "Brand",
            "COD金额": "COD Amount",
            "收件地址": "Consignee Address",
            "发货记录": "Shipment order management",
            "寄件地址": "Shipper address",
            "金额(本币)": "Amount (local currency)",
            "寄件邮编": "Postcode",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "包裹到达分拣中心": "Lastmile received",
            "离开分拣仓": "Lastmile Dispatched",
            "到达派件站点": "Arrive Local Courier Facilities",
            "跟踪记录": "Track record",
            "申报价值": "Declared Value",
            "订单成功上传": "Order successfully uploaded",
            "收件公司": "Consignee company",
            "单件信息": "Single piece information",
            "宽": "Width",
            "收件人": "Consignee",
            "待出货": "Pending ship",
            "位置": "Location",
            "寄件城市": "City",
            "寄件人信息": "Shipper",
            "代收款": "Agency fund",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "实重": "Actual weight",
            "计抛方式": "Charge weight rule",
            "目的地信息": "Destination information",
            "收费实重": "Charge Actual weight",
            "文件正在下载，请稍等！！！": "The file is downloading, please wait! ! !",
            "货物类型": "Cargo type",
            "处理时间": "Processing time",
            "关包": "Warehouse Scan Out",
            "创建时间": "Create time",
            "预报袋号": "Pre-alert bag number",
            "城市": "City",
            "客户(可多选)":"Customer (Multiple Selection) ",
            "客户":'Customer',
            '入口清关收货':'Import CC Received',
            '入口清关开始清关':'Import CC Start',
            '入口清关扣件不放行':'Import CC On Hold',
            '入口清关解除扣查':'Import CC Released',
            "入口清关扣查": 'Import clearance onhold',
            '入口清关重新装箱':'Import CC Repacking',
            '入口清关准备移交':'Import CC Prepare for Handover',
            '入口清关移交卡车':'Import CC Handover to Truck',
            '退件派送服务-已揽收':'Return-Collected by Courier',
            '退件派送服务-分拣仓入库':'Return-Warehouse Inbound',
            '退件派送服务-分拣仓出库':'Return-Warehouse Outbound',
            '退件派送服务-移交':'Return-Handover',
            '预报件数':'Number of pre-alert',
            '实收件数':'Number of received',

        },
        "OMS015": {
            "没有配置LABEL 输出方式": "Did not configure label output",
            "打印时间": "Timestamp",
            "扫描打印失败！": "Scan print failed!",
            "Invoice数量不能小于1": "The number of invoice cannot be less than 1",
            "printScene:接口打印": "PRINTSCENE: Interface printing",
            "接口打印": "Interface printing",
            "运单号码": "Order No.",
            "指定路线": "Channel Code",
            "printScene:自定义打印": "PRINTSCENE: Custom print",
            "没有配置INVOICE自定义模板": "No invoice custom template",
            "扫描单号不能为空": "Scanning single number cannot be empty",
            "收件邮编": "Consignee Postcode",
            "打印次数": "# of Prints",
            "没有获取到子单数据": "No sub-data",
            "没有配置LABEL自定义模板": "No configuration label custom template",
            "扫码打印为单票打印": "",
            "目的地": "Destination",
            "自定义打印": "Custom print",
            "包装类型": "Packing type",
            "没有获取到label 地址": "Did not get the Label address",
            "请仔细核对运单数据": "Please check the waybill data carefully",
            "参考编号": "Ref number",
            "转单号码": "Tracking number",
            "黑体 Regular": "Black body regular",
            "收费重": "Charge weight",
            "没有找到打印配置": "Did not find a print configuration",
            "打印": "Print Waybill",
            "件数": "Pieces",
            "货物类型": "Goods Type",
            "请输入": "Please Input",
            "扫描单号": "Scan Order Number to Print",
            "打单记录中不存在转单号，无法打印！": "There is no transfer number in the bill of record, you can't print!",
            "重置打印机": "Reset Printer"
        },
        "OMS009": {
            "体积(CBM)":"Volume(CBM)",
            "寄件邮编":"Sender Postcode",
            "寄件区县":"Sender District",
            "寄件城市":"Sender City",
            "寄件州省":"Sender Province",
            "汇总票数":"Summary votes",
            "月工作日平均票数": "Average daily order",
            "注意：":"Note: ",
            "更多条件":"More conditions ",
            "默认系统时间": "Default system time",
            "尾程": "Lastmile",
            "路线大类": "channel categories",
            "全部路线大类": "All routes",
            "名称": "Name",
            "附加费包括": "The surcharge includes",
            "路线分类": "channel classification",
            "指定路线": "Channel Code",
            "查询": "Quote",
            "报价生效日期": "Effective date of quotation",
            "收件邮编": "Consignee Postcode",
            "请选择目的地": "Please select a destination",
            "运费单价": "Freight unit price",
            "材积除以数": "Volume divided by number",
            "查询报价": "Inquiry for Quotation",
            "渠道发货要求和目的地国家的限制条件都会记录在备注中": "Channel delivery requirements and destination country restrictions will be recorded in the remarks",
            "包装类型": "Packing type",
            "总运费": "Total freight",
            "请选择包装类型": "Please select the Packing type",
            "下单": "Place an order",
            "安检费": "Security Check Fee",
            "本币金额合计": "Total amount in local currency",
            "温馨提示": "Tips",
            "科目名称": "Subject name",
            "公式": "formula",
            "其他费用明细": "Details of other expenses",
            "货物重量": "Package Weight",
            "业务类型": "Business type",
            "全部业务类型": "All business types",
            "时间": "Time",
            "件数": "Pieces",
            "起运地": "Departure",
            "指定路线编码": "Specify route code",
            "报价备注": "Quotation note",
            "防疫物资附加费等杂费": "Additional fees for epidemic prevention materials and other miscellaneous expenses",
            "请输入货物重量": "Please enter the weight of the goods",
            "宽": "Width",
            "收件城市": "Consignee City",
            "币别": "Currency",
            "序号": "No.",
            "旺季附加费": "Peak season surcharge",
            "停用时间": "Deactivate time",
            "单价": "Unit price",
            "关闭": "Closure",
            "重置": "Reset",
            "参考时效": "Reference aging",
            "计算公式的计算结果": "Calculation result",
            "收件州省": "Consignee province",
            "目的地": "Destination",
            "高": "Height",
            "本币金额": "Amount in local currency",
            "本币": "Currency",
            "头程": "Linehaul",
            "原币运费": "Original currency shipping",
            "附加费用明细": "Surcharge details",
            "附加费": "Surcharge",
            "计算公式(头程+尾程)": "Calculation formula (head stroke + tail stroke)",
            "生效日期": "Effective date",
            "收费重": "Charge weight",
            "具体发货前请仔细查看备注": "Please check the remarks carefully before delivery",
            "头程运费": "linehaul freight",
            "费用项": "Expense item",
            "报价分段": "Quotation segmentation",
            "计算公式": "Calculate formula",
            "报价备注说明": "Quotation note description",
            "请选择起运地": "Please select the origin",
            "总费用": "Total cost",
            "应收客服费等杂费": "Receivable customer service fees and other miscellaneous fees",
            "收件区县": "Consignee District",
            "货物类型": "Cargo type",
            "请输入货物类型": "Please enter the Cargo type",
            "运费": "Freight",
            "尾程运费": "Lastmile freight",
            "禁运货物类型": "Cargo type of prohibited goods",
            "金额": "Amount",
            "长": "Length",
            "附加费包括：安检费、应收客服费等杂费":"Surcharge: Security inspection fee,service fee,other fee",
            "计算公式的计算结果 = 原币运费":"Calculation result = Original currency shipping",
            "单价 = 总运费 / 收费重":"Unit price = Total cost/ Charge weight",
            "总费用 = 头程运费 +  尾程运费 + 附加费":"Total cost = linehaul fee + Lastmile fee + Surcharge",
            "完整查价": "Complete price inquiry",
            "快速查价": "Quickly query prices",
            "体积": "Volume",

        },
        "BMS011": {
            "机场代码": "Airport code",
            "请输入收费重": "Please enter Charge weight",
            "显示所在国家的所有偏远邮编": "Display all remote zip code in the country",
            "终止邮编": "Termination",
            "如输入邮编": "Enter a zip code",
            "非偏远": "Non-remote",
            "含燃油": "Containing fuel",
            "匹配规则": "Matching rule",
            "指定路线": "Channel Code",
            "查询": "Search",
            "收件邮编": "Consignee Postcode",
            "请选择目的地": "Please select a destination",
            "偏远邮编范围为": "Remote zip code",
            "其次匹配城市": "Secondly match the city",
            "未查询到偏远信息!": "No remote information is available!",
            "可正常匹配": "Match normally",
            "包装类型": "Packing type",
            "如输入城市为": "If you enter the city",
            "机场代码查询": "Airport code query",
            "开始邮编": "Start a postal code",
            "收件邮编与收件城市二者必填其一": "Receipt Zip Code and the receiving city must be filled",
            "请选择包装类型": "Please select the Packing type",
            "操作中心": "Operating center",
            "可匹配": "Match",
            "请输入收件邮编或者收件国家": "Please enter the recipient or recipient country",
            "邮编类型": "Zip code type",
            "不能匹配": "Cannot match",
            "重量": "Weight",
            "城市都为空时": "When the city is empty",
            "标准邮编数据": "Standard postal data",
            "支持子邮编匹配": "Support sub-zip matching",
            "邮编": "Post code",
            "以下查询结果为": "The result of the following query is",
            "偏远费查询": "Remote fee query",
            "州省编号": "State number",
            "收件城市": "Consignee city",
            "显示所在国家的所有邮编": "Display all postal code in the country",
            "输入邮编前几位在偏远邮编范围内时": "When entering a postal code, the first few in the remote zip code range",
            "支持城市右模糊匹配": "Support urban right blur match",
            "单价": "Unit price",
            "国家编号": "National number",
            "输入邮编前几位在邮编范围内时": "When entering a postal code, several in the zip code range",
            "查询结果": "Search result",
            "如输入邮编为": "If the input is called",
            "偏远城市为": "Remote city",
            "重置": "Reset",
            "偏远费": "Remote expense",
            "国家": "Nation",
            "目的地": "Destination ",
            "最高价格": "Highest price",
            "请选择指定路线": "Please select Channel Code",
            "偏远查询": "Remote query",
            "收费重": "Charge weight",
            "偏远": "Remote",
            "国家简码": "National state",
            "州省": "Province / State",
            "邮编范围为": "Zip code",
            "邮编查询": "Zip code query",
            "计算公式": "Calculate formula",
            "优先邮编匹配": "Priority zip match",
            "起始邮编": "Starting postal",
            "州/省": "Province / State",
            "如输入邮编和城市都为空时": "If you enter zip code and city are empty",
            "时": "Time",
            "最低价格": "The lowest price",
            "城市": "City"
        },
        "OMS011": {
            "扫码确认支付后": "Scan code confirmation",
            "模式": "Model",
            "已审余额": "Repeated balance",
            "状态": "Status",
            "二维码产生异常！！！": "QR code produces an abnormal! ! !",
            "微信支付": "WeChat payment",
            "立即充值": "Recharge immediately",
            "支付方式": "Payment method",
            "审核时间": "Review time",
            "微信扫码支付": "WeChat scan code payment",
            "查询": "Search",
            "尝试重连：第几次": "Try to re-connect: the first few times",
            "收款备注": "Collection note",
            "账单备注": "Bill note",
            "请等待页面跳转": "Please wait for page jump",
            "业务日期": "Business dates",
            "温馨提示": "Tips",
            "当前余额": "Current balance",
            "请选择审核时间！": "Please select the review time!",
            "支付宝": "Alipay",
            "正常": "Normal",
            "已锁机": "Lockup",
            "发生金额": "Amount",
            "2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。": "2. After the recharge is successful, the system balance is automatically increased. If the balance of the system is sufficient, it can be shipped normally.",
            "接到了": "Receiving",
            "币别": "Currency",
            ",支付金额：￥": ", Payment amount: ¥",
            "收款": "Collect money",
            "温馨提示：": "Tips:",
            "金额小于0": "The amount is less than 0",
            "可用余额": "Available Balance",
            "待审收款": "Test payment",
            "3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。": "3. If the recharge exception (such as the deduction, the system balance has not increased), please contact the company's finance.",
            "客户余额明细": "Customer balance",
            "到账金额": "Payment amount",
            "本期金额": "Current Amount",
            "所有币别": "All currency",
            "重连失败": "Reinforcement failure",
            "重连成功，重新发起心跳，并登录websocked": "Replay success, reactivate heartbeat, and log in to WebSocked",
            "支付成功": "Payment successful",
            "1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。": "1. Recharge the charge (minimum 3 yuan), the single recharge amount must not be less than 3 yuan. The handling fee is automatically deducted after the recharge is successful.",
            "余额": "Balance",
            "付款": "Payment",
            "充值金额": "Recharge amount",
            "账单号码": "Bill number",
            "导出": "Export",
            "当前只支持人民币": "Currently only supports RMB",
            "手续费": "Fee",
            "支付宝扫码支付": "Alipay scan code payment",
            "待审金额": "Preceding amount",
            "账单": "Bill",
            "上期余额": "The balance of"
        },
        "OMS0111": {
            "寄件日期": "Inbound Date",
            "币别": "Currency",
            "转本币金额": "Turn the money",
            "请选择日期": "Please select a date",
            "全部": "All",
            "结算状态": "Settlement status",
            "运单号码": "Order Number",
            "汇率": "Exchange rate",
            "待审帐单明细": "Waiting for the account",
            "待审核": "Be taken",
            "查询": "Search",
            "科目": "Suject",
            "待审收款": "Test payment",
            "已生成帐单未审核": "The bill has not been reviewed",
            "日期": "Date",
            "发生日期": "Date",
            "可结算": "Settled calculated",
            "待审金额": "Preceding amount",
            "未生成帐单": "Not generated bill",
            "金额": "Amount"
        },
        "OMS016": {
            "币别": "Currency",
            "寄件日期三天后为补收费用": "The delivery date is three days after the date",
            "账单明细": "Billing Details",
            "备注": "Remark",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "查询": "Search",
            "切换纵向账单": "Switch portrait bill",
            "重置": "Reset",
            "目的地": "Destination ",
            "帐单日期": "Bill date",
            "只查补收费用": "Only check the charge",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "补收": "Make up",
            "实重": "Actual weight",
            "账单日期": "Bill date",
            "转单号码": "Tracking Number",
            "收费重": "Charge weight",
            "目的地信息": "Destination information",
            "科目名称": "Subject name",
            "帐单号码": "Bill number",
            "计算公式": "Calculate formula",
            "未找到对应的账单格式，请联系管理员": "No founded bill format, please contact the administrator",
            "客户账单": "Customer bill",
            "其他费用": "Other fee",
            "材重": "Volume weight",
            "切换横向账单": "Switch horizontal bill",
            "件数": "Pieces",
            "货物类型": "Cargo type",
            "导出账单": "Export bill",
            "运费": "Freight",
            "应收费用": "Charge",
            "请选择单条数据进行查看": "Please select a single data to view",
            "金额": "Amount",
            "单票合计": "Single ticket",
            "收件人": "Consignee"
        },
        "OMS012": {
            "扫码确认支付后": "Scan code confirmation",
            "二维码产生异常！！！": "QR code produces an abnormal! ! !",
            "微信支付": "WeChat payment",
            "支付方式": "Payment method",
            "微信扫码支付": "WeChat scan code payment",
            "查询": "Search",
            "尝试重连：第几次": "Try to re-connect: the first few times",
            "总金额": "Lump sum",
            "账单信息查询错误！": "Billing information query error!",
            "请等待页面跳转": "Please wait for page jump",
            "付款金额": "Payment amount",
            "温馨提示": "Tips",
            "账单已全部核销，无需支付": "The bill has been all verified, no payment",
            "未找到对应的账单格式，请联系管理员": "No founded bill format, please contact the administrator",
            "客户账单": "Customer bill",
            "总笔数": "Total number",
            "支付宝": "Alipay",
            "2.充值成功后，系统余额自动增加，如系统余额足够，可正常出货。": "2. After the recharge is successful, the system balance is automatically increased. If the balance of the system is sufficient, it can be shipped normally.",
            "接到了": "Receiving",
            "币别": "Currency",
            "请选择需要导出的账单数据！": "Please select the bill data you want to export!",
            ",支付金额：￥": ", Payment amount: ¥",
            "总件数": "Total number",
            "温馨提示：": "Tips:",
            "待付款金额": "Payment amount",
            "金额小于0": "The amount is less than 0",
            "重置": "Reset",
            "导出总账单": "Export general bill",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it later in the export list!",
            "3.如充值异常(如已扣款，系统余额未增加情况),请联系公司财务。": "3. If the recharge exception (such as the deduction, the system balance has not increased), please contact the company's finance.",
            "只支持人民币(CNY)的在线付款，其他币别自动忽略，是否继续": "Only online payment of RMB (CNY), other currencies are automatically ignored, do they continue",
            "确定": "OK",
            "创建导出任务失败:": "Create an export task failed:",
            "导出合并格式": "Export merge format",
            "账单日期": "Bill date",
            "总重量": "Gross weight",
            "提示": "Hint",
            "重连失败": "Reinforcement failure",
            "重连成功，重新发起心跳，并登录websocked": "Replay success, reactivate heartbeat, and log in to WebSocked",
            "支付成功": "Payment successful",
            "1.充值收取0.03%手续费(最低3元)，单次充值金额不得低于3元。手续费在充值成功后自动扣除。": "1. Recharge the charge (minimum 3 yuan), the single recharge amount must not be less than 3 yuan. The handling fee is automatically deducted after the recharge is successful.",
            "付款": "Payment",
            "账单号码": "Bill number",
            "未设置默认导出格式,请联系管理员": "If you do not set the default export format, please contact the administrator",
            "当前只支持人民币": "Currently only supports RMB",
            "手续费": "Fee",
            "导出账单": "Export bill",
            "取消": "Cancel",
            "账单付款": "Bill payment",
            "请至少选择一行数据！": "Please choose at least one line of data!",
            "请选择同一币别的帐单": "Please select the same currency.",
            "总票数": "Total ticket",
            "支付宝扫码支付": "Alipay scan code payment",
            "请选择单条数据进行查看": "Please select a single data to view"
        },
        "OMS0121": {
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "币别": "Currency",
            "创建导出任务失败:": "Create an export task failed:",
            "转单号码": "Tracking Number",
            "账单日期": "Bill date",
            "收费重": "Charge weight",
            "目的地信息": "Destination information",
            "科目名称": "Subject name",
            "公式": "formula",
            "备注": "Remark",
            "运单号码": "Order Number",
            "未找到对应的账单格式，请联系管理员": "No founded bill format, please contact the administrator",
            "客户账单": "Customer bill",
            "指定路线": "Channel Code",
            "件数": "Pieces",
            "账单号码": "Bill number",
            "账单数据异常！": "Billing data exception!",
            "导出账单": "Export bill",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it later in the export list!",
            "金额": "Amount"
        },
        "OMS0122": {
            "寄件日期": "Inbound Date",
            "币别": "Currency",
            "目的地编码": "Destination code",
            "账单日期": "Bill date",
            "收费重": "Charge weight",
            "科目名称": "Subject name",
            "包装": "Package",
            "备注": "Remark",
            "指定路线": "Channel Code",
            "账单号码": "Bill number",
            "目的地": "Destination ",
            "包号": "Package number",
            "金额": "Amount"
        },
        "apiauth": {
            "等各大电商": "And other major e-commerce",
            "订单预报推送": "Order forecast push",
            "各类特殊校验接口": "Various special calibration interfaces",
            "大快递打单": "Big express order",
            "对接": "Dock",
            "当前未授权": "Not currently authorized",
            "授权成功！": "Authorization succeeded!",
            "应用场景": "Application scenario",
            "启用订单授权与启用打单授权必勾其一": "Enabling order authorization and enabling order authorization must be checked",
            "自有系统对接": "Own system docking",
            "订单授权": "Order authorization",
            "密钥": "Key",
            "含特殊业务": "Including special services",
            "即时获取转单及": "Instantly get transfer orders and",
            "如马帮": "Caravan",
            "通途": "Thoroughfare",
            "打单授权": "Order authorization",
            "店小蜜": "Shop Xiaomi",
            "帐号": "Account number",
            "当前已授权": "Current authorization",
            "交易助手": "Trading assistant",
            "芒果店长": "Mango Store Manager",
            "电商小包订单即时获取转单": "E-commerce small package orders get transfer orders instantly",
            "获取授权信息": "Obtain authorization information",
            "速猫": "Speed ​​cat",
            "电商": "E-commerce"
        },
        "authorization": {
            "会显示授权成功": "Will display authorization success",
            "结束时间不能为空": "End time cannot be empty",
            "获取授权时": "Get an authorization",
            "填写店铺昵称和授权码": "Fill in the store nickname and authorization code",
            "全部": "All",
            "您真的要停用当前店铺<": "You really have to disable the current store <",
            "寄件人信息用于": "Shipping information",
            "保存": "Keep",
            "省份": "Province",
            "前往授权": "Go to authorization",
            "查询授权信息异常": "Query authorization information exception",
            "新增Edi异常": "New EDI exception",
            "地址": "Address",
            "结束时间": "End Time",
            "自动下载": "Automatic download",
            "按单号下载": "Press single number",
            "失效时间": "Failure time",
            "授权码": "Authorization code",
            "修改授权成功": "Modify authorization success",
            "注意": "Notice",
            ">吗？": ">?",
            "个订单": "Order",
            "同步订单异常": "Synchronous order abnormal",
            "禁止填写中文或特殊字符": "Forbidden to fill in Chinese or special characters",
            "重新授权": "Re-authorize",
            "上次下载时间": "Last download time",
            "按时间下载": "Time download",
            "新增敦煌网授权": "Add Dunhuang Network Authorization",
            "平台类型": "Platform type",
            "在授权页面": "In the authorization page",
            "同步订单成功": "Synchronous order is successful",
            "单号不能为空": "Single number can't be empty",
            "授权": "Authorize",
            "店铺昵称禁止填写中文": "Store nickname prohibits filling in Chinese",
            "邮编": "Post code",
            "新增授权": "Add a new authorization",
            "授权异常": "Authorized abnormal",
            "修改启用状态异常": "Modifying is enabled",
            "开始时间": "Starting time",
            "速卖通": "AliExpress",
            "查询API列表异常": "Query API list exception",
            "仅对速卖通订单生效": "Effect only for AliExpress orders",
            "公司名称": "Company Name",
            "电话": "Telephone",
            "停用": "Deactivate",
            "按钮": "Button",
            "拉取方式": "Draw",
            "开始时间不能为空": "Start time can't be empty",
            "修改授权异常": "Modify authorization exception",
            "多个用回车隔开": "Multiple carriageway",
            "人工下载": "Artificial download",
            "关闭": "Closure",
            "启用": "Enable status",
            "同步订单": "Synchronous order",
            "官方指定买家授权网址": "Official designated buyers authorized Website",
            "不支持的平台": "Not supported platform",
            "请填写店铺昵称": "Please fill in the store nickname",
            "跳转打开成功！": "Jump is open!",
            "修改授权": "Modify authorization",
            "电商平台": "Electronic business platform",
            "下载订单": "Download orders",
            "最多支持": "Maximum support",
            "请输入订单号码": "Please enter the ref number",
            "新增": "Add new",
            "确定": "OK",
            "授权信息": "Authorization information",
            "店铺昵称": "Shop nickname",
            "修改敦煌网授权": "Modify Dunhuang Network Authorization",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "稍等片刻": "Wait a moment",
            "下载方式": "Download method",
            "允许访问": "Access",
            "获取授权时间": "Get an authorization time",
            "点击": "Click",
            "已向服务器发送下载请求，请点击确定并耐心等待3-5分钟！下载的订单会放入草稿订单中,请前往草稿订单查看！": "The download request has been sent to the server, please click OK and wait patiently for 3-5 minutes! Download orders will be placed in a draft order, please visit the draft order!",
            "打印": "Print",
            "联络人姓名": "Contact",
            "已停用，无法进行下载": "Disabled, unable to download",
            "设置寄件人信息": "Set the Shipping information",
            "授权时间": "Authorization time",
            "请输入": "please input",
            "取消": "Cancel",
            "只有速卖通才可以进行单号下载": "Only speed of selling can be downloaded",
            "您真的要启用当前店铺<": "You really want to enable the current store <",
            "下载订单异常": "Download orders",
            "城市": "City",
            ">吗？（店铺停用后，将不会自动下载订单，但会继续回传单号）": ">? (After the store is deactivated, the order will not be automatically downloaded, but will continue to return to the pass number)",
            "将访问": "Be accessed"
        },
        "downloadthelog": {
            "正在保存": "Saving",
            "保存异常": "Preventive exception",
            "未知异常": "Unknown exception",
            "创建任务": "Create tasks",
            "状态": "Status",
            "保存订单数": "Number of saved orders",
            "正在接收报文": "Receiving message",
            "下载方式": "Download method",
            "解析完成时间": "Analytical completion time",
            "下载备注": "Download notes",
            "解析订单数": "Analyze the number of orders",
            "解析报文异常": "Parsing message exception",
            "人工下载": "Manual download",
            "解析完成": "Parsing completed",
            "保存完成": "Saved",
            "保存完成时间": "Save time",
            "创建时间": "Create time",
            "订单数据条件": "Order data condition",
            "接收完成时间": "Receive completion time",
            "结束时间": "End Time",
            "正在解析报文": "Parsing message",
            "接收报文异常": "Received message is abnormal",
            "自动下载": "Automatic download"
        },
        "OMS017": {
            "确定要删除吗？": "You sure you want to delete it?",
            "修改": "Modify",
            "联系人": "Contact",
            "全部": "All",
            "指定路线": "Channel Code",
            "已取消": "Cancelled",
            "保存": "Keep",
            "联系电话": "Contact number",
            "修改异常": "Modified exception",
            "新增取件信息": "Added information",
            "申请日期": "Date of Application",
            "请先完善基础信息！": "Please improve the basic information first!",
            "取件公司": "Pick-up company",
            "预约取件时间": "Appointment pickup time",
            "申请": "Apply",
            "修改取件信息": "Modify pick-up information",
            "删除成功！": "Successfully deleted!",
            "删除异常": "Delete exception",
            "重量": "Weight",
            "货物信息": "Package Info",
            "件数": "Pieces",
            "司机电话": "Driver phone",
            "状态为‘已取件’或者‘已取消’的数据不允许修改": "The status is the 'has been takenwer' or 'cancel' data is not allowed to modify",
            "已取件": "Take part",
            "取件状态": "Pickup state",
            "车牌号": "Number plate",
            "修改成功！": "Successfully modified!",
            "取件地址": "Pickup address",
            "注意事项": "Precautions",
            "司机": "Driver",
            "请选择取件状态为’待取件‘的数据": "Please select the data of the pickup status to 'standing'",
            "关闭": "Closure",
            "销售员": "Seller",
            "待取件": "Tolerance",
            "取件申请": "Apply for pickup",
            "预约备注": "Appointment note",
            "请选择一行数据": "Please select a row of data",
            "背景色设置": "Background color set",
            "跟单员": "Follower",
            "相等": "Equal",
            "客户信息": "Customer Information",
            "确定": "OK",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "每行高亮": "Each line is high",
            "任务单号": "Mission number",
            "添加成功！": "Added successfully!",
            "报关方式": "Declaration method",
            "导出": "Export",
            "体积": "Volume",
            "请输入": "please input",
            "取消": "Cancel",
            "添加异常": "Adding anomalies"
        },
        "outtrack": {
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "地点": "Location",
            "转单号码": "Tracking Number",
            "轨迹信息": "Trajectory information",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "参考编码": "Reference code",
            "追踪结果": "Track results",
            "查询单号必填": "Enquiry number is required",
            "查询": "Search",
            "时间": "Time",
            "跟踪记录": "Track record",
            "目的地": "Destination ",
            "清空": "Clear",
            "无此单号<": "No such tracking number<",
            "订单信息": "Order information",
            "页面地址有误": "The page address is wrong"
        },
        "OMS0081": {
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "点击上传附件": "Click to upload attachment",
            "问题状态": "Problem status",
            "登记人": "Register person",
            "返回列表": "Back to list",
            "运单号码": "Order Number",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "指定路线": "Channel Code",
            "沟通记录": "Communication record",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "目的地": "Destination ",
            "问题描述": "Problem Description",
            "处理记录": "Processing records",
            "订单信息": "Order information",
            "包装类型": "Packing type",
            "寄件日期": "Inbound Date",
            "附件": "Attachments",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "参考编号": "Ref number",
            "只允许上传一个附件": "Only allow one attachment to be uploaded",
            "处理意见": "Handling opinions",
            "回复": "Reply",
            "登记时间": "Check-in time",
            "转单号码": "Tracking Number",
            "大小不能超过": "Size can't exceed",
            "问题类型": "Question type",
            "附件格式为": "The attachment format is",
            "件数": "Pieces",
            "回复异常": "Reply exception",
            "货物类型": "Cargo type",
            "问题信息": "Problem information",
            "请输入": "please input"
        },
        "OMS0071": {
            "省": "Province",
            "税金付款": "Tax payment",
            "海关编码": "HS code",
            "净重": "Net weight",
            "寄件信息": "Shipping information",
            "费用结算": "Fee settlement",
            "原产地": "country of origin",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "包装费": "Packaging fee",
            "收件邮编": "Consignee Postcode",
            "寄件电话": "Shipper phone",
            "总价": "Total price",
            "收件信息": "Receiving information",
            "包装类型": "Packing type",
            "操作": "Operation",
            "信息": "Information",
            "包装项目": "Packaging items",
            "收件地址": "Consignee Address",
            "到付款": "COD amount",
            "寄件地址": "Shipper address",
            "付款方式": "Payment method",
            "寄件人": "Shipper",
            "注意": "Notice",
            "基本信息": "Basic info",
            "寄件邮编": "Postal code",
            "收件统编": "Collector",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "除以数": "Divide by number",
            "件数": "Pieces",
            "申报价值": "Declared value",
            "包装说明": "Package instruction",
            "收件公司": "Consignee company",
            "单票计抛规则": "Pkg charge weight rule",
            "单件信息": "Single piece information",
            "宽": "Width",
            "收件人": "Consignee",
            "收件城市": "Consignee city",
            "币别": "Currency",
            "序号": "No.",
            "单价": "Unit price",
            "备注": "Remark",
            "寄件城市": "City",
            "该运单无单件信息": "The waybill has no single piece information",
            "删除": "Delete",
            "关闭": "Closure",
            "运单信息": "Welcome information",
            "数量": "Quantity",
            "目的地": "Destination ",
            "寄件公司": "Shipper company",
            "高": "Height",
            "收件州": "Consignee Province",
            "代收款": "Agency fund",
            "毛重": "Gross weight",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "寄件国家": "Consigner Country",
            "实重": "Actual weight",
            "单票进位规则": "Pkg carry rule",
            "收费重": "Charge weight",
            "收件国家": "Recipient country",
            "材重": "Volume weight",
            "收件电话": "Consignee phone",
            "报关方式": "Declaration method",
            "单件进位规则": "Pcs carry rule",
            "货物类型": "Cargo type",
            "导出": "Export",
            "中文品名": "Description CN",
            "以下录入的都为单件信息": "The following entries are all single pieces of information",
            "长": "Length"
        },
        "OMS0181": {
            "历史日志": "Historical log",
            "成功": "Success",
            "运单修改成功": "Ways to modify success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import files cannot exceed 10MB",
            "文件大小不超过": "File size does not exceed",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "导入时": "Introduction",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select the import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "请确认导入模板中表头的完整性": "Please confirm the integrity of the header in the import template",
            "导入历史日志": "Import history log",
            "总行数": "Total",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "模版下载": "Template download",
            "导入文件格式支持": "Import file format support",
            "订单导入修改标准模版": "Order import modification standard template",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "please input",
            "文件下载": "File download",
            "上传中": "Uploading",
            "行号": "Line number",
            "错误行数": "Error number",
            "导入模版": "Import template",
            "新增模板": "New template"
        },
        "OMS0041": {
            "省": "Province",
            "税金付款": "Tax payment",
            "海关编码": "HS code",
            "净重": "Net weight",
            "寄件信息": "Shipping information",
            "“总价”列内容格式不正确，限制导入！": "The ”total price” column is incorrect, limited to import!",
            "费用结算": "Fee settlement",
            "请选择代收币别!": "Please select the collection currency!",
            "原产地": "country of origin",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "保存": "Keep",
            "收件邮编": "Consignee Postcode",
            "寄件电话": "Shipper phone",
            "订单列表修改-Invoice导入模版": "Order list modify -Inotvoice import template",
            "上传成功！": "Uploaded successfully!",
            "总价": "Total price",
            "“单价”列内容格式不正确，限制导入！": "The ”unit price” column content is incorrect, limited to import!",
            "“净重”列内容格式不正确，限制导入！": "The ”net weight” column is not correct, restricted import!",
            "收件信息": "Receiving information",
            "包装类型": "Packing type",
            "操作": "Operation",
            "信息": "Information",
            "收件地址": "Consignee Address",
            "到付款": "COD amount",
            "寄件地址": "Shipper address",
            "导入模板": "Import template",
            "付款方式": "Payment method",
            "寄件人": "Shipper",
            "基本信息": "Basic info",
            "寄件邮编": "Postal code",
            "“毛重”列内容格式不正确，限制导入！": "”Gross” column is not correct, restricted import!",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "件数": "Pieces",
            "申报价值": "Declared value",
            "收件公司": "Consignee company",
            "修改成功！": "Successfully modified!",
            "收件人": "Consignee",
            "收件城市": "Consignee city",
            "文件格式不正确，请上传正确的Excel文件": "The file format is incorrect, please upload the correct Excel file",
            "单价": "Unit price",
            "第一步": "First step",
            "备注": "Remark",
            "寄件城市": "City",
            "删除": "Delete",
            "文件内容为空或格式不正确，请下载模版并填写导入内容！": "The file content is empty or the format is incorrect, please download the template and fill in the import content!",
            "运单号码<": "Welcome number <",
            "数量": "Quantity",
            "目的地": "Destination",
            "寄件公司": "Shipper company",
            "下载": "Download",
            "收件州": "Consignee Province",
            "第二步": "Second step",
            "代收款": "Agency fund",
            "毛重": "Gross weight",
            "上传": "Upload",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "寄件国家": "Consigner Country",
            "保存异常": "Save exception",
            "导入": "Import",
            "确定": "OK",
            "实重": "Actual weight",
            "提示": "Hint",
            "收费重": "Charge weight",
            "请选择到付币别!": "Please choose to pay the currency!",
            "请上传附件！": "Please upload an attachment!",
            "收件国家": "Recipient country",
            ">不为待审核，限制修改!": "> Do not be reviewed, restricted modifications!",
            "材重": "Volume weight",
            "收件电话": "Consignee phone",
            "报关方式": "Declaration method",
            "“数量”列内容格式不正确，限制导入！": "”Quantity” column content is incorrect, restricted import!",
            "模板": "Template",
            "货物类型": "Cargo type",
            "请输入": "please input",
            "中文品名": "Description CN",
            "取消": "Cancel",
            "确定删除此行吗？": "Are you sure to delete this line?"
        },
        "OMS004": {
            "修改项目": "Modify project",
            "状态": "Status",
            "净重": "Net weight",
            "确定要审核选中订单吗？": "Determine whether to review orders?",
            "原产地": "country of origin",
            "取消成功！": "Cancel success!",
            "我是标题": "I am title",
            "选择的订单中没有有效的PDF地址": "There is no valid PDF address in the selected order",
            "撤销审核成功！": "Revocation is successful!",
            "总价": "Total price",
            "材积除以数": "Volume divided by number",
            "文件名": "File name",
            "客户重量": "Customer weight",
            "操作": "Operation",
            "是否取消订单": "Whether to cancel an order",
            "收件人名": "Consignee name",
            "撤销审核异常": "Revoke audit abnormalities",
            "请至少选择一笔推送状态为推送成功的订单数据": "Please select at least one push state to push the order data of success.",
            "取消订单": "Cancel order",
            "订单已经打单，不可重复打单！": "Orders have gone, don't repeat the bill!",
            "，确定撤销审核吗？": "Determine the revocation audit?",
            "运单标签": "Welcome label",
            "币别": "Currency",
            "注意事项": "Precautions",
            "对应栏位<包装类型>为空，不能进行代理打单，请完善订单数据！": "The corresponding field <packaging type> is empty, can not make a proxy order, please perfect order data!",
            "EDI_LABEL打印机": "EDI_LABEL printer",
            "数量": "Quantity",
            "收件州省": "Consignee province",
            "未选择数据，请选择后再打印": "No data is selected, please select again",
            "取件申请": "Apply for pickup",
            "格式": "Format",
            "转单号码": "Tracking Number",
            "客户重量必须>=0.001": "Customer weight must be> = 0.001",
            "请选择至少一行\"待审核且不为推送中\"数据": "请选择至少一行\"待审核且不为推送中\"数据",
            "材重": "Volume weight",
            "报关方式": "Declaration method",
            "请勾选至少一行数据": "Please check at least one line of data",
            "笔，取消失败": "Pen, cancel failure",
            "请输入": "please input",
            "请选择报关方式": "Please select the declaration method",
            "请选择一个客户后再进行全部收货": "Please select a customer to carry out all the goods",
            "取消": "Cancel",
            "件数必须大于0且预报重量必须大于0！": "The number of pieces must be greater than 0 and the forecast weight must be greater than 0!",
            "件数必须>=1": "The number of pieces must be> = 1",
            "海关编码": "HS code",
            "全部": "All",
            "是否保存": "Whether saving",
            "已取消": "Cancelled",
            "查询": "Search",
            "联系电话": "Contact number",
            "未获取到对应数据": "Not acquired",
            "对应栏位<件数>为空，不能进行代理打单，请完善订单数据！": "The corresponding field is the number of pieces, it is empty, and cannot be exercised, please improve the order data!",
            "收费材重": "Charge volume weight",
            "取件公司": "Pick-up company",
            "请选择包装类型": "Please select the Packing type",
            "到付款": "COD amount",
            "取消异常": "Unusual cancellation",
            "已出货": "Warehouse Outbound",
            "审核": "Review",
            "最多不能超过": "Up to you can't exceed",
            "取件地址": "Pickup address",
            "备注": "Remark",
            "子单生成规则未设置，请重新设置": "Sub ordinary rules are not set, please reset",
            "订单日期不能为空": "Order create time cannot be empty",
            "关闭": "Closure",
            "取消原因": "Reason for Cancellation",
            "printScene:EDI_LABEL打印机": "PRINTSCENE: EDI_Label Printer",
            "下载": "Download",
            "高": "Height",
            "请选择一行数据": "Please select a row of data",
            "预报重量": "Pre-alert weight",
            "请选择至少一行数据": "Please select at least one line of data",
            "已提交收货请求！": "Receipt request has been submitted!",
            "确定": "OK",
            "面单打印": "Mandarin print",
            "收费重": "Charge weight",
            "收货标签": "Receipt label",
            "嘉里": "Kerry",
            "您选取": "You choose",
            "笔，无预报": "Pen, no prediction",
            "添加成功！": "Added successfully!",
            "您当前选中订单": "You are currently selected",
            "收件电话": "Consignee phone",
            "批量修改": "Batch modify",
            "材重合计": "Total material weight",
            "体积": "Volume",
            "中文品名": "Description CN",
            "修改": "Modify",
            "该订单无Invoice，无法下载": "This order is not invoice, you can't download",
            "指定路线": "Channel Code",
            "订单预报": "Order pre-alert",
            "保存": "Keep",
            "流水号位数不够，请重新设置": "The number of streams is not enough, please re-set",
            "笔": "Total",
            "实重合计": "Total actual weight",
            "创建人": "Creator",
            "请勾选至少一行状态为待收货并未申请的数据": "Please check at least one line of state for the data that is not applied.",
            "寄件时间": "Inbound At",
            "收费重合计": "Total charge",
            "包装费合计": "Total Packaging fee",
            "包装类型": "Packing type",
            "收货成功": "Shipping success",
            "微软雅黑 Regular": "Microsoft Yaishi Regular",
            ", 失败笔数：": ", Failure:",
            "请选择至少一行\"待收货\"数据": "Please select at least one row of \"to be received\" data",
            "付款方式": "Payment method",
            "注意": "Notice",
            "基本信息": "Basic info",
            "的订单共": "Order",
            "对应栏位<预报重>为空，不能进行代理打单，请完善订单数据！": "The corresponding field <pre-recovery> is empty, can not make a proxy order, please perfect order data!",
            "标签打印": "Label printing",
            "件数": "Pieces",
            "包装说明": "package instruction",
            "收件人信息": "Consignee Info",
            "收件城市": "Consignee city",
            "全部订单": "All orders",
            "查询订单是否打单失败！": "Query your order to order failed!",
            "取消成功": "Cancel success",
            "序号": "No.",
            "笔，可取消审核笔数": "Pen, cancel the number of review",
            "已收货": "Warehouse Inbound",
            "笔，可取消审核数": "Pen, can cancel the number of review",
            "对应栏位<货物类型>为空，不能进行代理打单，请完善订单数据！": "The corresponding field <Shipment types> is empty, can not perform a proxy order, please perfect order data!",
            "选择的订单中没有推送成功到POS的订单": "No orders in the order of the selected order",
            "重置": "Reset",
            "目的地": "Destination",
            "审核异常": "Review abnormal",
            "下载单件信息": "Download single piece information",
            "客户信息": "Customer Information",
            "请选择需要打印的数据": "Please select the data you want to print.",
            "提示": "Hint",
            "偏远": "Remote",
            "个字符": "Character",
            "笔，已收货": "Pen, Warehouse Inbound",
            "提交审核请求成功！": "Submit the audit success!",
            "打印": "Print",
            "导出": "Export",
            "添加异常": "Adding anomalies",
            "全部收货完成！": "All receipt completed!",
            "基础信息": "Basic Info",
            "长": "Length",
            "税金付款": "Tax payment",
            "联系人": "Contact",
            "待收货": "Be taken",
            "费用结算": "Fee settlement",
            "运单号码": "Order Number",
            "对应栏位<指定路线>为空，不能进行代理打单，请完善订单数据！": "The corresponding field <Channel Code> is empty, you can't make a proxy order, please perfect order data!",
            "待审核": "Be taken",
            "订单转单状态为“待转单”才允许代理打单！": "The order turning order status is ”to be transferred” to allow the agent to order!",
            "包装费": "Packaging fee",
            "没有配置“嘉里-末端”面单的打印机，请先进行打印设置": "No printer configured ”Kerry-End” mat, please print setting first",
            "收件邮编": "Consignee Postcode",
            "已签收": "Delivered",
            "标准面单": "Standard mat",
            "新增取件信息": "Added information",
            "发票标签": "Invoice label",
            "越南面单": "Vietnamese",
            "预约取件时间": "Appointment pickup time",
            "收件地址": "Consignee Address",
            "请先修改数据": "Please modify data first",
            "收件统编": "Collector",
            "英文品名": "Description EN",
            "重量": "weight",
            "货物信息": "Package Info",
            "订单日期": "Created At",
            "对应栏位<目的地>为空，不能进行代理打单，请完善订单数据！": "The corresponding field <Destination Country> is empty, can not perform a proxy order, please perfect order data!",
            "申报价值": "Declared value",
            "打印完成": "Print completion",
            "收件公司": "Consignee company",
            "订单状态为“待收货”才允许代理打单！": "The order status is ”waiting for the goods” to allow the agent to order!",
            "宽": "Width",
            "代理打单": "Agent list",
            "请先完善信息！": "Please improve the information first!",
            "预览": "Preview",
            "预约备注": "Appointment note",
            "请选择指定路线": "Please select Channel Code",
            "请选择至少一行\"待审核\"数据": "Please select at least one row of \"pending review\" data",
            "代收款": "Agency fund",
            "参考编号": "Ref number",
            "请勾选至少一行待审核、待收货数据": "Please check at least one visit to be reviewed, waiting for the goods",
            "实重": "Actual weight",
            "收货成功！": "The receipt is successful!",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "计抛方式": "Charge weight rule",
            "目的地信息": "Destination information",
            "香港面单": "Hong Kong face",
            "收件国家": "Recipient country",
            "收费实重": "Charge Actual weight",
            "货物类型": "Cargo type",
            "请选择至少一行待收货数据": "Please select at least one line to be charged",
            "请选择货物类型": "Please select the Cargo type",
            "收货异常": "Receiving exception",
            "创建时间": "Create time",
            "批量修改成功，成功笔数：": "Batch is successful, the number of success:"
        },
        "OMS0042": {
            "省": "Province",
            "税金付款": "Tax payment",
            "海关编码": "HS code",
            "净重": "Net weight",
            "寄件信息": "Shipping information",
            "“总价”列内容格式不正确，限制导入！": "The ”total price” column is incorrect, limited to import!",
            "费用结算": "Fee settlement",
            "请选择代收币别!": "Please select the collection currency!",
            "原产地": "country of origin",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "收件邮编": "Consignee Postcode",
            "寄件电话": "Shipper phone",
            "订单列表修改-Invoice导入模版": "Order list modify -Inotvoice import template",
            "上传成功！": "Uploaded successfully!",
            "总价": "Total price",
            "“单价”列内容格式不正确，限制导入！": "The ”unit price” column content is incorrect, limited to import!",
            "“净重”列内容格式不正确，限制导入！": "The ”net weight” column is not correct, restricted import!",
            "收件信息": "Receiving information",
            "包装类型": "Packing type",
            "操作": "Operation",
            "信息": "Information",
            "收件地址": "Consignee Address",
            "到付款": "COD amount",
            "寄件地址": "Shipper address",
            "导入模板": "Import template",
            "付款方式": "Payment method",
            "寄件人": "Shipper",
            "基本信息": "Basic info",
            "寄件邮编": "Postal code",
            "“毛重”列内容格式不正确，限制导入！": "”Gross” column is not correct, restricted import!",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "件数": "Pieces",
            "申报价值": "Declared value",
            "收件公司": "Consignee company",
            "修改成功！": "Successfully modified!",
            "收件人": "Consignee",
            "收件城市": "Consignee city",
            "文件格式不正确，请上传正确的Excel文件": "The file format is incorrect, please upload the correct Excel file",
            "单价": "Unit price",
            "第一步": "First step",
            "备注": "Remark",
            "寄件城市": "City",
            "删除": "Delete",
            "文件内容为空或格式不正确，请下载模版并填写导入内容！": "The file content is empty or the format is incorrect, please download the template and fill in the import content!",
            "运单号码<": "Welcome number <",
            "数量": "Quantity",
            "目的地": "Destination",
            "寄件公司": "Shipper company",
            "下载": "Download",
            "收件州": "Consignee Province",
            "第二步": "Second step",
            "代收款": "Agency fund",
            "毛重": "Gross weight",
            "上传": "Upload",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "寄件国家": "Consigner Country",
            "保存异常": "Preventive exception",
            "导入": "Import",
            "确定": "OK",
            "实重": "Actual weight",
            "提示": "Hint",
            "收费重": "Charge weight",
            "请选择到付币别!": "Please choose to pay the currency!",
            "请上传附件！": "Please upload an attachment!",
            "收件国家": "Recipient country",
            ">不为待审核，限制修改!": "> Do not be reviewed, restricted modifications!",
            "材重": "Volume weight",
            "收件电话": "Consignee phone",
            "报关方式": "Declaration method",
            "“数量”列内容格式不正确，限制导入！": "”Quantity” column content is incorrect, restricted import!",
            "模板": "Template",
            "货物类型": "Cargo type",
            "请输入": "please input",
            "中文品名": "Description CN",
            "取消": "Cancel",
            "确定删除此行吗？": "Are you sure to delete this line?"
        },
        "CMN002":{
			"只能上传jpg/png/word/excel/pdf文件":"Can only upload JPG / PNG / Word / Excel / PDF file",
			"下一条":"Next",
			"问题处理":"Problem",
			"上一条":"Previous one",
			"不提示":"Not prompt",
			"问题状态":"Status",
			"选中消息":"Select Message",
			"请选择消息":"Please select a message",
			"文件大小不能大于5MB":"File size cannot be greater than 5MB",
			"发送时间":"Time",
			"删除":"Delete",
			"沟通记录":"Communication Record",
			"港前问题件":"Hong Kong front problem piece",
			"查询":"Search",
			"系统消息":"System Information",
			"发件人":"Sender",
			"我":"I",
			"条，确认删除？":"Bar, confirm deletion?",
			"重置":"Reset",
			"请输入回复内容!":"Please enter the reply content!!",
			"消息类型":"Type",
			"消息删除成功！":"Message delete success!",
			"消息提醒设置":"Message Reminder Settings",
			"关联号码":"Related No.",
			"仅消息个数提示":"Only message only",
			"发送":"Send",
			"问题描述":"Description",
			"所选数据没有未读消息！":"There is no unread message selected!",
			"已经是最后一条消息了！":"Already the last message!",
			"附件":"Attachments",
			"确定":"Determine",
			"问题件回复":"Problem",
			"作者":"Author",
			"回复":"Reply",
			"登记时间":"Check-in time",
			"提示":"Tips",
			"在此回复处理问题件":"Reply to the problem of processing in this",
			"最新回复时间":"Latest reply time",
			"可添加附件":"Add Attachments",
			"标记已读":"Mark as Read",
			"添加附件":"Add attachments",
			"回复失败，请重新回复!":"Reply failed, please reply!!",
			"标记消息已读成功！":"The tag message is read successfully!",
			"主题":"Subject",
			"已经是第一条消息了！":"Already the first message!",
			"取消":"Cancel",
			"消息提醒方式设置成功！":"The message reminder is set up！",
			"屏幕弹窗提醒":"Screen pop-up reminder"
		},
        "trackquery":{
            "寄件日期":"Inbound Date",
            "参考编号":"Ref number",
            "查询后选中单号":"Select after search",
            "转单号码":"Tracking Number",
            "收费重":"Charge weight",
            "轨迹信息":"Trajectory information",
            "基本信息":"Basic info",
            "位置":"Location",
            "退返客户,退返方式为<":"Return the customer, the returns method is <",
            "运单号码":"Waybill number",
            "指定路线":"Channel Code",
            "追踪结果":"Track results",
            "查询单号必填":"Query single number",
            "查询":"Search",
            "时间":"Time",
            "跟踪记录":"Track record",
            "目的地":"Destination",
            "清空":"Empty",
            "无此单号<":"Nobody<",
            "回车后直接查询":"Press enter to search",
            "订单信息":"Order information"
        },
        "ImportLog":{
			"导入时间":"Import Time",
			"网点":"Outlet",
			"状态":"Status",
			"查询":"Search",
			"重置":"Reset",
			"批次号":"Batch No.",
			"结束时间":"End Time",
			"导入耗时":"Processing Time",
			"导入网点":"Site",
			"导入文件":"File Name",
			"错误描述":"Remarks",
			"错误行数":"Error Rows",
			"总行数":"Total Rows",
			"导入人":"Import by"
		},
        "BAS014":{
			"确定要删除吗？":"You sure you want to delete it? ",
			"修改":"Modify",
			"省":"Province ",
			"联系人":"Contact person ",
			"保存并继续":"Save&continue",
			"寄件邮箱":"Shipper Email",
			"业务电话":"Business phone",
			"请选择至少一行数据！":"Please select at least one row of data! ",
			"邮箱地址":"email address ",
			"寄件人管理":"Shipper management ",
			"此联系人将被删除，确认继续吗？":"This contact will be deleted. Are you sure to continue? ",
			"寄件州":"Consigner Province",
			"查询":"Search",
			"保存":"Save",
			"部门":"Department ",
			"寄件电话":"Shipper phone",
			"业务手机":"Business phone ",
			"联络":"Connection ",
            "联络&对接信息":"Connection & Docking information",
			"创建人":"Creator ",
			"修改异常":"Modify exception ",
			"请谨慎修改":"Please modify carefully",
			"修改信息":"Modify information ",
			"操作":"Operation",
			"分割":"Segmentation ",
			"寄件地址":"Shipper address",
			"寄件人":"Shipper",
			"基本信息":"Basic info ",
			"寄件邮编":"Postal code",
			"删除成功！":"successfully deleted!",
			"启用状态":"Enabled status ",
			"删除异常":"Delete exception ",
			"所属网点":"Outlets",
			"对接信息":"Docking information ",
			"寄件人不能为空":"Sender cannot be empty ",
			"家":"Home",
			"修改人":"Modifier ",
			"修改成功！":"Successfully modified! ",
			"增加":"Increase ",
			"请选择单行数据":"Please select a single row of data ",
			"备注":"Remark ",
			"寄件城市":"Shipping city ",
			"地址信息":"Address information ",
			"删除":"Delete ",
			"寄件人联系人":"Sender contact ",
			"关闭":"Close",
			"重置":"Reset",
			"启用":"Enable status ",
			"销售员":"Seller",
			"寄件公司":"Shipper company",
			"修改时间":"Modify time",
			"请选择一行数据":"Please select a row of data ",
			"寄件邮编不能为空":"The Postal code cannot be empty ",
			"跟单员":"Merchandiser ",
			"内部对接人信息":"Internal docking person information ",
			"寄件国家":"Shipping country ",
			"新增寄件人管理":"Add sender management ",
			"新增":"Add",
			"确定":"Determine ",
			"分类标签":"Classification label",
			"提示":"Hint ",
			"寄件公司不能为空":"Shipping company cannot be empty ",
			"寄件电话不能为空":"Sending phone number cannot be empty",
			"内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it? ",
            "寄件地址1":"Shipping address 1",
			"寄件地址3":"Shipping address 3 ",
			"寄件地址2":"Shipping address 2",
			"修改寄件人管理":"Modify sender management",
			"多个别名请用":"Please use multiple aliases",
			"添加成功！":"Added successfully! ",
			"批量修改":"Batch modify",
			"寄件公司别名":"Shipping company alias ",
			"寄件州/省":"Shipping State/Province ",
			"导出":"Export ",
			"传真":"Fax",
			"请输入":"please enter ",
			"港后客服":"CS after port",
			"取消":"Cancel",
			"当前选择批量修改寄件人":"Currently choose to modify Shipper in bulk",
			"创建时间":"Create time ",
			"添加异常":"Add exception ",
			"所属客户":"Owned customer ",
			"基础信息":"basic information ",
			"港前客服":"CS before port"
		},
        "BAS015":{
			"确定要删除吗？":"You sure you want to delete it?",
			"修改":"Modify",
            "省":"Province ",
			"保存并继续":"Save&continue",
			"请选择共享网点":"Please select a shared network ",
			"收件税号":"Receiving tax number",
			"查询":"Search",
			"保存":"Save",
			"收件邮编":"Consignee postcode",
			"收件州/省":"Receiving State/Province",
			"请选择共享方式":"Please choose a sharing method",
			"创建人":"Creator",
			"修改异常":"Modify exception",
			"共享给指定":"Share to designated ",
			"收件地址":"Shipping Address ",
			"删除成功！":"successfully deleted!",
			"修改收件人":"Modify Consignee ",
			"启用状态":"Enabled status ",
			"删除异常":"Delete exception ",
			"修改人":"Modifier",
			"收件公司":"Consignee company ",
			"修改成功！":"Successfully modified! ",
			"收件人":"Consignee ",
			"收件城市":"Receiving city ",
			"新增收件人":"Add Consignee ",
			"地址信息":"Address information ",
			"删除":"Delete",
			"关闭":"Close",
			"重置":"Reset",
			"启用":"Enable status",
			"收件地址1":"Shipping address 1",
			"收件地址3":"Shipping address 3",
			"收件地址2":"Shipping address 2",
			"修改时间":"Modify Time",
			"请选择一行数据":"Please select a row of data",
			"收件州":"Receiving State ",
			"新增":"Add",
			"确定":"Determine",
			"提示":"Hint",
			"内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it? ",
			"收件国家":"Receiving country ",
			"添加成功！":"Added successfully! ",
			"收件电话":"Consignee phone",
			"导出":"Export ",
			"请输入":"please enter ",
			"取消":"Cancel",
			"创建时间":"Create time",
			"添加异常":"Add exception ",
			"基础信息":"Basic information "
		},
        "scanManage":{
            "履约状态":"Performance Status",
            "读取时区标准":"Timezone standards",
			"修改":"Modify",
			"ICBU 推送编码":"ICBU Push code ",
            "验证排序":"Verification order",
            "开启后，轨迹录入/导入时验证轨迹时间不能小于排序之前的轨迹时间":"After opening, verify that the track time during track entry/import cannot be less than the track time before sorting",
            "唯一性":"Uniqueness",
            "开启后，轨迹录入/导入时验证轨迹时间唯一,不允许同个货态出现两个轨迹时间":"After it is turned on, the track time is verified to be unique when the track is imported and imported, and two track times are not allowed for the same cargo state.",
			"保存并继续":"Save&continue",
			"修改扫描状态成功":"Successfully modify the scan status",
			"扫描分段":"Scan segment ",
			"表示已结束，无需关注":"It is over, no need to pay attention",
			"扫描状态":"Scan status ",
			"系统标准状态，不允许修改":"System standard status, modification is not allowed",
			"查询":"Search",
			"保存":"Save",
			"勾选后会识别对应运单为已取件状态":"After checking, the corresponding waybill will be recognized as a picked up state ",
			"可多选":"Multiple choice",
			"创建人":"Creator ",
			"客户可视必须勾选":"Customers must check ",
			"新增扫描状态成功":"Successfully added scan status ",
			"请选择扫描状态":"Please select scan status ",
			"此操作将删除该扫描状态, 是否继续?":"This operation will delete the scan status, do you want to continue? ",
			"请选择":"please choose ",
			"标准数据无法删除！":"Standard data cannot be deleted!",
			"中文备注":"Chinese remarks ",
			"注意":"Notice ",
			"扫描状态删除失败！":"Scanning status deletion failed! ",
			"WISH 推送编码":"WISH Push code",
			"扫描编码":"Scan code",
			"启用状态":"Enabled status",
			"不允许随意修改":"Not allowed to modify at will ",
			"需重点关注":"Need to focus on ",
			"修改人":"Modifier ",
			"存在平台编码时，api_code必填，客户可视必须勾选":"There is a platform code, api_code is required, and the customer is required to check it",
			"已取件":"Picked up ",
			"推送编码":"Push code ",
			"请输入\"扫描编码\"!":"Please enter \"scan code\"! ",
			"存在平台编码时":"When there is platform code ",
			"请输入\"扫描分段\"!":"Please enter \"scan segment\"! ",
			"货物状态":"Cargo Status ",
			"属于异常操作，需重点关注":"abnormal operation, need to pay attention to",
			"必填":"Required ",
			"删除":"Delete",
			"排列顺序":"Arrange ",
			"关闭":"Close",
			"重置":"Reset",
			"启用":"Enable status",
			"修改时间":"Modify Time",
			"结案":"Case closed ",
			"标准状态":"Standard status",
			"属于港后状态":"Belonging to post-port status ",
			"新增":"Add",
			"确定":"determine",
			"无需关注":"No need to pay attention ",
			"内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it?",
			"提示":"Hint",
			"新增扫描状态":"Add scan status ",
			"客户可视":"Customer visibility ",
			"请输入\"扫描名称\"!":"Please enter \"scan name\"! ",
			"导出":"Export ",
			"请输入":"Please enter",
			"取消":"Cancel",
			"扫描名称":"Scan name ",
			"英文备注":"English remarks ",
			"创建时间":"Create time",
			"允许客户通过网站或对接显示的状态":"customer visual statuscustomer visual status",
			"异常":"Exception ",
			"扫描状态删除成功":"Scan status deleted successfully",
			"基础信息":"Basic information",
			"修改扫描状态":"Modify scan status",
            "扫描分段(可多选)":"Scan segment (Multiple choic)",
		},
        "BAS017":{
            "修改":"Modify",
            "保存并继续":"Save&continue",
            "问题名称":"Problem name ",
            "需要回复":"Need reply",
            "处理信息":"Processing information ",
            "问题状态":"Problem status ",
            "修改成功":"Successfully modified ",
            "识问题件":"Identify the problem",
            "收件后":"After receiving ",
            "不设置":"Not set ",
            "查询":"Search",
            "保存":"Save",
            "自动标识问题件":"Automatically identify problematic parts",
            "新增港后问题状态":"Issue status after adding port",
            "可多选":"Multiple choic",
            "新增港前问题状态":"Added pre-port problem status ",
            "登记":"Register ",
            "创建人":"Creator ",
            "已处理":"Processed ",
            "此问题件客户可视":"This problem is visible to customers ",
            "新增港后问题":"Post-port issue ",
            "默认补收科目":"Default replenishment account",
            "新增港前问题":"New pre-port issue",
            "标准状态无法修改":"Standard status cannot be modified ",
            "请选择":"Please choose ",
            "问题类型":"Problem type",
            "天":"day",
            "中文备注":"Chinese remarks",
            "处理时限":"Processing time limit",
            "启用状态":"Enabled state ",
            "需回复":"Need to reply ",
            "打单时":"When playing singles ",
            "通知岗位":"Notification post",
            "可多次":"Can be multiple times ",
            "申请暂扣标识问题件":"Application for temporary seizure of identification problem pieces",
            "重新排货标识问题件":"Reorder the problematic parts ",
            "修改人":"Modifier ",
            "收件标识问题件":"Receipt identification problem",
            "勾选":"Check ",
            "客户申请暂扣":"Customer application for temporary deduction",
            "删除成功":"successfully deleted",
            "指定处理岗位":"Designated processing position",
            "港前按小时":"Hourly before port ",
            "删除":"Delete",
            "回复中":"Replying ",
            "排列顺序":"Arrange ",
            "关闭":"Close",
            "此操作将删除该问题状态, 是否继续?":"This operation will delete the problem status, do you want to continue?",
            "重置":"Reset",
            "启用":"Enable status",
            "未选择数据，无法修改！":"No data is selected and cannot be modified! ",
            "修改时间":"Modify Time",
            "问题编码":"Problem coding ",
            "标准状态":"Standard status ",
            "港后按天":"After port by day",
            "新增":"Add",
            "确定":"Datermine",
            "请选择问题状态":"Please select the problem status",
            "提示":"Hint",
            "内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it? ",
            "修改港前问题状态":"Modify the status of the pre-port problem",
            "客户可视":"Customer visibility",
            "标准状态无法删除":"Standard status cannot be deleted ",
            "新增成功":"added successfully ",
            "问题大类":"Problem categories ",
            "打单标识问题件":"Marking problem pieces for ordering",
            "收件时":"When receiving ",
            "标识问题件":"Identify the problem piece ",
            "导出":"Export ",
            "修改港后问题状态":"The status of the problem after modifying the port ",
            "用于对外问题件显示":"Used to display external issues",
            "请输入":"please enter ",
            "取消":"Cancel",
            "英文备注":"English remarks ",
            "创建时间":"Create time ",
            "运单修改重新排货时标":"Waybill modification and re-scheduled time mark ",
            "基础信息":"Basic information "
		},
        "statManage":{
            "修改": "Modify",
            "省": "Province",
            "保存并继续": "Save&continue",
            "网点": "warehouse",
            "修改成功": "Successfully modified",
            "建立时间": "Establishment time",
            "客服电话": "Consumer hotline",
            "上级网点无法和下级网点相同，请重新选择！": "The upper-level outlets cannot be the same as the lower-level outlets, please select again!",
            "本位币": "Functional currency",
            "查询": "Search",
            "保存": "Save",
            "网点中文": "Chinese",
            "无法新增四级网点": "Unable to add four-level outlets",
            "网点导出": "Outlets export",
            "经理": "Manager",
            "非子节点的网点不能修改上级网点！": "Non-child nodes can’t modify the superior ones!",
            "新增同级": "Add",
            "网点名称": "Name of branches",
            "请选择\"网点类型\"!": "Please select \"Network Point Type\"!",
            "负责人电话": "Principal phone",
            "所属城市": "City of affiliation",
            "网点简码": "Shortcode",
            "客服": "Customer service",
            "联系信息": "Contact information",
            "委托录单网点": "Order Recording outlets",
            "网点编码": "Dot code",
            "网点信息": "Outlet info",
            "请选择网点": "Please select an outlet",
            "请选择": "please choose",
            "网点英文": "Network English",
            "请输入\"网点编码\"!": "Please enter \"Dot Code\"!",
            "异步导出": "Asynchronous export",
            "修改网点": "Modify outlets",
            "内部电话": "Internal phone",
            "修改人": "Modifier",
            "此操作将删除该网点, 是否继续?": "This operation will delete the outlet, do you want to continue?",
            "建立人": "Founder",
            "上级网点": "Super outlet",
            "对账员": "Reconciler",
            "传真电话": "Fax telephone",
            "无法删除非子节点的网点！": "Cannot delete non-child nodes!",
            "请先保存\"网点信息\"!": "Please save \"outlet information\" first!",
            "备注": "Remark",
            "根节点不能新建同级网点": "The root node cannot create a new network point at the same level",
            "删除": "Delete",
            "关闭": "Close",
            "所属州/省": "Province of affiliation",
            "请先选择上级网点！": "Please select a superior outlet first!",
            "重置": "Reset",
            "启用": "Enable status",
            "浏览": "Browse",
            "请选择\"本位币\"!": "Please select \"standard currency\"!",
            "修改时间": "Modify time",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it in the export list later!",
            "保存成功": "Saved successfully",
            "客服传真": "Customer Service Fax",
            "新增网点": "New outlets",
            "新增": "Add",
            "确定": "OK",
            "一级网点类型只能是“总部”！": "The type of first-level outlets can only be \"headquarters\"!",
            "浏览网点": "Browse outlets",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "网点删除成功": "The outlet was deleted successfully",
            "网点类型": "Type of outlets",
            "根节点不能修改上级网点！": "The root node cannot modify the superior outlets!",
            "选择网点": "Choose outlets",
            "导出": "Export",
            "负责人": "Principal",
            "请输入": "please input",
            "投诉电话": "Complaint telephone",
            "所属国家": "Country of affiliation",
            "经理电话": "Manager phone",
            "取消": "Cancel",
            "新增下级": "Add sub",
            "请输入\"网点名称\"!": "Please enter \"name of outlet\"!",
            "所属州": "State",
            "基础信息": "Basic Info",
        },
        "BAS005": {
            "确定要删除吗？": "You sure you want to delete it?",
            "修改": "Modify",
            "保存并继续": "Save&continue",
            "工作地址": "working address",
            "户籍地址": "Residence address",
            "修改员工": "Modify employee",
            "所属部门": "Department",
            "建立时间": "Establishment time",
            "籍贯": "Hometown",
            "请输入员工编码": "Please enter employee code",
            "合同截止日期": "Contract deadline",
            "现居住地址": "current residing address",
            "删除员工异常": "Delete employee exception",
            "查询": "Search",
            "紧急联系人": "Emergency contact",
            "保存": "Save",
            "婚姻状况": "Marital status",
            "合同签订日期": "Contract signing date",
            "员工管理": "Staff management",
            "紧急联系人电话": "Contact number",
            "工作": "Work",
            "身份证号": "ID number",
            "修改异常": "Modify exception",
            "家庭电话": "Home phone",
            "现居地址": "Current address",
            "在职状态": "In-service status",
            "员工姓名": "Employee's name",
            "请选择": "Please choose",
            "员工编号": "Employee ID",
            "社保号": "Social Security Number",
            "基本信息": "Basic info",
            "删除成功！": "successfully deleted!",
            "工作QQ": "Work QQ",
            "所属网点": "Outlets",
            "党员": "Party member",
            "修改人": "Modifier",
            "员工信息": "Employee information",
            "建立人": "Founder",
            "薪资等级": "Salary grade",
            "出生年月": "Date of birth",
            "修改成功！": "Successfully modified!",
            "手机": "Phone number",
            "手机号码": "Phone number",
            "职位状态": "Position status",
            "电话": "Telephone",
            "个人信息": "Personal information",
            "职位描述": "Job description",
            "备注": "Remark",
            "删除": "Delete",
            "入职日期": "Entry date",
            "离职日期": "Resignation date",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable status",
            "民族": "Nationality",
            "浏览": "Browse",
            "修改时间": "Modify time",
            "在职信息": "Job information",
            "个人": "personal",
            "请选择一行数据": "Please select a row of data",
            "背景色设置": "Background color setting",
            "紧急信息": "Emergency information",
            "相等": "Equal",
            "新增": "Add",
            "确定": "OK",
            "提示": "Hint",
            "浏览员工": "Browse employees",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "每行高亮": "Highlight each line",
            "所在职位": "Position",
            "学历": "Education",
            "新增员工": "New employee",
            "专业": "Professional",
            "英文名": "English name",
            "性别": "Gender",
            "添加成功！": "Added successfully!",
            "导出": "Export",
            "手机号": "Phone number",
            "请输入": "Please input",
            "出生日期": "Date of birth",
            "取消": "Cancel",
            "基本": "Basic",
            "联系人关系": "Contact relationship",
            "添加异常": "Add exception",
            "紧急联络信息": "Emergency contact information",
            "基本&在职信息": "Basic & on-the-job information",
            "个人&紧急信息": "Personal & emergency information",
            "Email": "Email",
            "主审批人": "Main approver",
            "副审批人": "Secondary approver",
        },
        "roleManage": {
            "修改": "Modify",
            "复制新增角色": "Copy new role",
            "角色授权": "Role authorization",
            "菜单名称": "Menu name",
            "请选择角色": "Please choose a role",
            "标识不勾": "Logo not tick",
            "菜单权限": "Menu permissions",
            "保存": "Save",
            "部门": "Department",
            "推荐值": "Recommended value",
            "创建人": "Creator",
            "菜单标题": "Menu title",
            "否": "No",
            "确定删除该职位?": "Are you sure to delete this position?",
            "注意": "Notice",
            "基本信息": "Basic info",
            "标准职位无法删除！": "Standard positions cannot be deleted!",
            "是": "Yes",
            "标准职位无法修改！": "Standard positions cannot be modified!",
            "修改人": "Modifier",
            "序号": "No.",
            "请设置参数信息!": "Please set the parameter information!",
            "复选框": "Checkbox",
            "删除": "Delete",
            "参数设置成功！": "The parameter setting is successful!",
            "重置": "Reset",
            "获取参数设置异常": "Get parameter setting exception",
            "确定要删除该部门吗(包含下级部门)？": "Are you sure you want to delete this department (including subordinate departments)?",
            "职位说明": "Job description",
            "导出选中": "Export selected",
            "一级模块": "First-level module",
            "导出明细": "Export details",
            "提示": "Hint",
            "二级菜单": "Secondary menu",
            "导出": "Export",
            "组件类型": "Component type",
            "请输入": "Please input",
            "取消": "Cancel",
            "参数设置": "Parameter settings",
            "新增部门成功！": "Successfully added department!",
            "一级菜单": "A menu",
            "授权菜单数": "Number of authorized menus",
            "保存并继续": "Save&continue",
            "勾选菜单权限自动勾选下属按钮权限": "Check menu, automatically check button permissions",
            "参数编码": "Parameter encoding",
            "导出详情": "Export details",
            "标识打勾": "Mark tick",
            "如设置值为空": "If the setting value is empty",
            "全部": "All",
            "修改部门成功！": "Modify department successfully!",
            "职位": "Position",
            "查询": "Search",
            "下拉框值为有效值": "The drop-down box value is a valid value",
            "登录入口": "Log entry",
            "职位角色信息": "Position and role information",
            "新增下属部门": "Add subordinate department",
            "部门删除成功！": "The department was deleted successfully!",
            "角色删除成功": "Role deleted successfully",
            "角色参数设置": "Character parameter setting",
            "按钮启用数": "Number of buttons enabled",
            "修改部门": "Modify department",
            "参数说明": "Parameter Description",
            "管理员": "Administrator",
            "启用状态": "Enabled state",
            "如设置值为": "If the setting value is",
            "按钮权限": "Button permissions",
            "按钮标题": "Button title",
            "数字框": "Number box",
            "部门说明": "Department Description",
            "参数定义": "Parameter definition",
            "组件类型为": "The component type is",
            "增加": "Increase",
            "修改角色": "Modify role",
            "复制新增": "Copy new",
            "密码框": "Password box",
            "按钮数": "Number of buttons",
            "设置值": "Settings",
            "关闭": "Close",
            "重量段删除失败！": "Failed to delete weight segment!",
            "启用": "Enable status",
            "参数设置数": "Number of parameter settings",
            "修改时间": "Modify time",
            "导出所有": "Export all",
            "多个有效值用": "For multiple valid values",
            "标识以系统设置值为准": "The logo is subject to the system settings",
            "下拉框": "Drop down box",
            "新增角色": "New role",
            "角色说明": "Role description",
            "请选择导出数据": "Please select export data",
            "功能说明": "Function Description",
            "新增下属部门成功！": "Successfully added subordinate department!",
            "新增": "Add",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "菜单": "Menu",
            "请先选择角色！": "Please select a role first!",
            "文本框": "Text box",
            "标准职位": "Standard Position",
            "角色": "Role",
            "时": "Time",
            "新增部门": "New department",
            "角色名称": "Role Name",
            "创建时间": "Create time",
            "隔开": "Separate",
            "审批人": "Approver"
        },
        "BAS006": {
            "请选择需要特殊授权的用户": "Please select a user who needs special authorization",
            "特殊授权": "Special authorization",
            "勾选菜单权限自动勾选下属按钮权限": "Check menu, automatically check button permissions",
            "角色授权": "Role authorization",
            "密码重置成功！！": "Password reset successfully! !",
            "你已改动，确定要关闭吗？": "You have changed, are you sure you want to close it?",
            "选项表方法": "Option list method",
            "追加授权": "Additional authorization",
            "授权角色": "Authorization role",
            "所属部门": "Department",
            "结果对象变量": "Result object variable",
            "角色列表": "Role list",
            "请输入关键字": "Please enter key words",
            "网点授权类型": "Outlet authorization",
            "职位": "Position",
            "授权按钮": "Authorize button",
            "查询": "Search",
            "菜单权限": "Menu permissions",
            "特殊授权成功": "Special authorization succeeded",
            "保存": "Save",
            "普通方法": "Ordinary method",
            "部门": "Department",
            "重置密码不能与原密码相同！": "The reset password cannot be the same as the original password!",
            "登录入口": "Log entry",
            "菜单标题": "Menu title",
            "事件触发调用方法": "Event trigger call method",
            "默认职位": "Default position",
            "密码不得少于": "Password must not be less than",
            "密码不能是完全相同的字符": "Password cannot be exactly the same characters",
            "按钮启用数": "Number of buttons enabled",
            "确认密码": "Confirm Password",
            "网点列表": "List of outlets",
            "授权网点方式": "Authorized outlets",
            "注意": "Notice",
            "调用表方法": "Call table method",
            "管理员": "administrator",
            "表单对象变量": "Form object variable",
            "启用状态": "Enabled state",
            "用户编号": "User ID",
            "所属网点": "Outlets",
            "按钮权限": "Button permissions",
            "用户授权": "User authorization",
            "密码不得少于6位！": "The password must not be less than 6 digits!",
            "按钮标题": "Button title",
            "修改人": "Modifier",
            "用户编码": "User code",
            "建立人": "Founder",
            "复制密码": "Copy password",
            "用户信息": "User Info",
            "序号": "No.",
            "登陆次数": "Number of logins",
            "重置密码": "Reset Password",
            "上次登录时间": "Last Login Time",
            "位": "Bit",
            "按钮数": "Number of buttons",
            "网点授权": "Outlet authorization",
            "关闭": "Close",
            "授权管理": "Authorization management",
            "授权网点": "Authorized outlets",
            "密码重置异常": "Password reset abnormal",
            "重置": "Reset",
            "启用": "Enable status",
            "用户姓名": "Username",
            "授权角色列表": "Authorized role",
            "普通变量": "Ordinary variable",
            "修改时间": "Modify time",
            "选项表表变量": "Options list table variables",
            "确定修改密码吗？": "Are you sure to change the password?",
            "请选择一行数据": "Please select a row of data",
            "功能说明": "Function Description",
            "不允许出现连续的数字或完全相同的字符": "Continuous numbers or identical characters are not allowed",
            "选项表变量": "Option list variable",
            "授权保存成功！": "The authorization is saved successfully!",
            "一级模块": "First-level module",
            "密码不能是连续数字": "Password cannot be consecutive numbers",
            "确定": "OK",
            "校验变量": "Check variable",
            "提示": "Hint",
            "角色授权保存异常": "Role authorization save exception",
            "网点授权保存异常": "Store authorization is abnormal",
            "调用表变量": "Call table variable",
            "用户名称": "User name",
            "密码重置": "Reset Password",
            "密码": "Password",
            "导出": "Export",
            "无效数据！": "Invalid data!",
            "请输入": "please input",
            "请输入密码": "Please enter the password",
            "取消": "Cancel",
            "创建时间": "Create time",
            "显示密码": "Show password",
            "授权网点列表": "Authorized outlet",
            "重置密码与确认密码必须相同！": "Reset password and confirm password must be the same!"
        },
        "BAS045": {
            "操作时间": "Operating At",
            "操作说明": "Instructions",
            "操作日志": "Operation log",
            "按钮": "Button",
            "命令": "Order",
            "主数据ID": "Master data ID",
            "查询": "Search",
            "重置": "Reset",
            "功能菜单": "Function menu",
            "操作用户": "Operation By",
            "操作日期不能为空": "Operation date cannot be empty",
            "导出": "Export",
            "主数据表": "Master data sheet",
            "操作网点": "Operation outlets",
            "标识字段": "Identification field"
        },
        "BAS036": {
            "注意: 创建成功后系统会提示初始密码, 请保存, 如未能保存请使用修改密码功能":"Attention: After successful creation, the system will prompt for the initial password. Please save it. If it cannot be saved, please use the password change function",
            "注意: 密码必须包含: 数字, 大写字母, 小写字母, 特殊字符, 最短长度12位"	:"The password must contain digits, lowercase letters, uppercase letters, and special characters. The minimum length is 12 characters",
            "重置通知":"Reset notification",
            "通知":"Notification",
            "修改": "Modify",
            "保存并继续": "Save&continue",
            "是否删除该授权用户": "Whether to delete the authorized user",
            "新增客户时自动生成": "Automatically generated when adding a new customer",
            "查询": "Search",
            "保存": "Save",
            "登录账号": "Login account",
            "创建人": "Creator",
            "菜单标题": "Menu title",
            "修改异常": "Modify exception",
            "修改OMS授权": "Modify OMS authorization",
            "用户账号": "User account",
            "注意": "Notice",
            "基本信息": "Basic info",
            "删除成功！": "successfully deleted!",
            "启用状态": "Enabled state",
            "删除异常": "Delete exception",
            "所属网点": "Outlets",
            "拥有权限": "Have permission",
            "修改人": "Modifier",
            "修改OMS角色": "Modify OMS role",
            "用户编码": "User code",
            "客户名称": "Customer name",
            "修改成功！": "Successfully modified!",
            "复制密码": "Copy password",
            "默认角色须唯一": "The default role must be unique",
            "新增OMS授权": "Add OMS authorization",
            "是否删除当前角色?": "Do you want to delete the current role?",
            "增加": "Increase",
            "备注": "Remark",
            "删除": "Delete",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable status",
            "用户姓名": "Username",
            "修改时间": "Modify time",
            "请选择一行数据": "Please select a row of data",
            "角色说明": "Role description",
            "OMS角色": "OMS role",
            "功能说明": "Function Description",
            "新增": "Add",
            "确定": "OK",
            "授权信息": "Authorization information",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "新增OMS角色": "Added OMS role",
            "用户名称": "User name",
            "已有默认角色": "Default role already exists",
            "密码": "Password",
            "添加成功！": "Added successfully!",
            "角色": "Role",
            "初始化密码为": "The initial password is",
            "请输入": "please input",
            "取消": "Cancel",
            "角色名称": "Role Name",
            "创建时间": "Create time",
            "显示密码": "Show password",
            "添加异常": "Add exception",
            "所属客户": "Owned customer",
            "默认角色": "Default role",
            "类型": "Type",
            "用户账号/手机号":"User account/Phone number",
            "绑定微信":"Binding WeChat",
            "手机号码":"Phone number"
        },
        "BAS008": {
            "新增": "Add",
            "修改": "Modify",
            "删除": "Delete",
            "设置报音": "Set up the announcement",
            "导出": "Export",
            "目的地信息": "Destination information",
            "目的地编码": "Destination code",
            "目的地名称": "Destination name",
            "国家简码": "Country code",
            "英文名称": "English name",
            "国家别名": "Country alias",
            "业务类型": "Business type",
            "启用状态": "Enabled state",
            "查询": "Search",
            "重置": "Reset",
            "基础信息": "Basic Info",
            "启用": "Enable status",
            "目的地国币别": "Destination country currency",
            "目的地服务电话": "Destination service phone",
            "可多选": "Multiple choice",
            "多个别名": "Multiple aliases",
            "请用": "Please use",
            "或": "Or",
            "隔开": "Separate",
            "主要用报价分区导入": "Mainly use quote partition to import",
            "中文名称": "Chinese name",
            "备注": "Remark",
            "保存并继续": "Save&continue",
            "保存": "Save",
            "关闭": "Close",
            "报音文件": "Announcement file",
            "序号": "No.",
            "货物类型": "Cargo type",
            "请输入": "please input",
            "请选择": "Please select",
            "请选择，请重请选择！": "Please select, please select again!",
            "目的地国家币别": "Destination country currency",
            "目的地国服务电话": "Destination country service phone",
            "目的地报音": "Destination announcement",
            "创建时间": "Create time",
            "创建人,是否创建人？": "Founder, do you want to create a person?",
            "修改时间": "Modify time",
            "修改人": "Modifier",
            "新增目的地": "Add destination",
            "修改目的地": "Modify destination",
            "请选择目的地": "Please select a destination",
            "新增成功, 是新增成功?": "The addition is successful, is the addition successful?",
            "修改成功": "Successfully modified",
            "此操作将删除该目的地, 是否继续?": "This operation will delete the destination, do you want to continue?",
            "提示": "hint",
            "确定": "OK",
            "取消": "Cancel",
            "删除成功": "Successfully deleted",
            "目的地": "Destination",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "目的地设置报音": "Destination setting announcement",
            "报音文件不能为空，请重新选择！": "The voice file cannot be empty, please select again!",
            "国家三字代码": "Country three-character code",
            "创建人": "Creator"
        },
        "BAS037": {
            "多个邮箱用“;”隔开":" multiple email addresses separated by \";\"",
            "预报发送邮箱":"Pre-alert sending email",
            "通知信息":"Notification information",
            "合约所属公司":"contract belongs company",
            "新增": "Add",
            "修改": "Modify",
            "批量修改": "Batch modify",
            "浏览": "Browse",
            "删除": "Delete",
            "导出": "Export",
            "代理信息": "Agency information",
            "所属网点": "Outlets",
            "代理编码": "Agent code",
            "代理名称": "Agent name",
            "代理类型": "Agent type",
            "启用状态": "Enabled state",
            "对账员": "Reconciler",
            "查询": "Search",
            "重置": "Reset",
            "基础信息": "Basic Info",
            "启用": "Enable status",
            "代理简码": "Proxy shortcode",
            "代理全称": "Agent's full name",
            "英文名称": "English name",
            "所属国家": "Country of affiliation",
            "所属州": "State",
            "省": "Province",
            "所属城市": "City of affiliation",
            "所属邮编": "Zip code",
            "地址": "Address",
            "地址2": "Address 2",
            "备注": "Remark",
            "付款信息": "payment info",
            "付款账号信息": "Payment account information",
            "银行账号": "Bank Account",
            "开户银行": "Bank of Deposit",
            "开户人": "Account holder",
            "付款账号协议": "Payment account agreement",
            "只能上传": "Can only upload",
            "张": "Open",
            "格式": "Format",
            "图片文件": "Picture file",
            "不超过": "Does not exceed",
            "联络信息": "contact information",
            "序号": "No.",
            "操作": "Operation",
            "联系人": "Contact person",
            "岗位": "Post",
            "电话": "Telephone",
            "手机": "Cell phone",
            "传真": "Fax",
            "保存并继续": "Save&continue",
            "保存": "Save",
            "关闭": "Close",
            "修改信息": "Modify information",
            "当前选择批量修改代理": "Currently select bulk edit agent",
            "家": "Family",
            "请谨慎修改": "Please modify carefully",
            "新增代理": "Add agent",
            "所属州/省": "Province of affiliation",
            "最后一次交货时间": "Last delivery time",
            "创建时间": "Create time",
            "创建人": "Creator",
            "修改时间": "Modify time",
            "修改人": "Modifier",
            "请输入": "Please input",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "是否删除当前代理": "Whether to delete the current agent",
            "提示": "Hint",
            "确定": "OK",
            "取消": "Cancel",
            "请选择一行数据": "Please select a row of data",
            "删除异常": "Delete exception",
            "删除成功！": "Successfully deleted!",
            "请输入代理编码": "Please enter the Agent code",
            "不能存在相同联系人": "Cannot have the same contact",
            "添加异常": "Add exception",
            "添加成功！": "Added successfully!",
            "修改异常": "Modify exception",
            "修改成功！": "Successfully modified!",
            "请选择要修改的数据": "Please select the data to be modified",
            "请选择代理类型": "Please select agent type",
            "请选择对账员": "Please choose a reconciler",
            "请先选择要修改列": "Please select the column to modify first",
            "代理浏览": "Agent browsing",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "修改代理": "Modify agent",
            "代理管理": "Agent management",
            "文件大小不能大于2MB": "File size cannot be larger than 2MB",
            "只能上传jpeg/jpg/png文件": "Only upload jpeg/jpg/png files",
            "确定删除此行吗？": "Are you sure to delete this line?",
            "联系人不能为空": "Contact cannot be empty",
            "岗位不能为空": "Post cannot be empty",
            "手机不能为空": "Phone cannot be empty"
        },
        "BAS028": {
            "共享网点（可多选）": "Shared network (multiple choices available)",
            "新增": "Add",
            "修改": "Modify",
            "删除": "Delete",
            "共享": "Share info",
            "不共享": "Not share",
            "共享给所有": "Share to all",
            "共享给指定": "Share to designated",
            "导出": "Export",
            "客户分组信息": "Customer group information",
            "客户组编码": "Customer Group Code",
            "客户组名称": "Customer group name",
            "所属网点": "Outlets",
            "共享方式": "Sharing method",
            "启用状态": "Enabled state",
            "查询": "Search",
            "重置": "Reset",
            "基本信息": "Basic info",
            "启用": "Enable status",
            "中隐藏公式": "Hidden formula",
            "备注": "Remark",
            "共享网点": "Shared network",
            "可多选": "Multiple choice",
            "保存并继续": "Save&continue",
            "保存": "Save",
            "关闭": "Close",
            "共享给指定网点": "Share to designated outlets",
            "网点列表": "List of outlets",
            "指定网点": "Designated outlets",
            "请输入关键字": "Please enter key words",
            "新增客户组": "Add customer group",
            "VIP中隐藏公式": "Hidden formulas in VIP",
            "现结客户":"Cash customer",
            "建立时间": "Establishment time",
            "建立人": "Founder",
            "修改时间": "Modify time",
            "修改人": "Modifier",
            "请输入": "please input",
            "确定要删除吗？": "You sure you want to delete it?",
            "提示": "Hint",
            "确定": "OK",
            "取消": "Cancel",
            "请选择一行数据": "Please select a row of data",
            "删除异常": "Delete exception",
            "删除成功！": "Successfully deleted!",
            "添加异常": "Add exception",
            "添加成功！": "Added successfully!",
            "修改异常": "Modify exception",
            "修改成功！": "Successfully modified!",
            "至少选择一个网点！": "Choose at least one outlet!",
            "保存异常": "Save exception",
            "修改共享方式成功！": "Successfully modified the sharing method!",
            "修改共享方式失败！": "Failed to modify the sharing method!",
            "修改客户组": "Modify customer group",
            "浏览客户组": "Browse customer groups",
            "客户组管理": "Customer Group Management",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?"
        },
        "custManage": {
            "可用产品码":"Available cahnnel codes",
            "开通产品码设置":"Activate channel code settings",
            "赔偿比率":"Compensation ratio",
            "保险公司":"Insurance company",
            "允许提供保险的指定路线":"Channel code that allows providing insurance",
            "保险设定":"Insurance setting",
            "扫描编码":"Scan status",
            "特殊不可视设定":"Special invisible Settings",
            "官网屏蔽出港前地址":"The official website blocks the pre-departure address",
            "货态设定":"Scan status configuration",
            "客制设定":"Customer customized configuration",
            "至":"to",
            "结束日期":"End Date",
            "开始日期":"Start date",
            "固定":"Fixed",
            "请输入纯数字":"Please enter pure numbers",
            "收件人DA邮件通知":"Email notify",
            "免仓期单位":"Demurrage free time unit",
            "免仓期":"Demurrage free time",
            "免仓期规则":"Demurrage free time rules",
            "指定路线":"Channel code",
            "注意：":"Attention:",
            "系统默认按寄件（入库）计费与结算":"The system defaults to billing and settlement based on shipment (inbound).",
            "设置其他结算节点后":"After setting up other settlement nodes",
            "对应账单数据需满足结算条件才允许结算":"the corresponding billing data must meet the settlement conditions before settlement can be allowed",
            "设置其他计费节点后":"After setting up other billing nodes",
            "系统支持根据设置计费节点时间进行批价计算":"the system supports pricing calculation based on the time of setting the billing node;",
            "若客户需根据指定路线设置计费":"If the customer needs to set billing/settlement nodes according to channel code",
            "请在":"please",
            "页签中设置":" set them in the \"Special Settlement Rules\" tab.",
            "回款期限（天）":"Payment deadline (days)",
            "资金账户":"Fund account",
            "结算相关":"Settlement related",
            "收件人电话":"Receiver phone",
            "收件人税号":"Receiver tax No.",
            "寄件人税号":"Sender tax No.",
            "特殊结算规则":"Special Settlement rules ",
            "账单格式&结算":"Bill format&settlement",
            "计费节点":"Billing node",
            "结算节点":"Settlement node",
            "账单公式不能为空":"the billing formula can't be empty",
            "账单格式": "The bill format",
            "账单格式信息": "Bill format information",
            "账单公式（可多选）": "Billing formula (multiple options)",

            "客户委托指定": "Customer entrusted designation",
            "删除销售员配置成功！": "Successfully delete the salesperson configuration!",
            "只显示含附件": "Only show with attachments",
            "交易流水": "Transaction flow",
            "客户编号": "Customer Number",
            "部门": "Department",
            "行,缺少联系人": "OK, missing contacts",
            "请选择客户": "Please select a client",
            "自动发送账单邮件": "Automatic billing email",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "此操作将停用该客户, 是否继续?": "This operation will deactivate the customer, do you want to continue?",
            "操作": "Operation",
            "子客户目的国家简码": "Country code of sub-customer's destination",
            "禁用下载": "Disable download",
            "关联主客户": "Associate the main customer",
            "请填写\"\"基本信息\"\"！": "Please fill in\"\"Basic info\"\"!",
            "主客户编码不能为空": "The main customer code cannot be empty",
            "请选择客户状态": "Please select customer status",
            "回款期限": "Payment period",
            "所属网点": "Outlets",
            "自动触发账单发送到指定邮箱": "Automatically trigger the bill to be sent to the specified mailbox",
            "修改人": "Modifier",
            "客户名称": "Customer name",
            "通知人优先取值客户管理": "The notifier gives priority to customer management",
            "默认帐单格式": "Default billing format",
            "账单发送邮箱": "Invoice sending email",
            "停用": "Deactivate",
            "是否需开票": "Do you need to invoice",
            "请填写必填值！": "Please fill in the required value!",
            "营业执照号": "Business License No",
            "英文地址": "English address",
            "请选择港前客服": "Please select CS before port",
            "删除": "Delete",
            "请选择销售员": "Please choose a salesperson",
            "允许有多个网点": "Multiple outlets allowed",
            "浏览": "Browse",
            "结算周期": "Billing cycle",
            "当前客户停用失败！": "The current customer deactivation failed!",
            "当前结算周期在第几天开始计算回款期限": "The current settlement cycle starts to calculate the payment period on the first few days",
            "关联客户组为空，确定继续保存吗？": "The associated customer group is empty. Are you sure you want to continue to save it?",
            "客户编码": "Customer code",
            "主客户编码": "Main customer code",
            "请选择\"所属网点\"!": "Please select \"Affiliated Network\"!",
            "此操作将删除该联系人, 是否继续?": "This operation will delete the contact, do you want to continue?",
            "中客户下单时": "When a middle customer places an order",
            "帐单接收邮箱最多可以输入5个": "You can enter up to 5 bill receiving mailboxes",
            "请输入": "Please input",
            "取消": "Cancel",
            "客户修改成功": "Customer modified successfully",
            "最多可以输入": "You can enter at most",
            "保存并继续": "Save&continue",
            "绑定子客户": "Bind sub-customers",
            "客户状态": "Customer status",
            "最后交货时间": "Final delivery time",
            "查询": "Search",
            "业务手机": "Business phone",
            "港前指定处理岗位": "Pre-port treatment",
            "请选择先客户！": "Please choose the first customer!",
            "帐单接收邮箱缺少“@”字符": "The billing mailbox is missing the \"@\" character",
            "个邮箱缺少“@”字符": "Mailboxes are missing the \"@\" character",
            "结算日为": "Settlement date is",
            "结算账单": "Settlement bills",
            "所属城市": "City of affiliation",
            "该模式将优先调用寄件人对接人跟进": "This mode will prioritize the call to the sender’s docking person for follow-up",
            "如果结算周期是周结": "If the billing cycle is weekly",
            "客户联系人": "Customer Contact",
            "税金押金币别": "Tax deposit currency",
            "请选择\"客户类型\"!": "Please select \"Customer Type\"!",
            "登记港前": "Before the port of registration",
            "港后指定处理岗位对应的员工": "Employees corresponding to designated processing positions after port",
            "根据主客户编码": "According to the main customer code",
            "账单审核后": "After bill review",
            "同行客户": "Peer customers",
            "多个邮箱之间用": "Use between multiple mailboxes",
            "结算日": "Settlement date",
            "举例说明": "for example",
            "请输入\"客户编码\"!": "Please enter \"Customer Code\"!",
            "通知岗位": "Notification post",
            "此客户只允许所属网点录单": "This customer is only allowed to record orders at his own outlets",
            "请选择\"客户状态\"!": "Please select \"Customer Status\"!",
            "帐单信息": "Billing information",
            "当前选择批量修改客户": "Currently choose to modify customers in bulk",
            "当前为主客户": "Current main client",
            "修改成功！": "Successfully modified!",
            "运费押金": "Freight deposit",
            "对账员": "Reconciler",
            "财务联络人": "Financial Contact",
            "请选择客户类型": "Please select customer type",
            "请填写\"基本信息\"！": "Please fill in \"Basic info\"!",
            "签约日期": "Contract date",
            "合同日期": "Contract date",
            "备注": "Remark",
            "复制新增": "Copy new",
            "个文件": "Files",
            "关闭": "Close",
            "所属邮编": "Zip code",
            "关联客户组": "Customer Group",
            "请选择帐单发送邮箱": "Please select an email address to send the bill",
            "请选择港后客服": "Please select CS after port",
            "修改时间": "Modify time",
            "按寄件人跟进": "Sender follow up",
            "请输入\"客户名称\"!": "Please enter \"Customer Name\"!",
            "请选择一行数据": "Please select a row of data",
            "合同编号": "Contract No",
            "内部对接人信息": "Docking information",
            "附件信息": "Attachment information",
            "新增": "Add",
            "确定": "OK",
            "用于订单导入时": "When used for order import",
            "客户委托所有": "Client entrusted all",
            "通知岗位对应的员工": "Notify the employee corresponding to the position",
            "文件大小不能大于10M": "File size cannot be greater than 10M",
            "批量修改": "Batch modify",
            "无需关联": "No need to associate",
            "以其他客户为主客户": "Focus on other customers",
            "当前客户删除成功": "Current customer deleted successfully",
            "税金押金": "Tax deposit",
            "委托录单": "Order record",
            "港后客服": "CS after port",
            "其他信息": "Other information",
            "所属国家": "Country of affiliation",
            "所属州": "State",
            "修改客户": "Modify customer",
            "指定处理岗位对应的员工": "Employee corresponding to designated processing position",
            "隔开": "Separate",
            "请选择\"运费押金币别\"!": "Please select \"Shipping Deposit Currency\"!",
            "修改": "Modify",
            "省": "Province",
            "网点委托指定给": "The outlets are entrusted to",
            "如有多个委托录单网点时": "If there are multiple sites for order registration",
            "所属网点下的所有客户的录单委托给指定网点": "Entrust the record orders of all customers under the affiliated outlets to the designated outlets",
            "请输入关键字": "Please enter key words",
            "押金信息": "Deposit information",
            "保存": "Save",
            "客户曾用名": "Former name",
            "联络": "Connection",
            "可多选": "Multiple choice",
            "帐单接收邮箱第": "Invoice receiving mailbox",
            "创建人": "Creator",
            "复制新增客户": "Copy new customer",
            "请输入帐单接收邮箱": "Please enter the bill receiving email address",
            "附件": "Attachments",
            "客户类型": "Customer type",
            "修改信息": "Modify information",
            "公司中文名称": "Company Name in Chinese",
            "请选择对账员": "Please choose a reconciler",
            "行邮箱地址缺少“@”字符": "Line email address is missing the \"@\" character",
            "勾选客户委托指定时，必须选择委托录单网点！": "When you check the client's entrusted designation, you must select the entrusted order recording outlet!",
            "网点列表": "List of outlets",
            "在": "exist",
            "天": "sky",
            "注意": "Notice",
            "付款方式": "Payment Method",
            "基本信息": "Basic info",
            "第": "NS",
            "当前客户已被停用": "Current customer has been deactivated",
            "浏览客户": "Browse customers",
            "客户等级": "Customer level",
            "对接信息": "Docking information",
            "请添加联系信息": "Please add contact information",
            "请选择\"结算周期\"！": "Please select \"Billing Period\"!",
            "取件员": "Pick up personnel",
            "首次交货时间": "First delivery time",
            "指定处理人优先取值客户管理": "Designated processor to give priority to customer management",
            "客户管理": "Customer management",
            "按客户跟进": "Customer follow up",
            "发票公司抬头": "Invoice company",
            "跟进模式": "Follow-up mode",
            "帐单": "Bill",
            "发票信息": "Invoice Information",
            "重置": "Reset",
            "此客户的录单委托给指定网点": "Entrust this customer’s order to the designated outlet",
            "表示下周二开始计算回款期限": "Indicates that the payment period will be calculated from next Tuesday",
            "第一个为默认的录单网点": "The first one is the default Recording outlets",
            "当前客户删除失败！": "Failed to delete the current client!",
            "个邮箱": "Mailboxes",
            "请先选择要修改列": "Please select the column to modify first",
            "添加或者修改销售员，系统会根据时间排序并把下一个起始时间作为上一个时间的终止时间，确定继续保存吗？": "Add or modify a salesperson, the system will sort according to time and use the next start time as the end time of the previous time. Are you sure to continue saving?",
            "子客户目的国家简码自动分拣出子客户编码": "Sub-customer destination country shortcode automatically sorts out sub-customer codes",
            "请填写销售员": "Please fill in the salesperson",
            "港后指定处理岗位": "Port post-processing",
            "收件人管理": "Recipient management",
            "提示": "hint",
            "账单接收邮箱": "Invoice receiving email",
            "委托录单网点列表": "List of commissioned sites",
            "导出": "Export",
            "财务联络电话": "Financial contact number",
            "自结算日开始多少天内回款": "How many days from the settlement date to receive the payment",
            "港前客服": "CS before port",
            "基础信息": "Basic Info",
            "联系人": "Contact person",
            "自动生成账单": "Automatic bill generation",
            "业务电话": "Business phone",
            "邮箱地址": "email address",
            "请选择\"税金押金币别\"!": "Please select \"tax deposit currency\"!",
            "中文地址": "Chinese address",
            "身份证号": "ID number",
            "请选择\"客户分类\"！": "Please select \"Classification\"!",
            "运费押金币别": "Freight deposit currency",
            "请谨慎修改": "Please modify carefully",
            "起始日期": "Start date",
            "新增客户成功": "Successfully added customers",
            "税号": "Tax number",
            "家": "Family",
            "其次取值问题状态": "Secondly, the status of the value problem",
            "可用于子客户分拣和统一以主客户收款": "Can be used for sub-customer sorting and unified collection of main customers",
            "请选择所属网点": "Please select a Outlets",
            "正在上传水单，请稍等": "Water bill is being uploaded, please wait",
            "发票": "bill",
            "此客户委托给任意网点录单": "This customer is entrusted to any outlet to record the order",
            "文件格式": "file format",
            "逾期利率": "Overdue interest rate",
            "当前客户即为主客户": "The current customer is the primary customer",
            "请选择跟单员": "Please select a merchandiser",
            "是否签合同": "Whether to sign a contract",
            "客户不委托": "Client does not entrust",
            "增加": "Increase",
            "合同信息": "Contract information",
            "网点未委托": "The outlet is not commissioned",
            "当前联系人删除成功": "The current contact was deleted successfully",
            "请选择默认帐单格式": "Please select the default billing format",
            "新增客户": "Add customer",
            "销售员": "Seller",
            "请填写起始时间": "Please fill in the start time",
            "网站限制查件": "Site restriction check",
            "港后问题件时": "In case of problems after port",
            "最多上传": "Upload at most",
            "跟单员": "Merchandiser",
            "单文件不超过": "Single file does not exceed",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "客户分类": "Classification",
            "超过回款期限开始计算逾期": "Overdue calculation begins after the payment period",
            "不限": "Unlimited",
            "发票地址": "Invoice address",
            "请先关联客户组！": "Please associate a customer group first!",
            "公司英文名称": "Company name in English",
            "客户附件": "Customer accessories",
            "港前": "Port front",
            "传真": "Fax",
            "此操作将删除该客户, 是否继续?": "This operation will delete the customer, do you want to continue?",
            "目的国家简码": "Destination country code",
            "创建时间": "Create time",
            "请先选择客户": "Please select customer first",
            "中转客户账单配置信息": "Transfer customer billing configuration information",
            "中转客户": "Transfer customer",
            "当前客户指定路线": "Current customer channel code",
            "中转客户指定路线": "Transfer customer channel code",

        },
        "BAS071": {
            "修改": "Modify",
            "保存并继续": "Save&continue",
            "出货批次规则第六段不能为空": "The sixth paragraph of the shipping batch rules cannot be empty",
            "修改成功": "Successfully modified",
            "请选择共享网点": "Please select a shared network",
            "自动生成出货批次规则": "Automatically generate shipping batch rules",
            "查询": "Search",
            "保存": "Save",
            "可多选": "Multiple choice",
            "自动生成规则第三段、第五段必填其一": "Either the third paragraph and the fifth paragraph of the automatic generation rule must be filled in",
            "创建人": "Creator",
            "第五段必填其一": "One of the fifth paragraph is required",
            "共享给指定": "Share to designated",
            "出货批次策略": "Shipment batch strategy",
            "请选择": "please choose",
            "请选择出货批次策略": "Please select shipping batch strategy",
            "启用状态": "Enabled state",
            "验证方式": "Ways of identifying",
            "所属网点": "Outlets",
            "修改人": "Modifier",
            "多个用逗号分隔": "Multiple separated by comma",
            "修改出货批次策略": "Modify shipping batch strategy",
            "为保证出货批次严谨性": "To ensure the rigor of the shipment batch",
            "策略名称": "Strategy name",
            "删除成功": "successfully deleted",
            "大包分拣码": "Box sorting code",
            "此操作将删除该出货批次策略, 是否继续?": "This operation will delete the shipment batch strategy, do you want to continue?",
            "备注": "Remark",
            "删除": "Delete",
            "自动生成规则第三段": "Automatically generate the third paragraph of the rule",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable status",
            "修改时间": "Modify time",
            "共享网点": "Shared network",
            "新增": "Add",
            "确定": "OK",
            "策略编码": "Strategy coding",
            "出货批次规则第四段不能为空": "The fourth paragraph of the shipping batch rule cannot be empty",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "提示": "Hint",
            "注": "Note",
            "共享方式": "Sharing method",
            "新增出货批次策略": "New shipping batch strategy",
            "新增成功": "Added successfully",
            "导出": "Export",
            "目的国家简码": "Destination country code",
            "请输入": "please input",
            "取消": "Cancel",
            "创建时间": "Create time",
            "出货批次规则中只能存在一段流水号规则": "Only one serial number rule can exist in the shipping batch rule",
            "大包分拣码（多个用逗号分隔）": "Box sorting code(Multiple separated by commas)",
            "共享网点(可多选)": "Shared network (multiple choices available)"
        },
        "BAS073":{
            "清关供应商":"Broker",
            "输入清关供应商检索":"Enter Broker search",
            "序列":"No.",
            "轨迹状态":"Status",
            "轨迹名称":"Staus Name",
            "轨迹阶段":"Status Stage",
            "轨迹类型":"Status Type",
            "匹配编码":"Mapping Code",
            "修改人":"Modify By",
            "修改时间":"Modify Time",
            "注：":"Note:",
            "1、匹配字符可修改删除，多个匹配字符以回车分隔；单个规则字符不允许超过40个字符；":"1. Matching characters can be modified and deleted. Multiple matching characters are separated by carriage return. A single rule cannot contain more than 40 characters.",
            "2、同时存在优先匹配轨迹编码；":"2. Priority matching trajectory coding exists at the same time;",
            "3、指定排除项，用于过滤指定轨迹。例如，不需要解析轨迹A，可设置A为指定排除项，后续A将不再解析到系统轨迹":"3. Specify exclusions for filtering specified trajectories. For example, track A does not need to be parsed. You can set A to specify exclusions. Subsequently, A will not be parsed to the system track",
        },
        "TMS009": {
            "修改": "Modify",
            "包数": "Number of packages",
            "装包数量必须大于0": "The number of packages must be greater than 0",
            "英文目的地": "English destination",
            "总体积": "Total volume",
            "邮包互换局": "Post and Parcel Interchange Office",
            "票数": "Votes",
            "请到": "Please come",
            "大包管理": "Box management",
            "完成": "Finish",
            "保存": "Save",
            "批量生成装包异常": "Batch generation package abnormal",
            "建包日期不能为空": "The package date cannot be empty",
            "建包日期": "Construction date",
            "装包管理": "Package management",
            "撤销完成异常": "Undo complete exception",
            "可多选": "Multiple choice",
            "撤销完成": "Undo complete",
            "批量生成装包成功！": "Batch generation and packaging succeeded!",
            "装包网点": "Packing outlets",
            "修改异常": "Modify exception",
            "目的城市": "Destination city",
            "总实重": "Total Actual weight",
            "操作": "Operation",
            "当前装包状态 不为\"已完成\", 不允许撤销完成": "The current package status is not \"completed\", and the undo completion is not allowed",
            "保存并打印": "Save and print",
            "注意": "Notice",
            "做完成装包操作？": "Do you complete the packing operation?",
            "中": "middle",
            "件数": "Number Of Item",
            "关包人": "Closer",
            "撤销装包": "Unpacking",
            "装包分析": "Packing analysis",
            "目的机场代码": "Destination airport code",
            "报关类型": "Type of customs declaration",
            "确认人": "Confirmor",
            "撤销装包成功！": "Unpacking successfully!",
            "重置": "Reset",
            "装包状态不为 “已建包”，不允许修改": "The package status is not \"built package\" and modification is not allowed",
            "目的地": "Destination",
            "核重人": "Nuclear heavy",
            "单票限制申报价值": "Single ticket limit declared value",
            "如未正常输出打印": "If the output is not normal, print",
            "核重重量": "Nuclear weight",
            "提示": "Hint",
            "装包完成成功！": "The package is completed successfully!",
            "装包日期不能为空": "Packing date cannot be empty",
            "长(cm)": "Length (cm)",
            "总运单确认时间": "Time to confirm the total waybill",
            "包材重(kg)": "Packing material weight (kg)",
            "完成装包异常": "Complete package abnormal",
            "存在装包状态不为\"已建包\"的装包, 不允许撤销装包": "There are packages whose package status is not \"built package\", and it is not allowed to cancel the package",
            "整包限制重量": "Weight limit for the whole package",
            "计划启程时间": "Planned departure time",
            "打印": "Print",
            "报关方式": "Declaration method",
            ":无票数, 无法打印": ": No votes, unable to print",
            "收货装包": "Receiving and packing",
            "导出": "Export",
            "实际为增加包号数据并完成打印的过程": "Actually increase the package number data and complete the printing process",
            "请输入": "please input",
            "取消": "Cancel",
            "关包时间": "Closing time",
            "总运单": "Master air waybill",
            "添加异常": "Add exception",
            "预打印包号": "Pre-printed package number",
            "出货实重": "Shipping actual weight",
            "请选择数据！": "Please select data!",
            "航班/车牌号": "Flight/license plate number",
            "保存并继续": "Save&continue",
            "核重时间": "Nuclear weight time",
            "是否对包号": "Whether to the package number",
            "出货时间": "Delivery time",
            "装包完成": "Packing is complete",
            "运单号码": "Order Number",
            "上板状态不满足条件<已完成，已到达>，不允许拆包": "The board status does not meet the condition <completed, reached>, unpacking is not allowed",
            "查询": "Search",
            "特殊单号": "Special order number",
            "出货批次": "Shipment batch",
            "最小单票限制申报价值不能大于最大单票限制申报价值": "The minimum single ticket limit declared value cannot be greater than the maximum single ticket limit declared value",
            "包号": "Package number",
            "装包状态": "Packing status",
            "一次打印份数最多不能超过": "The maximum number of copies printed at a time cannot exceed",
            "大包号": "Box number",
            "已合包，不允许拆包": "Closed, unpacking is not allowed",
            "请选择装包状态为\"已建包\"的数据!": "Please select the data whose package status is \"package built\"!",
            "撤销装包异常": "Undo the package exception",
            "撤销完成成功！": "The undo is completed successfully!",
            "中进行打印": "Print in",
            "出货人": "Shipper",
            "包号补打": "Package number make up",
            "当前包状态不为\"已建包\", 不允许装包完成": "The current package status is not \"built package\", and the package installation is not allowed to complete",
            "最小整包限制重量不能大于最大整包限制重量": "The minimum weight of the whole package cannot be greater than the maximum weight of the whole package",
            "高(cm)": "Height (cm)",
            "承运商": "Carrier",
            "打印完成": "Print completed",
            "包中运单": "In-package waybill",
            "计划到达时间": "Planned arrival time",
            "批量预打": "Batch pre-printing",
            "修改成功！": "Successfully modified!",
            "宽(cm)": "Width(cm)",
            "包号信息": "Package number information",
            "总件数": "total number",
            "大包分拣码": "Box sorting code",
            "走货路线": "Delivery route",
            "修改装包": "Modify the package",
            "备注": "Remark",
            "装包扫描": "Package scanning",
            "包材类型": "Packing material type",
            "请至少勾选一行数据": "Please check at least one row of data",
            "确定要撤销完成吗？": "Are you sure you want to undo completion?",
            "自动生成包号成功！": "The package number is automatically generated successfully!",
            "关闭": "Close",
            "预打印过程": "Pre-printing process",
            "简体目的地": "Simplified destination",
            "装包管理查询": "Package management query",
            "数据来源": "Data Sources",
            "新增装包": "New package",
            "请选择一行数据": "Please select a row of data",
            "装包策略": "Packing strategy",
            "确定要撤销装包吗？": "Are you sure you want to cancel the package?",
            "派件网点": "Distribution outlets",
            "新增": "Add",
            "确定": "OK",
            "目的地编码": "Destination code",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "添加成功！": "Added successfully!",
            "拆包": "Unpack",
            "货物类型": "Cargo type",
            "目的国家简码": "Destination country code",
            "生成包号异常！": "Abnormal package number generation!",
            "总票数": "Total votes",
            "份": "share",
            "运输方式": "Mode of transport",
            "走货路线(可多选)": "Delivery route (multiple choices available)",
            "整包限制重量（KG）": "Restricted weight of the whole package (KG)",
            "货物类型(可多选)": "Type of goods (multiple choices available)",
            "预打印过程，实际为增加包号数据并完成打印的过程": "The pre-printing process is actually the process of increasing the package number data and completing the printing process",
            "一次打印份数最多不能超过100份": "No more than 100 copies can be printed at a time",
            "如未正常输出打印，请到“装包管理”中，“打印.包号补打”中进行打印": "If the output is not printed normally, please go to \"Package Management\" and \"Print. Package Number Reprint\" to print",
            "尾程大包号": "LM Bag barcode",
            "打印尾程大包面单": "Print bag label",
        },
        "TMS114":{
            "轨迹匹配规则":"Status Mapping Rules",
            "清关轨迹匹配规则":"C/C Status Mapping Rules",
            "清关信息设置":"C/C Settings",
            "清关路线":"C/C Route",
            "序列":"No.",
            "轨迹状态":"Status",
            "轨迹名称":"Staus Name",
            "轨迹阶段":"Status Stage",
            "轨迹类型":"Status Type",
            "匹配编码":"Mapping Code",
            "修改人":"Modify By",
            "修改时间":"Modify Time",
            "清关供应商":"Broker",
            "正常":"Normal",
            "启用":"Enable status",
            "路线编码":"Route Code",
            "路线名称":"Route Name",
            "清关行":"Broker",
            "路线英文":"Route Name (Eng)",
            "路线简体":"Route shortcode",
            "路线分类":"Route Type",
            "目的地国家":"Destination",
            "备注":"Remarks",
            "建立时间":"Create Time",
            "建立人":"Create By",
            "路线编码/名称":"Route Code/Name",
            "启用状态":"Status",
            "查询":"Search",
            "重置":"Reset",
            "新增":"Add",
            "修改":"Modify",
            "删除":"Delete",
            "导出":"Export",
            "分类编码(分类名称）":"Category",
            "分批转机":"Transfer in Batches",
            "批次数":"Total Number of Batch",
            "推送清关数据":"Send C/C data",
            "推送状态":"C/C data status",
            "待推送":"Pending",
            "推送中":"Sending",
            "推送成功":"Sent",
            "推送失败":"Failed",
            "基础信息":"Basic Info",
            "目的地国家简码":"Destination country code",
            "特殊规则":"Special rules",
            "规则json":"Rule json",
            "保存":"Save",
            "关闭":"Close",
            "新增清关路线":"Add C/C Route",
            "编辑清关路线":"Edit C/C Route",
            "请选择一行数据":"Please select a row of data",
            "新增成功":"Added successfully",
            "修改成功":"Modified successfully ",
            "此操作将删除该行数据, 是否继续?":"This operation will delete the row data. Do you want to continue?",
            "提示":"Tips",
            "确定":"Sure",
            "取消":"Cancel",
            "删除成功":"Deleted successfully",

        },
        "BMS028":{
            "到达日":"Date of arrival",
            "启程日":"Date of departure",
            "车牌号":"license plate number",
            "航班":"Flight",
            "出港路由":"Outbound route",
            "可多选":"Multiple Choice",
            "出口清关关区":"Export customs clearance area",
            "入口清关关区":"Import customs clearance area",
            "自动生成总运单号规则":"Auto-generating of master air waybill number rule",
            "注意:为保证总运单号严谨性，规则第三段和第五段必填":"Attention: To ensure rigor, the third and fifth paragraphs of the rules are mandatory",
            "承运信息":"Carrier information",
            "序号":"No.",
            "操作":"Operation",
            "分段":"Subsection",
            "运输方式":"Transport Mode",
            "承运商":"Carrier",
            "航班/车牌号":"Flight/license plate number",
            "启程日期":"Date of departure",
            "启程时间":"Time of departure",
            "到达日期":"Date of arrival",
            "到达时间":"Time of arrival",
            "目的港":"Destination port",
            "保存并继续":"Save&continue",
            "确定要修改共享方式？":"Are you sure you want to modify the sharing method?",
            "取消":"Cancel",
            "确定":"OK",
            "共享给指定网点":"Share with designated outlets",
            "网点列表":"Outlets list",
            "指定网点":"Designated outlets",
            "保存":"Save",
            "关闭":"Close",
            "新增":"Add",
            "修改":"Modify",
            "删除":"Delete",
            "共享":"Share info",
            "不共享":"Not share",
            "共享给所有":"Share to all",
            "共享给指定":"Share to designated",
            "浏览":"View",
            "导出":"Export",
            "所属网点":"Outlets",
            "路由编码":"Route code",
            "名称":"name",
            "下一网点":"Next outlets",
            "干线运输方式":"Linehaul transport mode",
            "目的国家简码":"Destination country code",
            "启用状态":"Enable status",
            "查询":"Search",
            "重置":"Reset",
            "启用":"Enable status",
            "路由名称":"Route name",
            "始发港":"Departure port",
            "起运国家简码":"Departure country code",
            "目的港国家简码":"Destination Port Country Code",
            "提单计抛":"B/L charge weight rule",
            "计费货物类型":"Billing goods type",
            "共享方式":"Share method",
            "共享网点":"Share outlets",
            "备注":"Remark",
            "创建时间":"Create time",
            "创建人":"Creator",
            "修改时间":"Modify time",
            "修改人":"Modifier",

        },
        "TMS120": {
            "出库大包移交单":"Outbound box transfer document",
            "运单移交单":"Waybill transfer document",
            "小包分拣码":"Parcel sorting code",
            "修改": "Modify",
            "请选择一行运单数据": "Please select a row of waybill data",
            "修改成功": "Successfully modified",
            "出货批次发送时": "When shipping batches",
            "关联承运信息成功！": "Associated carrier information is successful!",
            "请选择一条数据": "Please select a piece of data",
            "交货承运代理必填": "Delivery carrier agent required",
            "查询": "Search",
            "保存": "Save",
            "出货批次": "Shipment batch",
            "已关联总运单包数": "Total number of associated waybill packages",
            "新增出货批次": "New shipment batch",
            "出货批次管理": "Shipment batch management",
            "出货批次状态不为\"已建立\",不允许修改": "The shipment batch status is not \"created\" and cannot be modified",
            "确认撤销此出货批次数据吗？": "Are you sure to cancel this shipment batch data?",
            "关联承运信息异常！": "The associated carrier information is abnormal!",
            "创建人": "Creator",
            "撤销成功！": "Successfully revoked!",
            "总实重": "Total Actual weight",
            "出货批次策略": "Shipment batch strategy",
            "发送人": "Sender",
            "请选择": "please choose",
            "出货批次状态不为“已发送”，无法撤销": "The shipment batch status is not \"sent\" and cannot be cancelled",
            "交货承运代理": "Delivery carrier agent",
            "基本信息": "Basic info",
            "出货批次数据": "Shipment batch data",
            "}>状态<{": "}>Status<{",
            "批次状态": "Batch status",
            "验证方式": "Ways of identifying",
            "可在出货批次管理中批量关联承运信息": "Shipment information can be associated in batches in shipment batch management",
            "出货批次单号<": "Shipment batch number<",
            "司机电话": "Driver phone",
            "车牌": "License plate",
            "修改人": "Modifier",
            "打印完成": "Print completed",
            "多个用逗号分隔": "Multiple separated by comma",
            "请求参数：": "Request parameters:",
            ">出货批次状态不等于\"已建立\"": ">The status of the shipment batch is not equal to \"created\"",
            "批次日期": "Batch date",
            "撤销失败！": "Unsuccessful!",
            "当出货批次状态 <> \"已建立\", 不允许继续出货": "When the shipment batch status <> \"Created\", it is not allowed to continue shipping",
            "修改出货批次": "Modify shipment batch",
            "当前没有选择出货批次，无法撤销": "No shipment batch is currently selected and cannot be undone",
            "大包分拣码": "Box sorting code",
            "总体积(m³)": "Total volume (m³)",
            "备注": "Remark",
            "发送时间": "Send time",
            "撤销": "Revoke",
            "出货网点": "Shipping outlets",
            "关闭": "Close",
            "重置": "Reset",
            "当出货批次状态不是 \"已建立\", 不允许撤销": "When the shipment batch status is not \"created\", cancellation is not allowed",
            "浏览": "Browse",
            "撤销发送": "Unsend",
            "修改时间": "Modify time",
            "}>（限制发送）": "}> (restrict sending)",
            "发送": "Send",
            "保存成功": "Saved successfully",
            "出货批次存在扫描明细数据时，限制撤销": "When there is scan detail data in the shipment batch, the restriction is cancelled",
            "交货司机": "Delivery driver",
            "保存异常": "Save exception",
            "新增": "Add",
            "确定": "OK",
            "提示": "Hint",
            "出货": "Handover to Linehaul",
            "出货批次<{": "Shipment batch<{",
            "注": "Note",
            "是否撤销已发送出货批次?": "Do you want to cancel the shipment batch that has been sent?",
            "撤销发送成功！": "Cancellation sent successfully!",
            "撤销发送失败！": "Failed to cancel sending!",
            "打印": "Print",
            "关联承运信息": "Associated carrier information",
            "导出": "Export",
            "保存并操作": "Save and Operation",
            "总包数": "Total packages",
            "目的国家简码": "Destination country code",
            "请输入": "please input",
            "取消": "Cancel",
            "创建时间": "Create time",
            "该出货批次没有明细！": "The shipment batch has no details!",
            "请至少选择一行数据！": "Please select at least one row of data!",
            "总票数": "Total votes",
            "交货承运信息": "Delivery Carrier Information",
            "出货实重": "Shipping actual weight",
            "生成接驳单": "Generate Connection",
            "走货路线":"Delivery route"
        },
        "shipment2": {
            "批次日期": "Batch date",
            "宽(cm)": "Width(cm)",
            "请输入大包号!": "Please enter the big package number!",
            "的出货批次": "Shipment batch",
            "扫描时间": "Scan time",
            "固定显示当前网点最近": "Fixed display of the current outlet closest",
            "大包分拣码": "Box sorting code",
            "包材类型": "Packing material type",
            "当前行双击后": "After double-clicking the current line",
            "请输入转运单号": "Please enter the transfer order number",
            "扫描成功!": "The scan was successful!",
            "出货批次": "Shipment batch",
            "请选择出货批次": "Please select shipping batch",
            "出货批次管理": "Shipment batch management",
            "将出货批次带入到扫描页面": "Bring the shipment batch to the scan page",
            "请选择出货批次!": "Please select the shipping batch!",
            "发送": "Send",
            "包材重量": "Packing material weight",
            "大包号": "Box number",
            "核重重量": "Nuclear weight",
            "出货批次策略": "Shipment batch strategy",
            "黑体 Regular": "Bold Regular",
            "注": "Note",
            "长(cm)": "Length (cm)",
            "请选择到件网点": "Please select a destination",
            "已建立": "It has been established",
            "重量": "weight",
            "选择批次": "Select batch",
            "扫描包数": "No. of scan box",
            "高(cm)": "Height (cm)",
            "目的国家简码": "Destination country code",
            "天内": "Within days",
            "总票数": "Total votes",
            "出货批次信息": "Shipment batch information"
        },
        "shipment2details": {
            "宽(cm)": "Width(cm)",
            "扫描时间": "Scan time",
            "发送异常": "Send exception",
            "问题状态": "Problem status",
            "大包分拣码": "Box sorting code",
            "登记人": "Register person",
            "问题运单列表": "List of problem waybills",
            "包材类型": "Packing material type",
            "运单号码": "Order Number",
            "发送时间": "Send time",
            "港前问题件处理完毕验证": "Verification of the handling of the problem before the port",
            "关闭": "Close",
            "扫描大包号回车搜索": "Scan the large package number and press Enter to search",
            "发送成功！": "Sent successfully!",
            "出货批次": "Shipment batch",
            "当前选择大包<": "Large package currently selected<",
            "发送": "Send",
            "问题描述": "Problem Description",
            "总实重": "Total Actual weight",
            "包材重量": "Packing material weight",
            "撤销大包": "Revoke selected box",
            "大包号": "Box number",
            "撤销大包异常": "Undo big package exception",
            "核重重量": "Nuclear weight",
            "确定": "OK",
            "输入": "Enter",
            "转单号码": "Tracking Number",
            "登记时间": "check-in time",
            "提示": "Hint",
            "长(cm)": "Length (cm)",
            ">个，确认从出货批次中撤销吗？？": ">A, is it confirmed to be withdrawn from the shipment batch? ?",
            "重量": "weight",
            "高(cm)": "Height (cm)",
            "总包数": "Total packages",
            "目的国家简码": "Destination country code",
            "取消": "Cancel",
            "撤销大包成功！": "Successfully canceled the big package!",
            "总票数": "Total votes",
            "请选择数据！": "Please select data!",
            "输入/扫描大包号回车搜索": "Enter/scan the large package number and press Enter to search",
            "是否复核":"Whether to review",
            "复核时间":"Review time",
            "走货路线":"Delivery route"
        },
        "TMS017": {
            "笔，确定重新发货吗?": "Pen, are you sure to resend it?",
            "重新发货成功！": "Re-shipment is successful!",
            "笔，确定取消退返吗?": "Pen, are you sure to cancel the return?",
            "退返备注": "Return notes",
            "运单号码": "Order Number",
            "退返时间": "Return time",
            "退返单号": "Return order number",
            "查询": "Search",
            "处理结果": "process result",
            "取消退返失败！": "Cancellation of return failed!",
            "撤销退返申请": "Cancellation of return application",
            "笔": "Total",
            "勾选的多条运单的客户必须是同一个才可打印！": "The customers of the checked multiple waybills must be the same before they can be printed!",
            "您选取的": "You select",
            "请选择申请退返时间": "Please select the time to apply for the return",
            "请选择数据": "Please select data",
            "笔记录数据": "data ,",
            "处理意见": "Handling opinions",
            "当前选择数据存在订单类型退返客户，不允许撤销退返申请": "The currently selected data has the order type to return to the customer, and it is not allowed to cancel the return application",
            "操作": "Operation",
            "包含待处理问题件": "Contains pending issues",
            "选择已退返数据": "Select returned data",
            "笔已退返客户": "has been returned to the customer, and",
            "选择待处理数据": "Select the data to be processed",
            "件数": "Number Of Item",
            "退返客户": "Return customer",
            "按当前时间发货": "Shipped at the current time",
            "处理状态": "Processing status",
            "录单网点": "Recording outlets",
            "申请退返时间": "Application time for return",
            "打印完成": "Print completed",
            "重新发货后，库存网点为当前操作网点，确认继续吗？?": "After re-delivery, the inventory outlets are the current operating outlets. Are you sure to continue? ?",
            "客户名称": "Customer name",
            "按原寄件日期发货": "Shipped according to the original shipping date",
            "退返客户失败！": "Failed to return the customer!",
            "当前选择数据存在订单类型退返客户，不允许重新发货": "The currently selected data has the order type to return to the customer, and re-delivery is not allowed",
            "取消退返成功！": "Cancellation returned successfully!",
            "是否重新发货?": "Will it be re-shipped?",
            "退返方式等于{第三方快递}时，退返单号必填": "When the return method is equal to {third-party express}, the return order number is required",
            "可处理笔数": "can be processed:",
            "关闭": "Close",
            "重置": "Reset",
            "退返方式": "Return method",
            "寄件网点": "Outlets",
            "当前有选择问题件存在已退返客户或重新发货数据，请检查后重试": "There are currently selected problem pieces that have been returned to the customer or re-shipped data, please check and try again",
            "客户": "Customer",
            "参考编号": "Ref number",
            "请选择已退返数据": "Please select returned data",
            "确定": "OK",
            "退返类型": "Return type",
            "转单号码": "Tracking Number",
            "提示": "Hint",
            "收费重": "Charge weight",
            "操作人": "Operator",
            "打印": "Print",
            "是否取消退返选择数据?": "Do you want to cancel the return of selected data?",
            "导出": "Export",
            "重新发货": "Redeliver",
            "请输入": "please input",
            "操作成功": "Successful operation",
            "退返客户成功！": "Return to the customer successfully!",
            "重新发货失败！": "Re-delivery failed!",
            "取消": "Cancel",
            "其中": "which",
            "您选择{length}笔数据，其中{error}笔已退返客户，可处理{correct}笔！":"You select {length} data,{error} of which has been returned to the customer,and {correct} can be processed!"
        },
        "TMS018": {
            "扫描时间": "Scan time",
            "分拣码": "Sort code",
            "出货重": "Shipping weight",
            ">票，其中有<": ">Tickets, which have<",
            "批量扫描": "Batch scan",
            "走货路线": "Delivery route",
            "出货时间": "delivery time",
            "请输入扫描单号": "Please enter the scan number",
            "运单号码": "Order Number",
            "当前包中有<": "There are <",
            "批量扫描运单异常": "Bulk scan waybill abnormal",
            "扫描票数": "Scan tickets",
            "指定路线": "Channel Code",
            "关闭": "Close",
            "笔运成功扫描": "Penyun successfully scanned",
            "保存": "Save",
            "总运单号": "MAWB",
            "出货批次": "Shipment batch",
            ">票已单独退件，是否继续将剩余<": ">Tickets have been returned separately, whether to continue to leave the remaining<",
            "目的地": "Destination",
            ">票做退件入库？": ">How to return the ticket to the warehouse?",
            "退件入库成功！": "Successfully returned and put into storage!",
            "批量扫描运单成功！": "The batch scanning of the waybill is successful!",
            "批量扫描运单": "Batch scan waybill",
            "客户": "Customer",
            "当前有": "Currently have",
            "运单号码不能为空": "Waybill number cannot be empty",
            "派件网点": "Distribution outlets",
            "整包退件": "Whole package return",
            "大包号": "Box number",
            "参考编号": "Ref number",
            "当整包退件时，将自动将包中明细全部转换为退件，是否继续？": "When the whole package is returned, all the details in the package will be automatically converted to return. Do you want to continue?",
            "确定": "OK",
            "取消扫描！": "Cancel scan!",
            "转单号码": "Tracking Number",
            "提示": "Hint",
            "黑体 Regular": "Bold Regular",
            "票": "ticket",
            "整包退件后": "After the whole package is returned",
            "直接将装包明细转换为运单": "Directly convert the packing details to the waybill",
            "件数": "Number Of Item",
            "货物类型": "Cargo type",
            "退件入库管理": "Return management",
            "扫描单号": "Scan order number",
            "取消": "Cancel",
            "退件原因": "Reason for Return"
        },
        "bounnemanagement": {
            "请选择需要处理的退件数据": "Please select the return data to be processed",
            "请选择需要撤销入库的数据": "Please select the data that needs to be withdrawn from storage",
            "处理信息": "Processing information",
            "分拣码": "Sort code",
            "出货重": "Shipping weight",
            "选择的数据中存在已处理数据": "Processed data exists in the selected data",
            "撤销入库成功！": "Cancellation of warehousing is successful!",
            "当前退件处理运单笔数": "Number of current waybills processed for return",
            "走货路线": "Delivery route",
            "出货时间": "Delivery time",
            "退件类型": "Return type",
            "运单号码": "Order Number",
            "指定路线": "Channel Code",
            "查询": "Search",
            "关闭": "Close",
            "退件处理": "Return processing",
            "处理结果": "Process result",
            "保存": "Save",
            "撤销入库": "Cancellation of storage",
            "重置": "Reset",
            "总运单号": "MAWB",
            "出货批次": "Shipment batch",
            "退件处理失败！": "Failed to process the return!",
            "目的地": "Destination",
            "客户": "customer",
            "已处理": "Processed",
            "派件网点": "Distribution outlets",
            "大包号": "Box number",
            "退件处理成功！": "Successful return processing!",
            "参考编号": "Ref number",
            "转单号码": "Tracking Number",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "处理说明": "Processing instructions",
            "请选择": "Please choose",
            "未处理天数": "Unprocessed days",
            "退件入库": "Returned items into storage",
            "退回网点": "Return to the outlet",
            "操作人": "Operator",
            "件数": "Number Of Item",
            "货物类型": "Cargo type",
            "导出": "Export",
            "处理状态": "Processing status",
            "退件入库管理": "Return management",
            "请输入": "please input",
            "扫描单号": "Scan order number",
            "退件入库时间": "Return shipment time",
            "退件原因": "Reason for Return"
        },

        "managewaybill": {
            "航班到达时间":"Flight arrival time",
            "子运单号":"Subwaybill number",
            "锁定":"Lock",
            "撤销锁定":"Undo lock",
            "总运单明细":"MAWB detail",
            "选取大包":"Select box",
            "撤销大包":"Revoke selected box",
            "大包号":"Box number",
            "扫描包数":"No. of scan box",
            "确认总运单":"",
            "附件一":"Appendix 1",
            "附件二":"Appendix 2",
            "附件三":"Appendix 3",
            "附件四":"Appendix 4",
            "附件五":"Appendix 5",
            "操作":"Operation",
            "X 笔":"Total X",
            "显示明文":"Display plaintext",
            "booking模板":"booking template",
            "是否撤销锁定下列总运单号:":"Are you sure to revoke locking the following master air waybill number:",
            "总运单撤销锁定":"MAWB revoke lock",
            "是否确认锁定下列总运单号:":"Are you sure to lock the following master air waybill number:",
            "总运单锁定确认":"MAMB lock confirmation",
            "出口清关抬头":"Export C/C title",
            "入口清关关区":"Import C/C area",
            "出口清关关区":"Export C/C area",
            "推送出口清关（正报）":"Push export CC(positive report)",
            "获取HS Code":"Obtain HS code",
            "下载干线booking模板":"Download booking template",
            "子运单箱号关系导入":"Import the sub-waybill box number",
            "邮件推送结果":"Email push results",
            "编辑附件":"Edit attachments",
            "提单附件":"Attachment to Bill of Lading",
            "出口清关推送状态":"Export clearance push status",
            "进口清关推送状态":"Import clearance push status",
            "HScode数":"No. of HScodes",
            "已获取HScode":"Obtained HScode",
            "下载干线booking邮件":"Download booking email",
            "推送干线booking邮件":"Push booking email",
            "推送邮件":"Push email",
            "下载附件":"Download attachment",
            "清关相关操作":"CC related operations",
            "Invoice维度报表":"Invoice dimension report",
            "导入":"Import",
            "请先确认总运单后再操作推送清关数据!":'Please confirm the waybill before operating the push customs clearance data!',
            "修改": "Modify",
            "笔总运单": "Master Air Waybill",
            "目的地港": "Destination Port",
            "总体积": "Total volume",
            "请选择状态为已建立的总运单": "Please select the master waybill whose status is established",
            "修改成功": "Successfully modified",
            "补录导入": "Supplementary import",
            "请输入提单重": "Please enter the B/L weight",
            "获取总运单信息异常": "Abnormal acquisition of master air waybill information",
            "保存": "Save",
            "按件数生成": "Generate by the number of pieces",
            "总运单号": "MAWB",
            "航班": "Flight",
            "条，已出货": "Article, shipped",
            "行的到达城市不能为空!": "The arrival city of the line cannot be empty!",
            "请选择提单计抛": "Please choose B/L charge weight rule",
            "可多选": "Multiple choice",
            "创建人": "Creator",
            "干线运输方式等于空运时，计费货物类型必填!": "When the trunk line transportation method is equal to air transportation, the chargeable cargo type is required!",
            "总运单信息": "Master Air Waybill Information",
            "总实重": "Total Actual weight",
            "补录成功！": "Successful supplementary recording!",
            "保存成功，成功": "Save successfully, successful",
            "此操作将删除该承运信息, 是否继续?": "This operation will delete the carrier information, do you want to continue?",
            "补录失败！": "Failed to make up the recording!",
            "附件": "Appendix",
            "张": "Open",
            "总运单状态不为“已建立”，无法撤销！": "The status of the master waybill is not created\" and cannot be cancelled!\"",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "请选择": "Please choose",
            "清单导出": "List Export",
            "干线运输方式": "Linehaul transport mode",
            "请选择总运单": "Please select the master air waybill",
            "变更总运单日期成功！": "Successfully changed the date of the master air waybill!",
            "有退件": "Return or not",
            "只能上传jpg/jpeg/png/pdf文件": "Only upload jpg/jpeg/png/pdf files",
            "撤销确认": "Revoke Confirmation",
            "请勾选总运单": "Please check the master waybill",
            "维度报表": "Dimension Report",
            "总运单管理": "Master Air Waybill Management",
            "提单重需大于0，请重新输入": "The weight of the bill of lading must be greater than 0, please re-enter",
            "下一网点": "Next outlets",
            "修改人": "Modifier",
            "车牌号": "Number plate",
            "其他运输单号": "Other shipping note number",
            "变更总运单日期异常！": "Change the date of the master waybill is abnormal!",
            "确认异常": "Confirm exception",
            "干线运输方式为空运，请录入提单图片后再确认": "The trunk line transportation method is air freight, please enter the bill of lading picture before confirming",
            "保存成功！": "Saved successfully!",
            "撤销失败！": "Unsuccessful!",
            "总运单确认": "Master Air Waybill Confirmation",
            "序号": "No.",
            "删除成功": "successfully deleted",
            "到达时间": "Time of arrival",
            "关联大包": "Associate box",
            "删除": "Delete",
            "二程提单": "Second way B/L",
            "确认人": "Confirmor",
            "重置": "Reset",
            "目的港": "Destination",
            "目的地": "Destination",
            "此操作将撤销总运单, 是否继续?": "This operation will cancel the master air waybill, do you want to continue?",
            "保存成功": "Saved successfully",
            "总运单不是已建立，无法修改!": "The master air waybill has not been created and cannot be modified!",
            "共选取": "Total selection",
            "启程时间": "Departure Time",
            "总运单状态不为“已确认”，无法补录！": "The status of the master waybill is not confirmed\" and cannot be added!\"",
            "分段": "Segmentation",
            "补": "Supplement or not",
            "提示": "Hint",
            "提单材重": "B/L vol weight",
            "提单体积": "B/L volume",
            "请输入提单材重": "Please enter the B/L vol weight",
            "请选择需要打印的总运单": "Please select the master air waybill to be printed",
            "提单重": "B/L weight",
            "是否撤销已发送总运单?": "Do you want to cancel the sent master air waybill?",
            "大包出货报表": "Large Package Shipment Report",
            "总运单日期": "MAWB date",
            "新增成功": "Added successfully",
            "浏览总运单": "Browse Master Air Waybill",
            "打印": "Print",
            "报关方式": "Declaration method",
            "承运信息": "Carriage Information",
            "导出": "Export",
            "请输入": "Please input",
            "运单维度报表": "Waybill dimension report",
            "取消": "Cancel",
            "总运单": "Master Air Waybill",
            "出货实重": "Shipping actual weight",
            "异常": "Exception",
            "头程提单": "First way B/L",
            "补录": "Supplementary record",
            "请选择寄件日期": "Please select the Inbound Date",
            "请核实": "Please check",
            "运单号码": "Order Number",
            "请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?": "Please confirm the integrity of the shipping information and the weight of the bill of lading, do you really want to confirm the master air waybill?",
            "查询": "Search",
            "保存并确认": "Save and Confirm",
            "总运单不是已建立，无法添加预出货运单!": "The master air waybill has not been created, and it is not possible to add a pre-out waybill!",
            "干线运输方式不等于<自交>时承运信息必填，请录入承运信息": "The carrier information is required when the trunk transportation method is not equal to <self-contained>, please enter the carrier information",
            "提单实重": "B/L actual weight",
            "不超过": "Does not exceed",
            "多笔运单回车换行输入": "Carriage return and line feed input for multiple waybills",
            "总运单状态等于已建立时，才允许变更总运单日期！": "The master waybill date is only allowed to be changed when the status of the master waybill is equal to established!",
            "提单实重需大于0，请重新输入": "The actual weight of the bill of lading must be greater than 0, please re-enter",
            "确认成功！": "Confirmation succeeded!",
            "计费货物类型": "Billing goods type",
            "撤销成功！": "Revocation successful!",
            "请勾选总运单!": "Please check the master air waybill!",
            "出港路由未设置承运信息，是否继续保存": "Shipping information is not set in the outbound route, whether to continue to save it",
            "重量信息": "Weight Information",
            "出港路由": "Outbound Route",
            "当前没有选择总运单，无法撤销": "Currently there is no master air waybill selected and cannot be cancelled",
            "干线运输方式不等于自交时，头程提单必填": "When the trunk transportation method is not equal to self-delivery, the first bill of lading is required",
            "提单分组导出": "B/L group export",
            "承运商": "Carrier",
            "预出货": "Pre-shipment",
            "条，已预出货": "Article, pre-shipped",
            "行的目的港不能为空!": "The destination port of the line cannot be empty!",
            "打印完成": "Printing completed",
            "多个用逗号分隔": "Multiple separated by comma",
            "按转单子单": "According to the transfer order sub-order",
            "总运单状态": "MAWB status",
            "该总运单日期超过一个月，无法补录！": "The master air waybill date is more than one month and cannot be re-entered!",
            "运输单号": "Shipping Order Number",
            "该总运单状态不为“已建立”，无法继续出货，请重新选择!": "The status of the master waybill is not created\" and cannot continue to ship. Please select again!\"",
            "请谨慎操作": "Please proceed with caution",
            "总运单打印": "Master Air Waybill Printing",
            "走货路线": "Delivery route",
            "增加": "Increase",
            "行的承运商不能为空!": "The carrier of the line cannot be empty!",
            "备注": "Remark",
            "以上单号为失败单号": "The above order number is the failure order number",
            "行的运输方式不能为空!": "The shipping method of the line cannot be empty!",
            "总运单类型不为\"已建立\"，无法关联大包": "The type of the general waybill is not established\", and cannot be associated with large packages\"",
            "提单件数需大于0，请重新输入": "The number of bills of lading must be greater than 0, please re-enter",
            "退件实重": "Actual weight of return",
            "一次转飞港":"OneDiverted",
            "二次转飞港":"TwoDiverted",
            "三次转飞港":"ThreeDiverted",
            "四次转飞港":"FourDiverted",
            "请选择一条数据导出!": "Please select a piece of data to export!",
            "修改总运单": "Modify Master Air Waybill",
            "请至少勾选一行数据": "Please check at least one row of data",
            "文件大小不能大于5M": "File size cannot be greater than 5M",
            "撤销": "Cancel",
            "关闭": "Close",
            "始发港": "Departure Port",
            "退件票数": "Number of returns",
            "忽略补录总运单": "Ignore supplemental MAWB",
            "该总运单为补录单，无法修改!": "The master air waybill is a supplementary record and cannot be modified!",
            "请输入提单实重": "Please enter the B/L actual weight",
            "修改时间": "Modify time",
            "条，失败": "Article, failed",
            "行的分段不能为空!": "The segment of the line cannot be empty!",
            "请选择一行数据": "Please select a row of data",
            "提单件数": "B/L quantity",
            "格式图片文件": "Format Picture File",
            "派件网点": "Dispatch Outlets",
            "条，其中不存在运单": "Article, there is no waybill in it",
            "附件信息": "Attachment Information",
            "新增": "Add",
            "确定": "OK",
            "确认时间": "Confirmation time",
            "请选择总运单!": "Please select the master air waybill!",
            "变更总运单日期": "Change MAWB date",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "条，已绑定其他": "Article, has been bound to others",
            "按运单子单": "By waybill sub-bill",
            "请选择状态为已确认的总运单": "Please select the master waybill whose status is confirmed",
            "您真的要补录总运单吗？（补录的总运单与原总运单相同日期；总运单号在原总运单上 + ‘-B’ + 1位流水号）": "Do you really want to make up the master air waybill? (The supplemented master air waybill has the same date as the original master air waybill; the master air waybill number is on the original master air waybill + ‘-B’ + 1 serial number)",
            "新增总运单": "Add Master Air Waybill",
            "提单图片": "Bill of Lading Picture",
            "确认信息": "Confirmation Information",
            "总包数": "Total packages",
            "目的国家简码": "Destination country code",
            "提单计抛": "B/L charge weight rule",
            "确认": "Confirm",
            "创建时间": "Create time",
            "承运信息第": "Carriage Information Section",
            "只能上传": "Only upload",
            "操作网点": "Operation outlets",
            "总票数": "Total votes",
            "总运单状态不为“已发送”，无法撤销": "The status of the master waybill is not sent\" and cannot be cancelled\"",
            "特殊报表": "Special report",
            "干线运输方式为“自交”时，无需填写承运信息": "When the trunk line transportation method is self-contained\", there is no need to fill in the carrier information\"",
            "运输方式": "Transport Method",
            "航班/车牌号": "Flight/License Plate Number",
            "Spring Post 预报 只允许大包维度导出!":"Spring Post reports only allow Big Bag dimension exports!",
            "清关路线":"C/C Route",
            "推送状态":"C/C data status",
            "推送清关数据":"Send C/C data",
            "分批转机":"Transfer in Batches",
            "批次数":"Total Number of Batch",
            "起运国家简码":"Departure country code",
            "目的港国家简码":"Destination Port Country Code",
        },
        "sendwaybill": {
            ",非出港路由目的地": ", Non-outbound routing destination",
            "当前总运单没有装包数据！": "The current master air waybill has no package data!",
            "票数": "Votes",
            "登记人": "Register person",
            "请输入提单重": "Please enter the B/L weight",
            "选择板异常": "Select board abnormal",
            "获取总运单信息异常": "Obtaining the master waybill information is abnormal",
            "选择": "choose",
            "保存": "Save",
            "总运单号": "MAWB",
            "航班": "flight",
            "发送成功！": "Sent successfully!",
            "笔": "0",
            "建包日期": "Construction date",
            "选取板": "Pick board",
            "请选择提单计抛": "Please select B/L charge weight rule",
            "选择运单异常": "Select the waybill exception",
            "总运单信息": "Master air waybill information",
            "总实重": "Total Actual weight",
            "单号类型": "Single number type",
            "附件": "Appendix",
            "张": "Open",
            "请选择": "Please choose",
            "干线运输方式": "Linehaul transport mode",
            "注意": "Notice",
            "核重重量(kg)": "Nuclear weight (kg)",
            "只能上传jpg/jpeg/png/pdf文件": "Only jpg/jpeg/png/pdf files can be uploaded",
            "提单重需大于0，请重新输入": "The weight of the bill of lading must be greater than 0, please re-enter",
            "下一网点": "Next outlets",
            "异常说明": "Exception description",
            ",报关方式不符": ", The customs declaration method does not match",
            "笔，失败": "Pen, fail",
            "扫描单号": "Scan order number",
            "车牌号": "Number plate",
            "其他运输单号": "Other shipping number",
            "确认异常": "Confirm exception",
            "保存成功！": "Saved successfully!",
            "撤销失败！": "Unsuccessful!",
            "总运单确认": "Master air waybill confirmation",
            "库存件数": "Number of inventory",
            "序号": "No.",
            "上板日期": "Date on board",
            "显示包": "Show package",
            "上板策略": "Listing strategy",
            "关联时间": "Associated time",
            ",走货路线不符": ", The delivery route does not match",
            "选择运单成功！": "The waybill is selected successfully!",
            "二程提单": "Second way B/L",
            "重置": "Reset",
            "请输入大包号回车搜索": "Please enter the big package number and press Enter to search",
            "目的港": "Destination",
            "板号": "Board number",
            "寄件网点": "Outlets",
            "选择板": "Selection board",
            "目的地": "Destination",
            "录入提单重后未及时确认": "After entering the bill of lading weight, it is not confirmed in time",
            "撤销大包": "Revoke selected box",
            "撤销运单": "Cancel the waybill",
            "入库时间": "Storage time",
            "分段": "Segmented",
            "转单号码": "Tracking Number",
            "提示": "Hint",
            "提单材重": "B/L vol weight",
            "请输入提单材重": "Please enter the B/L vol weight",
            "提单重": "B/L weight",
            "长(cm)": "Length (cm)",
            "选择包成功！": "The package selection is successful!",
            "选择板成功": "Select board success",
            "报关方式": "Declaration method",
            "承运信息": "Carriage Information",
            "请输入": "Please input",
            "选择运单成功": "Select the waybill successfully",
            "取消": "Cancel",
            "出货批次号": "Shipment batch number",
            "选择运单": "Choose waybill",
            "出货实重": "Shipping actual weight",
            "头程提单": "First way B/L",
            "发送异常": "Send exception",
            "问题状态": "Problem status",
            "重量(kg)": "Weight (kg)",
            "上板状态": "On board status",
            "运单号码": "Order Number",
            ",客户锁机": ",Customer lock machine",
            "操作员": "Operator",
            "请确认承运信息与提单重量的完整性, 您真的要做总运单确认吗?": "Please confirm the integrity of the shipping information and the weight of the bill of lading. Do you really want to confirm the master air waybill?",
            "有部分运单包含在其他总运单中或少件未出，是否继续发送?": "Some of the waybills are included in other master waybills or there are few pieces that have not been shipped. Do you want to continue sending?",
            "查询": "Search",
            "系统将在": "System will be in",
            "保存并确认": "Save and confirm",
            "特殊单号": "Special order number",
            "出货批次": "Shipment batch",
            "提单实重": "B/L actual weight",
            "撤销包关联": "Unlink package",
            "不超过": "Does not exceed",
            "装包状态": "Packing status",
            "问题描述": "Problem Description",
            ",非预出货运单": ", Non-pre-shipped freight bill",
            "提单实重需大于0，请重新输入": "The actual weight of the bill of lading must be greater than 0, please re-enter",
            "确认成功！": "Confirmed successfully!",
            "撤销成功！": "Successfully revoked!",
            "包材重量": "Packing material weight",
            "大包号": "Box number",
            "当前总运单没有上板数据！": "The current master air waybill has no board data!",
            "重量信息": "Weight information",
            "出货总运单": "Shipment master waybill",
            "出港路由": "Outbound route",
            "选择包成功": "Select package successfully",
            "待出件数": "Number of pieces to be shipped",
            "当前没有数据，无法选择": "There is currently no data and cannot be selected",
            "天后自动确认该总运单": "Automatically confirm the master air waybill after days",
            "打印参数": "Printing parameters",
            "选取待出货运单": "Select pending shipment",
            ",排货状态不符": ", The discharge status does not match",
            "干线运输方式不等于自交时，头程提单必填": "When the trunk transportation method is not equal to self-delivery, the first bill of lading is required",
            "高(cm)": "Height (cm)",
            "承运商": "Carrier",
            "行的目的港不能为空!": "The destination port of the line cannot be empty!",
            "预出货异常": "Pre-shipment exception",
            "运输单号": "Transport order number",
            "宽(cm)": "Width(cm)",
            "扫描时间": "Scan time",
            "排货状态": "Arrangement status",
            "扫描件数": "Number of scans",
            "总件数": "Total number",
            "大包分拣码": "Box sorting code",
            "走货路线": "Delivery route",
            "行的承运商不能为空!": "The carrier of the line cannot be empty!",
            "备注": "Remark",
            "选择包异常": "Select package exception",
            "问题运单列表": "List of problem waybills",
            "包材类型": "Packing material type",
            "提单件数需大于0，请重新输入": "The number of bills of lading must be greater than 0, please re-enter",
            "行的运输方式不能为空!": "The shipping method of the line cannot be empty!",
            "显示板": "Display board",
            ">吗?": ">?",
            "文件大小不能大于5M": "File size cannot be greater than 5M",
            "撤销": "Revoke",
            "关闭": "Close",
            "始发港": "Departure Port",
            "总价值": "Total value",
            "没有已排货运单，无法选择": "There is no scheduled freight order, unable to select",
            "选取大包": "Select box",
            "真的要撤销运单<": "Really want to cancel the waybill<",
            "请输入提单实重": "Please enter the B/L actual weight",
            "请输入出货件数": "Please enter the number of shipments",
            "撤销板关联": "Unlink board",
            "提单件数": "B/L quantity",
            "客户": "Customer",
            "格式图片文件": "Format picture file",
            "派件网点": "Distribution outlets",
            "寄件日期": "Inbound Date",
            "附件信息": "Attachment information",
            "参考编号": "Ref number",
            "大包号码": "Large package number",
            "建板日期": "Build date",
            "确定": "OK",
            "当前运单是包中运单或板中运单，无法单独撤销!": "The current waybill is the waybill in the package or the waybill in the board, which cannot be cancelled individually!",
            "登记时间": "Check-in time",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "走货路线分类": "Route classification",
            "当前没有数据，无法撤销!": "There is currently no data and cannot be undone!",
            "确认信息": "Confirm information",
            "货物类型": "Cargo type",
            "总包数": "Total packages",
            "目的国家简码": "Destination country code",
            "提单计抛": "B/L charge weight rule",
            "确定要撤销大包吗?": "Are you sure you want to cancel the big package?",
            "承运信息第": "Carriage Information Section",
            "只能上传": "Can only upload",
            "总票数": "Total votes",
            "无有效数据，无法选择": "No valid data, can't choose",
            "当前没有数据，无法撤销": "There is currently no data and cannot be undone",
            "选择板成功！": "The selection board is successful!",
            "运输方式": "Mode of transport",
            "航班/车牌号": "Flight/license plate number"
        },
        "zydglimport": {
            "历史日志": "History Log",
            "成功": "Success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "单号": "Number",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "验证中": "Verifying",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please choose to import a template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import History Log",
            "总行数": "Total number of rows",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "补录导入成功": "Successful import of supplementary records",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template Download",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please input",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "错误行数": "Number of error lines",
            "导入模版": "Import template"
        },
        "TMS032": {
            "注意：总运单确认后才允许操作轨迹":"Attention: The operation trajectory is only allowed after the MAWB is confirmed",
            "总运单状态":"MAWB status",
            "子单号":"Sub-order number",
            "交货给干线代理修改人":"Linehaul pickup modifier",
            "交货给干线代理修改时间":"Linehaul pickup modify time",
            "出口清关开始修改人":"Export customs clearance start modifier",
            "出口清关开始修改时间":"Export customs clearance start modify time",
            "出口清关扣查修改人":"Export customs clearance on hold modifier",
            "出口清关扣查修改时间":"Export customs clearance on hold modify time",
            "出口清关扣件不放行修改人":"Export customs clearance not release modifier",
            "出口清关扣件不放行修改时间":"Export customs clearance not release modify time",
            "出口清关成功修改人":"Export Custom Cleared modifier",
            "出口清关成功修改时间":"Export Custom Cleared modify time",
            "航班起飞时间修改人":"air freight uplift modifier",
            "航班起飞时间修改时间":"air freight uplift modify time",
            "航班抵达时间修改人":"air freight arrived modifier",
            "航班抵达时间修改时间":"air freight arrived modify time",
            "入口清关成功修改人":"Successful import clearance modifier",
            "入口清关成功修改时间":"Successful import clearance modify time",
            "交货到末公里修改人":"Handover to Lastmile modifier",
            "交货到末公里修改时间":"Handover to Lastmile modify time",
            "共选取x笔总运单数据":"Select x MAWB data in total",
            "将在x笔总运单中补录轨迹 “ ”！":"Track will be added to the x master air waybill",
            "子运单轨迹维护":"Maintain subwaybill tracks",
            "子运单号":"Subwaybill number",
            "追踪状态": "Tracking Status",
            "最新状态时间": "Latest status time",
            "批量录入轨迹": "Batch input track",
            "日志信息": "Log Info",
            "入口清关扣查票数": "Quantity of import clearance onhold",
            "轨迹状态": "Track Status",
            "出货日期不能为空": "The shipping date cannot be empty",
            "轨迹描述": "Track Description",
            "运输号码为空": "Shipping number is empty",
            "助手返回任务id失败": "Assistant failed to return task id",
            "将在":"Track will be added to the ",
            "笔总运单中补录轨迹": "master air waybill",
            "保存": "Save",
            "总运单号": "MAWB",
            "航班": "Flight",
            "总运单信息": "Master Air Waybill Information",
            "补录成功！": "Successful supplementary recording!",
            "失败": "Fail",
            "操作": "Operation",
            "航班起飞时间": "Flight Departure Time",
            "出口清关开始": "Export customs clearance start",
            "出口清关扣查": "Export customs clearance on hold",
            "出口清关扣件不放行": "Export customs clearance not release",
            "轨迹地点不能为空!": "The track location cannot be empty!",
            "导入轨迹": "Import Track",
            "干线运输方式": "Linehaul transport mode",
            "注意": "Notice",
            "其他": "Other",
            "请选择总运单": "Please select the master air waybill",
            "扫描编码": "Scan Code",
            "清关代理": "Customs clearance agent",
            "下一网点": "Next outlets",
            "批量录入异常": "Batch Entry Abnormal",
            "出货件数": "Number of Shipments",
            "车牌号": "Number plate",
            "其他运输单号": "Other shipping note number",
            "没有查询到当前总运单关联的运单": "There is no waybill associated with the current master waybill",
            "问题件登记": "Problem registration",
            "追踪进行中，请稍候查询": "Tracking in progress, please wait for inquiries",
            "交货给干线代理":"Linehaul pickup",
            "出口清关成功": "Export Custom Cleared",
            "交货到末公里": "Handover to lastmile",
            "序号": "No.",
            "录入成功！": "The entry is successful!",
            "删除成功": "Successfully deleted",
            "错误原因": "Wrong reason",
            "删除": "Delete",
            "二程提单": "Second way B/L",
            "出货票数": "Number of votes shipped",
            "重置": "Reset",
            "轨迹时间": "Track Time",
            "需要追踪的数据不能为空": "The data to be tracked cannot be empty",
            "共选取": "Total selection",
            "所有存在异常": "All there are exceptions",
            "追踪网络为空": "Tracking network is empty",
            "提示": "Hint",
            "运输号码": "Shipping Number",
            "已有一笔科目相同的账单，是否继续？": "There is already a bill with the same account, do you want to continue?",
            "总运单日期": "MAWB date",
            "新增成功": "Added successfully",
            "报关方式": "Declaration method",
            "补录异常": "Supplementary Recording Abnormal",
            "导出": "Export",
            "获取扫描状态异常": "Get Scanning Status Abnormal",
            "请输入": "Please input",
            "取消": "Cancel",
            "入口清关成功": "Successful import clearance",
            "只查看含承运分段": "Only view the subsections that contain the carrier",
            "出货实重": "Shipping actual weight",
            "批量登记": "Bulk registration",
            "头程提单": "First way B/L",
            "笔总运单数据": "MAWB data in total",
            "到达城市": "Arrival city",
            "导出日志": "Export log",
            "总运单确认后才允许操作轨迹": "Operation trajectory is allowed only after the master air waybill is confirmed",
            "获取承运信息异常": "Abnormal acquisition of carrier information",
            "成功": "Success",
            "刷新到达信息成功！": "Refresh the arrival information successfully!",
            "追踪日志": "Tracking Log",
            "全部": "All",
            "轨迹地点": "Track Location",
            "操作员": "Operator",
            "查询": "Search",
            "只能选择一行数据进行问题件登记": "Only one row of data can be selected for problem registration",
            "没有数据可以导出！": "There is no data to export!",
            "总数": "Total",
            "查询追踪数据中,请稍候": "Querying tracking data, please wait",
            "请勾选总运单!": "Please check the master air waybill!",
            "承运代理": "Carrier Agent",
            "物流助手初始化失败,请稍后重试": "The logistics assistant failed to initialize, please try again later",
            "追踪网络": "Tracking Network",
            "航班号": "Flight number",
            "批量录入成功！": "Batch entry is successful!",
            "出港路由": "Outbound Route",
            "刷新完成！": "Refresh complete!",
            "轨迹信息": "Trajectory information",
            "干线轨迹追踪": "Trunk Track Tracking",
            "跟踪记录": "TRACK & TRACE",
            "干线扫描状态": "Linehaul Scan Status",
            "录入异常": "Input Abnormal",
            "承运商": "Carrier",
            "干线承运信息": "Mainline Carriage Information",
            "运输单号": "Shipping Order Number",
            "刷新扣查票数": "Refresh the number of deducted votes",
            "出发城市": "Departure city",
            "运输单号补录": "Transportation note number supplement",
            "走货路线": "Delivery route",
            "轨迹时间不能为空!": "The track time cannot be empty!",
            "备注": "Remark",
            "关闭": "Close",
            "始发港": "Departure Port",
            "请输入运单号码": "Please enter the waybill number",
            "录入轨迹": "Enter Track",
            "请选择一行数据": "Please select a row of data",
            "请选择至少一行数据": "Please select at least one row of data",
            "刷新到达信息异常": "Refresh arrival information exception",
            "派件网点": "Dispatch Outlets",
            "确定": "OK",
            "轨迹时间不能小于之前的轨迹时间!": "The track time cannot be less than the previous track time!",
            "请选择总运单!": "Please select the master air waybill!",
            "航班抵达时间": "Flight Arrival Time",
            "中程起運":"Middlemile Uplift",
            "中程转运中":"Middlemile InTransit",
            "中程抵达":"Middlemile Arrived",
            "最新状态": "Latest status",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "--请求轨迹原数据失败--": "--Failed to request the original track data--",
            "补录费用": "Additional Fees",
            "错误日志": "Error log",
            "操作方式": "Operation method",
            "只能选择一行数据进行补录": "Only one line of data can be selected for supplementary recording",
            "获取运单信息异常": "Abnormal Obtaining Waybill Information",
            "目的国家简码": "Destination country code",
            "超2天未更新": "Not updated for more than 2 days",
            "操作网点": "Operation outlets",
            "编辑轨迹": "Edit Track",
            "运输方式": "Transport Method",
            "航班/车牌号": "Flight/License Plate Number"
        },
        "gxgjglimport": {
            "历史日志": "History Log",
            "成功": "Success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "验证中": "Verifying",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please choose to import a template!",
            "总运单/提单号": "Master Waybill/Bill of Lading Number",
            "干线轨迹导入成功": "The main line trajectory was imported successfully",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import History Log",
            "总行数": "Total number of rows",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template Download",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please input",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "行号": "Line number",
            "错误行数": "Number of error lines",
            "导入模版": "Import template"
        },
        "TMS014": {
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "问题单号": "Issue number",
            "问题状态": "Problem status",
            "登记人": "Register person",
            "登记成功！": "Registration is successful!",
            "小时": "Hour",
            "运单号码": "Order Number",
            "关闭": "Close",
            "批量登记异常": "Batch registration exception",
            "当前": "Current",
            "回复提交": "Reply to submission",
            "输入处理意见后": "After inputting the handling comments",
            "可多选": "Multiple choice",
            "多笔运单回车换行输入": "Carriage return and line feed input for multiple waybills",
            "问题件通知人": "Problem notification person",
            "登记": "Register",
            "问题描述": "Problem Description",
            "指定处理人": "Designated processor",
            "当前有": "Currently have",
            "附件": "Appendix",
            "参考编号": "Ref number",
            "确定": "OK",
            "文件大小不能大于15MB": "File size cannot be larger than 15MB",
            "通知人": "Alert others",
            "批量登记成功！": "Batch registration is successful!",
            "笔单号问题件已存在，不允许重复登记": "The problem with the order number already exists, and duplicate registration is not allowed",
            "转单号码": "Tracking Number",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "笔运单未能成功登记问题件": "The waybill failed to successfully register the problem piece",
            "登记网点": "Registration Points",
            "处理时限": "Processing time limit",
            "问题件信息": "Problem information",
            "导入登记": "Import Registration",
            "可": "Can",
            "处理网点": "Processing warehouse",
            "文件还未上传成功，请等待文件上传成功后再登记！": "The file has not been uploaded successfully, please wait for the file to upload successfully before registering!",
            "处理状态": "Processing status",
            "请输入": "please input",
            "获取运单信息失败！": "Failed to obtain waybill information!",
            "取消": "Cancel",
            "登记异常": "Registration exception",
            "获取问题状态信息失败！": "Failed to obtain problem status information!",
            ">存在未处理完成问题件，确定继续登记吗？": ">There are unprocessed problems, are you sure to continue registration?",
            "问题件登记": "Problem registration",
            "批量登记": "Bulk registration",
            "截止处理时间": "Deadline for processing",
            "输入处理意见后可回复提交": "You can reply and submit after inputting the handling comments",
            "通知人可多选": "Alert others",
            "处理时限(H)": "Processing time limit(H)",
            "运单号码(多笔运单回车换行输入)": "Waybill number (enter multiple waybills by carriage return and line feed)"
        },
        "gqwtjimport": {
            "历史日志": "History Log",
            "成功": "success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "验证失败": "verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please choose to import a template!",
            "失败": "fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import History Log",
            "总行数": "Total number of rows",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template Download",
            "港后问题件导入成功": "Successful import of problem parts after port",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "please input",
            "文件下载": "Download Document",
            "上传中": "uploading",
            "行号": "Line number",
            "错误行数": "Number of error lines",
            "导入模版": "Import template"
        },
        "ghwtjimport": {
            "历史日志": "History Log",
            "成功": "success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "验证失败": "verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please choose to import a template!",
            "失败": "fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import History Log",
            "总行数": "Total number of rows",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template Download",
            "港后问题件导入成功": "Successful import of problem parts after port",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "please input",
            "文件下载": "Download Document",
            "上传中": "uploading",
            "行号": "Line number",
            "错误行数": "Number of error lines",
            "导入模版": "Import template"
        },
        "TMS015": {
            "港前问题件查询导出": "Export the query and export of the pre-port problem",
            "最新回复人": "Latest Reply",
            "寄件邮箱": "Shipper Email",
            "登记人": "Register person",
            "指定路线": "Channel Code",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "部门": "Department",
            "笔": "0",
            "问题相关": "Question related",
            "请选择一笔数据作为查询客户联系人！": "Please select a piece of data as the query customer contact!",
            "附件": "Appendix",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "通知人": "alert others",
            "费用补录": "Expense Supplementary Record",
            "问题类型": "question type",
            "寄件人": "Shipper",
            "登记网点": "Registration Points",
            "确定申请退返客户吗?": "Are you sure to apply for return to the customer?",
            "问题件信息": "Problem information",
            "处理状态": "Processing status",
            "客户名称": "Customer name",
            "笔已处理": "Pen processed",
            "截止处理时间": "Deadline for processing",
            "手机": "cell phone",
            "港前问题件处理导出": "Export of the handling of problematic documents before port",
            "可处理笔数": "The number of transactions that can be processed",
            "重置": "Reset",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it in the export list later!",
            "问题件通知人": "Problem notification person",
            "指定处理人": "Designated processor",
            "费用补录管理": "Expense Supplementary Record Management",
            "转单号码": "Tracking Number",
            "提示": "hint",
            "费用批量补录": "Expense Bulk Supplementary Recording",
            "请选择运单！": "Please select the waybill!",
            "最新回复时间": "Latest reply time",
            "通知客户": "Notify customer",
            "打印": "Print",
            "批量补录": "Batch Supplementary Recording",
            "回复异常": "Reply exception",
            "导出": "Export",
            "请输入": "please input",
            "取消": "Cancel",
            "只能打印一个问题件": "Only one problem piece can be printed",
            "其中": "in",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "联系人": "Contact",
            "选中待处理问题件": "Select the problem to be solved",
            "问题状态": "Problem status",
            "全部": "All",
            "业务电话": "Business Phone",
            "运单号码": "Order Number",
            "邮箱地址": "email address",
            "选中单号状态必须为待处理": "The status of the selected order number must be pending",
            "查询": "Search",
            "寄件电话": "Shipper phone",
            "您选取的": "You selected",
            "问题描述": "Problem Description",
            "登记日期不能为空": "Registration date cannot be empty",
            "问题件批量回复": "Bulk Reply to Questions",
            "申请退返": "Apply for Return",
            "收费材重": "Charge volume weight",
            "客户联系人": "Customer Contact",
            "处理意见": "Handling opinions",
            "文件大小不能大于15MB": "File size cannot be larger than 15MB",
            "处理网点": "Processing warehouse",
            "待处理": "Pending",
            "处理中": "Processing",
            "打印完成": "Printing completed",
            "费用补录申请": "Application for supplementary entry of fees",
            "笔问题件数据": "Pen problem data",
            "目的地名称": "Destination Name",
            "含子客户": "sub-customers",
            "最新回复": "Latest Reply",
            "通知成功！": "Notification successful!",
            "备注": "Remark",
            "港前问题件处理": "Handling of Issues Before Port",
            "批量回复成功！": "Batch reply is successful!",
            "关闭": "Close",
            "销售员": "Seller",
            "笔无需回复": "Pen does not need to reply",
            "请选择一行数据": "Please select a row of data",
            "处理状态不能为空!": "The processing status cannot be empty!",
            "登记日期": "Registration Date",
            "请选择至少一行数据": "Please select at least one row of data",
            "笔,确认已通知客户？": "Pen, confirm that the customer has been notified?",
            "跟单员": "Tracker",
            "客户": "customer",
            "参考编号": "Ref number",
            "确定": "OK",
            "目的地编码": "Destination code",
            "回复": "reply",
            "登记时间": "check-in time",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Charge weight",
            "收费实重": "Charge actual weight",
            "运单导入修改": "Import and modify waybill",
            "运单修改": "Consignment Note Modification",
            "传真": "fax",
            "费用补录新增": "Addition of Expenses Supplementary Record",
            "笔问题件数据，其中": "Pen problem piece data, where",
            "笔无需回复，可处理笔数": "No need to reply, the number of transactions can be processed"
        },

        "TMS016": {
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "港前问题件查询导出": "Export the query and export of the pre-port problem",
            "最新回复人": "Latest Reply",
            "寄件邮箱": "Shipper Email",
            "问题状态": "Problem status",
            "登记人": "Register person",
            "运单号码": "Order Number",
            "确定要删除该数据吗?": "Are you sure you want to delete this data?",
            "问题状态不为待处理的问题件！": "The problem status is not a pending problem!",
            "指定路线": "Channel Code",
            "查询": "Search",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "笔": "0",
            "寄件电话": "Shipper phone",
            "处理完毕时间": "Processing time",
            "请勾选一行数据": "Please check a row of data",
            "您选取的": "You selected",
            "问题件交接": "Problem Handover",
            "问题描述": "Problem Description",
            "登记日期不能为空": "Registration date cannot be empty",
            "问题件批量回复": "Bulk Reply to Questions",
            "申请退返": "Apply for Return",
            "附件": "Appendix",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "收费材重": "Charge volume weight",
            "处理意见": "Handling opinions",
            "文件大小不能大于15MB": "File size cannot be larger than 15MB",
            "问题类型": "question type",
            "登记网点": "Registration Points",
            "寄件人": "Shipper",
            "接收人": "Receiver",
            "确定申请退返客户吗?": "Are you sure to apply for return to the customer?",
            "问题件信息": "Problem information",
            "接收网点": "Receiving Points",
            "处理网点": "Processing warehouse",
            "科目": "suject",
            "件数": "Number Of Item",
            "处理状态": "Processing status",
            "待处理": "Pending",
            "打印完成": "Printing completed",
            "笔问题件数据": "Pen problem data",
            "请选择至少一行可处理数据": "Please select at least one row to process data",
            "客户名称": "Customer name",
            "第一次回复时间": "First response time",
            "目的地名称": "Destination Name",
            "笔已处理": "Pen processed",
            "截止处理时间": "Deadline for processing",
            "交接备注": "Handover Remarks",
            "最新回复": "Latest Reply",
            "删除成功": "successfully deleted",
            "批量回复成功！": "Batch reply is successful!",
            "可处理笔数": "The number of transactions that can be processed",
            "删除": "Delete",
            "关闭": "Close",
            "交接信息": "Handover Information",
            "重置": "Reset",
            "笔无需回复": "Pen does not need to reply",
            "寄件公司": "Shipper company",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it in the export list later!",
            "请选择一行数据": "Please select a row of data",
            "问题件通知人": "Problem notification person",
            "处理状态不能为空!": "The processing status cannot be empty!",
            "请选择至少一行数据": "Please select at least one row of data",
            "指定处理人": "Designated processor",
            "请勾选未处理完的问题件": "Please check the unfinished problem pieces",
            "参考编号": "Ref number",
            "确定": "OK",
            "目的地编码": "Destination code",
            "回复": "reply",
            "登记时间": "check-in time",
            "转单号码": "Tracking Number",
            "提示": "hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Charge weight",
            "最新回复时间": "Latest reply time",
            "收费实重": "Charge actual weight",
            "打印": "Print",
            "问题件交接成功！": "The problem piece was successfully handed over!",
            "回复异常": "Reply exception",
            "导出": "Export",
            "请输入": "please input",
            "港前问题件查询": "Inquiry for Issues Before Port",
            "取消": "Cancel",
            "只能打印一个问题件": "Only one problem piece can be printed",
            "其中": "in",
            "金额": "Amount",
            "笔，其中": "Pen, where",
            "笔已处理，": "Pen has been processed,",
            "笔无需回复，可处理笔数": "No need to reply, the number of transactions can be processed"
        },
        "TMS057": {
            "立刻处理的可直接写入处理说明": "The processing instructions can be directly written into the processing instructions for immediate processing",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "修改": "Modify",
            "国外退件": "Foreign Return",
            "问题状态": "Problem status",
            "登记人": "Register person",
            "登记成功！": "Registration is successful!",
            "运单号码": "Order Number",
            "截止日期不能小于当前日期！": "The due date cannot be less than the current date!",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "多笔单号回车换行输入": "Multiple note numbers with carriage return and line feed input",
            "可多选": "Multiple choice",
            "登记": "Register",
            "导入登记": "Import Registration",
            "问题描述": "Problem Description",
            "当前有": "Currently have",
            "附件": "Appendix",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "处理?": "deal with?",
            "处理意见": "Handling opinions",
            "文件大小不能大于15MB": "File size cannot be larger than 15MB",
            "通知人": "alert others",
            "运单做\\": "Waybill do \\",
            "笔单号问题件已存在，不允许重复登记": "The problem with the order number already exists, and duplicate registration is not allowed",
            "登记网点": "Registration Points",
            "问题件信息": "Problem information",
            "需回复": "Need reply",
            "处理网点": "Processing warehouse",
            "处理状态": "Processing status",
            "登记异常": "Registration exception",
            "问题件登记": "Problem registration",
            "截止处理时间": "Deadline for processing",
            "问题单号": "Issue number",
            "确定对": "OK",
            "处理意见有值时，处理状态不能为待处理": "When the processing opinion has value, the processing status cannot be pending",
            "处理内容选填": "Processing content optional",
            "关闭": "Close",
            "批量登记异常": "Batch registration exception",
            "当前": "current",
            "销毁": "destroy",
            "回复提交": "Reply to submission",
            "退客户海外仓": "Return customer overseas warehouse",
            "输入处理意见后": "After inputting the handling comments",
            "处理状态不能为空!": "The processing status cannot be empty!",
            "二次销售": "Second Sale",
            "登记日期": "Registration Date",
            "指定处理人": "Handler",
            "客户信息": "Customer Information",
            "参考编号": "Ref number",
            "确定": "OK",
            "问题件回复": "Question response",
            "批量登记成功！": "Batch registration is successful!",
            "回复": "reply",
            "转单号码": "Tracking Number",
            "提示": "hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "笔运单未能成功登记问题件": "The waybill failed to successfully register the problem piece",
            "可": "Can",
            "文件还未上传成功，请等待文件上传成功后再登记！": "The file has not been uploaded successfully, please wait for the file to upload successfully before registering!",
            "回复异常": "Reply exception",
            "请输入": "please input",
            "获取运单信息失败！": "Failed to obtain waybill information!",
            "取消": "Cancel",
            "获取问题状态信息失败！": "Failed to obtain problem status information!",
            "批量登记": "Bulk registration",
            "输入处理意见后，可Enter回复提交": "After inputting the handling comments, you can enter to reply and submit",
            "处理内容选填，立刻处理的可直接写入处理说明": "The processing content is optional, and the processing instructions can be directly written into the processing instructions for immediate processing",
            "通知人(可多选)": "Notifier (multiple choice)",
            "问题单号(多笔单号回车换行输入)": "Problem ticket number (enter multiple ticket numbers by carriage return and line feed)"
        },
        "TMS058": {
            "修改": "Modify",
            "登记人": "Register person",
            "截止时间": "deadline",
            "指定路线": "Channel Code",
            "港后问题件处理导出": "Handling and exporting of problem files after port",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "笔": "0",
            "问题相关": "Problem related",
            "可多选": "Multiple choice",
            ",补收科目": ", Make-up account",
            "附件": "Appendix",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "通知人": "alert others",
            "费用补录": "Supplementary expense",
            "运单做\\": "Waybill to do \\",
            "天": "sky",
            "登记网点": "Registered outlets",
            "问题件信息": "Problem information",
            "件数": "Number Of Item",
            "处理状态": "Processing status",
            "客户名称": "Customer name",
            "问题状态：": "Problem status:",
            "笔已处理": "Pen processed",
            "截止处理时间": "Deadline",
            "收件城市": "Consignee city",
            "币别": "Currency",
            "确定对": "Sure right",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "可处理笔数": "Number of transactions that can be processed",
            "重置": "Reset",
            "退客户海外仓": "Return customer overseas warehouse",
            "目的地": "Destination",
            "二次销售": "Second sale",
            "指定处理人": "Designated processor",
            "费用补录管理": "Expense supplement management",
            "客户信息": "Customer Information",
            "转单号码": "Tracking Number",
            "提示": "hint",
            "费用批量补录": "Batch re-entry of expenses",
            "补收科目：": "Replenishment subjects:",
            "最新回复时间": "Latest reply time",
            ",金额：": ",Amount:",
            "打印": "Print",
            "批量补录": "Bulk Supplementary Record",
            "文件还未上传成功，请等待文件上传成功后再回复！": "The file has not been uploaded successfully, please wait for the file to upload successfully before replying!",
            "回复异常": "Reply exception",
            "导出": "Export",
            "最新轨迹状态": "Latest track status",
            "最新轨迹描述": "Latest track description",
            "请输入": "please input",
            "取消": "Cancel",
            "只能打印一个问题件": "Only one problem piece can be printed",
            "其中": "in",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "国外退件": "Return abroad",
            "问题状态": "Problem status",
            "运单号码": "Order Number",
            "剩余期限": "remaining period",
            "查询": "Search",
            "确定移除": "Sure to remove",
            "截止日期不能小于登记日期!": "The deadline cannot be less than the registration date!",
            "收件邮编": "Consignee Postcode",
            "您选取的": "You selected",
            "问题描述": "Problem Description",
            "登记日期不能为空": "Registration date cannot be empty",
            "问题件批量回复": "Bulk Reply to Questions",
            "处理?": "deal with?",
            "处理意见": "Handling opinions",
            "港后": "Hong Kong",
            "打印完成": "Print completed",
            "费用补录申请": "Application for supplementary entry of fees",
            "笔问题件数据": "Pen problem data",
            "目的地名称": "Destination name",
            "目的地简码": "Destination shortcode",
            ",问题描述": ",Problem Description",
            "补录费用成功！": "Succeeded in making up the cost!",
            "最新回复": "Latest Reply",
            "最新轨迹时间": "Latest track time",
            "走货路线": "Delivery route",
            "小时": "Hour",
            "批量回复成功！": "Batch reply is successful!",
            "关闭": "Close",
            "销售员": "Seller",
            "销毁": "destroy",
            "回复提交": "Reply to submission",
            "笔无需回复": "No need to reply",
            "输入处理意见后": "After inputting the handling comments",
            "请选择一行数据": "Please select a row of data",
            "处理状态不能为空!": "The processing status cannot be empty!",
            "登记日期": "Registration Date",
            "请选择至少一行数据": "Please select at least one row of data",
            "跟单员": "Merchandiser",
            "客户": "customer",
            "参考编号": "Ref number",
            "确定": "OK",
            "问题件回复": "Question response",
            "港后问题件处理": "Handling of problems after port",
            "回复": "reply",
            "补收科目": "Replenishment account",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Charge weight",
            "走货路线分类": "Route classification",
            "可": "Can",
            "代理客服": "Agent customer service",
            "费用补录新增": "Expense supplementary record added",
            "补录费用：": "Supplementary entry fee:",
            "超时未处理完毕": "Timeout has not been processed",
            "金额": "Amount",
            "最新轨迹地点": "Latest track location",
            "运单号码/转单号码/参考编号": "Order Number/Tracking Number/Ref number",
            "港后/代理客服": "Post-Hong Kong/Agent Customer Service",
            "指定路线/走货路线": "Channel Code/Delivery route",
            "件数/收费重": "Pieces/Charge weight",
            "收件城市/收件邮编": "Consignee city/Consignee postcode",
            "输入处理意见后，可Enter/回复提交": "After inputting the handling comments, you can enter/reply to submit",
            "通知人(可多选)": "Alert others",
            "笔问题件数据，其中": "Pen problem data, where",
            "笔已处理，": "The pen has been processed,",
            "笔无需回复，可处理笔数": "No need to reply, can handle the number"
        },

        "problemsquery": {
            "修改": "Modify",
            "补收金额/币别必填!": "Replenishment amount/currency is required!",
            "港后问题件查询": "Post-port problem inquiry",
            "登记人": "Register person",
            "指定路线": "Channel Code",
            "回复成功！": "Reply successfully!",
            "处理结果": "process result",
            "笔": "0",
            "可多选": "Multiple choice",
            ",补收科目": ", Make-up account",
            "附件": "Appendix",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "通知人": "alert others",
            "运单做\\": "Waybill to do \\",
            "天": "sky",
            "登记网点": "Registered outlets",
            "问题件信息": "Problem information",
            "件数": "Number Of Item",
            "处理状态": "Processing status",
            "客户名称": "Customer name",
            "问题状态": "Problem status",
            "笔已处理": "Pen processed",
            "截止处理时间": "Deadline",
            "收件城市": "Consignee city",
            "币别": "Currency",
            "确定对": "Sure right",
            "文件大小不能大于5MB": "File size cannot be larger than 5MB",
            "可处理笔数": "Number of transactions that can be processed",
            "重置": "Reset",
            "退客户海外仓": "Return customer overseas warehouse",
            "目的地": "Destination",
            "二次销售": "Second sale",
            "指定处理人": "Designated processor",
            "客户信息": "Customer Information",
            "转单号码": "Tracking Number",
            "提示": "hint",
            "补收科目": "Replenishment account",
            "最新回复时间": "Latest reply time",
            ",金额": ", Amount",
            "打印": "Print",
            "文件还未上传成功，请等待文件上传成功后再回复！": "The file has not been uploaded successfully, please wait for the file to upload successfully before replying!",
            "回复异常": "Reply exception",
            "导出": "Export",
            "最新轨迹状态": "Latest track status",
            "最新轨迹描述": "Latest track description",
            "请输入": "please input",
            "取消": "Cancel",
            "只能打印一个问题件": "Only one problem piece can be printed",
            "其中": "in",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "国外退件": "Return abroad",
            "运单号码": "Order Number",
            "剩余期限": "remaining period",
            "查询": "Search",
            "截止日期不能小于登记日期!": "The deadline cannot be less than the registration date!",
            "收件邮编": "Consignee Postcode",
            "处理完毕时间": "Processing time",
            "您选取的": "You selected",
            "问题描述": "Problem Description",
            "登记日期不能为空": "Registration date cannot be empty",
            "问题件批量回复": "Bulk Reply to Questions",
            "处理?": "deal with?",
            "处理意见": "Handling opinions",
            "处理网点": "Processing warehouse",
            "港后": "Hong Kong",
            "打印完成": "Print completed",
            "笔问题件数据": "Pen problem data",
            "请选择至少一行可处理数据": "Please select at least one row to process data",
            ",问题描述": ",Problem Description",
            "补录费用成功！": "Succeeded in making up the cost!",
            "最新回复": "Latest Reply",
            "最新轨迹时间": "Latest track time",
            "走货路线": "Delivery route",
            "批量回复成功！": "Batch reply is successful!",
            "小时": "Hour",
            "关闭": "Close",
            "港后问题件查询导出": "Post-port problem query export",
            "销毁": "destroy",
            "回复提交": "Reply to submission",
            "笔无需回复": "No need to reply",
            "输入处理意见后": "After inputting the handling comments",
            "请选择一行数据": "Please select a row of data",
            "处理状态不能为空!": "The processing status cannot be empty!",
            "登记日期": "Registration Date",
            "请选择至少一行数据": "Please select at least one row of data",
            "客户": "customer",
            "参考编号": "Ref number",
            "确定": "OK",
            "问题件回复": "Question response",
            "回复": "reply",
            "登记时间": "check-in time",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Charge weight",
            "走货路线分类": "Route classification",
            "可": "Can",
            "代理客服": "Agent customer service",
            "补录费用": "Supplementary entry fee",
            "金额": "Amount",
            "最新轨迹地点": "Latest track location",
            "运单号码/转单号码/参考编号": "Order Number/Tracking Number/Ref number",
            "港后/代理客服": "Post-Hong Kong/Agent Customer Service",
            "指定路线/走货路线": "Channel Code/Delivery routel",
            "件数/收费重": "Pieces/Charge weight",
            "收件城市/收件邮编": "Consignee city/Consignee postcode",
            "输入处理意见后，可Enter/回复提交": "After inputting the handling comments, you can enter/reply to submit",
            "通知人(可多选)": "Notifier (multiple choices available)",
            "笔问题件数据，其中问题件数据": "Pen problem data, among which problem data",
            "笔已处理，": "The pen has been processed,",
            "笔无需回复，可处理笔数": "No need to reply, can handle the number"
        },
        "CMN005": {
            "单号类型等于总运单号或头程提单才允许导出shopee daily report（MY）报表!": "Only when the tracking number type is equal to the general waybill number or the first bill of lading, the shopee daily report (MY) report is allowed to be exported!",
            "一行": "One line",
            "运/转/参考单号,一次导出单号数量不能超过1000": "Transport/Transfer/Reference note number, the number of exported note numbers at one time cannot exceed 1000",
            "提单货量分摊": "Bill of lading cargo apportionment",
            "单号类型等于总运单号/头程提单，才允许提单货量分摊导出!": "The type of the bill of lading is equal to the total waybill number/the first bill of lading, only then can the bill of lading volume be shared and exported!",
            "可包含运单信息": "Can include waybill information",
            "维度的特殊报表": "Dimensional Special Report",
            "大包/总运单/出货批次/头程提单号，一次导出单号数量不能超过300": "Large package/general waybill/shipment batch/first-way bill of lading number, the number of export single number cannot exceed 300",
            "导出说明": "Export Description",
            "单号类型等于总运单号或头程提单才允许导出shopee daily report（TH）报表!": "Only when the tracking number type is equal to the total waybill number or the first bill of lading, the shopee daily report (TH) report is allowed to be exported!",
            "单号类型等于总运单号，才允许turkey-mawb-box报表导出!": "Only when the tracking number type is equal to the total waybill number, the turkey-mawb-box report export is allowed!",
            "单号类型等于总运单号、大包号或者等于出货批次，才允许导出大包出货报表!": "Only when the tracking number type is equal to the general waybill number, the large package number or the shipment batch, the large package shipment report is allowed to be exported!",
            "导出单号不能为空!": "The export order number cannot be empty!",
            "一个运单一行记录": "A single line record for one shipment",
            "信息一行记录": "Information one line record",
            "非运单维度": "Non-waybill dimension",
            "则导出": "Export",
            "请输入单个单号!": "Please enter a single tracking number!",
            "个": "indivual",
            "大包出货报表": "Large Package Shipment Report",
            "运/转/参考单号,一次导出单号数量不能超过50000": "Transport/Transfer/Reference note number, the number of exported note numbers at one time cannot exceed 50000",
            "维度报表": "Dimension Report",
            "Invoice维度报表": "Invoice dimension report",
            "例如一个运单包含": "For example, a waybill including",
            "节点时间": "Node time",
            "数据": "data",
            "行记录数据": "Line record data",
            "单号类型等于总运单号或头程提单才允许导出shopee daily report报表!": "Only when the tracking number type is equal to the total waybill number or the first bill of lading is allowed to export shopee daily report!",
            "运单维度报表": "Waybill dimension report",
            "单号类型等于总运单号或出货批次,头程提单，才允许导出APG报表!": "The tracking number type is equal to the total waybill number or the shipment batch, and the first bill of lading is allowed to export APG reports!",
            "特殊报表": "Special report",
            "1、运单维度报表，一个运单一行记录；可包含运单信息、节点时间、数据": "1. Waybill dimension report, a single line record; can include waybill information, node time, and data",
            "2、Invoice维度报表，一行invoice信息一行记录例如一个运单包含3个invoice，则导出3行记录数据": "2. Invoice dimension report, one line of invoice information and one line of record. For example, if a waybill contains 3 invoices, then 3 lines of record data will be exported.",
            "3、特殊报表，非运单维度、Invoice维度的特殊报表": "3. Special reports, special reports for non-waybill dimensions and Invoice dimensions"
        },
        "cargoImport":{
            "历史日志":"History Log",
            "模版下载":"Template download",
            "导入模版":"Import Template",
            "导入文件":"Import file",
            "状态":"state",
            "总行数":"Total number of branches",
            "错误行数":"Number of incorrect lines",
            "模板下载":"Template Download",
            "行号":"Line number",
            "错误说明":"Error description",
            "创建货物描述映射":"Create cargo description mapping",
            "末端货态描述":"LM status description",
            "最终描述":"Final description",
            "保存":"Save",
            "关闭":"Close",
            "删除成功":"Delete successfully",
            "基本信息":"Basic info"
        },
        "TMS020": {
            "子单号":"Sub-order number",
            "跟进状态":"Follow-up status",
            "预计件数":"Pre-alert pieces",
            "实收件数":"Actual pieces",
            "尾程实重":"LM actual weight",
            "尾程材重":"LM volume weight",
            "尾程体积":"LM volume",
            "尾程重":"LM weight",
            "无效轨迹":"Invalid track&trace",
            "来源状态编码":"LM status code",
            "原因描述":"Reason description",
            "原因码":"reason code",
            "状态编码":"Status code",
            "时区":"Timezone",
            "转单Lable": "Transfer Lable",
            "轨迹状态": "Track status",
            "原产地": "country of origin",
            "描述": "describe",
            "子单": "Sub-list",
            "INVOICE信息": "INVOICE information",
            "退件单号": "Return order number",
            "处理结果": "process result",
            "printScene:INVOICE打印机": "printScene: INVOICE printer",
            "转单子单(0)": "Transfer Order Sub-Order (0)",
            "总价": "Total price",
            "文件名": "file name",
            "寄件区县": "District",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "查询后选中单号": "Select after search",
            "货款信息": "Payment information",
            "操作": "Operation",
            "操作时间": "Operating At",
            "处理人": "Handler",
            "处理期限": "Processing period",
            "包装项目": "Packaging items",
            "收款时间": "Collection time",
            "寄件人": "Shipper",
            "到": "arrive",
            "运单文件": "Waybill documents",
            "功能": "Function",
            "寄件税号": "Shipping tax number",
            "转【": "change【",
            "打单前请设置好LABEL打印机": "Please set up the LABEL printer before placing orders",
            "币别": "Currency",
            "请输入日志信息": "Please enter log information",
            "出货重": "Shipping weight",
            "删除成功": "successfully deleted",
            "单价": "unit price",
            "请选择处理状态": "Please select processing status",
            "删除": "Delete",
            "EDI_LABEL打印机": "EDI_LABEL printer",
            "没有配置INVOICE自定义模板": "No INVOICE custom template is configured",
            "运单信息": "Waybill information",
            "打印设置": "Print Settings",
            "数量": "quantity",
            "寄件网点": "Outlets",
            "跟进日志(": "Follow-up log(",
            "】已取到快件": "】The shipment has been picked up",
            "格式": "Format",
            "转单号码": "Tracking number",
            "打单前请设置好INVOICE打印机": "Please set up the INVOICE printer before placing orders",
            "查询单号必填": "Enquiry number is required",
            "材重": "Volume weight",
            "报关方式": "Declaration method",
            "单件进位规则": "Pcs carry rule",
            "收件备注": "Receiving note",
            "备份联打印机": "Backup printer",
            "跟进人": "Follower",
            "以下录入的都为单件信息": "The following entries are all single pieces of information",
            "出货实重": "Shipping actual weight",
            "收件邮箱": "Email",
            "类型": "type",
            "海关编码": "HS code",
            "派送代理": "Delivery agent",
            "出货备注": "Shipping notes",
            "查询": "Search",
            "寄件电话": "Shipper phone",
            "分拣分区": "Sorting zone",
            "登记": "Register",
            "收费材重": "Charge volume weight",
            "附件类型": "Attachment type",
            "需要追踪的数据转单不能为空": "The data transfer order to be tracked cannot be empty",
            "该问题件没有图片！": "There is no picture for this problem!",
            "客户服务信息": "Customer service",
            "到付款": "COD amount",
            "追踪信息": "tracking information",
            "个问题件": "Problem pieces",
            "除以数": "Divide by number",
            "时间": "time",
            "当前文件为其他网点创建，没有删除权限": "The current file was created by another network, and there is no permission to delete it",
            "对账员": "Reconciler",
            "出货材重": "Shipping volume weight",
            "走货路线": "Delivery route",
            "跟进网点": "Follow up outlets",
            "关闭": "Close",
            "printScene:EDI_LABEL打印机": "printScene: EDI_LABEL printer",
            "没有获取到子单数据": "No sub-order data is obtained",
            "下载": "download",
            "高": "Height",
            "没有获取到下载地址！": "Did not get the download address!",
            "收件州": "Consignee Province",
            "没有获取到label 地址": "The label address was not obtained",
            "客户": "customer",
            "内容": "content",
            "printScene:备份联打印机": "printScene: backup connected printer",
            "返款信息": "Rebate information",
            "单票进位规则": "Pkg carry rule",
            "收费重": "Charge weight",
            "--请求轨迹原数据失败--": "--Failed to request the original data of the trajectory--",
            "转单子单(": "Transfer Order (",
            "收件电话": "Consignee phone",
            "体积": "volume",
            "件": "Pieces",
            "问题信息": "Problem information",
            "港后客服": "CS after port",
            "中文品名": "Description CN",
            "省": "Province",
            "修改": "Modify",
            "日志信息": "Log Info",
            "修改日志": "Modify log",
            "寄件邮箱": "Shipper Email",
            "登记人": "Register person",
            "一次最多查询": "Query at a time",
            "助手返回任务id失败": "The assistant failed to return the task id",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "收件税号": "Receiving tax number",
            "咨询来源": "Consultation source",
            "保存": "Save",
            "提交后台失败": "Failed to submit background",
            "没有配置LABEL自定义模板": "No LABEL custom template is configured",
            "清空": "Clear",
            "创建人": "Create By",
            "包装类型": "Packing type",
            "类别": "category",
            "附件": "Appendix",
            "跟进日志(无)": "Follow-up log (none)",
            "打单前请设置好备份联打印机": "Please set up a backup printer before placing orders",
            "返款时间": "Rebate time",
            "注意": "Notice",
            "付款方式": "Payment",
            "第": "NS",
            "没有获取到备用联label地址": "Did not get the backup link label address",
            "详细信息": "details",
            "件数": "Pieces",
            "处理状态": "Processing status",
            "包装说明": "package instruction",
            "收": "receive",
            "上传时间": "Upload time",
            "跟进时间": "Follow-up time",
            "需要追踪的数据追踪网络不能为空": "The data to be tracked. The tracking network cannot be empty",
            "追踪进行中，请稍候查询": "Tracking is in progress, please wait for inquiries",
            "收件城市": "City",
            "没有配置LABEL 输出方式": "No LABEL output mode is configured",
            "序号": "No.",
            "没有获取到文件地址，无法查看": "The file address is not obtained and cannot be viewed",
            "分拣码": "Sort code",
            "单号": "Number",
            "一次最多查20个单号": "Check up to 20 tracking numbers at a time",
            "运单文件(无)": "Waybill document (none)",
            "重置": "Reset",
            "推送": "Push",
            "目的地": "Destination",
            "转单子单": "Transfer Order",
            "寄件国家": "Country",
            "品名": "Product name",
            "备份联": "Backup link",
            "个字符": "Characters",
            "INVOICE打印机": "INVOICE printer",
            "子单号码": "Sub-order number",
            "最多允许录入": "Allow entry at most",
            "没有找到打印配置": "No print configuration found",
            "收件区县": "District",
            "打印": "Print",
            "仅显示": "Show only",
            "导出": "Export",
            "请输入处理结果": "Please enter the processing result",
            "转单": "tracking no",
            "一次最多查询20个单号": "Query up to 20 tracking numbers at a time",
            "签": "sign",
            "港前客服": "CS before port",
            "长": "Length",
            "税金付款": "Tax Payment",
            "使用": "use",
            "网点": "warehouse",
            "费用结算": "Fee settlement",
            "运单号码": "Order Number",
            "操作员": "operator",
            "包装费": "Packaging fee",
            "收件邮编": "Consignee postcode",
            "】已收到快件": "】The shipment has been received",
            "问题描述": "Problem Description",
            "物流助手初始化失败,请稍后重试": "The logistics assistant failed to initialize, please try again later",
            "品牌": "brand",
            "收件地址": "Consignee Address",
            "提交后台成功": "Submitted to the background successfully",
            "寄件地址": "Shipper address",
            "寄件邮编": "Postal code",
            "退返客户,退返方式为<": "Return the customer, the return method is<",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "跟踪记录": "TRACK & TRACE",
            "样式": "style",
            "申报价值": "Declared value",
            "收件公司": "Consignee company",
            "单票计抛规则": "Pkg charge weight rule",
            "单件信息": "Single piece information",
            "宽": "Width",
            "收件人": "Consignee",
            "回款时间": "Payback time",
            "个单号": "Single number",
            "跟进日志": "Follow-up log",
            "请输入最后期限": "Please enter a deadline",
            "位置": "Location",
            "INVOICE信息(无)": "INVOICE information (none)",
            "寄件城市": "City",
            "请选择咨询来源": "Please select the source of inquiry",
            "INVOICE信息(有)": "INVOICE information (Yes)",
            "付款时间": "Payment time",
            "销售员": "Seller",
            "日期": "date",
            "录入日志": "Log entry",
            "寄件公司": "Shipper company",
            "回款信息": "Payment information",
            "预览": "Preview",
            "跟单员": "Merchandiser",
            "打单数据附件不允许删除": "The attachment of the order data is not allowed to be deleted",
            "代收款": "Agency fund",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "实重": "Actual weight",
            "登记时间": "check-in time",
            "计抛方式": "Charge weight rule",
            "运单文件(": "Waybill documents (",
            "订单创建日期": "Order creation date",
            "收件国家": "Receiving country",
            "存在多个PDF文件，请下载后查看": "There are multiple PDF files, please download and view",
            "收费实重": "Charge actual weight",
            "操作方式": "Operation method",
            "参考编码": "Reference code",
            "货款信息(有)": "Payment information (Yes)",
            "的轨迹信息": "Trajectory information",
            "货物类型": "Cargo type",
            "代理客服": "Agent customer service",
            "处理时间": "Processing time",
            "创建时间": "Create time",
            "出": "out",
            "回车后直接查询": "Press enter to search",
            "货款信息(无)": "Payment information (none)",
            "寄件州/省": "Province",
            "收件州/省": "Province",
            "最多允许录入1000个字符": "A maximum of 1000 characters are allowed",
            "最新状态":"Last State",
            "下次跟进时间":"Next follow-up time"
        },
        "destlimit":{
            "目的地":"Destination",
            "限制货物类型（可多选）"	:"Restricting cargo type (multiple choices)",
            "限制方式":"Restriction method",
            "限制提示":	"Restriction Tips",
            "提示内容（模糊）":"Tips content (vague)",
            "排仓分区":"Warehouse partition",
            "序号":"No.",
        },
        "TMS133":{
            "删除成功":"Delete successfully",
            "关闭":"Close",
            "保存":"Save",
            "最终描述":"Final description",
            "末端货态描述":"LM status description",
            "基本信息":"Basic info",
            "启用":"Enable status",
            "货物描述映射":"Cargo description mapping",
            "新增":"Add",
            "修改":"Modify",
            "删除":"Delete",
            "导入":"Import",
            "末端供应商":"LM carrier",
            "客户":"Customer",
            "启用状态":"Enable status",
            "查询":"Search",
            "重置":"Reset",
            "创建时间":"Creation time",
            "创建人":"Creator",
            "修改时间":"Modify time",
            "修改人":"Modifier",
            "货物描述映射导入":"Import cargo description mapping",
            "导入模版":"Import Template",
            "导入文件":"Import file",
            "状态":"state",
            "总行数":"Total number of branches",
            "错误行数":"Number of incorrect lines",
            "模板下载":"Template Download",
            "行号":"Line number",
            "错误说明":"Error description",
            "创建货态描述映射":"Create cargo description mapping",
            "末端供应商(单选)":"LM carrier(single choice)",
            "客户(多选)":"Customer(Multiple Choice)",
            "货态描述映射":"Mapping status description",
            "末端货态代码不为空时，优先使用末端货态代码匹配":"When the LM status code is not empty, prioritize using the LM status code to match",
            "末端货态代码":"LM status code",
        },
        "TMS122":{
            "导出":"Export",
            "运单号码":"Order umber",
            "转单号码":"Tracking number",
            "订单日期":"Create at",
            "删除时间":"Delete at",
            "客户":"Customer",
            "查询":"Search",
            "重置":"Reset",
            "恢复":"Recovery",
            "订单状态":"Order Status",
            "打印":"Print",
            "暂扣":"Withhold",
            "删除原因":"Deletion reason",
            "参考编号":"Ref number",
            "转寄原单号":"Original number",
            "收货包号":"Receipt bag number",
            "录单网点":"Recording outlets",
            "寄件网点":"Outlets",
            "客户编码":"Customer code",
            "客户名称":"Customer Name",
            "指定路线":"Channel Code",
            "目的地编码":"Destination code",
            "目的地":"Destination",
            "包装类型":"Packing type",
            "货物类型":"Cargo type",
            "报关方式":"Declaration method",
            "件数":"Pieces",
            "预报重":"Pre-alert weight",
            "申报价值":"Declared value",
            "申报价值币别":"Declared value currency",
            "COD金额":"COD Amount",
            "COD币别":"COD currency",
            "中文品名":"Description CN",
            "预报时间":"Pre-alert time",
            "预报异常":"Exception pre-alert",
            "异常信息":"Exception information",
            "寄件人":"Shipper",
            "寄件公司":"Shipper company",
            "寄件电话":"Shipper phone",
            "寄件邮箱":"Shipper Email",
            "收件人":"Consignee",
            "收件公司":"Consignee company",
            "收件电话":"Consignee phone",
            "收件邮编":"Consignee postcode",
            "分拣码":"Sort code",
            "分拣分区":"Sort partition",
            "走货路线":"Delivery route",
            "派件网点":"Distribution outlets",
            "平台类型":"Platform type",
            "订单数据来源":"Order data source",
            "排货状态":"Arrangement status",
            "打单状态":"Play status",
            "是否终止":"Whether to terminate",
            "终止原因":"Reason for termination",
            "终止备注":"Termination note",
            "揽收时间":"Collection time",
            "揽收人":"Collector",
            "创建时间":"Creation time",
            "创建人":"Founder",
            "删除人":"Deleter",
        },
        "BAS010": {
            "请选择一条数据":"Please select a piece of data",
            "本地揽派服务":"Local delivery service",
            "代理信息":"Agent info",
            "有配置edi_id":"Configured edi",
            "分类编码（分类名称）":"Classification Code/Name",
            "分类编码/分类名称":"Classification Code/Name",
            "修改走货路线分类":"Modify Route classification",
            "走货路线分类":"Route classification",
            "启用":"Enabled",
            "分类编码":"Classification Code",
            "分类名称":"Classification Name",
            "排列顺序":"Arrange",
            "保存":"Save",
            "关闭":"Close",
            "提示":"Tips",
            "确定要删除吗？":"Are you sure you want to delete it?",
            "取消":"Cancel",
            "确定":"OK",
            "新增":"Add",
            "修改":"Modify",
            "删除":"Delete",
            "共享":"Share info",
            "不共享":"Not share",
            "共享给所有":"Share to all",
            "共享给指定":"Share to designated",
            "批量修改":"Batch modify",
            "目的地限制规则":"Destination restriction rule",
            "排仓分区规则":"Warehouse zone rules",
            "代理客户":"",
            "目的地限制服务":"Destination restriction service",
            "导出":"Export",
            "只查所属":"Only own",
            "路线编码/名称":"Route code/name",
            "启用状态":"Enabled state",
            "有配置edi":"Configured edi",
            "查询":"Search",
            "重置":"Reset",
            "路线编码":"Route code",
            "路线名称":"Route name",
            "路线英文":"Route name in English",
            "路线简体":"Route shortcode",
            "业务类型":"Business type",
            "路线分类":"Route classification",
            "偏远分类":"Remote classification",
            "所属网点":"Outlets",
            "共享方式":"Sharing mode",
            "共享网点":"Sharing outlets",
            "EDI名称":"EDI name",
            "出货材积除以数":"Volume divided by",
            "派件网点":"Distribution outlets",
            "结算节点":"Settlement node",
            "备注":"Remark",
            "建立时间":"Creation time",
            "建立人":"Creator",
            "修改时间":"Modify time",
            "修改人":"Modifier",
            "确定要修改共享方式？":"Are you sure you want to modify the sharing method?",
            "新增/修改":"",
            "新增走货路线":"Add delivery route",
            "修改走货路线":"Modify delivery route",
            "基础信息":"Basic info",
            "出货重规则":"Shipping weight rules",
            "出货重单件进位规则":"Shipping weight Pcs carry rule",
            "出货重单票计抛规则":"Shipping weight Pkg charge weight rule",
            "出货重单票进位规则":"Shipping weight Pkg carry rule",
            "共享网点(可多选)":"Sharing outlets(Multiple Choice)",
            "保存并继续":"Save&continue",
            "特殊计费规则":"Special billing rules",
            "序号":"No.",
            "计费科目":"Billing account",
            "应付代理":"AP agent",
            "批量修改目的地限制规则":"Batch modify destination restriction rules",
            "批量修改排仓分区规则":"Batch modify warehouse zone rules",
            "批量修改代理客服":"Batch modify agent CS",
            "设置信息":"Set info",
            "走货路线":"Delivery route",
            "代理客服":"Agent CS",
            "您当前选中走货路线":"You have currently selected",
            "笔，批量修改，请谨慎操作":"delivery routes for batch modification. Please proceed with caution",
            "您当前选中走货路线N笔，批量修改，请谨慎操作！":"You have currently selected N delivery routes for batch modification. Please proceed with caution!",
            "目的地":"Destination",
            "限制货物类型（可多选）":"Restricting cargo type (multiple choices)",
            "限制方式":"Restriction method",
            "限制提示":"Restriction Tips",
            "提示内容（模糊）":"Tips content (vague)",
            "排仓分区":"Warehouse partition",
            "分区名称":"Partition Name",
            "不存在目的地":"Non-existent destination",
            "目的地交货承运代理":"Dest Transport Subcon",
            "始发港":"Departure Port",
            "目的港":"Destination Port",

        },
        "BAS009": {
            "分类编码/分类名称":"Classification Code/Name",
            "申报价值处理":"Declaration value rules",
            "申报汇率规则":"Exchange rate rules",
            "允许币别":"Allow currency",
            "目标币别":"Target currency",
            "跳过ioss校验":"Skip ioss verify",
            "删除预报单(30-90天)":"Delete pre-alert (30-90 days)",
            "校验并获取HS CODE":"Verify and obtain HS CODE",
            "校验申报价值与商品价值相等":"Verify that the declared value is equal to the value of the goods",
            "最大单边长(CM)":"Maximum side length (CM)",
            "最大三边和(CM)":"Maximum trilateral sum (CM)",
            "最大单边长,最大三边和有配置值时,则会对应限制仓库入库":"If the maximum side length and maximum trilateral sum are configured, the warehouse inbound is restricted",
            "限制货物(item)数量":"Limit the number of items",
            "不填则不校验,填写后校验item数量不能超过所填值":"After filling in, it will verify that the number of items cannot exceed the entered value",
            "入库后拦截":"Intercept after inbound",
            "指定客户入库后自动拦截，待客服确定可出货后解除拦截":"Packages of designated customers are automatically intercepted when inbound, the interception can be lifted once shipment confirmed",
            "强制量方":"Mandatory measurement",
            "指定客户的运单必须进行量方操作":"The designated customer's order must be measured",
            "拍照边长设定（CM）":"Camera side length setting (CM)",
            "配置后，尺寸大于等于设置边长，则强制要求仓库操作拍照":"After configuration, if the size is greater than or equal to the set side length, it is mandatory to require the warehouse to take photos",
            "必填字段":"Mandatory Field",
            "寄件邮编拦截":"Postcode interception",
            "国家字段标准校验：":"National field standard check:",
            "国家简码信息":"National code information",
            "履约状态自动补全":"Scan status autocomplete",
            "客户":"Customer",
            "触发状态":"Trigger condition",
            "生成状态":"Generate Status",
            "时间计算方式":"Time calculation method",
            "参考状态":"Reference status",
            "时间差(s)":"Time difference (s)",
            "自提点黑名单":"Pickup point blacklist",
            "客户自定义":"Customer customization",
            "规则内容":"Rule content",
            "请选择":"Select",
            "本地揽派服务": "Local delivery service",
            "确定要删除吗？": "You sure you want to delete it?",
            "修改": "Modify",
            "获取指定线路类型树异常": "Getting the specified line type tree exception",
            "不共享": "Not share",
            "生成应收": "Generate Accounts Receivable",
            "请输入关键字": "Please enter key words",
            "指定路线": "Channel Code",
            "应付账单明细数据": "Bills payable detail data",
            "保存": "Save",
            "默认invoice格式默认份数必须大于等于1小于100": "The default number of copies of the default invoice format must be greater than or equal to 1 and less than 100",
            "路线英文": "Course",
            "请选择单一行数据": "Please select a single row of data",
            "可多选": "Multiple choice",
            "收费重规则": "Heavy Fees Rules",
            "EDI配置客户名称不能为空": "EDI configuration customer name cannot be empty",
            "请选择数据": "Please select data",
            "共享给指定": "Share to designated",
            "分类编码（分类名称）": "Classification Code/Name",
            "EDI配置二次账号不能为空": "EDI configuration secondary account cannot be empty",
            "否": "no",
            "默认货物类型": "Default Cargo type",
            "网点列表": "List of outlets",
            "其他": "other",
            "请选择录单网点": "Please select a recording outlets",
            "路线编码": "Route Code",
            "只查所属": "Only own",
            "指定路线分类": "Designated route classification",
            "是": "Yes",
            "所属网点": "Outlets",
            "起运地": "Departure",
            "目的地": "Destination",
            "请选择业务类型": "Please select business type",
            "修改人": "Modifier",
            "国家标签中国家简码不能为空": "The country shortcode in the country tag cannot be empty",
            "国家标签中Label格式不能为空": "The label format in the country label cannot be empty",
            "保存成功！": "Saved successfully!",
            "请选择收费重单票计抛规则": "Please select the Pkg charge weight rule",
            "修改指定路线": "Modify Channel Code",
            "有多条走货路线时，是否启用分拣排货？": "When there are multiple delivery routes, whether to enable sorting and scheduling?",
            "请选择收费重单票进位规则": "Please select the Pkg carry rule",
            "序号": "No.",
            "分拣排货后": "After sorting and arranging",
            "订单预报成功": "Order forecast successful",
            "删除": "Delete",
            "收费重单件进位规则": "Pcs carry rule",
            "共享": "Share info",
            "排列顺序": "Arrange",
            "指定网点": "Designated outlets",
            "重置": "Reset",
            "请先设置EDI": "Please set up EDI first",
            "国家简码不能重复": "Country shortcode cannot be repeated",
            "当前指定路线未设置默认Lable格式，确认继续保存吗？": "The default Lable format is not set for the currently specified route. Are you sure to continue saving?",
            "路线名称": "Route name",
            "接口时": "Interface time",
            "确定要修改共享方式？": "Are you sure you want to modify the sharing method?",
            "共享网点": "Shared network",
            "分类名称": "Category Name",
            "格式": "Format",
            "不能实现一键打印": "Cannot realize one-key printing",
            "请选择收费重单件进位": "Please select the charge for heavy single piece carry",
            "设置大类默认规则": "Set default rules for major categories",
            "排货类型": "Arrange type",
            "默认使用指定路线的打印规则输出": "By default, use the print rule output of the specified route",
            "共享给指定网点": "Share to designated outlets",
            "提示": "hint",
            "请选择指定路线分类": "Please select the designated route category",
            "修改指定路线分类": "Modify the designated route classification",
            "共享方式": "Share Method",
            "请选择起运地": "Please select the origin",
            "新增成功": "added successfully",
            "共享设置": "Sharing Settings",
            "导出": "Export",
            "请输入": "please input",
            "取消": "Cancel",
            "指定路线<": "Specified route<",
            "二次账号不能为空": "The secondary account cannot be empty",
            "基础信息": "Basic Info",
            "设置默认打印格式和默认份数": "Set the default print format and the default number of copies",
            "用于一键打印": "For one-click printing",
            "保存并继续": "Save&continue",
            "当前指定路线为其他网点共享的指定路线，没有修改权限": "The current designated route is a designated route shared by other outlets, and there is no permission to modify it",
            "路线大类": "channel categories",
            "名称": "name",
            "建立时间": "Established Time",
            "请选择共享网点": "Please select a shared network",
            "说明": "illustrate",
            "默认为": "The default is",
            ">已存在运费报价，分段修改会导致报价失效，请尽快修改对应报价？": ">A freight quotation already exists. Modifying it in sections will invalidate the quotation. Please modify the corresponding quotation as soon as possible?",
            "分类编码": "Classification Code",
            "Label格式不能为空": "Label format cannot be empty",
            "路线分类": "channel classification",
            "查询": "Search",
            "起始收费重必须小于等于终止收费重": "The starting fee weight must be less than or equal to the ending fee weight",
            "默认份数": "Default Number of Copies",
            "收费重单票计抛规则": "Pkg charge weight rule",
            "走货路线未设置": "The delivery route is not set",
            "请选择共享方式": "Please choose a sharing method",
            "尾程订单自动结算": "LM order auto-settlement",
            "全链路尾程货态转结算": "LM status convers settlement",
            "开放现结客户":"Open Cash customer",
            "收货允许收费实重": "Receipt is allowed to Charge actual weight",
            "请输入线路名称": "Please enter the line name",
            "共享给所有": "Share to all",
            "如默认份数设置为空": "If the default number of copies is set to blank",
            "默认A4格式默认份数必须大于等于1小于100": "The default A4 format, the default number of copies must be greater than or equal to 1 and less than 100",
            "允许": "allow",
            "起始实重必须小于等于终止实重": "The starting actual weight must be less than or equal to the ending actual weight",
            "起始材重必须小于等于终止材重": "The starting material weight must be less than or equal to the ending Volume weight",
            "请输入材积除以数": "Please enter the volume divided by the number",
            "国家标签中国家简码不能重复": "The country shortcode in the country label cannot be repeated",
            "收费材积除以数": "Volume rule value",
            "允许规则": "Allow Rules",
            "收费材重": "Charge volume weight",
            "限制规则": "Restriction Rules",
            "默认invoice格式份数必须大于等于1小于100": "The number of copies of the default invoice format must be greater than or equal to 1 and less than 100",
            "包税": "Tax Package",
            "自动转结算": "Auto-transfer settlement",
            "转单获取方式=运单分配时，运单分配规则必填": "Transfer order acquisition method=When the waybill is distributed, the waybill distribution rule is required",
            "指定线路": "Designated Route",
            "起始件数必须小于等于终止件数": "The starting piece count must be less than or equal to the ending piece count",
            "默认Label格式默认份数必须大于等于1小于100": "The default number of copies in the default Label format must be greater than or equal to 1 and less than 100",
            "默认A4格式份数必须大于等于1小于100": "The default number of copies in A4 format must be greater than or equal to 1 and less than 100",
            "删除成功！": "successfully deleted!",
            "启用状态": "Enable Status",
            "新增指定路线": "Add a designated route",
            "当收费实重": "When the Charge actual weight",
            "默认Label格式份数必须大于等于1小于100": "The number of copies of the default Label format must be greater than or equal to 1 and less than 100",
            "业务类型": "business type",
            "录单网点": "Recording outlets",
            "请选择所属网点": "Please select a Outlets",
            "新增指定路线分类": "Add designated route classification",
            "建立人": "Build people",
            "客户名称不能为空": "Customer name cannot be empty",
            "当前指定路线分类含有指定路线，不允许删除！": "The current designated route category contains the designated route and cannot be deleted!",
            "修改成功！": "Successfully modified!",
            "收费重都不为": "The charges are not heavy",
            "当前指定路线为其他网点共享的指定路线，没有删除权限": "The current designated route is a designated route shared by other outlets, and there is no permission to delete it",
            "路线大类默认设置规则与当前界面不同，是否覆盖？": "The default setting rule of the route category is different from the current interface. Do you want to overwrite it?",
            "符合其中任何一个条件": "Meets any of these conditions",
            "增加": "Increase",
            "偏远分类": "Remote Classification",
            "备注": "Remark",
            "关闭": "Close",
            "则允许收货": "Receipt is allowed",
            "启用": "Enable",
            "转单获取方式=代理edi返回时，代理edi接口必填": "Transfer order acquisition method = when the agent edi returns, the agent edi interface is required",
            "修改时间": "Modify time",
            "请输入路线编码": "Please enter the route code",
            "默认": "default",
            "新增": "Add",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "如未设置默认打印格式": "If the default print format is not set",
            "报价分段": "Quotation segmentation",
            "收货允许收费材重": "Receipt is allowed to Charge volume weight",
            "打印规则": "Printing Rules",
            "路线简体": "Route shortcode",
            "请选择单条数据进行删除": "Please select a single data to delete",
            "时": "Time",
            "请选择报价分段": "Please select the Quotation segmentation",
            "收费重单票进位规则": "Pkg carry rule",
            "确定删除此行吗？": "Are you sure to delete this line?",
            "国家简码不能为空": "The country shortcode cannot be empty",
            "份": "share",
            "启用商家二次账号前，EDI需必填(推送代理)": "Before enabling the merchant's secondary account, EDI must be filled in (push agent)",
            "1、分拣排货后，走货路线未设置EDI接口时，默认使用指定路线的打印规则输出Lable": "1. After sorting and arranging, when the EDI interface is not set on the delivery route, the print rule of the specified route will be used by default to output Lable",
            "2、设置默认打印格式和默认份数，用于一键打印": "2. Set the default printing format and the default number of copies for one-key printing",
            "3、如未设置默认打印格式，不能实现一键打印；如默认份数设置为空，默认为1份": "3. If the default print format is not set, one-key printing cannot be achieved; if the default number of copies is set to blank, the default is 1 copy",
            "路线编码/名称": "Route Code/Name",
            "收货允许收费实重(KG)": "Receipt allows the actual weight (KG)",
            "收货允许收费材重(KG)": "Receipt allows to charge material weight (KG)",
            "允许&限制规则": "Allow & Restrict Rules",
            "默认Label格式": "Default Label Format",
            "默认A4格式": "Default A4 format",
            "共享网点(可多选)": "Shared outlets (multiple choices available)",
            "分类编码(分类名称)": "Category Code (Category Name)",
            "履约状态设置":"Performance Status Settings",
            "签收状态(支持多选)":"Signed Status (multiple selection is supported)",
            "失败状态(支持多选)":"Failed Status (multiple selection supported)",
            "未完成状态(支持多选)":"Unfinish Status (multiple choices supported)",
            "注意：同一扫描状态只允许存在一个履约状态下。":"Note: Only one performance status can exist in the same scan status.",
            "特殊客户收费重规则":"Special customer charge heavy rule",
            "COD服务":"COD Service",
            "操作":"Operation",
            "生效日期":"Effective Date",
            "停用日期":"Discontinued Date",
            "客户（可多选）":"Customer (optional)",
            "收货材积除以数":"Received volume divided by number",
            "收货重单件进位规则":"Receiving Pcs carry rule",
            "收货重单票进位规则":"Charge weight Pkg carry rule",
            "收货重单票计抛规则":"Shipper weight Pkg charge weight rule",
            "集运模式(加总一段)":"Conso Transport Mode (paragraph 1 sum)",
            "校验地址系数":"Check address coefficient",
            "不填则不校验,填写后小于系数则装包操作不拦截,反之≥系数则拦截":"If it is not filled, it will not be checked. If it is less than the coefficient after filling, the packing operation will not be blocked, and if it is greater than the coefficient, it will be blocked",
            "添加":"Add",
            "默认地址": "Default Address",
            "收件信息": "Consignee Info",
            "收件公司": "Consignee company",
            "收件人": "Consignee",
            "收件电话": "Consignee phone",
            "收件地址": "Consignee Address",
            "收件州/省": "Province",
            "收件城市": "City",
            "收件区县": "District",
            "收件门牌号": "House number",
            "收件邮编": "Postcode",
            "收件邮箱": "Email",
            "说明：当客户填写的收件地址下单失败时，如果指定路线配置并启用了默认地址，则会自动使用默认地址重新下单": "Note: When creating a shipment with the customer-provided receive address fails, if the default address is configured and enabled, the default address will be automatically used to create the shipment.",
            "特殊偏远": "Special remote",
            "履约状态断更补全": "Scan status interruption autocomplete",
            "结束状态": "End status",
            "断更时间(天)": "Interruption day",
            "货态描述": "Status description",


        },
        "cmnMsgMsgMag": {
            "下一条": "next",
            "去收件箱": "Go to the inbox",
            "条，确认发送？": "Article, confirm sending?",
            "草稿": "Draft",
            "不提示": "Don't prompt",
            "输入客户": "Enter Customer",
            "选中消息": "Selected message",
            "请选择消息": "Please select a message",
            "内部": "internal",
            "全部": "All",
            "选择的消息内容存在收件人、主题或内容为空不能发送！": "The selected message content has a recipient, subject or content is empty and cannot be sent!",
            "查询": "Search",
            "系统消息": "system information",
            "部门": "Department",
            "条，确认删除？": "Article, confirm deletion?",
            "最大上传": "Max upload",
            "关联号码": "Associated Number",
            "正文内容不超过": "The body content does not exceed",
            "已经是最后一条消息了！": "This is the last message!",
            "附件": "Appendix",
            "作者": "author",
            "草稿保存成功！": "The draft was saved successfully!",
            "请选择": "please choose",
            "注意": "Notice",
            "全选": "select all",
            "转单变更": "Transfer order change",
            "添加附件": "Add attachments",
            "消息提示设置": "Prompt settings",
            "请选择收件人！": "Please select the recipient!",
            "收件箱": "inbox",
            "编辑": "edit",
            "主题": "theme",
            "已经是第一条消息了！": "It's already the first message!",
            "消息发送成功": "Message sent successfully",
            "屏幕弹窗提醒": "Shield popup",
            "收件人": "Consignee",
            "输入员工": "Enter employees",
            "存为草稿": "Save as Draft",
            "上一条": "Previous",
            "发件箱": "Outbox",
            "文件夹": "folder",
            "发送时间": "Send time",
            "文件大小不能大于5M": "File size cannot be greater than 5M",
            "删除": "Delete",
            "港前问题件": "Pre-port problem",
            "关闭": "Close",
            "发件人": "Sender",
            "重置": "Reset",
            "消息类型": "Message type",
            "消息删除成功！": "Message deleted successfully!",
            "字": "Character",
            "仅消息个数提示": "Number of messages",
            "发送": "send",
            "内容": "content",
            "客户": "customer",
            "所选数据没有未读消息！": "There are no unread messages for the selected data!",
            "写信": "write a letter",
            "确定": "OK",
            "再写一封": "Write another one",
            "按网点显示": "Display by outlet",
            "回复": "reply",
            "提示": "hint",
            "个附件": "Attachments",
            "标记已读": "Mark read",
            "按部门显示": "Display by department",
            "标记消息已读成功！": "The marked message has been read successfully!",
            "选中草稿": "Select Draft",
            "存为草稿时收件人、主题、附件、消息内容至少一项不能为空！": "At least one item of recipient, subject, attachment, and message content cannot be empty when saving as a draft!",
            "请输入": "please input",
            "用户账号检索": "User Account Search",
            "取消": "Cancel",
            "创建时间": "Create time",
            "可选多个附件": "Optional multiple attachments",
            "网点检索": "Network Search",
            "类型": "type",
            "正文内容不超过7000字": "The body content does not exceed 7000 words",
            "输入员工/部门/网点检索": "Enter employee/department/site search",
            "输入客户/用户账号检索": "Enter customer/user account to retrieve",
            "注意：可选多个附件，最大上传5个附件": "Note: Multiple selections are allowed, up to 5 uploads"
        },
        "BMS013": {
            "默认系统时间": "Default system time",
            "本币单价": "Unit Price of Local Currency",
            "路线大类": "channel categories",
            "出货时间": "delivery time",
            "指定路线": "Channel Code",
            "路线分类": "channel classification",
            "查询": "Search",
            "收件邮编": "Consignee Postcode",
            "材积除以数": "Volume divided by number",
            "包装类型": "Packing type",
            "时效": "aging",
            "限制货物类型": "Restricted Cargo type",
            "请输入\"重量\"!": "Please enter \"weight\"!",
            "本币金额合计": "Total amount in local currency",
            "本币运费": "Local Currency Shipping",
            "科目名称": "Subject name",
            "公式": "formula",
            "注意": "Notice",
            "指定路线为查询允许": "Specified route is allowed for query",
            "其他费用明细": "Details of other expenses",
            "汇率": "exchange rate",
            "重量": "weight",
            "业务类型": "business type",
            "代理帐号": "Agent Account",
            "时间": "time",
            "付费重": "Payment heavy",
            "币别": "Currency",
            "序号": "No.",
            "停用时间": "Deactivation time",
            "原币": "Original currency",
            "禁用": "Disabled",
            "走货路线": "Delivery route",
            "备注": "Remark",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable",
            "目的地": "Destination",
            "本币金额": "Amount in local currency",
            "原币金额": "Original currency",
            "派送代理": "Dispatch Outlets",
            "本币其他": "Others in local currency",
            "生效日期": "effective date",
            "原币单价": "Unit Price of Original Currency",
            "计算公式": "Calculation formula",
            "货物类型": "Cargo type",
            "显示已停用走货路线报价": "Show deactivated quotes",
            "请输入": "please input",
            "走货路线的应付报价": "The payable quotation of the cargo route",
            "金额": "Amount",
            "本币合计": "Local Currency Total",
            "收件区县": "Consignee district",
            "收件城市": "Consignee city",
            "收件州省": "Consignee province",
        },
        "BMS094": {
            "修改": "Modify",
            "提交时间": "Submission time",
            "费用信息": "Expense Information",
            "请选择要删除的数据！": "Please select the data to be deleted!",
            "费用补录提交": "Submission of Expenses Supplement",
            "指定路线": "Channel Code",
            "请输入正确的公式": "Please enter the correct formula",
            "可多选": "Multiple choice",
            "包装类型": "Packing type",
            "费用补录": "Expense Supplementary Record",
            "注意": "Notice",
            "跟进记录": "Follow up record",
            "但允许继续跟进": "But allow to follow up",
            "请选择要跟进的数据！": "Please select the data to follow up!",
            "科目": "suject",
            "请选择要修改的数据！": "Please select the data to be modified!",
            "单票补录": "Single Ticket Supplementary Record",
            "已提交导出任务，正在下载": "The export task has been submitted and is downloading",
            "客户名称": "Customer name",
            "跟进时间": "Follow up time",
            "内部备注": "Internal Remarks",
            "币别": "Currency",
            "进入异常": "Incoming exception",
            "序号": "No.",
            "是否继续": "Whether to continue",
            "字数不能超过300，请修改后提交": "The number of words cannot exceed 300, please modify and submit",
            "提交状态": "Submission Status",
            "日期不能为空！": "The date cannot be empty!",
            "删除": "Delete",
            "客户结算已存在科目": "Customer settlement accounts already exist",
            "确认人": "Confirmor",
            "重置": "Reset",
            "寄件网点": "Outlets",
            "目的地": "Destination",
            "笔数据吗？(已提交数据不会被确认)": "Pen data? (Data submitted will not be confirmed)",
            "笔已提交，是否继续(已提交数据不会被提交)？": "The pen has been submitted, do you want to continue (the submitted data will not be submitted)?",
            "笔数据删除成功！": "The data was deleted successfully!",
            "最多录入": "Maximum Entry",
            "转单号码": "Tracking Number",
            "账单日期": "Bill Date",
            "提示": "hint",
            "客户编码": "Customer code",
            "费用批量补录": "Expense Bulk Supplementary Recording",
            "个字符": "Characters",
            "费用补录导出": "Export of Expenses Supplementary Record",
            "批量补录": "Batch Supplementary Recording",
            "报关方式": "Declaration method",
            "导出": "Export",
            "请选择要提交的数据！": "Please select the data to be submitted!",
            "请输入": "please input",
            "笔待提交，": "Pending submission,",
            "跟进人": "Follow up",
            "取消": "Cancel",
            "录入人": "Entry Person",
            "其中": "in",
            "补录相关": "Make up",
            "笔数据吗？(已提交数据不会被删除)": "Pen data? (Data submitted will not be deleted)",
            "税金付款": "Tax Payment",
            "就不允许修改": "No modification allowed",
            "科目编码": "Subject Code",
            "名称": "name",
            "运单号码": "Order Number",
            "不可多条修改！": "No more modifications!",
            "查询": "Search",
            "不可多条跟进 ！": "No more follow-ups!",
            "请输入跟进内容 ！": "Please enter the follow-up content!",
            "您选取的": "You selected",
            "增值费导入": "Value-added fee import",
            "本次跟进": "Follow up this time",
            "确认删除所选": "Confirm to delete selected",
            "账单备注": "Bill Remarks",
            "已提交数据不可修改！": "The submitted data cannot be modified!",
            "金额不能为空": "Amount cannot be empty",
            "科目名称": "Subject name",
            "结算状态": "Billing Status",
            "科目不能为空": "Subject cannot be empty",
            "笔数据，其中": "Pen data, where",
            "科目编号": "Subject Number",
            "费用补录申请": "Application for supplementary entry of fees",
            "已取消数据不可修改！": "Canceled data cannot be modified!",
            "笔客户结算已有相同科目": "The client settlement already has the same account",
            "当费用信息确认之后": "When the fee information is confirmed",
            "对账员": "Reconciler",
            "补录原因": "Reason for Supplementary Recording",
            "进入确认": "Enter Confirmation",
            "笔数据": "Pen data",
            "走货路线": "Delivery route",
            "已有金额": "Amount already available",
            "跟进": "follow up",
            "关闭": "Close",
            "销售员": "Seller",
            "笔成功！": "The pen is successful!",
            "数据来源": "Data Sources",
            "提交异常": "Submit exception",
            "跟单员": "Tracker",
            "客户": "customer",
            "内容": "content",
            "已提交数据不会被提交": "Submitted data will not be submitted",
            "费用补录修改": "Expense Supplementary Record Modification",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "导入": "Import",
            "确定": "OK",
            "确认时间": "Confirmation time",
            "最新状态": "Latest status",
            "提交人": "Submitter",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Charge weight",
            "确认所选": "Confirm selection",
            "计算公式": "Calculation formula",
            "不可多条跟进！": "Not many follow-ups!",
            "笔已提交": "Pen has been submitted",
            "跟进成功！": "Follow up successfully!",
            "删除的数据为空，请确认提交状态，重新选择": "The deleted data is empty, please confirm the submission status and select again",
            "货物类型": "Cargo type",
            "运单状态": "order status",
            "确认": "confirm",
            "录入时间": "Entry Time",
            "补录相关不能为空！": "The supplementary record cannot be empty!",
            "金额": "Amount",
            "客户编码/名称": "Customer Code/Name",
            "提交人(可多选)": "Submitter",
        },
        "productcontrolrules": {
            "确定要删除吗？": "You sure you want to delete it?",
            "备注": "Remark",
            "匹配英文品名": "Match Description EN",
            "删除": "Delete",
            "匹配规则": "Matching rules",
            "查询": "Search",
            "匹配栏位": "Match field",
            "时如中文品名为空": "Shiru Chinese title is empty",
            "重置": "Reset",
            "得到中文品名": "Get the Description CN",
            "修改时间": "Modify Time",
            "请选择一行数据": "Please select a row of data",
            "创建人": "Founder",
            "需自动根据英文品名转换为中文品名": "Need to automatically convert Description EN to Description CN",
            "导入": "Import",
            "确定": "OK",
            "提示": "Hint",
            "删除成功！": "successfully deleted!",
            "品名对照规则": "Product name comparison rules",
            "删除异常": "Delete exception",
            "导出": "Export",
            "以分号分隔的字符串需包含在": "Strings separated by semicolons must be included in",
            "中文品名": "Description CN",
            "优先于完全匹配": "Takes precedence over exact match",
            "修改人": "Modifier",
            "接口对接": "Interface docking",
            "不分先后顺序": "In no particular order",
            "取消": "Cancel",
            "创建时间": "Creation time",
            "的英文品名中": "In the Description EN",
            "被选中的记录需符合以下条件": "The selected record must meet the following conditions",
            "接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名": "When the interface is connected to INVOICE, if the Description CN is empty, it needs to be automatically converted to Description CN according to the Description EN",
            "匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配": "Match the Description EN to get the Description CN; the selected record must meet the following conditions, and the semicolon-separated string must be included in the Description EN of INVOICE (in no particular order), which takes precedence over the exact match "

        },
        "productnameimport": {
            "历史日志": "History log",
            "订单导入成功": "Order imported successfully",
            "成功": "Successfully",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "验证中": "Verifying",
            "匹配规则": "Matching rules",
            "匹配栏位": "Match field",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select an import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import history log",
            "总行数": "Total",
            "请选择模版！": "Please choose a template!",
            "导入时间": "Import time",
            "请选择匹配栏位！": "Please select a matching field!",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template download",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please enter",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "行号": "Line number",
            "错误行数": "Error no.",
            "导入模版": "Import template "
        },
        "BAS066": {
            "指定路线":"Channel code",
            "录单网点":"Recording outlets",
            "配置方法: ABC%, 则ABC开头视为匹配; %ABC, 则ABC结尾视为匹配; %ABC%, 则含有ABC视为匹配; ABC,则需要完全匹配":"Configuration method: ABC%, then the beginning of ABC is considered a match;% ABC,  The end of ABC is considered a match;% ABC%,  If it contains ABC, it is considered a match; ABC, Then a perfect match is required",
            "配货信息": "Distribution information",
            "修改": "Modify",
            "当运单有多个": "When there are multiple waybills",
            "精准匹配": "Precise matching",
            "查询": "Search",
            "保存": "Save",
            "货物类型不能为空": "The cargo type cannot be empty",
            "当运单有多个品名时": "When the waybill has multiple item names",
            "创建人": "Founder",
            "需完全匹配": "Need to match exactly",
            "否": "No",
            "只要有一个匹配即满足要求": "As long as there is a match, the requirement is met",
            "请选择": "please choose",
            "删除成功！": "successfully deleted!",
            "中": "middle",
            "启用状态": "Enabled state",
            "是": "Yes",
            "修改人": "Modifier",
            "视为匹配": "Treat as a match",
            "修改成功！": "Successfully modified!",
            "可对特定国家设置货物类型": "Cargo type can be set for specific countries",
            "英文品名关键字": "Description EN",
            "配货信息必填其一": "Delivery information must be filled in one",
            "新增货物类型策略": "Add cargo type strategy",
            "删除": "Delete",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable",
            "违禁品": "Contraband",
            "修改时间": "Modify Time",
            "品名关键字只允许填入一个": "Only one keyword of product name is allowed",
            "请选择一行数据": "Please select a row of data",
            "仅查违禁品": "Check only contraband",
            "中文品名关键字": "Description CN",
            "新增": "Add",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "提示": "Hint",
            "货物类型策略": "Cargo type strategy",
            "国家简码": "Country shortcode",
            "只允许填入一个": "Only one is allowed",
            "英文品名包含关键字时": "When the Description EN contains keywords",
            "添加成功！": "Added successfully!",
            "修改货物类型策略": "Modify cargo type strategy",
            "货物类型": "Cargo type",
            "是否删除该货物类型策略": "Whether to delete the Cargo type strategy",
            "导出": "Export",
            "时": "Time",
            "取消": "Cancel",
            "创建时间": "Creation time",
            "品名关键字": "Product name keywords",
            "只允许填入一个SKU；当运单有多个SKU时，只要有一个匹配即满足要求（需完全匹配）": "Only one SKU is allowed; when there are multiple SKUs in the waybill, as long as there is one match, the requirement is met (complete match is required)",
            "品名关键字只允许填入一个；当运单有多个品名时，只要有一个匹配即满足要求": "Only one item name keyword is allowed; when there are multiple item names in the waybill, as long as there is one match, the requirement is met",
            "中/英文品名包含关键字时，视为匹配": "When the Chinese/English product name contains keywords, it will be regarded as a match",
            "SKU、品名关键字、配货信息必填其一": "SKU, product name keywords, and distribution information are required "
        },
        "BAS067": {
            "修改": "Modify",
            "修改分拣码": "Modify Sort code",
            "拦截": "Intercept",
            "名称": "Name",
            "指定路线": "Channel Code",
            "查询": "Search",
            "保存": "Save",
            "仅查询拦截分拣码": "Search interception",
            "分拣分区": "Sort partition",
            "可多选": "Multiple choice",
            "是否删除该邮编目的地策略": "Whether to delete the postal code destination policy",
            "创建人": "Founder",
            "启用拦截后": "After enabling interception",
            "修改异常": "Modify exception",
            "收费重范围": "Heavy range of charges",
            "拦截提示": "Blocking prompt",
            "COD金额": "COD Amount",
            "否": "No",
            "金额范围": "Amount range",
            "分拣操作时会拦截此分拣码": "This sorting code will be intercepted during sorting operation",
            "新增分拣码": "Add sort code",
            "分拣码信息": "Info",
            "删除成功！": "successfully deleted!",
            "启用状态": "Enable Status",
            "是": "Yes",
            "删除异常": "Delete exception",
            "重量": "Weight",
            "申报价值": "Declared value",
            "申报价值范围": "Range of declared value",
            "修改人": "Modifier",
            "请求成功": "Request succeeded",
            "修改成功！": "Successfully modified!",
            "分拣码": "Sort code",
            "优先级": "Priority",
            "走货路线": "Delivery route",
            "删除": "Delete",
            "关闭": "Close",
            "重置": "Reset",
            "启用": "Enable",
            "修改时间": "Modify Time",
            "请选择一行数据": "Please select a row of data",
            "客户": "Customer",
            "新增": "Add",
            "确定": "OK",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Weight",
            "国家简码": "Country shortcode",
            "输入国家简码检索": "Enter country shortcode to search",
            "拦截时必填": "Required when intercepting",
            "添加成功！": "Added successfully!",
            "报关方式": "Declaration method",
            "货物类型": "Cargo type",
            "导出": "Export",
            "请输入": "Please Enter",
            "取消": "Cancel",
            "英文的时候需要加上这句": "You need to add this sentence in English",
            "创建时间": "Creation time",
            "自动换行": "Word wrap",
            "添加异常": "Add exception",
            "请输入,必须是数字": "Please enter, it must be a number",
            "分拣规则": "Sorting rules ",
            "批量导入": "Batch import",
            "需二次分拣": "Secondary sort",
            "异步下单": "Asynchronous order",
            "末端分拣标签": "LM sorting label",
            "包裹尺寸上限": "Upper size limit (CM)",
            "服务类型": "Service type",
            "仓操作不校验限制": "Restrictions invalid for operations",
            "转单号生成二维码面单": "Tracking No generate QR code",
            "二维码面单":"QR code",
            "CBM上限": "CBM upper limit"
        },
        "sortpartition": {
            "修改": "Modify",
            "地址关键字": "Address key",
            "数据修改成功！": "Data modification is successful!",
            "删除": "Delete",
            "区县": "District",
            "查询": "Search",
            "关闭": "Close",
            "保存": "Save",
            "重置": "Reset",
            "启用": "Enable",
            "收件邮编": "Receiving Postcode",
            "分拣分区": "Sort partition",
            "修改时间": "Modify time",
            "请选择一行数据": "Please select a row of data",
            "创建人": "Founder",
            "例如": "E.g",
            "新增": "Add",
            "确定": "OK",
            "或者": "or",
            "是否该分拣码配置?": "Whether the sorting code configuration ?",
            "新增分拣分区": "Add Sort partition",
            "提示": "Hint",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "州省": "Province",
            "国家简码": "Country shortcode",
            "数据新增成功！": "The data is added successfully!",
            "分区信息": "Partition information",
            "输入国家简码检索": "Enter country shortcode to search",
            "删除成功！": "successfully deleted!",
            "启用状态": "Enable Status",
            "支持单个邮编与邮编区间设置": "Support single Postcode and Postcode interval setting",
            "删除异常": "Delete exception",
            "多组邮编用逗号分隔": "Multiple groups of Postcode are separated by commas",
            "导出": "Export",
            "修改分拣分区": "Modify Sort partition",
            "修改人": "Modifier",
            "取消": "Cancel",
            "创建时间": "Creation time",
            "不能为空": "Can not be empty",
            "邮编": "Postcode",
            "城市": "City",
            "分拣规则": "Sort Rules",
            "批量导入": "Batch import",
            "支持单个邮编与邮编区间设置，多组邮编用逗号分隔；例如 10000,10001 或者 28000~28099,13000~13999": "Support setting single postcode or postcode range, multiple postcodes separated by commas; For example, 10000,10001 or 28000~28099,13000~13999",

        },
        "BAS070": {
            "确定要删除吗？": "You sure you want to delete it?",
            "修改": "Modify",
            "编辑轨迹推送配置": "Edit track push configuration",
            "删除成功": "successfully deleted",
            "取消": "Cancel",
            "删除": "Delete",
            "修改时间": "Modify time",
            "请选择一行数据": "Please select a row of data",
            "配置信息": "Config information",
            "创建人": "Founder",
            "新增轨迹推送配置": "Add track push configuration",
            "客户": "Customer",
            "轨迹推送配置": "Track push configuration",
            "货态描述映射": "Mapping status description",
            "新增": "Add",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "提示": "Hint",
            "编辑成功": "Edit successfully",
            "客户编码": "Customer code",
            "名称检索": "Name search",
            "新增成功": "added successfully",
            "输入客户编码": "Enter customer code",
            "导出": "Export",
            "请输入": "Please enter",
            "修改人": "Modifier",
            "轨迹推送地址": "Track push address",
            "创建时间": "Creation time",
            "客户名称": "Customer Name"
        },
        "TMS091": {
            "订单导入模板有更新, 请下载最新模板":"Order import template is updated, please download the latest template",
			"提示":"Hint",
			"确定":"OK",
            "模版下载": "Template download",
            "导入模版": "Import template ",
            "历史日志": "History Log",
            "订单导入成功": "Order imported successfully",
            "成功": "Success",
            "状态": "Status",
            "自动获取运单号码": "Obtain the waybill number automatically",
            "导入中": "Importing",
            "上传失败": "upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "名称": "Name",
            "备注": "Remark",
            "验证中": "Verifying",
            "指定路线": "Channel Code",
            "模板管理": "Template management",
            "验证失败": "verification failed",
            "解析中": "Parsing",
            "标准模板": "Standard template",
            "请选择客户！": "Please select a customer!",
            "客户": "Customer",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "订单号码": "Order number",
            "导入": "Import",
            "导入历史日志": "Import History log",
            "编码": "Coding",
            "总行数": "Total",
            "请选择模版！": "Please choose a template!",
            "无对应文件": "No corresponding file",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please enter",
            "上传中": "Uploading",
            "导入后自动排货": "Automatically arrange goods after import",
            "行号": "Line number",
            "错误行数": "Error no."
        },
        "TMS092": {
            "电池类型":"Battery type",
            "型号":"model",
            "长":"Length",
            "宽":"Width",
            "高":"Height",
            "申报金额":"DeclarationAmount",
            "自定义面单":"Customize label",
            "IOSS签发国":"IOSS Country",
            "收件门牌号":"House number ",
            "证件类型":"Type of certificate ",
            "证件号码":"ID number ",
            "寄件门牌号":"House number ",
            "单位": 'Unit',
            "请输入收件城市": "Please enter the Consignee city",
            "请完善收件人信息": "Please complete the Consignee information",
            "省": "Province",
            "请选择税金支付": "Please select tax payment",
            "订单保存并预报成功，订单号码： <": "Order saves and forecasts success, Ref Number: <",
            "税金支付不能为空": "Tax payment cannot be empty",
            "添加": "Add to",
            "原产地": "country of origin",
            "指定路线": "Channel Code",
            "寄件州": "Consigner Province",
            "收件州/省": "Province",
            "寄件州/省": "Province",
            "选择": "Choose",
            "保存": "Keep",
            "最多": "Most",
            "总价": "Total price",
            "列": "List",
            "清空": "Clear",
            "包装类型": "Packing type",
            "请输入寄件城市": "Please enter the Consigner city",
            "获取文件路径异常": "Get file path exception",
            "单价不能为空": "Unique unit price cannot be empty",
            "操作": "Operation",
            "货物重量不能为空": "The weight of the cargo cannot be empty",
            "请输入收件地址": "Please enter the Consignee address",
            "请输入内容": "Please enter content",
            "否": "No",
            "行邮税号": "Postal tax number",
            "付款方式": "Payment",
            "其他": "Other",
            "基本信息": "Order Info",
            "是": "Yes",
            "件数": "Pieces",
            "查看订单": "Check order",
            "平台类型": "Platform type",
            "不能上传jsp,bat,sh,js,exe文件": "Can't upload JSP, BAT, SH, JS, EXE file",
            "选择常用收件人": "Choose common Consignee",
            "请输入寄件地址": "Please enter the Shipper address",
            "请输入货物重量": "Please enter the weight of the goods",
            "收件人信息": "Consignee",
            "继续编辑": "Continue editing",
            "收件城市": "City",
            "序号": "No.",
            "指定路线不能为空": "The channel code cannot be empty",
            "单价": "Unit price",
            "自定义信息": "Remarks",
            "行": "Row",
            "必填": "Required",
            "注意以下几点要求": "Pay attention to the following requirements",
            "删除": "Delete",
            "数量": "Quantity",
            "请完善寄件人信息": "Please complete the Shipping information",
            "请输入寄件邮编": "Please enter the Shipping postcode",
            "保存成功": "Successfully saved",
            "列与列直接用": "Columns and columns",
            "数量不能为空": "Quantity can't be empty",
            "寄件国家": "Country",
            "英文品名不能为空": "English description cannot be empty",
            "请输入0-9999之间的重量": "Please enter a weight between 0-9999",
            "信息复制到剪贴板即可": "Information is copied to the clipboard",
            "请输入寄件国家": "Please enter the Shipping country",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "文件大小不能大于10MB": "File size cannot be greater than 10MB",
            "商品图片地址": "Product picture address",
            "请选择目的地！": "Please select a destination!",
            "字符以内": "Within the character",
            "订单保存到草稿成功，订单号码： <": "Order saves to the draft success, Ref Number: <",
            "请选择报关方式": "Please select the declaration method",
            "请输入寄件电话": "Please enter the Shipper phone",
            "收件人电话不能为空": "Consignee phone cannot be empty",
            "运费": "Freight",
            "取消": "Cancel",
            "位小数": "Position",
            "保存到草稿": "Save to draft",
            "收件邮箱": "Email",
            "配货信息": "Distribution information",
            "海关编码": "HS code",
            "商品链接地址": "Item Product URL",
            "快速录入": "Quick entry",
            "用于额外打印在标签上": "Used to print on the label",
            "请输入寄件人": "Please enter the Shipper",
            "删除成功!": "Successfully deleted!",
            "货物类型不能为空": "The cargo type cannot be empty",
            "选填": "Optional",
            "寄件电话": "Shipper phone",
            "请选择目的地": "Please select a destination",
            "请选择币别": "Please select currency",
            "包装类型不能为空": "Packaging type cannot be empty",
            "订单号码": "Ref Number",
            "品牌": "Brand",
            "请选择包装类型": "Please select the Packing type",
            "信息": "information",
            "收件地址": "Consignee Address",
            "下一订单": "Next order",
            "寄件地址": "Shipper address",
            "寄件邮编": "Postal code",
            "请输入收件人！": "Please enter the recipient!",
            "货物重量": "Weight",
            "英文品名": "Description EN",
            "寄件人不能为空": "Consigner name cannot be empty",
            "请输入件数": "Please enter the number of pieces",
            "上传附件": "Upload Attachment",
            "请输入需要导入的信息!": "Please enter the information you want to import!",
            "保存为常用收件人": "Save Consignee",
            "收件人不能为空": "The Consignee name cannot be empty",
            "备注": "Remark",
            "寄件城市": "City",
            "寄件人信息": "Shipper",
            "单个重量": "Piece weight",
            "请输入收件电话！": "Please enter the receiving phone number!",
            "区县": "District",
            "关闭": "Closure",
            "请输入收件电话": "Please enter the Consignee phone",
            "格式为": "Format",
            "目的地不能为空": "Destination can't be empty",
            "材质": "Material",
            "收件人地址不能为空": "The Consignee address cannot be empty",
            "第三方税金账号": "Third-party tax account",
            "收件州": "Consignee Province",
            "请输入至少一行invoice信息！": "Please enter at least one line of INVOICE information!",
            "请选择指定路线": "Please select Channel Code",
            "请选择付款方式": "Please select a payment method",
            "代收款": "Agency fund",
            "导入": "Import",
            "用途": "Use",
            "确定": "OK",
            "请输入订单号码": "Please enter the ref number",
            "点击保存按钮后添加信息": "Add information when you click save the button",
            "税金支付": "Tax payment",
            "请输入收件人": "Please enter the Consignee",
            "规格": "Specification",
            "件数不能为空": "The number of pieces cannot be empty",
            "订单号码为空，系统自动分配订单号码，是否继续？": "The order number is empty, the system automatically assigns the order number, is there?",
            "请输入收件地址！": "Please enter the receipt address!",
            "更多信息": "More information",
            "导入格式": "Import format",
            "保存为草稿": "Save as draft",
            "保留上一笔": "Keep the previous",
            "导入前请将": "Please",
            "货物类型": "Cargo type",
            "请输入收件邮编": "Please enter the Consignee postcode",
            "中文品名": "Description CN",
            "请选择货物类型": "Please select the Cargo type",
            "请输入中文品名": "Please enter Chinese description",
            "保存并预报": "Save&continue",
            "确定删除此行吗？": "Are you sure to delete this line?",
            "选取": "Choose",
            "第三方付税金账号": "Third-party tax payment account",
            "隔开": "Separately",
            "客户": "Customer",
            "必填，最多3位小数": "Required, 3 decimal places",
            "选填，200字符以内": "Optional, within 200 characters",
            "选填，用于额外打印在标签上， 500字符以内": "Optional, used for additional printing on the label, within 500 characters",
            "必填，300字符以内": "Required, within 300 characters",
            "服务类型": "Service type",
            "平台运费": "Platform freight",
            "自定义面单 URL": "Customize label URL",
            "税金付款": "Tax payment",
            "保险金额": "Insurance",
            "保险类别": "Insurance type",
            "包裹长": "Pkg length",
            "包裹宽": "Pkg width",
            "包裹高": "Pkg height",
            "目的国语言品名": "DC language description",
            "类别": "Category",
            "电池类型/型号": "Battery type/model",
            "电池数量": "Number of batteries",
            "销售平台商品编码": "Sales-platform product code",
            "长(cm)": "Length (cm)",
            "宽(cm)": "Width (cm)",
            "高(cm)": "Height (cm)",
            "目的地": "Destination",
            "收件公司": "Consignee company",
            "收件人": "Consignee",
            "收件电话": "Consignee phone",
            "收件邮编": "Consignee postcode",
            "寄件公司": "Shipper company",
            "寄件人": "Shipper",
            "寄件邮箱": "Shipper Email",
            "税号类型": "Tax number type",
            "收件税号": "Receiving tax number",
            "寄件税号": "Shipping tax number",
            "转寄原单号": "Original number",
        },
        "BAS063": {
            "未知异常": "Unknown exception",
            "创建任务": "Create task",
            "状态": "Status",
            "解析完成时间": "Analysis completion time",
            "解析订单数": "Analyze the number of orders",
            "报文": "Message",
            "解析报文异常": "Parsing message exception",
            "人工下载": "Manual download",
            "查询": "Search",
            "只显示异常": "Only show exceptions",
            "重置": "Reset",
            "保存完成时间": "Save time",
            "订单数据条件": "Order data conditions",
            "接收完成时间": "Receive completion time",
            "结束时间": "End time",
            "正在解析报文": "Parsing message",
            "接收报文异常": "Received message is abnormal",
            "客户": "Customer",
            "自动下载": "Automatic download",
            "附件": "Appendix",
            "正在保存": "Saving",
            "保存异常": "Save exception",
            "保存订单数": "Saved orders",
            "店铺昵称": "Shop nickname",
            "正在接收报文": "Receiving message",
            "下载异常": "Download abnormal",
            "下载方式": "Download method",
            "解析完成": "Parsing is complete",
            "保存完成": "Saved",
            "平台类型": "Platform type",
            "创建时间": "Creation time"
        },
        "TMS001": {
            "invoice总数量":"Total invoice",
            "二次路由修改":"Secondary route modify",
            "异步订单修改":"Modify asyn order",
            "首公里面单":"FM label",
            "首公里面单-二维码":"FM label-QRcode",
            "末端面单":"LM label",
            "无章":"No stamp",
            "報關文":"Customs declare form",
            "Invoice导出":"Export invoice",
            "单号导出":"Export number",
            "ICBU快递单号导出":"Export ICBU number",
            "shopee日货量导出":"Export Shopee daily output",
            "二次路由":"Secondary routing",
            "异步状态":"Asynchronous status",
            "条形码":"Barcode number",
            "揽收快递号":"Collect delivery number",
            "显示明文":"Display plaintext",
            "揽收取件码":"Collect pickup code",
            "二次路由详情":"Secondary routing",
            "二次路由状态":"Secondary routing status",
            "二次路由结果":"Secondary routing result",
            "跟单员":"Merchandiser",
            "排除":"Exclude",
            "修改":"Modify",
            "特殊导出":"Special export",
            "ICBU操作":"ICBU Operation",
            "面单打印":"Print",
            "指定模板打印":"Print specified template",
            "公司": "Company",
            "不刷新": "Don't refresh",
            "成功转草稿": "Draft successfully transferred",
            "原产地": "country of origin",
            "请选择至少一行\"草稿\"或\"已预报\"数据": "Please select at least one line of \"draft\" or \"predicted\" data",
            "我是标题": "I am the title",
            "是否终止": "Whether to terminate",
            "选择": "Choose",
            "是否确定标记为已打印？": "Are you sure you want to mark as printed?",
            "预报箱号": "Forecast box number",
            "请选择订单状态是\"草稿\"的数据": "Please select the data whose order status is \"Draft\"",
            "总价": "Total price",
            "请选择要取消拦截的数据": "Please select the data to be cancelled",
            "文件名": "File name",
            "客户重量": "Customer weight",
            "收货包号": "Receipt bag number",
            "寄件区县": "Sending district",
            "获取文件路径异常": "Obtaining the file path is abnormal",
            "预报箱材积": "Forecast box volume",
            "操作": "Operation",
            "操作时间": "Operate time",
            "请选择": "Please Select",
            "寄件人": "Shipper",
            "取消订单": "Cancel order",
            "拦截": "Withhold",
            "是否打印": "Whether to print",
            "将不允许收货": "Will not allow receipt",
            "排货时间": "Arrangement time",
            "寄件税号": "Shipping tax number",
            "请选择订单！": "Please select an order!",
            "修改人": "Modify",
            "运单标签": "Waybill label",
            "邮编": "Postcode",
            "客户名称": "Customer Name",
            "卖家昵称": "Seller's nickname",
            "异常信息": "Exception information",
            "订单来源": "Order source",
            "COD币别": "COD currency",
            "只有在已预报": "Only in the forecast",
            "排货成功": "Successfully arranged",
            "转寄原单号": "Original number",
            "单价": "Price",
            "请选择要修改的数据": "Please select the data to be modified",
            "自定义信息": "Custom information",
            "请选择订单状态是\"已收货\", \"已出货\",\"已预报\"的数据": "Please select the data whose order status is \"received\", \"shipped\",\"predicted\"",
            "彻底删除订单将不能恢复，您真的要彻底删除吗？": "If you delete the order completely, it will not be restored. Do you really want to delete it completely?",
            "数量": "Number",
            "刷新": "Refresh",
            "预报修改操作成功": "Forecast modification operation succeeded",
            "自定义备注": "Custom note",
            "寄件网点": "Outlets",
            "已预报的订单在收货时": "The forecasted order is at the time of receipt",
            "收件州省": "Consignee province",
            "未选择数据，请选择后再打印": "No data selected, please select and then print",
            "相关文件": "Related documents",
            "客户类型":"Customer Type",
            "创建导出任务，请稍后在导出列表中下载！": "Create an export task, please download it in the export list later!",
            "成功删除订单": "Order deleted successfully",
            "目的编码": "Destination code",
            "格式": "Format",
            "请输入单号！": "Please enter the tracking number!",
            "销售记录编码": "Sales record code",
            "请选择订单状态是\"已删除\",\"已预报\"的数据": "Please select the data whose order status is \"deleted\",\"predicted\"",
            "笔！": "Pen!",
            "转单号码": "Tracking number",
            "客户编码": "Customer code",
            "客户重量必须>=0.001": "Customer weight must be >=0.001",
            "终止平台订单": "Terminate platform order",
            "关联运单号码": "Associate jobno",
            "报关方式": "Declaration method",
            "按单号导出": "Export by order number",
            "寄件州/省": "Shipping Province",
            "交易ID": "Transaction ID",
            "该订单没有明细！": "The order has no details!",
            "你真的要将选择的数据获取转单吗？(注意：此功能适合于快递订单)": "Do you really want to transfer the selected data? (Note: This function is suitable for express orders)",
            "将不允许出货": "Will not be allowed to ship",
            "请选择报关方式": "Please choose the declaration method",
            "请选择一个客户后再进行全部收货": "Please select a customer before receiving all the goods",
            "取消": "Cancel",
            "订单包号": "Order package number",
            "请选择要修改指定路线的数据": "Please select the data to modify the specified route",
            "收件邮箱": "Receiving mailbox",
            "件数必须>=1": "The number of pieces must be >=1",
            "揽收人": "Collector",
            "快递单号导出": "Courier number export",
            "海关编码": "Customs code",
            "您将终止订单共": "You will terminate the order total",
            "确定取消吗": "Are you sure to cancel",
            "出货时间": "delivery time",
            "全部": "All",
            "请选择要排货的订单数据": "Please select the order data to be dispatched",
            "是否保存": "Whether to save",
            "目的名称": "Purpose name",
            "查询": "Search",
            "成功获取转单信息": "Successfully obtain transfer order information",
            "您真的要将选择的数据修改指定路线吗？": "Do you really want to modify the selected data to specify the route?",
            "寄件电话": "Shipper phone",
            "分拣分区": "Sort partition",
            "未获取到对应数据": "Corresponding data is not obtained",
            "发票打印": "Invoice printing",
            "成功提交预报": "Forecast submitted successfully",
            "订单号码": "Order number",
            "请选择包装类型": "Please select the Packing type",
            "转草稿": "Transfer draft",
            "到付款": "COD amount",
            "删除订单": "Delete order",
            "货物重量": "Cargo weight",
            "录单网点": "Recording outlets",
            "是否确定": "Are you sure",
            "真的要将选择的订单申请拦截吗？": "Do you really want to apply for temporary hold of the selected order?",
            "最多不能超过": "No more than",
            "导入修改": "Import modify",
            "请输入拦截原因!": "Please enter the reason for suspension !",
            "走货路线": "Delivery route",
            "备注": "Remark",
            "子单生成规则未设置，请重新设置": "Sub-order generation rules are not set, please reset",
            "订单日期不能为空": "Order date cannot be empty",
            "关闭": "Close",
            "申请拦截后": "After applying for suspension",
            "取消原因": "Reason for Cancellation",
            "终止原因不能为空": "The termination reason cannot be empty",
            "终止成功": "Termination success",
            "查录单": "Checklist",
            "收件地址3": "Shipping Address 3",
            "收件地址2": "Shipping Address 2",
            "修改时间": "Modify time",
            "下载": "Download",
            "请选择一行数据": "Please select a row of data",
            "没有获取到下载地址！": "Did not get the download address!",
            "收件门牌": "Receiving house number",
            "收件州": "Receiving Province",
            "请选择至少一行数据": "Please select at least one row of data",
            "选择的订单拦截成功！": "The selected order has been temporarily deducted successfully!",
            "已提交收货请求！": "The receipt request has been submitted!",
            "客户": "Customer",
            "内容": "Content",
            "确定": "OK",
            "目的地编码": "Destination code",
            "终止备注": "Termination note",
            "请选择订单状态是\"已删除\"的数据": "Please select the data whose order status is \"deleted\"",
            "收货标签": "Receipt label",
            "您选取": "You select",
            "请选择小于50笔数据下载": "Please select less than 50 data to download",
            "彻底删除": "Remove completely",
            "提交预报": "Submit a forecast",
            "护照/身份证号": "Passport/ID number",
            "笔，无预报": "Pen, no forecast",
            "删除订单异常": "Delete order exception",
            "您当前选中订单": "Your currently selected order",
            "批量修改": "Batch modify",
            "收件电话": "Consignee phone",
            "请选择要申请拦截的数据": "Please select the data to be deducted",
            "中文品名": "Description CN",
            "成功删除订单！": "Successfully deleted the order!",
            "省": "Province",
            "该订单无Invoice，无法下载": "The order has no invoice and cannot be downloaded",
            "日志信息": "Log information",
            "寄件邮箱": "Shipper Email",
            "终止原因": "Reason for termination",
            "专线": "Dedicated line",
            "预报重": "Pre-alert weight",
            "预报异常": "Exception pre-alert",
            "已收货情况下申请拦截": "Application for temporary detention in the case of received goods",
            "指定路线": "Channel Code",
            "寄件州": "Shipping Province",
            "收货时间": "Receipt time",
            "收件税号": "Receiving tax number",
            "订单预报": "Order pre-alert",
            "保存": "Save",
            "该订单暂无Api Request": "There is no Api Request for this order",
            "请选择要彻底删除的数据": "Please select the data to be completely deleted",
            "流水号位数不够，请重新设置": "The number of serial number is not enough, please reset",
            "笔": "Total",
            "打单状态": "Play status",
            "拦截原因": "Reason for suspension",
            "请选择至少一行\"草稿\",\"已预报\"数据": "Please select at least one line of \"draft\",\"predicted\" data",
            "创建人": "Founder",
            "寄件时间": "Inbound At",
            "包装类型": "Packing type",
            "类别": "category",
            "取消拦截成功": "Succeeded in canceling the suspension",
            "请选择订单状态是\"已预报\", \"已出货\",\"已收货\"的数据": "Please select the data whose order status is \"predicted\", \"shipped\",\"received\"",
            "收货成功": "Successfully received",
            "预报箱重量": "Forecast box weight",
            "发票下载": "Invoice download",
            "申请拦截": "Block Order",
            "付款方式": "Payment method",
            "注意": "Notice",
            "只查拦截": "Withhold",
            "基本信息": "Basic Information",
            "的订单共": "Total orders",
            "标签打印": "Label printing",
            "件数": "Pieces",
            "平台类型": "Platform type",
            "是否退回": "Whether to return",
            "删除订单比较危险，您真的要删除吗？": "Deleting an order is dangerous. Do you really want to delete it?",
            "成功修改指定路线": "Successfully modified the specified route",
            "请求参数：": "Request parameters:",
            "申报价值币别": "Declared value currency",
            "收件人信息": "Consignee information",
            "代收款币别": "Collection currency",
            "修改指定路线": "Modify Channel Code",
            "收件城市": "Consignee city",
            "序号": "No.",
            "分拣码": "Sort code",
            "电话": "Phone",
            "订单数据来源": "Order data source",
            "请选择订单状态是\"预报\"的数据": "Please select the data whose order status is \"Forecast\"",
            "彻底删除订单完成，若删除失败，请在【预报异常】查看具体错误提示！": "The complete deletion of the order is complete. If the deletion fails, please check the specific error message in [Forecast Exception]!",
            "尾程订单结算": "Final order settlement",
            "重置": "Reset",
            "按快递单号导出": "Export by courier number",
            "目的地": "Destination",
            "您真的要将选择的数据提交预报？": "Do you really want to submit the selected data to the forecast?",
            "寄件国家": "Country",
            "请选择需要打印的数据": "Please select the data to be printed",
            "提示": "Hint",
            "个字符": "Characters",
            "笔，已收货": "Pen, received",
            "寄件地址3": "Shipper address 3",
            "寄件地址2": "Shipper address 2",
            "打印": "Print",
            "收件区县": "Consignee District",
            "更多操作": "More Operation",
            "操作用户": "Operation user",
            "导出": "Export",
            "订单管理": "Order management",
            "异常": "Exception",
            "全部收货完成！": "All receipts are complete!",
            "基础信息": "basic information",
            "税金付款": "Tax payment",
            "待收货": "To be received",
            "请选择一行运单数据": "Please select a row of waybill data",
            "请选择订单状态是\"已预报\"或\"已收货\"的数据": "Please select the data whose order status is \"predicted\" or \"received\"",
            "尾程订单": "LM order",
            "运单号码": "Order Number",
            "买家备注": "Buyer notes",
            "收件邮编": "Consignee postcode",
            "请选择至少一行已预报数据": "Please select at least one row of forecasted data",
            "装包状态": "Packing status",
            "取消拦截失败": "Failed to cancel suspension",
            "发票标签": "Invoice label",
            "品牌": "Brand",
            "COD金额": "COD Acount",
            "收件地址": "Consignee address",
            "请先修改数据": "Please modify the data first",
            "寄件地址": "Shipper address",
            "已收货的订单": "Reserved order",
            "寄件邮编": "Shipping postcode",
            "揽收时间": "Collection time",
            "英文品名": "Description EN",
            "货物信息": "Package Info",
            "订单日期": "Created At",
            "申报价值": "Declared value",
            "打印完成": "Print completion",
            "收件公司": "Consignee company",
            "预报修改": "Forecast modification",
            "含子客户": "sub-customers",
            "收件人": "Consignee",
            "到付款币别": "Cash on delivery currency",
            "排货状态": "Arrangement status",
            "预报箱尺寸": "Forecast box size",
            "请选择要转草稿的数据": "Please select the data to be transferred to the draft",
            "寄件城市": "Shipping city",
            "预报时间": "Pre-alert time",
            "寄件人信息": "Shipping information",
            "取消拦截": "Cancel suspension",
            "请输入拦截原因": "Please enter the reason for suspension",
            "寄件公司": "Shipper company",
            "请选择指定路线": "Please select Channel Code",
            "请选择要打印订单的数据": "Please select the order data to be printed",
            "代收款": "Agency fund",
            "派件网点": "Distribution outlets",
            "参考编号": "Ref number",
            "买家ID": "Buyer ID",
            "只能选中一行数据！": "Only one row of data can be selected!",
            "创建导出任务失败:": "Failed to create export task :",
            "收货成功！": "Successfully received!",
            "请选择一行\"草稿\"或\"已预报\"数据": "Please select a row of \"draft\" or \"predicted\" data",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "请选择订单状态是\"已预报\",\"待排货\"的数据": "Please select the data whose order status is \"predicted\",\"to be dispatched\"",
            "收件国家": "Recipient country",
            "货物类型": "Cargo type",
            "请选择货物类型": "Please select Cargo type",
            "收货异常": "Receiving exception",
            "创建时间": "Creation time",
            "收件手机": "Receiving phone",
            "请选择要获取转单号码的订单数据": "Please select the order data to get the transfer number",
            "订单状态": "Order Status",
            "城市": "City",
            "可取消订单笔数": "Number of cancelable orders",
            "提货时间":"Pickup time",
            "平台运费":"Shipping Fee",
            "保险金额":"Insurance",
            "默认地址": "Default address",
            "展开更多": "Expand more",

            
        },
        "downloadorder": {
            "下载日志": "Download Log",
            "立即下载": "download now",
            "报文": "Message",
            "数据类型": "Data Type",
            "查询": "Search",
            "重置": "Reset",
            "请选择至少一行数据": "Please select at least one row of data",
            "客户": "Customer",
            "日志": "Log",
            "OIS订单": "OIS Order",
            "订单号码": "Ref Number",
            "订单": "Order",
            "转单号码": "Tracking number",
            "获取平台类型列表异常": "Obtaining the list of platform types is exception",
            "客户编码": "Customer code",
            "立即下载异常": "Download now exception",
            "下载异常": "Download exception",
            "请求报文": "Request message",
            "重量": "Weight",
            "订单日期": "Created At",
            "件数": "Pieces",
            "平台类型": "Platform type",
            "获取下载状态列表异常": "Get download status list exception",
            "立即下载成功！": "Download successfully now!",
            "创建时间": "Creation time",
            "POS订单": "POS Order",
            "下载状态": "Download Status",
            "异常信息": "Exception information "
        },
        "TMS004": {
            "确定要删除吗？": "You sure you want to delete it?",
            "修改": "Modify",
            "预报重": "Pre-alert weight",
            "您选择的收货包存在已取消、已揽收、收货中或已收货的数据，禁止退货！": "The receiving package you selected has data that has been canceled, received, received, or received, and it is forbidden to return!",
            "取消成功！": "Cancel success!",
            "预报材重": "Pre_alert Volume weight",
            "新增收货包": "Add receiving package",
            "非WISH客户禁止退货！": "Non-WISH customers are prohibited from returning!",
            "指定路线": "Channel Code",
            "选择": "Choose",
            "保存": "Save",
            "收货中": "Receiving",
            "笔": "Total",
            "退货原因": "Reasons for return",
            "请选择收货中/已收货 的数据": "Please select the data in receipt/received",
            "未揽收才允许退货！": "Return of goods is not allowed until collection!",
            "创建人": "Founder",
            "修改异常": "Modify exception",
            "收货包号": "Receipt bag number",
            "揽收重量（kg）": "Collecting weight (kg)",
            "操作": "Operation",
            "删除收货包异常": "Delete receiving package exception",
            "请选择": "Please select",
            "取消确认": "Cancel confirm",
            "退货": "return the goods",
            "修改人": "Modifier",
            "客户名称": "Customer name",
            "取件员": "Pick up personnel",
            "退件原因": "Reason for Return",
            "刷新运单异常": "Refresh the waybill exception",
            "收货包号信息": "Receiving package number information",
            "撤销提交": "Cancel submission",
            "删除": "Delete",
            "已收货": "received",
            "待收货票数": "Number of tickets to be received",
            "重置": "Reset",
            "收货包管理": "Receiving package management",
            "修改收货包": "Modify the receiving package",
            "收货日期不能为空": "Receipt date cannot be empty",
            "收货提交": "Receipt submission",
            "提示": "Hint",
            "客户编码": "Customer code",
            "收货日期": "Receipt date",
            "刷新运单": "Refresh the waybill",
            "收货尺寸": "Receipt size",
            "收货体积": "Receipt volume",
            "取消大包": "Cancel box",
            "导出": "Export",
            "请输入": "Please enter",
            "取消": "Cancel",
            "添加异常": "Add exception",
            "全部收货完成！": "All receipts are complete!",
            "收货实重": "Receiving actual weight",
            "收货提交成功！": "The receipt is submitted successfully!",
            "确定要撤销吗？": "Are you sure you want to cancel?",
            "保存并继续": "Save&continue",
            "预报实重": "Forecast actual weight",
            "揽收人": "Collector",
            "待收货": "To be received",
            "全部": "All",
            "预报尺寸": "Forecast size",
            "预报体积": "Forecast volume",
            "揽收日期": "Collection date",
            "查询": "Search",
            "已收货票数": "Number of tickets received",
            "包状态": "Package status",
            "未获取到对应数据": "Corresponding data is not obtained",
            "撤销成功！": "Successfully revoked!",
            "退件备注": "Return notes",
            "退件原因不能为空": "The reason for the return cannot be empty",
            "撤销提交异常": "Unsubmit exception",
            "揽收时间": "Collection time",
            "取消异常": "Cancel exception",
            "删除成功！": "successfully deleted!",
            "收货重": "Receipt weight",
            "退货备注": "Return note",
            "是否确定": "Are you sure",
            "修改成功！": "Successfully modified!",
            "大包入库": "Box warehousing",
            "备注": "Remark",
            "运单重": "Waybill weight",
            "收货材重": "Receiving Volume weight",
            "关闭": "Close",
            "取消原因": "Reason for Cancellation",
            "数据来源": "Data Sources",
            "修改时间": "Modify time",
            "请选择一行数据": "Please select a row of data",
            "刷新运单成功！": "Refresh the waybill successfully!",
            "收货网点": "Receiving outlets",
            "请选择至少一行数据": "Please select at least one row of data",
            "客户": "Customer",
            "新增": "Add",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "预报日期": "Forecast date",
            "添加成功！": "Added successfully!",
            "货物类型": "Cargo type",
            "总包数": "Total packages",
            "请选择至少一行待收货数据": "Please select at least one row of data to be received",
            "确认": "Confirm",
            "创建时间": "Creation time",
            "您选择退货的订单共": "The total number of orders you choose to return",
            "总票数": "Total votes",
            "请至少选择一行数据": "Please select at least one row of data",
            "是否退货": "Whether to return ",
            "退返后重出": "Resend after returning",
        },
        "bagreceive": {
            "采集失败！": "Collection failed!",
            "预报实重": "Forecast actual weight",
            "称重设备": "Weighing equipment",
            "客户不能为空": "Customer cannot be empty",
            "指定路线不能为空": "The channel code cannot be empty",
            "电子秤": "Electronic scale",
            "指定路线": "Channel code",
            "收费尺寸长宽高不能为0": "The length, width, and height of the charge cannot be 0",
            "关闭": "Close",
            "货物类型不能为空": "The cargo type cannot be empty",
            "设备名称": "Equipment name",
            "自动保留": "Automatic reservation",
            "扫描装包失败！": "Failed to scan the package!",
            "收货包管理": "Receiving package management",
            "请填写端口": "Please fill in the port",
            "请选择设备": "Please select a device",
            "请选择一行数据": "Please select a row of data",
            "设备类型": "Equipment type",
            "端口": "Port",
            "收货包号": "Receipt bag number",
            "客户": "Customer",
            "收费尺寸": "Charged size",
            "收货包号不能为空": "The receiving package number cannot be empty",
            "确定": "OK",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "提示": "Hint",
            "收费重": "Charge weight",
            "请填写1-20的端口号": "Please fill in the port number from 1-20",
            "收费实重": "Charge actual weight",
            "自动": "Automatic",
            "你确定删除该预报包吗？": "Are you sure to delete this forecast package?",
            "预报包删除成功！": "The forecast package is deleted successfully!",
            "货物类型": "Cargo type",
            "重量采集设置": "Weight collection settings",
            "请输入": "Please enter",
            "波特率": "Baud rate",
            "开始采集": "Start collecting",
            "取消": "Cancel",
            "客户名称": "Customer name",
            "总票数": "Total votes",
            "收费实重不能为空": "The actual weight of the charge cannot be empty",
            "预报包删除失败！": "Failed to delete forecast package! "
        },
        "TMS121": {
            "分拣码(可多选)":"Sorting code(multiple choice)",
            "走货路线分类(可多选)":"Delivery route type",
            "含COD":"including COD",
            "再次外出派送失败":"Lastmile Out For Delivery Failed",
            "末端退货移交给海外仓":"Lastmile Return Handover WH",
            "退回到达海外仓":"Lastmile return to warehouse",
            "退件派送服务-揽收中":"Return Collecting",
            "港后退返客户":"Return To Shipper After Export",
            "定为违禁品":"Prohibited",
            "出口清关开始":"Export customs clearance start",
            "出口清关扣查":"Export customs clearance on hold",
            "出口清关扣件不放行":"Export customs clearance not release",
            "离开起运地":"Departure From Departure",
            "到达目的国":"Arrive Destination Port",
            "入口清关站已通知提货":"Cargo ready at terminal",
            "中程起運":"Middlemile Uplift",
            "中程转运中":"Middlemile InTransit",
            "中程抵达":"Middlemile Arrived",
            "尾程退貨-轉運中":"Lastmile Return In Transit",
            "原因描述":"Reason description",
            "原因码":"reason code",
            "货物到达转运中心":"Lastmile Main Hub Received",
            "包裹到达派件站点":"Lastmile arrive destination hub",
            "首次外出派送失败":"Lastmile First Delivery Attempt Failed",
            "再次外出派送":"Other Delivery Attempt",
            "投递":"Delivery",
            "包裹离开分拣仓库":"Lastmile depart sorting center",
            "二次外出派送":"Lastmile Second Delivery Attempt",
            "重复扫描":"Duplicate scan",
            "路由变更":"Route variation",
            "港前退返客户":"Return To Shipper",
            "最新下次跟进时间":"Latest next follow-up time",
            "最新跟进状态":"Latest follow-up status",
            "最新跟进时间":"Latest follow-up time",
            "最新跟进内容":"Latest follow-up content",
            "运单数量":"Quantity of waybill",
            "下载Invoice":"Download Invoice",
            "预计件数":"Pre-alert pieces",
            "实收件数":"Actual pieces",
            "子单号":"Sub-order number",
            "显示明文":"Display plaintext",
            "跟进日志导出":"Export follow-up log",
            "排除":"Exclude",
            "跟单员":"Merchandiser",
            "操作说明": "Instructions",
            "轨迹状态": "Track status",
            "补录成功：": "Succeeded in re-recording:",
            "操作日志": "Operation log",
            "退返备注": "Return notes",
            "轨迹描述": "Trajectory description",
            "原产地": "country of origin",
            "本位币金额": "Standard currency amount",
            "笔，删除失败": "Pen, delete failed",
            "扫描分段": "Scan segment",
            "应付明细": "Cope details",
            "我是标题": "I am the title",
            "退件单号": "Return order number",
            "换单号": "Exchange Tracking Number",
            "删除运单异常": "Delete waybill exception",
            "总价": "Total price",
            "国外退件，退件单号为: ": "For overseas returns, the return order number is:",
            "材积除以数": "Volume divided by number",
            "代理退件": "Agent return",
            "文件名": "File name",
            "费用合计": "Total fees",
            "寄件区县": "Sending district",
            "笔记录数据": "Pen record data",
            "没有文件可以下载": "No file to download",
            "操作": "Operation",
            "处理人": "Handler",
            "操作时间": "Operate time",
            "包装项目": "Packaging items",
            "收件人名": "Recipient name",
            "交货段": "Delivery section",
            "已入库": "Warehouse Scan In",
            "含": "including",
            "汇率": "Exchange rate",
            "功能菜单": "Function menu",
            "运/转/参考/收货袋单号,一次导出单号数量不能超过1000": "Shipping/transfer/reference/receiving bag order number, the number of export order numbers at one time cannot exceed 1000",
            "寄件税号": "Shipping tax number",
            "退返客户": "Return the customer",
            "派送段": "Delivery section",
            "请勾选需要删除的运单！": "Please tick the waybill that needs to be deleted!",
            "客户名称": "Customer name",
            "退件派送服务-已揽收": "Return collected",
            "退件派送服务-移交": "Return handover success",
            "退返客户失败！": "Failed to return the customer!",
            "币别": "Currency",
            "交货到末公里": "Handover to Lastmile",
            "文件": "File",
            "删除成功": "successfully deleted",
            "转寄原单号": "Original number",
            "订单已支付":"Shipping Fee Paid",
            "货物状态": "Cargo status",
            "单价": "Price",
            "单件": "Single",
            "删除": "Delete",
            "核销状态": "Write-off status",
            "表格参数": "Table parameter",
            "数量": "Number",
            "寄件网点": "Outlets",
            "收件州省": "Consignee province",
            "已核销": "Written off",
            "补录轨迹": "Supplementary recording track",
            "退返结果": "Return result",
            "笔运单数据": "Waybill data",
            "格式": "Format",
            "出货日期": "Shipping",
            "转单号码": "Tracking number",
            "笔运单中补录轨迹": "Complementary track in the waybill",
            "客户编码": "Customer code",
            "出货": "Handover to Linehaul",
            "交货给干线代理":"Linehaul pickup",
            "入口清关重新装箱": "Import customs repacking",
            "费用批量补录": "Batch re-entry of expenses",
            "运单管理": "Waybill management",
            "寄件日期不能为空": "Shipment date cannot be empty",
            "材重": "Volume weight",
            "批量补录": "Bulk Supplementary Record",
            "报关方式": "Declaration method",
            "收件备注": "Receiving note",
            "补录异常": "Supplementary recording exception",
            "请输入": "Please enter",
            "跟进人": "Follower",
            "取消": "Cancel",
            "基本": "Basic",
            "总运单": "Master air waybill",
            "航班起飞": "Flight take off",
            "轨迹未更新天数": "No update days",
            "海关编码": "Customs code",
            "国外退件": "Return abroad",
            "运单轨迹显示": "Waybill track display",
            "出货时间": "delivery time",
            "出货备注": "Shipping notes",
            "查询": "Search",
            "运单id为空": "Waybill id is empty",
            "入口清关解除扣查": "Import customs clearance released",
            "账单备注": "Bill remarks",
            "日志": "Log",
            "收费材重": "Charge volume weight",
            "请选择运单": "Please select the waybill",
            "到付款": "COD amount",
            "轨迹信息": "Trajectory information",
            "科目名称": "Subject name",
            ">吗？": "> Is it?",
            "已二次转寄": "Return warehouse outbound",
            "删除成功！": "successfully deleted!",
            "个问题件": "Problem pieces",
            "包裹损坏": "Damage",
            "除以数": "Divide by number",
            "时间": "Time",
            "退件派送服务-分拣仓入库": "Return warehouse inbound",
            "大包/总运单/出货批次号，一次导出单号数量不能超过300": "Box/general waybill/shipping batch number, the number of export single number cannot exceed 300",
            "录单网点": "Recording outlets",
            "退件派送服务-分拣仓出库": "Return Service-WH Outbound",
            "费用补录申请": "Application for supplementary entry of fees",
            "只允许勾选一条运单进行编辑轨迹": "Only allow one waybill to be checked to edit the track",
            "上传附件": "Upload Attachment",
            "运费合计": "Total freight",
            "对账员": "Reconciler",
            "到达派件站点": "Arrive at the dispatch site",
            "末端转运中": "Lastmile in transit",
            "退件号码": "Return number",
            "走货路线": "Delivery route",
            "备注": "remark",
            "入口清关扣查": "Import clearance onhold",
            "退回海外仓": "Return to overseas warehouse",
            "返回末端退货仓库":"LastmileReturnedFromHubDatetime",
            "跟进网点": "Follow up outlets",
            "关闭": "Close",
            "已对账": "Reconciled",
            "查录单": "Checklist",
            "退返方式": "Return method",
            "包裹到达自提点": "The parcel in pickup point already",
            "下载": "Download",
            "高": "Height",
            "背景色设置": "Background color setting",
            "请选择一行数据": "Please select a row of data",
            "预报重量": "Pre-alert weight",
            "请选择至少一行数据": "Please select at least one row of data",
            "导入客服日志": "Import customer service logs",
            "客户": "Customer",
            "确定": "OK",
            "默认目的地": "Default destination",
            "目的地编码": "Destination code",
            "海关已放行": "Customs has released",
            "收费重": "Charge weight",
            "每行高亮": "Highlight each line",
            "派送异常": "Exception",
            "已出货，不允许删除！": "Has been shipped and cannot be deleted!",
            "计算公式": "Calculation formula",
            "收件电话": "Consignee phone",
            "材重合计": "Total material weight",
            "更多条件": "More conditions",
            "最新轨迹网点": "Latest track outlets",
            "费用补录新增": "Expense supplementary record added",
            "运单状态": "Waybill status",
            "客户类型":"Customer Type",
            "中文品名": "Description CN",
            "操作网点": "Operation outlets",
            "账单": "Bill",
            "金额": "Amount",
            "最新轨迹地点": "Latest track location",
            "省": "Province",
            "寄件邮箱": "Shipper Email",
            "航班抵达": "Flight arrival",
            "入口清关扣件不放行": "Import customs clearance not released",
            "国外退件不允许批量操作": "Batch operations are not allowed for foreign returns",
            "收件人拒收": "Rejected",
            "指定路线": "Channel code",
            "寄件州": "Consigner Province",
            "保存": "Save",
            "跟进内容": "Follow up content",
            "笔": "Total",
            "可多选": "Multiple choice",
            "实重合计": "Total actual weight",
            "创建人": "Founder",
            "收费重合计": "Total charge",
            "包装费合计": "Total packaging fee",
            "包装类型": "Packing type",
            "入口清关收货": "Import customs received",
            "类别": "Category",
            "附件": "Appendix",
            "请选择数据": "Please select data",
            "全部轨迹": "All tracks",
            "费用补录": "Supplementary expense",
            "入口清关准备移交": "Import customs prepare for handover",
            "导入轨迹": "Import track",
            "付款方式": "Payment method",
            "包裹丢失": "Lost",
            "第": "NS",
            "扫描编码": "Scan code",
            "收货备注": "Receipt note",
            "指定路线分类": "Channel code type",
            "件数": "Pieces",
            "包装说明": "Package instruction",
            "跟进时间": "Follow-up time",
            "收件人信息": "Consignee",
            "收件城市": "Consignee city",
            "出口清关成功": "Export Custom Cleared",
            "序号": "NO.",
            "分拣码": "Sort code",
            "分拣分区": "Sort Partitions",
            "该运单无单件信息，无法下载": "The waybill has no single piece information and cannot be downloaded",
            "二次转寄上架": "return warehouse putaway",
            "海外仓移出":"Moved Out Return-Warehouse",
            "单号": "Number",
            "提交状态": "Submission status",
            "补录信息": "Supplementary information",
            "列样式": "Column style",
            "重置": "Reset",
            "轨迹时间": "Track time",
            "目的地": "Destination",
            "退返参数": "Return parameters",
            "请选择货物状态": "Please select the cargo status",
            "下载单件信息": "Download single piece information",
            "费用补录管理": "Expense supplement management",
            "寄件国家": "Country",
            "结算备注": "Settlement notes",
            "新增运单": "New waybill",
            "提示": "Hint",
            "偏远": "Remote",
            "请选择运单！": "Please select the waybill!",
            "打印": "Print",
            "收件区县": "Consignee District",
            "操作用户": "Operation user",
            "导出": "Export",
            "最新轨迹状态": "Latest track status",
            "最新轨迹描述": "Latest track description",
            "退返客户成功！": "Return to the customer successfully!",
            "入口清关成功": "Successful import clearance",
            "未对账": "Unreconciled",
            "首次派送": "First Delivery Attempt",
            "首次派送失败": "FirstDeliveryFailedDatetime",
            "二次派送":"LastmileSecondDeliveryDatetime",
            "二次派送失败":"LM Second Delivery Attempt Failed",
            "再次派送":"OutDeliveryDatetime",
            "再次派送失败":"OutDeliveryFailedDatetime",
            "基础信息": "Basic information",
            "头程提单": "First way B/L",
            "长": "Length",
            "轨迹": "Track",
            "只能上传jpg/png/word/excel/pdf文件": "Only jpg/png/word/excel/pdf files can be uploaded",
            "税金付款": "Tax payment",
            "包裹销毁": "Scrapped",
            "您选取了": "You selected",
            "网点": "Outlets",
            "批量操作时，国外退件页签不允许切换": "During batch operation, the foreign return tab is not allowed to switch",
            "问题件": "Problem piece",
            "代理": "Proxy",
            "费用结算": "Fee settlement",
            "运单号码": "Order Number",
            "退返单号": "Return order number",
            "轨迹地点": "Track location",
            "操作员": "operator",
            "扫描状态": "Scan status",
            "入口清关开始清关": "Import customs clearance start",
            "包装费": "Packaging fee",
            "状态时间": "State time",
            "收件邮编": "Consignee postcode",
            "出货批次": "Shipment batch",
            "展开开关": "Expand switch",
            "您选取的": "You selected",
            "已签收": "Delivered",
            "退回海外仓中":"Lastmile returning to warehouse",
            "问题描述": "Problem Description",
            "应收明细": "Receivable details",
            "确定要删除勾选中的运单吗？": "Are you sure you want to delete the checked waybill?",
            "该运单无Invoice，无法下载": "The waybill has no Invoice and cannot be downloaded",
            "确定要删除<": "Are you sure you want to delete<",
            "大包号": "Box number",
            "快速退返": "Fast return",
            "关联运单号码": "Associate jobno",
            "条形码": "Barcode No",
            "品牌": "Brand",
            "COD金额": "COD amount",
            "文件大小不能大于15MB": "File size cannot be larger than 15MB",
            "收件地址": "Consignee address",
            "寄件地址": "Shipper address",
            "寄件邮编": "Postal code",
            "收件统编": "Receiving Coordinator",
            "英文品名": "Description EN",
            "货物信息": "Cargo information",
            "包裹到达分拣中心": "Lastmile received",
            "跟踪记录": "Track record",
            "申报价值": "Declared value",
            "订单成功上传": "Order successfully uploaded",
            "收件公司": "Consignee company",
            "单件信息": "Single piece information",
            "宽": "Width",
            "含子客户": "sub-customers",
            "收件人": "Consignee",
            "报表导出": "Report export",
            "退返": "Return",
            "离开分拣仓": "Leaving the sorting bin",
            "条，失败：": "Bar, failed ：",
            "跟进日志": "Follow-up log",
            "最新轨迹时间": "Latest track time",
            "退返方式等于{第三方快递}时，退返单号必填": "When the return method is equal to {third-party express}, the return order number is required",
            "位置": "Location",
            "寄件城市": "City",
            "寄件人信息": "Shipping information",
            "预览": "Preview",
            "未更新天数": "Days not updated",
            "数据来源": "Data Sources",
            "我们将在": "We will",
            "配置信息": "Configuration information",
            "代收款": "Agency fund",
            "寄件日期": "Inbound Date",
            "参考编号": "reference number",
            "实重": "Actual weight",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "计抛方式": "Charge weight rule",
            "其中可退返": "Which can be returned",
            "收件国家": "Receiving country",
            "走货路线分类": "Route classification",
            "收费实重": "Charge actual weight",
            "操作方式": "Operation method",
            "文件正在下载，请稍等！！！": "The file is downloading, please wait! ! !",
            "入口清关移交卡车": "Import customs handover to truck",
            "运单修改": "Waybill modification",
            "货物类型": "Cargo type",
            "操作成功": "Successful operation",
            "处理时间": "Processing time",
            "关包": "Warehouse Scan Out",
            "创建时间": "Creation time",
            "预报袋号": "Pre-alert bag number",
            "编辑轨迹": "Edit track",
            "派件网点":"Distribution outlets",
            "出货实重":"Shipping actual weight",
            "出货材重":"Shipping volume weight",
            "尾程实重":"LM actual weight",
            "尾程材重":"LM volume weight"
        },
        "trajectorytrackingimport": {
            "历史日志": "History Log",
            "订单导入成功": "Order imported successfully",
            "成功": "success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "验证失败": "verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select an import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import history log",
            "总行数": "Total",
            "请选择模版！": "Please choose a template!",
            "导入时间": "Import time",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template download",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please enter",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "行号": "Line number",
            "错误行数": "Error no.",
            "导入模版": "Import template "
        },
        "InvoicePreEdit": {
            "补录原因": "Reason for Supplementary Record",
            "币别": "Currency",
            "保存并继续": "Save&continue",
            "运单数据不存在！": "Waybill data does not exist!",
            "费用信息": "Cost information",
            "运单号码": "Order Number",
            "补录信息": "Supplementary information",
            "请输入正确的公式": "Please enter the correct formula",
            "关闭": "Close",
            "客户编号": "Customer code",
            "保存": "Save",
            "寄件网点": "Outlets",
            "寄件时间": "Inbound At",
            "账单备注": "Bill remarks",
            "参考编号": "Ref number",
            ">已收费用：": ">Charges:",
            "确定": "OK",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "收费重": "Weight",
            "计算公式": "Calculation formula",
            ",确认继续补收？": ",Confirm to continue to replenish?",
            "科目": "Suject",
            "燃油加收比例": "Fuel surcharge ratio",
            "件数": "Pieces",
            "请输入": "Please enter",
            "取消": "Cancel",
            "客户名称": "Customer name",
            "保存成功！": "Saved successfully!",
            "内部备注": "Internal remarks",
            "金额": "Amount"
        },
        "BMS084": {
            "修改": "Modify",
            "提交时间": "Submission time",
            "费用信息": "Cost information",
            "请选择要删除的数据！": "Please select the data to be deleted!",
            "费用补录提交": "Submission of expense re-entry",
            "指定路线": "Channel Code",
            "请输入正确的公式": "Please enter the correct formula",
            "可多选": "Multiple choice",
            "包装类型": "type of packaging",
            "注意": "Notice",
            "跟进记录": "Follow-up record",
            "撤销确认": "Revocation confirmation",
            "请选择要跟进的数据！": "Please select the data to follow up!",
            "科目": "Suject",
            "请选择要修改的数据！": "Please select the data to be modified!",
            "已提交导出任务，正在下载": "The export task has been submitted and is downloading",
            "客户名称": "Customer name",
            "跟进时间": "Follow-up time",
            "内部备注": "Internal remarks",
            "币别": "Currency",
            "进入异常": "Enter abnormal",
            "序号": "No.",
            "是否继续": "Whether to continue",
            "字数不能超过300，请修改后提交": "The number of words cannot exceed 300, please modify and submit",
            "id为空不允许取消！，请选择待提交的数据": "If id is empty, cancellation is not allowed! , Please select the data to be submitted",
            "提交状态": "Submission status",
            "日期不能为空！": "The date cannot be empty!",
            "删除": "Delete",
            "客户结算已存在科目": "Customer settlement existing accounts",
            "确认人": "Confirmor",
            "重置": "Reset",
            "寄件网点": "Outlets",
            "目的地": "Destination",
            "笔已提交或金额为0，是否继续(已提交数据不会被提交)？": "The pen has been submitted or the amount is 0, do you want to continue (the submitted data will not be submitted)?",
            "费用补录管理": "Expense supplement management",
            "笔数据删除成功！": "Data deleted successfully!",
            "最多录入": "Maximum entry",
            "转单号码": "Tracking number",
            "账单日期": "Bill date",
            "提示": "Hint",
            "客户编码": "Customer code",
            "个字符": "Characters",
            "费用补录导出": "Expense supplementary record export",
            "报关方式": "Declaration method",
            "导出": "Export",
            "请选择要提交的数据！": "Please select the data to be submitted!",
            "请输入": "Please enter",
            "笔待提交，": "Pending submission,",
            "取消": "Cancel",
            "跟进人": "Follower",
            "录入人": "Entry person",
            "录入人（可多选）": "Entry person",
            "其中": "in",
            "补录相关": "Make up",
            "笔数据吗？(已提交数据不会被删除)": "Data? (The submitted data will not be deleted)",
            "补录": "Supplementary record",
            "税金付款": "Tax payment",
            "科目编码": "Subject code",
            "名称": "Name",
            "运单号码": "Order Number",
            "不可多条修改！": "No more changes are allowed!",
            "查询": "Search",
            "请选择要取消的数据！": "Please select the data to cancel!",
            "请输入跟进内容 ！": "Please enter the follow-up content  ！",
            "您选取的": "You selected",
            "增值费导入": "Import of value-added fees",
            "本次跟进": "Follow up this time",
            "确认删除所选": "Confirm to delete selected",
            "账单备注": "Bill remarks",
            "确认撤销所选": "Confirm cancel selection",
            "已提交数据不可修改！": "The submitted data cannot be modified!",
            "科目名称": "Subject name",
            "结算状态": "Settlement status ",
            "笔数据，其中": "Data, where",
            "请选择未提交的数据和金额不为0的数据！": "Please select the unsubmitted data and the data whose amount is not 0!",
            "科目编号": "Account number",
            "笔客户结算已有相同科目": "Client settlements already have the same account",
            "对账员": "Reconciler",
            "补录原因": "Reason for Supplementary Record",
            "进入确认": "Enter confirmation",
            "笔数据": "Data",
            "走货路线": "Delivery route",
            "已有金额": "Amount already",
            "请选择要撤销的数据！": "Please select the data to be revoked!",
            "跟进": "follow up",
            "关闭": "Close",
            "取消原因": "Reason for Cancellation",
            "销售员": "Seller",
            "笔成功！": "The pen is successful!",
            "数据来源": "Data Sources",
            "提交": "Submit",
            "提交异常": "Submit exception",
            "请选择待提交的数据": "Please select the data to be submitted",
            "客户": "Customer",
            "内容": "Content",
            "已提交数据不会被提交": "The submitted data will not be submitted",
            "费用补录修改": "Re-entry and modification of expenses",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "导入": "Import",
            "确定": "OK",
            "确认时间": "Confirmation time",
            "最新状态": "Latest status",
            "提交人": "Submitter",
            "提交人（可多选)": "Submitter",
            "内容有修改,是否确认关闭？": "The content has been modified, are you sure to close it?",
            "收费重": "Weight",
            "计算公式": "Calculation formula",
            "笔数撤销成功！": "Successful cancellation of the number of transactions!",
            "不可多条跟进！": "No more follow-ups!",
            "笔已提交": "Pen submitted",
            "跟进成功！": "Follow up successfully!",
            "笔数取消成功！": "Successfully cancelled!",
            "货物类型": "Cargo type",
            "费用补录新增": "Expense supplementary record added",
            "运单状态": "Waybill status",
            "确认": "Confirm",
            "录入时间": "Entry Time",
            "补录相关不能为空！": "The supplementary record cannot be empty!",
            "金额": "Amount"
        },
        "BMSAdd": {
            "历史日志": "History log",
            "成功": "Success",
            "状态": "Status",
            "上传失败": "Upload failed",
            "导入中": "Importing",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "文件大小不超过": "File size does not exceed",
            "验证中": "Verifying",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select an import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import history log",
            "总行数": "Total No.",
            "请选择模版！": "Please choose a template!",
            "导入时间": "Import time",
            "模版下载": "Template download",
            "导入文件格式支持": "Import file format support",
            "错误说明下载": "Entry person",
            "运单号": "Order Number",
            "导入文件": "Import file",
            "请输入": "Please enter",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "错误信息": "Error message",
            "行号": "Line Number",
            "错误行数": "Error no.",
            "导入模版": "Import template"
        },
        "custlogimport": {
            "历史日志": "History log",
            "成功": "Success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import file cannot exceed 10MB",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select an import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "导入历史日志": "Import history log",
            "总行数": "Total No.",
            "请选择模版！": "Please choose a template!",
            "客服日志导入成功": "Customer service log imported successfully",
            "导入时间": "Import time",
            "导入成功才可下载": "Can be downloaded only after successful import",
            "模版下载": "Template download",
            "错误说明": "Error description",
            "导入文件": "Importing files",
            "请输入": "Please enter",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "行号": "Line Number",
            "错误行数": "Error no.",
            "导入模版": "Import template "
        },
        "TMS076": {
            "修改": "Modify",
            "寄件邮箱": "Shipper Email",
            "单件取大不计抛": "Take the big one piece and not throw it",
            "净重": "net weight",
            "收费重为0，不允许保存": "The charge is 0, and storage is not allowed",
            ">设置的邮编目的地规则，收件邮编<": ">Set the postal code destination rule, receiving postal code<",
            "请选择代收币别!": "Please select the collection currency!",
            "原产地": "Country of origin",
            "录入件数为": "The number of entries is",
            "助手返回任务id失败": "The assistant failed to return the task id",
            "已加入自动追踪任务": "Automatic tracking task has been added",
            "指定路线": "Channel Code",
            "{附加项目:": "{Additional items :",
            "收件税号": "Receiving tax number",
            "保存": "Save",
            "根据指定路线<": "According to the Channel Code <",
            "总价": "Total price",
            "尺寸复制": "Size copy",
            "包装类型": "Package",
            "寄件区县": "Sending district",
            "操作": "Operate",
            "包装项目": "Packaging items",
            "存在不收件，请重新填写标红件！": "There is a non-acceptance, please fill in the red one again!",
            "寄件人": "Shipper",
            "付款方式": "Payment",
            "注意": "Notice",
            "确定删除当前所有单件信息？": "Are you sure to delete all current item information?",
            "件数": "Pieces",
            ">分拣的目的地为<": ">The sorting destination is <",
            "寄件税号": "Shipping tax number",
            "包装说明": "Package instruction",
            "当前指定路线的计抛方式发生变化，收费重由<": "The current calculation method of the designated route has changed, and the toll will be re- <",
            "件，是否清除多余的件数": "Pieces, whether to clear the excess pieces",
            "净重必须大于等于0": "Net weight must be greater than or equal to 0",
            "取件员": "Pick up personnel",
            "追踪进行中，请稍候查询": "Tracking is in progress, please wait for inquiries",
            "币别": "Currency",
            "收件城市": "City",
            "序号": "No.",
            "分拣码": "Sort code",
            "出货重": "Shipping weight",
            "当前指定路线的材积除以数由<": "The volume of the current specified route divided by the number by <",
            "单价": "unit price",
            "删除": "Delete",
            "全部清除": "Clear All",
            "运单信息": "Waybill information",
            "运单号码<": "Order number<",
            "数量": "Number",
            "寄件网点": "Outlets",
            "收件州省": "Consignee province",
            "目的地": "Destination",
            "毛重": "Gross weight",
            "寄件国家": "Country",
            "进位后收费重:": "Charge weight after rounding :",
            "英文品名不能为空": "English description cannot be empty",
            "其他科目": "Other subjects",
            "结算备注": "Settlement notes",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "请选择到付币别!": "Please select the currency to pay!",
            "存在为空数据,不允许保存和关闭": "There is empty data, save and close are not allowed",
            "材重": "Volume weight",
            "报关方式": "Declaration method",
            "收件区县": "District",
            "单件进位规则": "Pcs carry rule单票计抛规则",
            "收件备注": "Receiving note",
            "导出": "Export",
            "取消": "Cancel",
            "同步复制实重": "Synchronous replication Actual weight",
            "以下录入的都为单件信息": "The following entries are all single pieces of information",
            ">变为<": ">Becomes <",
            "出货实重": "Shipping actual weight",
            "收件邮箱": "Email",
            "长": "Length",
            "配货信息": "Distribution information",
            "请选择寄件日期": "Please select the Inbound Date",
            "税金付款": "Tax payment",
            "海关编码": "HS code",
            "确认删除当前单件信息？": "Confirm to delete the current item information?",
            "费用结算": "Fee settlement",
            "运单号码": "Order Number",
            "出货备注": "Shipping notes",
            "包装费": "Total Packaging fee",
            "运单": "Waybill",
            "寄件电话": "Shipper phone",
            "收件邮编": "Consignee postcode",
            "请选择指定路线!": "Please select Channel Code!",
            "分拣分区": "Sort partition",
            "请输入收费实重": "Please enter the Charge actual weight",
            ">改为<": ">To <",
            "请选择需要删除的单件信息!": "Please select the piece of information to be deleted !",
            "物流助手初始化失败,请稍后重试": "The logistics assistant failed to initialize, please try again later",
            "收费材重": "Charge volume weight",
            "信息": "information",
            "收件地址": "Consignee Address",
            "寄件地址": "Shipper address",
            "到付款": "COD amount",
            "毛重必须大于等于0": "The gross weight must be greater than or equal to 0",
            "寄件邮编": "Postal code",
            "当前指定路线为空改为<": "The current specified route is empty and changed to<",
            "英文品名": "Description EN",
            "显示": "Show",
            "存在为0数据,不允许保存和关闭": "0 data exists, save and close are not allowed",
            "货物信息": "Cargo information",
            "除以数": "Divide by number",
            "申报价值": "Declared value",
            "收件公司": "Consignee company",
            "单票计抛规则": "Pkg charge weight rule",
            "单件信息": "Single piece information",
            "宽": "Width",
            "修改成功！": "Successfully modified!",
            "收件人": "Consignee",
            "当前指定路线的计抛方式发生变化，请重新保存单件信息": "The calculation method of the current designated route has changed, please save the item information again",
            ">，请重新保存单件信息": ">, Please save the item information again",
            "出货材重": "Shipping volume weight",
            "件，而单件数为": "Pieces, and the number of single pieces is",
            "寄件城市": "City",
            "实重材重同时为0，不允许保存和关闭": "The actual weight and material weight are 0 at the same time, and it is not allowed to save and close",
            "最小重量": "Minimum weight",
            "未找到对应运单，请重新填写": "The corresponding waybill was not found, please fill in again",
            "寄件公司": "Shipper company",
            "高": "Height",
            "根据计抛得出收费重:": "According to the calculation, the weight of the fee is calculated :",
            "单件信息件数与运单件数不一致，是否继续保存": "The number of single piece information is inconsistent with the number of waybill, whether to continue to save",
            "客户": "Customer",
            "代收款": "Agency fund",
            "寄件日期": "Inbound Date",
            "追踪结束": "End of tracking",
            "参考编号": "Ref number",
            "确定": "OK",
            "实重": "Actual weight",
            "单票进位规则": "Pkg carry rule",
            "收费重": "Weight",
            "--请求轨迹原数据失败--": "--Failed to request original track data--",
            "收件国家": "Country",
            "保存&S": "Save&S",
            "收费实重": "Charge actual weight",
            "全部删除": "delete all",
            "生效类型": "Effective type",
            "收件电话": "Consignee phone",
            ">收货中，限制修改!": ">During receipt, modification is restricted !",
            "货物类型": "Shipment types",
            "中文品名": "Description CN",
            "请选择货物类型": "Please select the Shipment type",
            "确定删除此行吗？": "Are you sure to delete this line?",
            "寄件州省": "Province",
            "金额": "Amount"
        },
        "TMS063": {
            "历史日志": "History log",
            "成功": "Success",
            "状态": "Status",
            "导入中": "Importing",
            "上传失败": "Upload failed",
            "导入文件不能超过10MB": "Import files cannot exceed 10MB",
            "适用于提前导入代理重量": "Suitable for importing agent weight in advance",
            "文件大小不超过": "File size does not exceed",
            "运单号码": "Order Number",
            "验证中": "Verifying",
            "导入时": "Introduction",
            "导入重量小于收费重时": "When the imported weight is less than the charged weight",
            "批次号": "Batch number",
            "验证失败": "Verification failed",
            "解析中": "Parsing",
            "请选择导入模版！": "Please select an import template!",
            "失败": "Fail",
            "解析失败": "Parsing failed",
            "导入": "Import",
            "请确认导入模板中表头的完整性": "Please confirm the integrity of the header in the imported template",
            "导入历史日志": "Import History log",
            "总行数": "Total",
            "请选择模版！": "Please select a template!",
            "导入时间": "Import time",
            "模版下载": "Template download",
            "运单修改标准模版": "Waybill modification standard template",
            "导入文件格式支持": "Import file format support",
            "错误说明": "Error description",
            "导入文件": "Import file",
            "请输入": "Please enter",
            "导入成功": "Imported successfully",
            "不修改": "Do not modify",
            "文件下载": "Download Document",
            "上传中": "Uploading",
            "行号": "Line number",
            "错误行数": "Error No.",
            "导入模版": "Import template",
            "新增模板": "Add template"
        },
        "TMS062": {
            "&费用合计": "&Total fees",
            "取消审核成功！": "Successful cancellation of review!",
            "&计抛规则": "&Calculating and tossing rules",
            "审核人": "Reviewer",
            "变更状态": "Change status",
            "运单号码": "Order Number",
            "&指定路线": "&Channel Code",
            "请选择待审核的变更记录": "Please select the change record to be reviewed",
            "审核时间": "Review time",
            "&付款方式": "&Payment",
            "查询": "Search",
            "&包装类型": "&Type of packaging",
            "&收费重": "&Weight",
            "全部审核": "All review",
            "&收费材重": "&Charge volume weight",
            "全部审核成功！": "All audits are successful!",
            "&报关方式": "&Declaration method",
            "审核成功！": "Successful review!",
            "&合计币别": "&Total currency",
            "审核失败！": "Audit failure!",
            "&收费实重": "&Charge actual weight",
            "&寄件日期": "&Inbound Date",
            "笔运单的变更申请？": "Change application of waybill?",
            "&到付币别": "&Cash-on-delivery",
            "对账员": "Reconciler",
            "&货物类型": "&Cargo type",
            "请选择申请变更时间": "Please select the time to apply for change",
            "变更来源": "Change source",
            "&走货路线": "&delivery route",
            "&出货重": "&Shipping weight",
            "取消变更": "Cancel changes",
            "重置": "Reset",
            "查录单": "Checklist",
            "寄件网点": "Outlets",
            "取消审核失败！": "Cancel review failed!",
            "&客户编码": "&Customer code",
            "请选择至少一行数据": "Please select at least one row of data",
            "客户": "Customer",
            "&派件网点": "&Distribution outlets",
            "批量审核": "Batch review",
            "申请人": "Applicant",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "确定": "OK",
            "自动审核": "Auto review",
            "转单号码": "Tracking number",
            "&寄件网点": "&Outlets",
            "请选择至少一行待审核数据": "Please select at least one row of data to be reviewed",
            "提示": "Hint",
            "&目的地": "&Destination",
            "其他费用": "Other fee",
            "请选择变更记录": "Please select a change record",
            "申请变更时间": "Application change time",
            "导出": "Export",
            "取消": "Cancel",
            "确定取消": "confirm cancellation",
            "&到付款": "&COD amount"
        },
        "BMS012": {
            "汇总票数":"Summary votes",
            "注意：":"Note: ",
            "更多条件":"More conditions ",
            "月工作日平均票数": "Average daily order",
            "默认系统时间": "Default time",
            "尾程": "Lastmile",
            "路线大类": "channel categories",
            "全部路线大类": "All routes",
            "名称": "Name",
            "附加费包括": "The surcharge includes",
            "路线分类": "channel classification",
            "指定路线": "Channel Code",
            "查询": "Search",
            "报价生效日期": "Effective date of quotation",
            "收件邮编": "Consignee Postcode",
            "请选择目的地": "Please select a destination",
            "运费单价": "Freight unit price",
            "材积除以数": "Volume divided by number",
            "查询报价": "Inquiry for Quotation",
            "渠道发货要求和目的地国家的限制条件都会记录在备注中": "Channel delivery requirements and destination country restrictions will be recorded in the remarks",
            "包装类型": "Type of packaging",
            "总运费": "Total freight",
            "请选择包装类型": "Please select the type of packaging",
            "下单": "Place an order",
            "安检费": "Security Check Fee",
            "本币金额合计": "Total amount in local currency",
            "温馨提示": "Tips",
            "科目名称": "Subject name",
            "公式": "formula",
            "其他费用明细": "Details of other expenses",
            "货物重量": "Package Weight",
            "业务类型": "Business type",
            "全部业务类型": "All business types",
            "时间": "Time",
            "件数": "Pieces",
            "起运地": "Departure",
            "指定路线编码": "Specify route code",
            "报价备注": "Quotation note",
            "防疫物资附加费等杂费": "Additional fees for epidemic prevention materials and other miscellaneous expenses",
            "请输入货物重量": "Please enter the weight of the goods",
            "宽": "Width",
            "收件城市": "Consignee city",
            "币别": "Currency",
            "序号": "No.",
            "旺季附加费": "Peak season surcharge",
            "停用时间": "Deactivate time",
            "单价": "Unit price",
            "关闭": "Closure",
            "重置": "Reset",
            "参考时效": "Reference aging",
            "计算公式的计算结果": "Calculation result of calculation formula",
            "收件州省": "Consignee province",
            "目的地": "Destination",
            "高": "Height",
            "本币金额": "Amount in local currency",
            "本币": "Currency",
            "头程": "Linehaul",
            "原币运费": "Original currency shipping",
            "附加费用明细": "Surcharge details",
            "附加费": "Surcharge",
            "计算公式(头程+尾程)": "Calculation formula (head stroke + tail stroke)",
            "生效日期": "Effective date",
            "收费重": "Weight",
            "具体发货前请仔细查看备注": "Please check the remarks carefully before delivery",
            "头程运费": "linehaul freight",
            "费用项": "Expense item",
            "报价分段": "Quotation segmentation",
            "计算公式": "Calculate formula",
            "报价备注说明": "Quotation note description",
            "请选择起运地": "Please select the Departure",
            "总费用": "Total cost",
            "应收客服费等杂费": "Receivable customer service fees and other miscellaneous fees",
            "收件区县": "Consignee District",
            "货物类型": "Type",
            "请输入货物类型": "Please enter the type of goods",
            "运费": "Freight",
            "尾程运费": "Lastmile freight",
            "禁运货物类型": "Types of prohibited goods",
            "金额": "Amount",
            "长": "Length",
            "附加费包括：安检费、应收客服费等杂费": "Surcharge: Security inspection fee,service fee,other fee",
            "计算公式的计算结果 = 原币运费": "Calculation result of calculation formula = Original currency shipping",
            "单价 = 总运费 / 收费重": "Unit price = Total cost/ Chargeable weight",
            "总费用 = 头程运费 +  尾程运费 + 附加费": "Total cost = linehaul fee + Lastmile fee + Surcharge",
            "客户": "Customer",
            "客户分组": "Customer Group",
            "显示已停用路线": "Disabled route"
        },
        "BMS121": {
            "预计产生偏远费": "Estimated remote costs",
            "请输入收费重": "Please enter the charge",
            "城市": "Consignee city",
            "城市必填其一": "City is required",
            "专线偏远根据邮编、地址、区县、城市判断，请填写其中任何一项！": "The remote line is judged according to the receiving postal code, address, district, county, and city, please fill in any of them!",
            "必填": "Required",
            "指定路线": "Channel Code",
            "匹配规则": "Matching rules",
            "区县": "District",
            "州省": "Province",
            "查询": "Search",
            "地址关键字模糊匹配": "Address keyword fuzzy matching",
            "重置": "Reset",
            "请选择目的地": "Please select a destination",
            "不偏远": "Not remote",
            "最多": "Most",
            "目的地": "Destination",
            "查询信息": "Search information",
            "请选择指定路线": "Please select Channel Code",
            "当前查询结果为": "The current query result is",
            "地址": "Consignee address",
            "收费重": "Weight",
            "偏远": "Remote",
            "建议全部填写": "It is recommended to fill in all",
            "邮编": "Postcode",
            "位小数": "Decimal places",
            "城市完全匹配": "City exact match ",
            "客户": "Customer "
        },
        "MOA001": {
            "重复数据：": "Duplicate data:",
            "成功": "Success",
            "状态": "Status",
            "响应总笔数": "Total number of responses",
            "写入失败：": "Writing failed:",
            "请选择": "Please enter",
            "写入成功：": "Successfully written:",
            "请求时间": "Request time",
            "响应总笔数：": "Total responses:",
            "写入成功": "Successfully written",
            "返回最大ID": "Returns the largest ID",
            "查询": "Search",
            "轨迹对接监控": "Track docking monitoring",
            "请求次数：": "Number requests:",
            "写入失败": "Writing failed",
            "导出": "Export",
            "请求次数": "Number requests",
            "响应时间": "Response time",
            "请求起始ID": "Request start ID",
            "重复数据": "Duplicate data",
            "响应报文摘要": "Response message summary",
            "失败": "Fail"
        },
        "spiderTrajectoryDetail": {
            "轨迹编码": "Trajectory coding",
            "末端供应商": "End supplier",
            "轨迹位置": "Track position",
            "导出": "Export",
            "轨迹时间": "Track time",
            "轨迹异常详情": "Trajectory anomaly details",
            "异常描述": "Exception description",
            "追踪单号": "Tracking number",
            "轨迹描述": "Trajectory description "
        },
        "MOA003": {
            "轨迹位置": "Track position",
            "操作失败": "Operation failed",
            "状态": "Status",
            "轨迹描述": "Trajectory description",
            "运单号码": "Order Number",
            "查询": "Search",
            "推送状态": "Push Status",
            "参考号码": "reference number",
            "轨迹时间": "Track time",
            "收费重(g)": "Weight(g)",
            "客户": "Customer",
            "是否要进行推送": "Whether to push",
            "确定": "OK",
            "数据推送时间": "Data push time",
            "已推送": "Pushed",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "轨迹推送监控": "Track push monitoring",
            "客户编码": "Customer code",
            "异常描述": "Exception description",
            "待推送": "To be pushed",
            "导出": "Export",
            "数据写入时间": "Data writing time",
            "取消": "Csncel",
            "客户名称": "Customer name",
            "确认后，轨迹数据将会进行再次推送，请耐心等待": "After confirmation, the track data will be pushed again, please wait patiently",
            "再次推送": "Push again",
            "异常": "Exception",
            "请选择异常数据进行推送": "Please select abnormal data to push"
        },
        "MOA004": {
            "日志监控": "Log monitoring",
            "数据集": "Data set",
            "事件": "Event",
            "状态": "Status",
            "日期不能为空": "Date cannot be empty",
            "消费时间": "Consumption time",
            "异常描述": "Exception description",
            "发送时间": "Send time",
            "消费异常": "Exception consumption",
            "查询": "Search",
            "导出": "Export",
            "仅查询补发": "Only query reissue",
            "生产者": "Producer",
            "是否补发": "Whether to reissue",
            "异常": "Exception",
            "主数据单号": "Master data number "
        },
        "MOA005": {
            "成功": "Success",
            "状态": "Status",
            "服务接口": "Service interface",
            "快递单号": "Tracking number",
            "运单号码": "Order Number",
            "重新推送": "Push again",
            "我是标题": "I am the title",
            "查询": "Search",
            "接口": "Interface",
            "响应报文": "Response message",
            "菜鸟": "CAINIAO",
            "推送": "Push",
            "接口类型": "Interface type",
            "请求参数": "Request Parameter",
            "接口信息": "Interface information",
            "失败": "Fail",
            "请选择数据": "Please select data",
            "推送时间": "Push time",
            "参考编号": "Ref Number",
            "主单号数据": "Master number data",
            "异常描述": "Exception description",
            "请求时间": "Request time",
            "接口code": "Interface code",
            "平台对接监控": "Platform docking monitoring",
            "请求报文": "Request message",
            "导出": "Export",
            "重新推送执行成功，请在页面查看推送结果": "The re-push is executed successfully, please check the push result on the page",
            "创建时间": "Creation time",
            "推送时间不能为空": "Push time cannot be empty",
            "执行次数": "Number of executions",
            "主数据单号": "Master data number",
            "推送方式": "Push method",
            "再次推送": "Push again"
        },
        "MOA007": {
            "COD币别": "COD currency",
            "状态": "Status",
            "时间不能为空": "Time cannot be empty",
            "运单号码": "Order Number",
            "请选择要推送的数据": "Please select the data to be pushed",
            "查询": "Search",
            "推送状态": "Push status",
            "确认后，数据将会进行再次推送，请耐心等待": "After confirmation, the data will be pushed again, please wait patiently",
            "收件人电话": "Consignee phone",
            "签收时间": "Submission time",
            "客户": "Customer",
            "珊瑚": "Coral",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref Number",
            "COD金额": "COD Amount",
            "数据推送时间": "Data push time",
            "转单号码": "Tracking number",
            "客户编码": "Customer code",
            "异常描述": "Exception description",
            "待推送:": "To be pushed:",
            "订单日期": "Created At",
            "非异常数据不能推送": "Non-abnormal data cannot be pushed",
            "已推送:": "Pushed:",
            "异常:": "Exception:",
            "导出": "Export",
            "数据写入时间": "Data writing time",
            "监控": "Monitoring",
            "客户名称": "Customer name",
            "再次推送": "Push again",
            "收件人": "Consignee"
        },
        "MOA006": {
            "推送重量": "Push weight",
            "大包总票数": "Total number of votes",
            "操作失败": "Operation failed",
            "状态": "Status",
            "走货路线": "Delivery route",
            "派送代理": "Delivery agent",
            "查询": "Search",
            "推送状态": "Push status",
            "特殊单号": "Special order number",
            "确认后，数据将会进行再次推送，请耐心等待": "After confirmation, the data will be pushed again, please wait patiently",
            "推送票数": "Push tickets",
            "是否要进行推送": "Whether to push",
            "大包号": "Box number",
            "推送时间": "Push time",
            "大包核重重量": "Large package core weight",
            "确定": "OK",
            "提示": "Hint",
            "异常描述": "Exception description",
            "大包总实重": "Total Actual weight of big package",
            "请求报文": "Request message",
            "待推送:": "To be pushed:",
            "已推送:": "Pushed:",
            "异常:": "Exception:",
            "导出": "Export",
            "目的国家简码": "Destination country code",
            "推送监控": "Push monitoring",
            "数据写入时间": "Data writing time",
            "取消": "Cancel",
            "总运单": "Master air waybill",
            "再次推送": "Push again",
            "请选择异常数据进行推送": "Please select abnormal data to push",
            "头程提单": "First way B/L",
            "必须为异常的数据才允许再次推送": "Only abnormal data can be pushed again"
        },
        "MOA009": {

        },
        "outboundLogDtl": {
            "分拣码": "Sort code",
            "走货路线": "Delivery route",
            "派送代理": "Delivery agent",
            "运单号码": "Order number",
            "指定路线": "Channel Code",
            "参考编号回车搜索": "Ref number enter search",
            "收件邮编": "Consignee Postcode",
            "寄件网点": "Outlets",
            "分拣分区": "Sort partition",
            "目的地": "Destination",
            "客户": "Customer",
            "大包号": "Box number",
            "寄件日期": "Inbound Date",
            "参考编号": "Ref number",
            "收费材重": "Charge volume weight",
            "转单号码": "Tracking number",
            "收费重": "Weight",
            "客户编码": "Customer code",
            "收费实重": "Charge actual weight",
            "输入运单": "Enter order number",
            "报关方式": "Declaration method",
            "件数": "Piece",
            "货物类型": "Cargo type",
            "转单": "Transfer order",
            "出货实重": "Shipping actual weight "
        },
        "bagdetails": {
            "确定要撤销运单吗？": "Are you sure you want to cancel the waybill?",
            "排货状态": "Arrangement status",
            "分拣码": "Sort code",
            "走货路线": "Delivery route",
            "运单号码": "Order number",
            "指定路线": "Channel Code",
            "参考编号回车搜索": "Ref number enter search",
            "查询": "Search",
            "请选择至少一行已排货运单数据": "Please select at least one row of scheduled freight order data",
            "重置": "Reset",
            "收件邮编": "Consignee Postcode",
            "寄件网点": "Outlets",
            "目的地": "Destination",
            "分拣分区": "Sort partition",
            "选取运单异常": "Select the waybill abnormal",
            "请选择一行数据": "Please select a row of data",
            "请选择至少一行数据": "Please select at least one row of data",
            "撤销运单异常": "Cancel the waybill exception",
            "客户": "Customer",
            "入库时间不能为空": "The storage time cannot be empty",
            "大包号": "Box number",
            "派件网点": "Distribution outlets",
            "寄件日期": "Inbound Date",
            "撤销运单": "Cancel the waybill",
            "参考编号": "Ref number",
            "收费材重": "Charge volume weight",
            "确定": "OK",
            "入库时间": "Storage time",
            "选取运单成功！": "The waybill is selected successfully!",
            "转单号码": "Tracking number",
            "提示": "Hint",
            "收费重": "Weight",
            "客户编码": "Customer code",
            "收费实重": "Charge actual weight",
            "输入运单": "Enter order number",
            "报关方式": "Declaration method",
            "件数": "Piece",
            "关联总运单号": "Associated MAWB",
            "货物类型": "Cargo type",
            "选取运单": "Select waybill",
            "转单": "Transfer order",
            "取消": "Cancel",
            "撤销运单成功！": "The waybill is cancelled successfully!",
            "选择运单": "Select waybill",
            "出货实重": "Shipping actual weight"
        },

        "BMS078":{
            "可按关键字检索指定路线、价格组、客户分组、特殊客户、分区":"Search by keyword for specified routes, price groups, customer groups, special customers, partition",
            "搜索报价":"Search Quotes",
            "搜索树":"Search Trees",
            "销售员":"Seller",
            "导入报价":"Import quotation",
            "增加":"Add",
            "修改":"Modify",
            "复制新增":"Copy to add",
            "特殊报价导入":"Import special quotation",
            "关联客户导入":"Import associated customers",
            "删除":"Delete",
            "浏览":"View",
            "现结客户报价导入":"Import current customer quotes",
            "显示待生效报价":"Display pending quotes",
            "显示使用中报价":"Display in use quotes",
            "显示历史报价":"Display historical quotes",
            "显示停用指定路线报价":"Display deactivated route quotes",
            "注意：双击行显示详细的客户分组和特殊客户":"Note: Double click on the row to display detailed customer groups and special customers",
            "修改时间":"Edited time",
            "我是标题":"I'm the title.",
            "新增":"Add",
            "导出":"Export",
            "特殊客户":"Special customers",
            "分组列表":"grouping list",
            "已选分组列表":"Selected group list",
            "客户列表":"Customer list",
            "已选客户列表":"Selected customer list",
            "销售员列表":"Salesperson list",
            "已选销售员列表":"Selected salesperson List",
            "生效时间":"Effective time",
            "选择时间":"Select time",
            "停用时间":"Deactivation time",
            "折扣":"Discount",
            "特定燃油加收比率":"Specific fuel surcharge ratio",
            "保存":"Save",
            "关闭":"Close",
            "价格组":"Price group",
            "指定路线":"Route code",
            "价格类型":"Price type",
            "引用价格组":"Quote price group",
            "修改生效/停用时间":"Modification effective/inactive time",
            "客户名称":"Customer name",
            "分组名称":"Group name",
            "输入客户编码或者名称后回车":"Enter customer code or name then press enter",
            "价格等级":"Price level",
            "客户分组":"Customer groups",
            "被引用价格组":"Quoted price groups",
            "币别":"Currency",
            "生效类型":"Effective type",
            "批价类型":"Approval price type",
            "分区":"Partition zones",
            "重量段":"Weight section",
            "统一燃油加收比率":"Unified fuel surcharge ratio",
            "其他应收科目":"Other receivable subject",
            "创建时间":"Create time",
            "创建人":"Creator",
            "修改人":"Editor",
            "生效日期":"Effective Date",
            "停用日期":"Deactivation Date",
            "特定燃油加收比例":"",
            "新增价格组":"Add price group",
            "修改价格组":"Edited price group",
            "此操作将删除该价格组数据, 是否继续?":"This operation will delete the price group data. Do you want to continue",
            "价格组删除成功":"Price group deleted successfully",
            "新增成功":"New successfully added",
            "修改成功！":"Modified successfully",
            "销售员名称":"Salesperson Name",
            "此操作将删除该应收运费设置, 是否继续?":"This operation will delete the configuration of the receivable shipping fee. Do you want to continue",
            "删除成功":"Delete successful",
            "请选择需要删除的数据！":"Please select the data that needs to be deleted!",
            "请选择需要操作的应收运费数据！":"Please select the receivable freight data that needs to be operated on!",
            "请选择价格组树节点":"Please select a price group tree node",
            "请选择销售员":"Please select a salesperson",
            "请选择'特殊客户' 或者 '分组'":"Please select 'Special Customers' or' Grouping '",
            "特殊客户新增成功":"Special customer added successfully",
            "请刷新页面，在重新选择一条要修改的数据":"Please refresh the page and select the data you want to modify again.",
            "请选择一条需要修改的数据":"Please select a piece of data that needs modification.",
            "请选择数据删除":"Please select the data to delete.",
            "您真的要删除当前客户分组吗？":"Do you really want to delete the current customer group?",
            "提示":"Tips",
            "确定":"Yes",
            "取消":"Cancel",
            "客户分组删除成功":"Customer group deleted successfully",
            "您真的要删除当前销售员吗？":"Do you really want to delete the current salesperson?",
            "销售员删除成功":"Salesperson successfully deleted",
            "您真的要删除当前特殊客户吗？":"Do you really want to delete the current special customer?",
            "特殊客户删除成功":"Special customer deleted successfully",
        },
        "BMS07801":{
            "导入报价":"Import quotation",
            "目的地编码":"Destination code",
            "目的地名称":"Destination name",
            "英文目的地":"English destination",
            "中文目的地":"Chinese destination",
            "国家别名":"Country alias",
            "国家简码":"Country code",
            "路线设置":"Setting route",
            "分区设置":"Setting Partition",
            "头程报价设置":"Setting first pass quotation",
            "尾程重量段设置":"Setting last mile weight section",
            "重量段设置":"Weight segment settings",
            "尾程报价设置":"Setting last mile quotation",
            "应收其他":"Setting other receivables",
            "基本信息":"Basic information",
            "价格组":"Price group",
            "指定路线":"Route code",
            "币别":"Currency",
            "尾程批价类型":"Lastmile approval price type",
            "生效时间":"Effective time",
            "选择时间":"Select time",
            "停用时间":"Deactivation time",
            "最低价格":"Lowest price",
            "阶梯计费类型":"Step charging type",
            "备注":"notes",
            "免收偏远费":"Exempting remote fees",
            "免收超值费":"Exempting supervalue fees",
            "免收包装费":"Exempting packaging fees",
            "免收其他":"Exempting other fees",
            "免收后，仍然会产生客户账单明细，但金额为0，账单备注为“免收”":'After exemption, customer billing details will still be generated, but the amount is 0 and the billing note is "exemption"',
            "输入关键字进行过滤":"Enter keywords for filtering",
            "分区名称":"Partition name",
            "公共分区":"Public partition",
            "复制":"Copy",
            "修改":"Modify",
            "删除":"Delete",
            "检查不存在目的地":"Checking non-existent destinations",
            "清除":"Clean up",
            "导入分区":"Import partition",
            "导出分区":"Export partition",
            "分区导入模版":"Partition import template",
            "分区信息":"Partition information",
            "区域编码":"Region code",
            "区域名称":"Region name",
            "收件信息":"Receiver information",
            "目的地":"Destination",
            "输入目的地搜索":"Enter destination search",
            "支持，,；;、多种符号分隔(可含回车)，如中国、香港或中国；美国":"Support Multiple symbol separations (including carriage return), such as China, Hong Kong, or China; United States",
            "数量":"Quantity",
            "邮编":"Postcode",
            "区县":"County",
            "城市":"City",
            "州省":"Province",
            "寄件信息":"Shipper information",
            "起运地":"Departure",
            "递送时效":"Deliver limitation period",
            "不存在目的地":"Non-existent destinations",
            "分区导入":"Import partition",
            "分区导入格式":"Partition import format",
            "行":"Rows",
            "列":"Columns",
            "格式1：区域编码，区域名称（可以忽略，支持2列导入），目的地（可多个目的地）；列与列直接用TAB隔开；导入要求如下":"Format 1: Area code, area name (optional, supports import with 2 columns), destination (multiple destinations allowed); columns are separated by TAB; import requirements as follows:",
            "区域编码：范围在01-150之间方可有效，提取格式中的数字作为区域编码":"Area code: It must be within the range of 01-150 to be valid. Extract the numbers from the provided format as the area code.",
            "目的地：匹配优先级，匹配结果只能有一个结果方可有效":"Destination: Match priority, only one result can be valid for the matching result.",
            "目的地编码最优先，依次为国家简码、目的地名称、英文名称、中文名称（注意：目的地维护时只允许一个，精确匹配":"Destination code has the highest priority, followed by country code, destination name, English name, Chinese name (Note: Only one destination is allowed to be maintained, and it should be an exact match).",
            '最后再按国家别名 (注意：国家别名在维护时一个目的地允许有多个，多个之间用","号隔开。以","分割做精确匹配)':"Finally, according to the country alias (Note: When maintaining country aliases for a destination, multiple aliases are allowed, separated by commas. Exact match is done by splitting with ',').",
            "按以上六个栏位如未匹配出结果，表示导入无效（如有空行，直接忽略空行）":"If no result is matched according to the above six fields, the import is considered invalid (empty lines should be ignored directly).",
            '一个区域中有多个目的地时，可用以下符号进行分割：,", ";", "/", ".","，", "；", "、"均可，同一目的地两头的空格将自动过滤掉':"When there are multiple destinations in one area, the following symbols can be used for separation: ',', ';', '/', '.', '，', '；', '、'. Any spaces at the beginning or end of a destination will be automatically filtered out.",
            "格式2：":"Format 2: ",
            "行第一列为区域编码：提取格式中的数字作为区域编码":"The first column of each row is the area code, extracted as the area code from the provided format.",
            "行每列为中文，英文，简码：一行一个目的地，依次匹配目的地编码、国家简码、目的地名称、英文名称、中文名称、国家别名":"Each row consists of Chinese, English, and abbreviation: one destination per row, sequentially matching destination code, country code, destination name, English name, Chinese name, country alias.",
            "导入":"Import",
            "关闭":"Close",
            "分区.邮编设置":"Partition postal code setting",
            '支持多组邮编，每组邮编之间用;隔开，邮编起始范围与终止范围之间用-隔开':"Support multiple sets of postal codes, separated by ';'. Use '-' to separate the start and end of a postal code range within each set.",
            "邮编匹配逻辑":"Postal code matching logic",
            "在匹配邮编时，需考虑设置的起始邮编长度等于运单邮编。如设置为11111-11333，当运单邮编为11112时，允许匹配":"When matching the postal code, it's necessary to consider the situation where the length of the set starting postal code is equal to the length of the waybill postal code.  For instance, if set as 11111-11333 and the postal code is 11112, it's allowed to match.",
            "如邮编匹配出多个结果，优先匹配分区编码最小的":"If multiple results are matched for the postal code, prioritize matching the smallest partition code.",
            "分区.区县设置":"Partition county/district setting",
            '支持多组数据，每组数据之间用;隔开':"Support multiple sets of data, separated by ';'",
            "匹配逻辑":"Matching logic",
            "完全匹配，例如设置区县为":"Exact match. For example, if the district is set as ",
            "则订单的收件区县必须为":"the recipient's district on the order must be ",
            "才能匹配。":"for a match.",
            "分区.城市设置":"Partition city setting",
            '支持多组城市，每组城市之间用;隔开"':"Support multiple sets of cities, separated by ';' ",
            "完全匹配，例如设置城市为“Huyện Cờ Đỏ”，则订单的收件城市必须为“Huyện Cờ Đỏ”才能匹配。":"Exact match. For example, if the city is set as 'Huyện Cờ Đỏ', the recipient's city on the order must be 'Huyện Cờ Đỏ' for a match.",
            "分区设置_州省设置":"Partition State/Province setting",
            '支持多组州省，每组州省之间用;隔开':"Support multiple sets of states/provinces, separated by ';'  ",
            "完全匹配，例如设置州省为“Huyện Cờ Đỏ”，则订单的收件州省必须为“Huyện Cờ Đỏ”才能匹配。":"Exact match. For example, if the state/province is set as 'Huyện Cờ Đỏ', the recipient's state/province on the order must be 'Huyện Cờ Đỏ' for a match.",
            "分区.目的地查找":"Partition destination lookup",
            "目的地查找":"Destination lookup",
            "输入即可立刻查询以下任意列":"Enter to instantly search any of the following columns:",
            "加入":"Include",
            "头程批价分区":"First pass Approval price partition",
            "编辑":"Edit",
            "保存":"Save",
            "报价明细":"Quotation details",
            "表格双击后加入编辑状态":"Double click on the table to enter editing mode",
            "导出报价":"Export quotation",
            "目的地(可多选)":"Destination (Multiple Choice)",
            "货物类型":"Goods type",
            "计费重区间类型":"Billing weight interval type",
            "起始重量":"Starting weight",
            "终止重量":"Termination weight",
            "公式（运费）":"Formula (Freight)",
            "折扣":"Discount",
            "重量段分类":"Weight segment classification",
            "重量段明细":"weight segment details",
            "分段号":"Segmentation number",
            "计重方式":"Weight calculation method",
            "包装类型":"Packing type",
            "其他包装类型":"Other packing types",
            "首重":"First weight",
            "单位重(续重)":"Unit weight (continued weight)",
            "创建时间":"Create time",
            "创建人":"Creator",
            "批价分区":"Approval price partition",
            "重量段":"Weight segment",
            "特殊报价设置(未含)":"Setting special quotation(not included)",
            "特殊报价设置(已含)":"Setting special quotation(included)",
            "优先特殊价，其次标准价":"Priority special price, followed by standard price",
            "设置重量区间折扣":"Set weight interval discounts.",
            "小包报价导入":"Small parcel quotation import",
            "小包报价导入格式":"Small parcel quotation import format",
            "行列转置":"Row-column transposition",
            "导入前请将报价复制到剪贴板即可，注意以下几点要求：":"Before importing, please copy the quotation to the clipboard. Please note the following requirements:",
            "格式为：目的地(编码,中文名称,英文名称均可)":"The format is: Destination (code, Chinese name, English name are all acceptable).",
            "列与列直接用TAB隔开":"The columns are separated by TAB.",
            "折扣类型":"Discount type",
            "注意：":"Note: ",
            "可以同时附加折扣、运费折扣，但与统一折扣不能同时存在":"Can simultaneously attach discounts and shipping discounts, but they cannot coexist with uniform discounts.",
            "重量范围统一为 起始重量 < 重量 <= 终止重量":"The weight range is uniformly defined as: Starting weight < Weight ≤ Ending weight.",
            "如未设置重量区间，表示没有折扣":"If weight intervals are not set, it means there are no discounts.",
            "最多设置6个区间段":"Can set up to 6 interval segments at most.",
            "首重续重导入":"Importing initial weight and additional weight",
            "首重续重导入格式":"Importing initial weight and additional weight foemat",
            "默认折扣":"Default discount",
            "默认附加费":"Default additional fee",
            "格式为：区域编码、目的地(编码,中文名称,英文名称均可)、价格（可多个）":"The format is: Area code, destination (code, Chinese name, English name are all acceptable), price (multiple prices allowed).",
            "直接价格导入":"Direct price import",
            "直接价格导入格式":"Direct price import format",
            "格式为：重量范围(纯数字、带-范围、带+)、价格（可多个）":"The format is: Weight range (pure numbers, with '-' range, with '+' range), price (multiple prices allowed).",
            "特殊报价":" Special quotation",
            "特殊报价设置":"Setting special quotation",
            "符号：+：加、 -：减、 *：乘、 /：除、()：括号":"Symbols:+: add, -: subtract, *: multiply,/: divide, (): parentheses",
            "变量：重量(@w),件数(@p),代收款(@c),到付款(@d),应收燃油加收比率(@f),应收运费(@y),申报价值(@s),收费材重(@v),商品件数(@qts)":"Variables: weight (@w), pcs (@p), for collection (@c) , the payment (@d), Fuel surcharge  (@f) receivable, accounts receivable freight (@y) , declared value (@s), the charging material weight (@v), the quantity of goods (@qts)",
            "变量：收费重(@w)，标准价格(@y); 燃油附加费(@f)":"Variables: chargeable weight (@ w), standard price (@ y); Fuel surcharge (@ f)",
            "函数：round()，按指定的小数位数，四舍五入；ceiling()，进位取整；floor()，退位取整":"Function: round(), rounded to the specified number of decimal places; Ceiling(), rounding; Floor(), rounding with rounding out",
            "判断语句":"check statement",
            "范围：起始重量 < 收费重 <= 终止重量":"Scope: Starting weight<chargeable weight<=ending weight",
            "首重/续重设置方法：首重价 + ceiling ((@w-首重)/续重)*续重价":"Method for setting the first weight/renewal weight: First weight price+ceiling (@ w - first weight)/renewal weight) * renewal weight price",
            "包装类型、区域编码、目的地、起始重量四项不能有重复":"The four items of packaging type, area code, destination, and starting weight cannot have duplicates",
            "特殊价格 = (公式 + 燃油内加收)*（1+燃油加收比率） + 燃油外加收":"Special price=(formula+fuel surcharge) * (1+fuel surcharge ratio)+fuel surcharge",
            "完全按特殊价计算":"Completely at special price",
            "起始票数":"Starting votes",
            "终止票数":"Termination votes",
            "阶梯起始重":"Step starting weight",
            "阶梯终止重":"Step Termination weight",
            "每公斤":"Per kilogram",
            "重量":"Weight",
            "燃油内加收":"Internal fuel charging",
            "燃油外加收":"Fuel surcharge",
            "标准导入":"Standard import",
            "导入模版":"Import Template",
            "导入列格式：起始票数、终止票数、货物类型、包装类型、区域编码、目的地、起始重量、终止重量、公式、燃油内加收、燃油外加收":"The import column format: Starting ticket number, ending ticket number, type of goods, packaging type, area code, destination, starting weight, ending weight, formula, fuel surcharge (internal), fuel surcharge (external).",
            "特殊折扣导入":"Special discount import",
            "特殊折扣导入格式":"Special discount import format",
            "科目":"Subject",
            "报关方式":"Declaration method",
            "公式":"Formula",
            "最低价":"Lowest price",
            "免收":"Exempting",
            "变量：重量(@w),件数(@p),代收款(@c),到付款(@d),应收燃油加收比率(@f),应收运费(@y),申报价值(@s)":"Variables: weight (@ w), quantity (@ p), collection (@ c), payment upon delivery (@ d), fuel receivable rate (@ f), freight receivable (@ y), declared value (@ s)",
            "函数：round()，按指定的小数位数，四舍五入":"Function: round(), rounding to the specified number of decimal places",
            "进位取整":" rounding",
            "退位取整":"rounding with rounding out",
            "举例：香港DHL。(计算公式需遵循SQL规范)":"Example: DHL Hong Kong. (The calculation formula must follow SQL specifications)",
            "公式：":"Formula:",
            "保存分区":"Save partition",
            "注意：可在此新增头程分区和尾程分区":"Note: can add origin and destination sections here.",
            "下一步":"Next",
            "保存重量段":"Save weight segments",
            "保存并下一步":"Save and Next",
            '请选择"指定路线"!':"Please select 'Channel code'.",
            '请选择"币别"!':'Please select "Currency"',
            '请选择"批价类型"!':"Please select 'Approval-price type'.",
            '请选择"价格组"!':"Please select 'Price group'.",
            '请输入"生效时间"!':"Please enter 'Effective time'.",
            '请输入"停用时间"!':"Please enter 'Discontinuation time'.",
            '"生效时间"不能大于"停用时间"!':"The 'Effective time' cannot be greater than the 'Discontinuation time'.",
            "路线报价未保存，不能新增报价明细！":"The route quotation is not saved, can’t add quotation details.",
            "报价明细或特殊报价未设置，不能保存！":"Can’t save without setting quotation details or special quotations.",
            "区域编码和目的地不能同时输入,请去除一个":"Can’t input both area code and destination at the same time. Please remove one.",
            "报价明细保存成功！":"Quotation details saved successfully",
            "路线报价未保存，不能设置应收其他！":"Can’t set other receivables without saving the route quotation.",
            "科目不能为空！":"The account subject cannot be empty.",
            "公式不能为空！":"Formula cannot be empty.",
            "最低价不能为空！":"The minimum price cannot be empty.",
            "币别不能为空！":'Currency cannot be empty',
            "区域编码和目的地不能同时输入":"Area code and destination cannot be entered simultaneously.",
            "应收其他保存成功！":"The other receivables saved successfully.",
            "请设置分区明细！":"Please set partition details.",
            "分区明细第":"Partition details line",
            "行未设置区域编码！":"The row does not have an area code set.",
            "行未设置目的地！":"The row does not have a destination set.",
            "行已设置收件邮编，不能设置多个目的地！":"The row already has a recipient postal code set, so multiple destinations cannot be set.",
            "行已设置收件区县，不能设置多个目的地！":"The row already has a recipient district set, so multiple destinations cannot be set.",
            "行已设置收件城市，不能设置多个目的地！":"The row already has a recipient city set, so multiple destinations cannot be set.",
            "行已设置收件州省，不能设置多个目的地！":"The row already has a recipient state/province set, so multiple destinations cannot be set.",
            "行已设置寄件邮编，不能设置多个起运地！":"The row already has a sender postal code set, so multiple origins cannot be set.",
            "行已设置寄件区县，不能设置多个起运地！":"The row already has a sender district set, so multiple origins cannot be set.",
            "行已设置寄件城市，不能设置多个起运地！":"The row already has a sender city set, so multiple origins cannot be set.",
            "行已设置寄件州省，不能设置多个起运地！":"The row already has a sender state/province set, so multiple origins cannot be set.",
            "行已设置寄件信息，起运地必填！":"The row already has sender information set, the origin is required.",
            "行，收件邮编,区县,城市和州省，不能同时设置！":"The row cannot have recipient postal code, district, city, and state/province set simultaneously.",
            "行，寄件邮编,区县,城市和州省，不能同时设置！":"The row cannot have sender postal code, district, city, and state/province set simultaneously.",
            "行与第":"Row and line",
            "行区域编码重复！":"The row has a duplicate area code.",
            "应付分区不能在应收分区设置中修改":"Cannot modify the payable partition in the receivable partition settings.",
            "应付分区不能在应收分区设置中删除":"Cannot delete the payable partition in the receivable partition settings.",
            "此操作将删除该分区设置, 是否继续?":"This action will delete the partition settings. Do you want to continue?",
            "删除成功":"Delete successful",
            "行有不存在的目的地！":"The row contains non-existent destinations.",
            "是否确认删除全部分区明细？":"Are you sure you want to delete all partition details?",
            "提示":"Tips",
            "确定":"Yes",
            "取消":"Cancel",
            "请新增或修改一个分区进行导入！":"Please add or modify a partition for import.",
            "区域编码必须在01-150之间！":"The area code must be between 01 and 150.",
            "分区导入格式数据不能为空！":"The data in the partition import format cannot be empty.",
            "区域编码数量达到上限，无法添加！":"The maximum number of area codes has been reached, and no more can be added.",
            '删除成功！':"Delete successful",
            "请先选择数据！":"Please select data first.",
            "邮编设置异常，请重新设置！":"The postal code settings are abnormal. Please reset.",
            "当前分区已被多个报价引用，是否继续保存(保存后可能会影响到已有报价)?":"The current partition is referenced by multiple quotations. Do you want to continue saving? (Saving may affect existing quotations.)",
            "计费重区间类型不能为空":"The billing weight interval type cannot be empty.",
            "请先保存头程报价分区":"Please save the origin quotation partition first.",
            "请先保存报价":"Please save the quotation first.",
            "修改分区成功！":'Successfully modified partition',
            "新增分区成功！":'Successfully added partition',
            "请设置重量段明细！":'Please set weight segment details',
            "请选择分段号！":'Please select a segment number',
            '"分段号"不能重复出现！':'The segment number cannot appear repeatedly',
            "请选择计重方式！":'Please select the weight calculation method',
            '"包装类型"不能与"其他包装类型"相同！':"'Packaging type' cannot be the same as 'Other packaging type'.",
            '"起始重量"必须大于或者等于0！':"The starting weight must be greater than or equal to 0.",
            '"终止重量"必须大于"起始重量"！':"The ending weight must be greater than the starting weight.",
            '"首重"必须大于0！':"The initial weight must be greater than 0.",
            '"单位重"必须大于0！':"The unit weight must be greater than 0.",
            '上一重量段的"终止重量"必须等于下一重量段的"起始重量"！':"The 'Ending weight' of the previous weight interval must be equal to the 'Starting weight' of the next weight interval.",
            "此操作将删除该重量段设置, 是否继续?":"This action will delete the weight segment settings. Do you want to continue?",
            "是否确认删除全部重量段明细？":"Are you sure you want to delete all weight segment details?",
            "重量段明细数量达到上限，无法添加！":"The maximum number of weight segment details has been reached, and no more can be added.",
            "该重量段明细删除成功":'The weight segment details have been successfully deleted',
            "当前重量段已被多个报价引用，是否继续保存(保存后可能会影响到已有报价)?":"The current weight segment is referenced by multiple quotations. Do you want to continue saving? (Saving may affect existing quotations.)",
            "新增重量段成功！":'Successfully added weight segment',
            "修改重量段成功！":'Successfully modified weight segment',
            '请选择"分区设置"!':'Please select "Partition Settings"',
            "请选择头程批价分区":"Please select the origin pricing partition.",
            '请选择"重量段设置"!':"Please select 'Weight segment settings'.",
            "线路报价保存成功！":"Route quotation saved successfully",
            "保存成功！":"Save successful",
            "正在使用分区<":"The partition is currently in use.",
            ">编辑":"Edit",
            "，确认更换至分区<":"Confirm change to partition",
            ">；覆盖后，会清空正在编辑的明细数据。确认继续？":"After overwriting, the currently edited detail data will be cleared. Confirm to continue?",
            "请先选择头程报价分区":"Please select the origin pricing partition first.",
            "未选择批价类型（首续重/直接价格）！":"You haven't selected the pricing type (initial/continuation weight or direct price).",
            "首重续重导入格式数据不能为空！":"The data in the initial and additional weight import format cannot be empty.",
            "直接价格导入格式数据不能为空！":"The data in the direct price import format cannot be empty.",
            "小包报价导入格式数据不能为空！":"The data in the small parcel quotation import format cannot be empty.",
            "是否确认删除全部报价明细？":'Are you sure to delete all quotation details',
            "是否确认删除全部头程报价明细？":'Are you sure to delete all first-pass quotation details',
            "该报价明细删除成功":'The quotation details have been successfully deleted',
            "设置成功":'Set successfully',
            "最大设置6个重量区间折扣！":"The maximum is to set up to 6 weight interval discounts.",
            "请先设置报价":"Please set the quotation first.",
            "该分区段删除成功":"The partition segment has been successfully deleted.",
            "该特殊报价明细删除成功":"The special quotation detail has been successfully deleted.",
            "是否确认删除全部特殊价明细？":"Are you sure to delete all special price details",
            "路线报价未保存，不能设置特殊报价！":"Cannot set special quotations without saving the route quotation.",
            "请设置特殊报价明细！":"Please set special quotation details.",
            '请选择"包装类型"！':"Please select 'Packaging type'.",
            "特殊报价保存成功！":"Special quotation saved successfully",
            "标准导入格式数据不能为空！":"The data in the standard import format cannot be empty.",
            "特殊折扣导入格式数据不能为空！":"The data in the special discount import format cannot be empty.",
            "无法加载表头！！！":"Unable to load header",
            "无报价数据，无法导出！":"There is no quotation data, so export is not possible.",
            "退出":"Exit",
            "分区明细":"Partition details",
            "范围：起始重量 <  收费重 <= 终止重量": "Range: Initial weight < Chargeable weight ≤ Final weight",
        },
        "OMS043":{
            '集运单管理':"",
            "销毁":"",
            "导出":"",
            "货物状态时间查询":"",
            "查询":"",
            "重置":"",
            "我是标题":"",
            "货物信息":"",
            "基础信息":"",
            "一段参考编号":"",
            "一段快递单号":"",
            "二段参考编号":"",
            "二段运单号":"",
            "客户编码":"",
            "商品价值":"",
            "重量":"",
            "税金方式":"",
            "一段发件人信息":"",
            "名字":"",
            "公司名":"",
            "国家":"",
            "州省":'',
            "城市":"",
            "区":"",
            "邮编":'',
            "地址":"",
            "电话":"",
            "税号":"",
            "税号类型":"",
            "身份证号":"",
            "身份证类型":"",
            "二段发件人信息":"",
            "二段收件人信息":"",
            "货物明细":"",
            "货物状态":"",
            "收件人旺旺ID":"",
            "二段供应商":"",
            "二段供应商服务码":"",
            "二段单创建时间":"",
            "异常原因":"",
            "货物状态时间":"",
            "货物状态时区":"",
            "包裹价值":"",
            "包裹实重(KG)":"",
            "长（CM）":"",
            "宽（CM）":"",
            "高（CM）":"",
            "中文品名":"",
            "类别":"",
            "英文品名":"",
            "单价":"",
            "数量":"",
            "单个重量（KG）":"",
            "尺寸（长*宽*高 CM）":"",
            "状态":"",
            "时间":"",
            "时区":"",
            "是否确定销毁":"",
            "个数据":"",
            "提示":"",
            "确定":"",
            "取消":"",
            "成功":"",
            "请选择一行数据":"",
        },
        "OMS044":{
            "入库日期":"",
            "分组数据(支持多选)":"",
            "导出":"",
            "查询":"",
            "重置":"",
            "数据更新时间":"",
            "总票数":"",
            "总签收票数":"",
            "总签收率":"",
            "未完成票数":"",
            "未完成占比":"",
            "失败票数":"",
            "失败占比":"",
            "平均签收时间(day)":"",
            "最小签收时间(day)":"",
            "最大签收时间(day)":"",
            "平均上线时间(day)":"",
            "平均首次派送时间(day)":"",
            "≤H3D占比":"",
            "≤H5D占比":"",
            "≤H6D占比":"",
            "≤H7D占比":"",
            "≤H8D占比":"",
            "≤H9D占比":"",
            "≤H10D占比":"",
            "≤H11D占比":"",
            "≤H12D占比":"",
            "≤H13D+占比":"",
            '日期不能为空':"",
            "客户":"",
            "指定路线分类":"",
            "指定路线":"",
            "目的国家":"",
            "运单号码":"",
            "参考编号":"",
            "最新轨迹状态":"",
            "最新轨迹描述":"",
            "最新轨迹时间":"",
            "未更新天数":"",
            "目的地编码":"",
            "目的地":"",
            "产品码分类":"",
            "产品码":"",
            "分拣码":"",
            "订单成功上传":"",
            "已入库":"",
            "关包":"",
            "出货":"",
            "交货给干线代理":"",
            "出口清关成功":"",
            "航班起飞":"",
            "航班抵达":"",
            "入口清关成功":"",
            "交货到末公里":"",
            "包裹到达分拣中心":"",
            "末端转运中":"",
            "到达派件站点":"",
            "首次派送":"",
            "二次派送":"",
            "再次派送":"",
            "包裹到达自提点":"",
            "派送异常":"",
            "收件人拒收":"",
            "已签收":"",
            "退回海外仓中":"",
            "返回末端退货仓库":"",
            "退回海外仓":"",
            "二次转寄上架":"",
            "海外仓移出":"",
            "已二次转寄":"",
            "退返客户":"",
            "包裹丢失":"",
            "包裹损坏":"",
            "包裹销毁":"",
        },
        "BIS031":{
            "产品码分类":"Channel code classification",
            "产品码":"Channel code",
            "分组数据(支持多选)":"Grouping data (Multiple choice)",
            "查询":"Search",
            "重置":"Reset",
            "导出":"Export",
            "数据更新时间":"Data update time",
            "入库日期":"Scan-in date",
            "总票数":"Total number pkgs",
            "总签收票数":"Total number pkgs signed",
            "总签收率":"Total signing rate",
            "未完成票数":"Unfinished quantity",
            "未完成占比":"Unfinished proportion",
            "失败票数":"Failed pkgs",
            "失败占比":"Failed proportion",
            "平均签收时间":"Average signed time",
            "最小签收时间":"Min signed time",
            "最大签收时间":"Max signed time",
            "平均上线时间":"Average online time",
            "平均首次派送时间":"Average first delivery time",
            "H3D占比":"H3D Proportion",
            "H4D占比":"H4D Proportion",
            "H5D占比":"H5D Proportion",
            "H6D占比":"H6D Proportion",
            "H7D占比":"H7D Proportion",
            "H8D占比":"H8D Proportion",
            "H9D占比":"H9D Proportion",
            "H10D占比":"H10D Proportion",
            "H11D占比":"H11D Proportion",
            "H12D占比":"H12D Proportion",
            "H13D占比":"H13D Proportion",
        }
    }
};
export default enUS;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/page_en-US.js